export const locales = {
    'zh-Hans': {
        "cohort_registered_status_scope": "状态卡按当前登记记录统计，不是历史患者分布",
        "cohort_registered_active": "登记记录·监测中",
        "cohort_registered_completed": "登记记录·已完成",
        "cohort_registered_terminated": "登记记录·提前终止",
        "cohort_registered_status_detail": "当前未移除的登记身份，非历史患者人数",
        "cohort_registered_subjects": "登记受试者",
        "cohort_confirmed_enrollment": "确认累计入组",
        "cohort_institution_confirmed": "机构确认累计入组",
        "cohort_reconciliation_source": "确认依据：",
        "cohort_snapshot_fixed": "此为截至日期的确认快照；新增登记或姓名修改不会自动增加，后续须重新核对确认。",
        "cohort_current_registered_count": "当前登记记录：",
        "cohort_scopes_not_additive": "两种口径不相加，状态合计不代表累计患者分布。",
        "cohort_registered_only_scope": "按当前登记身份统计；同一记录可能被复用，不能据此认定历史患者人数。",
        "cohort_enrollment_invalid": "累计确认配置无效，待管理员核对；不以登记数替代。",
        "cohort_weekly_enrollment": "本周新增入组（待核对）",
        "cohort_history_unavailable": "暂无可核验的患者入组及状态流转历史，近7天新增、恢复、完成及终止不作推算。以下仅为当前登记记录状态。",

        "research_trend_sleep_age": "睡眠年龄",
        "research_trend_aging_speed": "衰老速度",
        "research_trend_recovery": "醒来恢复",
        "research_trend_years": "岁",
        "research_trend_years_per_year": "岁/年",
        "research_trend_28d": "近28天趋势",

        "cohort_null_report_read_hint": "此报告未关联受试者；仅显示报告数据，不提供受试者资料编辑或 PDF。",
        "cohort_null_report_pdf_hint": "未关联受试者的报告不支持 PDF；仅导出所选真实受试者。",
        "cohort_null_report_stage_hint": "未关联受试者的报告不支持分期导出；可导出逐夜报告数据或原始通道。",

        "cohort_device_reports_scope": "当前筛选范围",
        "cohort_device_reports_count_unit": "份报告",
        "cohort_device_reports_exporting": "正在获取全部筛选报告…",
        "cohort_device_reports_export": "导出全部筛选报告 XLSX",
        "cohort_device_reports_export_scope": "导出范围（全部筛选报告，非当前页）",
        "cohort_device_reports_loading": "正在加载报告…",
        "cohort_device_reports_empty": "当前范围没有报告。",
        "cohort_device_reports_view_metrics": "查看全部报告指标",
        "cohort_device_reports_paging": "报告分页",
        "cohort_device_reports_select_org": "请先选择队列机构。",
        "cohort_device_reports_all_sites": "全部站点",
        "cohort_device_reports_all_devices": "全部设备",
        "cohort_device_reports_open_date": "不限日期",
        "cohort_device_reports_cancelled": "导出已取消，未下载文件。",
        "cohort_device_reports_no_access": "当前账号无查看权限。",
        "cohort_device_reports_load_failed": "报告加载失败，旧数据已清除。请重新查询。",
        "cohort_device_reports_date_error": "开始日期不能晚于结束日期。",
        "cohort_device_reports_exported": "已导出全部筛选报告，报告数",
        "cohort_device_reports_export_failed": "导出失败或报告范围发生变化，未下载不完整文件。请重新查询后重试。",
        "clinical_heading": "检验、检查与医嘱",
        "clinical_import": "导入临床文档",
        "clinical_close": "关闭面板",
        "clinical_upload": "选择文件导入",
        "clinical_refresh": "刷新列表",
        "clinical_upload_hint": "支持 PNG、JPEG、PDF，每个文件最多 10 MiB；多个文件逐个识别。",
        "clinical_all_sites": "全部站点",
        "clinical_transcription_only": "仅转录原始检验、检查与临床医嘱，须人工核对确认；不生成治疗建议，与睡眠报告分开保存。",
        "clinical_queued": "等待上传",
        "clinical_processing": "正在上传与识别…",
        "clinical_uploaded": "已保存识别结果",
        "clinical_failed": "失败",
        "clinical_loading": "正在加载临床文档…",
        "clinical_empty": "暂无临床文档，可直接导入，无需睡眠报告。",
        "clinical_confirmed": "已人工确认",
        "clinical_draft": "待核对草稿",
        "clinical_view_edit": "查看 / 核对编辑",
        "clinical_downloading": "正在下载…",
        "clinical_source": "下载原文件",
        "clinical_pages": "临床文档分页",
        "clinical_previous": "上一页",
        "clinical_next": "下一页",
        "clinical_edit": "编辑并确认",
        "clinical_preview": "已确认数据预览",
        "clinical_close_editor": "关闭编辑",
        "clinical_warnings": "识别与身份提示（请核对原文件）",
        "clinical_PATIENT_NAME_MISMATCH": "原报告姓名与当前受试者档案姓名不一致。修改姓名不能消除此提示。",
        "clinical_PATIENT_NAME_UNVERIFIED": "报告或档案缺少姓名，无法核验；文档仍归属于当前受试者身份。",
        "clinical_nullable_hint": "未知内容可留空；检验结果按原文保留不等式、范围或定性文字，不推断代码、单位和参考范围。",
        "clinical_type": "文档类型",
        "clinical_type_laboratory": "检验",
        "clinical_type_examination": "检查",
        "clinical_type_order": "医嘱（原文转录）",
        "clinical_remove_row": "删除此行",
        "clinical_add_row": "添加一行",
        "clinical_ack": "我已核对原文件与当前受试者身份，明确知悉姓名不一致并确认文档归属。",
        "clinical_saving": "正在确认保存…",
        "clinical_save": "确认并保存完整记录",
        "clinical_saved": "已人工确认保存。",
        "clinical_conflict": "记录已被其他人更新，您的编辑仍保留，未覆盖服务器记录。请重新加载最新版本后核对。",
        "clinical_reload_discard": "放弃当前编辑，加载最新版本",
        "clinical_discard": "有未保存的修改，确定放弃吗？",
        "clinical_file_size": "文件超过 10 MiB，请选择较小文件。",
        "clinical_file_type": "仅支持 PNG、JPEG、PDF 文件。",
        "clinical_load_failed": "临床文档加载失败，请重试。",
        "clinical_upload_failed": "上传或识别失败，请检查文件后重试。",
        "clinical_save_failed": "确认保存失败，编辑内容已保留。",
        "clinical_download_failed": "原文件下载失败，请重试。",
        "clinical_invalid_date": "报告日期须为有效 YYYY-MM-DD；不明确时请留空。",
        "clinical_field_title": "标题",
        "clinical_field_patientName": "报告患者姓名",
        "clinical_field_reportDate": "报告日期",
        "clinical_field_rawText": "原始识别文字（展开查看 / 编辑）",
        "clinical_field_name": "检验项目名称",
        "clinical_field_code": "原文代码",
        "clinical_field_value": "结果（文字）",
        "clinical_field_unit": "单位",
        "clinical_field_referenceRange": "参考范围",
        "clinical_field_flag": "异常标记",
        "clinical_field_findings": "检查所见",
        "clinical_field_conclusion": "检查结论",
        "clinical_field_modality": "检查方式",
        "clinical_field_bodyPart": "检查部位",
        "clinical_field_treatment": "原文治疗医嘱",
        "clinical_field_drug": "药品",
        "clinical_field_dose": "剂量",
        "clinical_field_route": "途径",
        "clinical_field_frequency": "频次",
        "clinical_field_start": "开始时间（原文）",
        "clinical_field_end": "结束时间（原文）",
        "clinical_field_status": "医嘱状态",
        'cohort_profile_add': '添加基本信息',
        'cohort_profile_edit': '编辑基本信息',
        'cohort_profile_unset': '未填写',
        'cohort_profile_unknown': '未知',
        'cohort_profile_age_mode': '年龄录入方式',
        'cohort_profile_age_only': '仅填写年龄',
        'cohort_profile_optional_hint': '所有字段可选；留空可清除已填写的信息。',
        'cohort_profile_derived_bmi': 'BMI（自动计算）',
        'cohort_profile_remarks_hint': '选填，可填写多行备注（最多 2,000 字）',
        'cohort_profile_discard': '有未保存的修改，确定放弃吗？',
        'cohort_profile_unsaved': '未保存的修改',
        'cohort_profile_discard_button': '放弃修改',
        'cohort_profile_keep_editing': '继续编辑',
        'cohort_profile_invalid_text': '请检查文本长度及控制字符（姓名 128 字，民族 64 字，备注 2,000 字）。',
        'cohort_profile_invalid_sex': '性别请选择男、女、未知，或留空。',
        'cohort_profile_invalid_number': '年龄须为 0–130 岁，身高须为 30–250 cm，体重须为 1–500 kg，均为整数。',
        'cohort_profile_invalid_date': '请输入 1900 年至今天的有效日期，出生日期对应年龄不能超过 130 岁。',
        'cohort_profile_load_failed': '基本信息加载失败',
        'cohort_profile_loading': '正在加载基本信息…',
        'cohort_profile_retry': '重新加载',
        'cohort_profile_missing_context': '缺少历史受试者身份，无法加载或编辑基本信息。',
        'cohort_profile_export_detail': '受试者基本信息（年龄按该受试者最新报告日期计算；年龄观察保留参考日期）',
        'cohort_profile_summary': '查看 / 编辑基本信息',
        'cohort_realtime': '实时监测',
        'cohort_realtime_unavailable': '当前队列不支持实时监测。',
        'cohort_realtime_polling': '每 5 秒刷新；仅在当前页面可见时更新',
        'cohort_realtime_paused': '更新已暂停，返回此页面后重新获取数据',
        'cohort_realtime_search': '搜索床位、当前受试者或设备',
        'cohort_realtime_all': '全部',
        'cohort_realtime_onbed': '在床',
        'cohort_realtime_offbed': '离床',
        'cohort_realtime_unknown': '暂无法判断',
        'cohort_realtime_state': '在离床状态',
        'cohort_realtime_subject': '当前受试者',
        'cohort_realtime_hr': '心率（次/分）',
        'cohort_realtime_status_unavailable': '暂不可用',
        'cohort_realtime_hr_label': '心率',
        'cohort_realtime_rr_label': '呼吸率',
        'cohort_realtime_hr_unit': 'bpm',
        'cohort_realtime_rr_unit': '次/分',
        'cohort_realtime_rr': '呼吸率（次/分）',
        'cohort_realtime_source_time': '最近监测时间',
        'cohort_realtime_stale': '暂无法获取当前状态',
        'cohort_realtime_error': '刷新失败，当前测量不可用；将自动重试',
        'cohort_realtime_empty': '当前筛选条件下没有设备',
        'cohort_realtime_loading': '正在更新监测数据…',
        'cohort_realtime_updated': '页面刷新时间',
        'cohort_realtime_counts': '设备概况（筛选结果中的全部设备）',
        'cohort_realtime_devices': '设备总数',
        'cohort_realtime_page_size': '每页设备数',
        'cohort_realtime_refresh': '立即刷新',
        'cohort_realtime_channels': '独立通道',
        'cohort_realtime_hrv_estimate': 'HRV RMSSD（5分钟估计）',
        'cohort_realtime_hrv_window': '测量窗口',
        'cohort_realtime_hrv_explanation': '显示测量窗口；质量结果来自现有算法，不代表原始数据完整性。非即时值。',
        'cohort_movement_recent': '体动状态 · 最近5分钟',
        'cohort_movement_insufficient': '数据不足',
        'cohort_movement_not_detected': '未检测到体动',
        'cohort_movement_detected': '有体动',
        'cohort_movement_coverage': '监测覆盖',
        'cohort_movement_seconds': '秒',
        'cohort_movement_past_five': '近5分钟',
        'cohort_movement_count': '{count}次',
        'cohort_movement_observed_count': '已观测{count}次',
        'cohort_movement_distribution': '最近30分钟体动分布',
        'cohort_movement_thirty_ago': '30分钟前',
        'cohort_movement_now': '现在',
        'cohort_movement_coverage_incomplete': '覆盖不完整，次数可能不完整',
        'cohort_movement_timeline_gaps': '斜纹表示覆盖或片段起点数据不足，不代表未检测到体动。',
        'cohort_movement_count_explanation': '次数按连续体动片段统计，不等同于翻身次数。',
        'cohort_movement_count_incomplete': '片段起点数据不足，次数不确定',
        'cohort_realtime_movement': '是否正在体动',
        'cohort_realtime_moving_yes': '是',
        'cohort_realtime_moving_no': '否',
        'cohort_realtime_channel_unavailable': '暂无可用数据',
        'cohort_realtime_channel_time_unverified': '时间未验证',
        'cohort_realtime_channel_read_failed': '读取暂不可用',
        'cohort_realtime_note': '仅供监测参考，不替代临床评估或告警。— 表示暂无可显示的当前测量。',

        // Cohort module
        'cohort_numeric_metric': '数值指标',
        'cohort_boolean_metric': '布尔指标',
        'cohort_exit_batch_mode': '退出批量模式',
        'cohort_enter_batch_mode': '进入批量模式',
        'cohort_deselect_all': '取消全选',
        'cohort_select_all_results': '全选筛选结果',
        'cohort_select_fields_export': '选择字段并导出（',
        'cohort_export_raw_data_prefix': '导出原始数据（',
        'cohort_selected_people_suffix': '人）',
        'cohort_conditions_active': '个条件生效',
        'cohort_filtered_out': '筛出',
        'cohort_collapse_advanced_filters': '收起高级筛选',
        'cohort_expand_advanced_filters': '展开高级筛选',
        'cohort_real_metrics_unit': '个Wuji Data真实指标',
        'cohort_categories_unit': '个分类',
        'cohort_no_unit': '无单位',
        'cohort_page_prefix': '第',
        'cohort_page_of': '/',
        'cohort_page_suffix': '页',
        'cohort_total_prefix': '共',
        'cohort_selected_fields_prefix': '已选择',
        'cohort_fields_unit': '个字段',
        'cohort_will_export': '将导出',
        'cohort_subjects_unit': '位受试者',
        'cohort_found': '找到',
        'cohort_integrated_metrics_unit': '个已接入指标',
        'cohort_selected_metrics_unit': '个指标',
        'cohort_nightly_report_suffix': '逐夜报告',
        'cohort_ahi_all': '全部AHI',
        'cohort_ahi_normal': '<5 正常',
        'cohort_ahi_mild': '5—15 轻度',
        'cohort_ahi_moderate': '15—30 中度',
        'cohort_ahi_severe': '≥30 重度',
        'cohort_quick_report_7': '报告夜 ≥7',
        'cohort_quick_low_efficiency': '平均睡眠效率 <80%',
        'cohort_quick_short_sleep': '平均睡眠 <6小时',
        'cohort_quick_high_hr': '平均心率 ≥70',
        'cohort_quick_no_report_7d': '连续7天无报告',
        'cohort_tag_mild_osa': '轻度OSA',
        'cohort_tag_moderate_osa': '中度OSA',
        'cohort_tag_severe_osa': '重度OSA',
        'cohort_tag_insufficient_nights': '报告夜不足',
        'cohort_tag_consecutive_missing': '存在连续缺失',
        'cohort_tag_short_sleep': '睡眠时间不足',
        'cohort_tag_low_efficiency': '睡眠效率偏低',
        'cohort_tag_high_sleep_hr': '睡眠心率偏高',
        'cohort_report_data_load_failed': '报告数据加载失败',
        'cohort_nightly_reports_load_failed': '逐夜报告加载失败',
        'cohort_night_report_module_load_failed': '单夜报告页面加载失败。请刷新页面后，再打开同一设备和日期的报告。',
        'cohort_night_report_navigation_failed': '无法打开单夜报告。请重试；若仍失败，请刷新页面后重试。',
        'cohort_aggregation_help_median': '该受试者在所选日期范围内所有夜晚的中位数：排序后取中间值，较少受个别异常夜影响',
        'cohort_aggregation_help_mean': '该受试者在所选日期范围内所有夜晚的平均值',
        'cohort_aggregation_help_min': '所选日期范围内的最小值',
        'cohort_aggregation_help_max': '所选日期范围内的最大值',
        'cohort_aggregation_help_latest': '所选日期范围内最新一夜的值',
        'cohort_operator_equal': '等于',
        'cohort_operator_gte': '大于等于',
        'cohort_operator_lte': '小于等于',
        'cohort_operator_gt': '大于',
        'cohort_operator_lt': '小于',
        'cohort_operator_between': '介于',
        'cohort_no_data': '无数据',
        'cohort_signal_none': '无信号',
        'cohort_signal_weak': '弱',
        'cohort_signal_medium': '中',
        'cohort_signal_good': '好',
        'cohort_signal_excellent': '极好',
        'cohort_signal_unknown': '未知',
        'cohort_signal_label': '信号：',
        'cohort_signal_bars': '格',
        'cohort_wifi_recommendation': '信号较弱，建议配置 WiFi',
        'cohort_exporting_raw_data': '正在导出原始数据...',
        'cohort_raw_export_success': '原始数据导出成功',
        'cohort_raw_export_failed': '原始数据导出失败',
        'cohort_loading_nightly_data': '正在加载逐夜数据...',
        'cohort_load_nightly_data_failed': '加载逐夜数据失败',
        'cohort_no_nightly_data_selected': '所选受试者无逐夜报告数据',
        'cohort_exporting_count_prefix': '正在导出',
        'cohort_raw_files_suffix': '份原始数据...',
        'cohort_export_complete': '导出完成：',
        'cohort_success': '成功',
        'cohort_failed': '失败',
        'cohort_export_success_prefix': '成功导出',
        'cohort_raw_files_unit': '份原始数据',
        'cohort_export_subject_id': '受试者ID',
        'cohort_export_stable_id_detail': '队列内稳定脱敏编号',
        'cohort_export_name': '姓名/脱敏称呼',
        'cohort_export_name_detail': '当前队列显示名称',
        'cohort_export_current_device': '当前设备号',
        'cohort_export_current_device_detail': '受试者当前主要设备',
        'cohort_export_window_detail': '筛选后首末报告日期',
        'cohort_export_nights_detail': '时间窗内报告总数',
        'cohort_export_ahi_label': 'AHI中位数',
        'cohort_export_ahi_detail': '逐夜AHI中位数',
        'cohort_export_efficiency_detail': '逐夜睡眠效率均值',
        'cohort_export_sleep_duration': '平均总睡眠时长',
        'cohort_unit_minutes_detail': '单位：分钟',
        'cohort_unit_bpm_detail': '单位：bpm',
        'cohort_export_last_report_detail': '时间窗内最新报告日期',
        'cohort_export_tags': '综合标签',
        'cohort_export_tags_detail': '多夜聚合标签',
        'cohort_export_night_device_detail': '该夜报告设备',
        'cohort_export_report_date_detail': '报告日期',
        'cohort_window_separator': '至',
        'cohort_historical_subjects': '历史受试者',
        'cohort_reports_detail_suffix': '份报告',
        'cohort_total_people_prefix': '共',
        'cohort_previous_devices_prefix': '曾用设备',
        'cohort_reported': '有报告',
        'cohort_no_report': '无报告',
        'cohort_historical_report_suffix': '份历史报告',
        'cohort_source': '来源：',
        'cohort_operation_rules_source': '队列运营规则',
        'cohort_current_operation_alert': '当前运营提醒',
        'cohort_device_issue': '设备问题',
        'cohort_active_devices_7d': '近7天活跃设备',
        'cohort_active_devices_30d': '近30天活跃设备',
        'cohort_unbound_devices_hint_prefix': '其中',
        'cohort_unbound_devices_hint_suffix': '台未进入当前受试者：请在下方分页查看',
        'cohort_view_all_devices': '查看全部',
        'cohort_unassigned_label': '未分配:',
        'cohort_selected_device_prefix': '已选',
        'cohort_unbound_subject': '未绑定受试者',
        'cohort_unassigned': '未分配',
        'cohort_usage_records_unit': '段',
        'cohort_usage_record_suffix': '段使用记录',
        'cohort_enter_batch_mode': '批量操作',
        'cohort_exit_batch_mode': '退出批量操作',
        'cohort_batch_unbind': '批量解绑',
        'cohort_batch_download_reports': '批量下载报告',
        'cohort_unbind_device': '解绑设备',
        'cohort_device_action_replace': '更换',
        'cohort_device_action_unbind': '解绑',
        'cohort_device_action_bind': '绑定',
        'cohort_device_action_history': '历史',
        'cohort_device_unbound': '未绑定',
        'cohort_last_unbind_prefix': '上次：',
        'cohort_device_history_loading': '正在加载设备历史…',
        'cohort_no_device_history': '暂无设备历史',
        'cohort_usage_interval': '使用区间',
        'cohort_end_reason': '结束原因',
        'cohort_unknown_source': '来源未知',
        'cohort_retry': '重试',
        'cohort_saving': '保存中…',
        'cohort_bed_label': '床位',
        'cohort_bed_history': '床位历史',
        'cohort_edit_bed': '编辑床位',
        'cohort_bed_edit_success': '床位已更新',
        'cohort_bed_edit_failed': '编辑床位失败',
        'cohort_gender': '性别',
        'cohort_not_set': '未设置',
        'cohort_male': '男',
        'cohort_female': '女',
        'cohort_birthdate': '出生日期',
        'cohort_height_cm': '身高（cm）',
        'cohort_weight_kg': '体重（kg）',
        'cohort_confirm_unbind_subject': '确定解绑该受试者当前设备吗？历史报告不会删除。',
        'cohort_unbind_success': '解绑成功',
        'cohort_unbind_failed': '解绑失败',
        'cohort_selected_no_bound_devices': '所选受试者没有已绑定设备',
        'cohort_confirm_batch_unbind_prefix': '确定批量解绑 ',
        'cohort_batch_unbind_success': '批量解绑完成',
        'cohort_no_reports_to_download': '所选设备暂无可下载报告',
        'cohort_batch_download_failed': '批量下载报告失败',
        'cohort_rebind_device': '更换设备',
        'cohort_bind_device': '绑定设备',
        'cohort_subject_list_load_failed': '受试者列表加载失败',
        'cohort_all_subjects_tab': '全部',
        'cohort_history_monitoring_tab': '历史监测',
        'cohort_pending_confirmation': '待确认',
        'cohort_device_list_load_failed': '设备列表加载失败',
        'cohort_assign_success_prefix': '已分配',
        'cohort_assign_success_middle': '台设备到',
        'cohort_assign_failed': '分配失败',
        'cohort_unassign_success_prefix': '已解除',
        'cohort_unassign_success_suffix': '台设备的站点分配',
        'cohort_unassign_failed': '解除分配失败',
        'cohort_device_history_load_failed': '设备历史加载失败',
        'cohort_rebind_failed': '换绑失败',
        'cohort_add_subject_failed': '添加受试者失败',
        'cohort_update_status_failed': '更新状态失败',
        'cohort_save_note_failed': '保存备注失败',
        'cohort_delete_note_failed': '删除备注失败',
        'cohort_subject_report_filter': '受试者报告筛选',
        'cohort_report_filter_description': '先按日期限定报告，再聚合为一人一行，用多夜指标筛选受试者。',
        'cohort_batch_scope_hint': '所有批量操作只作用于当前筛出的人',
        'cohort_filter_subjects': '筛选受试者',
        'cohort_filter_and_hint': '不同维度按 AND 组合；指标选择后需点击弹窗底部“确定添加”',
        'cohort_reset': '重置',
        'cohort_ahi_median_category': 'AHI 中位数分级',
        'cohort_quick_filters': '常用快速筛选',
        'cohort_multi_select_and_hint': '可多选，条件按 AND 组合',
        'cohort_save_current_filters': '保存当前条件',
        'cohort_manage': '管理',
        'cohort_sort_latest_report_desc': '末次报告从新到旧',
        'cohort_sort_report_nights_desc': '报告夜从多到少',
        'cohort_sort_ahi_desc': 'AHI 中位从高到低',
        'cohort_sort_sleep_efficiency_asc': '平均睡眠效率从低到高',
        'cohort_metric_conditions': '分析指标条件',
        'cohort_add_metric_condition': '+ 添加指标条件',
        'cohort_subject_aggregate_value': '受试者汇总值',
        'cohort_yes': '是',
        'cohort_no': '否',
        'cohort_delete': '删除',
        'cohort_no_metric_conditions': '尚未添加词典指标条件',
        'cohort_multi_night_tags': '多夜综合标签',
        'cohort_any_tag': '任一标签',
        'cohort_all_tags': '全部标签',
        'cohort_signal': '信号',
        'cohort_pending_reupload': '待补发数据',
        'cohort_completeness': '完整率',
        'cohort_device_status_hint': '第一行是报告对应设备号；第二行是筛选时间窗内逐夜报告的平均完整率。',
        'cohort_completeness_hint': '昨晚最新报告睡眠窗口内的原始数据完整率。',
        'cohort_completeness_missing_hint': '昨晚暂无可用的报告完整性结果。',
        'cohort_latest_completeness_hint': '昨晚最新报告；待补仅统计报告睡眠窗口内的队列交集。',
        'cohort_latest_completeness_full_hint': '昨晚最新报告原始数据完整，无需展示待补。',
        'cohort_missing_data': '缺失',
        'cohort_no_pending_reupload': '暂无补发',
        'cohort_pending_reupload_hint': '等待补传；时长表示待补数据量，不是完成倒计时。',
        'cohort_reupload_active_hint': '正在补传；时长表示待补数据量，不是完成倒计时。',
        'cohort_reupload_active': '补发中',
        'cohort_reupload_pending': '待补发',
        'cohort_reupload_scope_night': '夜间可能影响',
        'cohort_reupload_scope_night_hint': '包含睡眠时段，可能影响报告完整率。',
        'cohort_reupload_scope_day': '白天/窗口外',
        'cohort_reupload_scope_day_hint': '不在睡眠时段内，不影响当前报告完整率。',
        'cohort_reupload_scope_mixed': '夜间+窗口外',
        'cohort_reupload_scope_mixed_hint': '部分在睡眠时段内，可能影响报告完整率。',
        'cohort_reupload_scope_unknown': '时段待确认',
        'cohort_reupload_scope_unknown_hint': '暂时无法判断是否包含睡眠时段。',
        'cohort_report_window': '报告时间窗',
        'cohort_ahi_median': 'AHI 中位',
        'cohort_average_sleep_efficiency': '平均睡眠效率',
        'cohort_average_duration': '平均时长',
        'cohort_multi_night_summary_tags': '多夜汇总标签',
        'cohort_actions': '操作',
        'cohort_view_nights': '查看逐夜',
        'cohort_no_matching_subjects': '没有符合条件的受试者',
        'cohort_previous_page': '上一页',
        'cohort_next_page': '下一页',
        'cohort_save_quick_filter': '保存快速筛选',
        'cohort_save_filter_description': '保存当前日期、队列状态、AHI、快捷标签及指标条件。',
        'cohort_filter_name': '筛选名称',
        'cohort_manage_quick_filters': '管理快速筛选',
        'cohort_researcher_saved_filters': '研究者自己保存的筛选组合。',
        'cohort_apply': '应用',
        'cohort_no_custom_filters': '暂无自定义筛选',
        'cohort_select_export_fields': '选择导出字段',
        'cohort_export_level_hint': '先选择导出粒度，再勾选需要的字段。',
        'cohort_subject_summary': '受试者汇总',
        'cohort_nightly_details': '逐夜明细',
        'cohort_stage_details': '睡眠分期明细',
        'cohort_stage_startTime': '开始时间（本地时间）',
        'cohort_stage_endTime': '结束时间（本地时间）',
        'cohort_stage_duration': '持续秒数',
        'cohort_stage_displayStage': '睡眠分期',
        'cohort_stage_export_hint': '按分期段逐行导出，时间使用该报告记录的用户本地时区',
        'cohort_stage_export_busy': '正在导出…',
        'cohort_stage_export_missing': '该报告没有可导出的最终分期数据',
        'cohort_stage_export_identity_error': '报告归属已变化，请刷新后重试',

        'cohort_select_all': '全选',
        'cohort_clear': '清空',
        'cohort_export_excel': '导出Excel',
        'cohort_select_available_metrics': '选择已接入指标',
        'cohort_metric_picker_description': '这里只展示当前安徽队列快照中有真实字段、能够执行筛选的指标',
        'cohort_metric_picker_filterable_only': '仅展示当前可以实际筛选的Wuji Data指标',
        'cohort_confirm_add': '确定添加',
        'cohort_total_sleep': '总睡眠',
        'cohort_single_night_report': '单夜报告',
        'cohort_export_raw_data': '导出原始数据',
        'cohort_subject_device': '受试者 / 设备',
        'cohort_name_id_device_placeholder': '姓名 / ID / 设备号',
        'cohort_report_start_date': '报告开始日期',
        'cohort_report_end_date': '报告结束日期',
        'cohort_queue_status': '队列状态',
        'cohort_ahi_median_value': 'AHI 中位数',
        'cohort_average_sleep_duration': '平均睡眠时长',
        'cohort_average_sleep_heart_rate': '平均睡眠心率',
        'cohort_sort': '排序',
        'cohort_threshold': '阈值',
        'cohort_upper_limit': '上限',
        'cohort_filter_name_example': '例如：监测中或已完成 + AHI≥15',
        'cohort_metric_search_placeholder': '搜索：HRV、REM、呼吸率、温度、睡眠年龄…',
        'cohort_delete_subject': '删除受试者',
        'cohort_deleting_subject': '删除中…',
        'cohort_delete_subject_confirmation': '删除后，该受试者将从 Research 受试者列表及统计中移除，并解除当前设备绑定。历史睡眠报告和用户身份仍保留，不会删除。此操作无法在页面撤销，确定继续吗？',
        'cohort_delete_subject_success': '受试者已从 Research 移除，历史报告仍保留',
        'cohort_delete_subject_failed': '删除受试者失败，请重试',
        'cohort_delete_subject_reload_failed': '受试者已移除，但列表刷新失败，请刷新页面',
        'cohort_add_subject': '添加受试者',
        'cohort_device_operations': '设备运营',
        'cohort_subject_notes': '受试者 / 备注',
        'cohort_existing_report_interval': '已有报告区间',
        'cohort_last_30_nights_status': '最近30夜状态',
        'cohort_current_issues': '当前问题',
        'cohort_add_note': '+ 添加备注',
        'cohort_last_30_nights_legend': '最近30夜：蓝色有报告 · 灰色无报告',
        'cohort_20_per_page': '20条/页',
        'cohort_50_per_page': '50条/页',
        'cohort_100_per_page': '100条/页',
        'cohort_device_operations_description': '查看当前设备、轮转历史和站点分配',
        'cohort_current_device': '当前设备',
        'cohort_site_assignment': '站点分配',
        'cohort_pending_recovery_confirmation': '待回收/确认',
        'cohort_pending_recovery_devices': '待回收/确认设备',
        'cohort_recovery_devices_description': '包括受试者已结束、近30天无活跃，以及未进入当前受试者的设备。',
        'cohort_no_recovery_devices': '当前没有待回收设备。',
        'cohort_assign': '分配',
        'cohort_unassign': '解除',
        'cohort_subject_device_history': '受试者设备使用记录',
        'cohort_previous_devices': '曾用设备',
        'cohort_all_usage_records': '全部使用记录',
        'cohort_device_history_explanation': '当前设备不计入“曾用设备”；只有确认使用过其他设备时才显示入口。孤立解绑、无法确认实际使用者的记录不计入。',
        'cohort_effective_date': '生效日期',
        'cohort_new_device_id': '新设备号',
        'cohort_replacement_reason': '更换原因',
        'cohort_please_select': '请选择',
        'cohort_reason_device_failure': '原设备故障',
        'cohort_reason_device_recovery': '设备回收',
        'cohort_reason_device_lost': '设备丢失',
        'cohort_reason_organization_change': '机构调整',
        'cohort_reason_data_correction': '录入纠错',
        'cohort_other': '其他',
        'cohort_notes': '备注',
        'cohort_rebind_explanation': '历史报告仍保留在原设备和原时间段下；新设备仅对生效日期后的数据生效。',
        'cohort_confirm_rebind': '确认换绑',
        'cohort_add_subject_description': '先建立队列成员，睡眠报告仍由设备数据源自动关联。',
        'cohort_name_or_masked_name': '姓名或脱敏称呼',
        'cohort_hospital_record_number': '住院号 / 病案号',
        'cohort_device_id': '设备号',
        'cohort_study_group': '研究分组',
        'cohort_add_subject_default_hint': '添加后默认处于“监测中”。未分配设备时不会产生逐夜报告，可后续补充设备号。',
        'cohort_add': '添加',
        'cohort_subject_note': '受试者备注',
        'cohort_note_privacy_hint': '可记录住院号、病案号、科室、病区、研究分组等便于定位的信息。',
        'cohort_delete_note': '删除备注',
        'cohort_unique_bound_identities': '绑定身份去重',
        'cohort_all_nightly_reports': '全部逐夜报告',
        'cohort_unlinked_identity': '未关联身份',
        'cohort_reports_without_bound_identity': '有报告但无绑定身份',
        'cohort_monitoring_search_placeholder': '搜索姓名 / 受试者ID / 设备号 / 备注',
        'cohort_site_name_placeholder': '输入站点名称',
        'cohort_new_device_placeholder': '输入新设备号',
        'cohort_handover_note_placeholder': '可填写交接说明',
        'cohort_masked_name_example': '例如：张*明',
        'cohort_patient_locator_hint': '用于定位患者',
        'cohort_device_optional_hint': '可以暂不分配',
        'cohort_study_group_example': '例如：观察组',
        'cohort_location_note_placeholder': '科室、病区、责任人或其他定位信息',
        'cohort_note_example': '例如：住院号 ZY20260812；呼吸科；睡眠中心病区；项目A组',
        'cohort_current_site': '当前站点:',
        'cohort_global_view': '全局视图',
        'cohort_settings': '队列设置',
        'cohort_progress': '队列进度',
        'cohort_status_adjust_hint': '状态可在“监测运营”逐人调整',
        'cohort_planned_recruitment': '计划招募',
        'cohort_current_completion': '当前完成',
        'cohort_to_be_filled': '待填写',
        'cohort_real_bound_identities': '真实绑定身份人数',
        'cohort_monitoring': '监测中',
        'cohort_reports_in_last_30_days': '人近30天有报告',
        'cohort_completed': '已完成',
        'cohort_completed_exit_detail': '完成计划后退出活跃队列',
        'cohort_early_termination': '提前终止',
        'cohort_termination_detail': '未完成计划规定随访',
        'cohort_device_ledger_activity': '设备台账与活跃度',
        'cohort_device_ledger': '设备台账',
        'cohort_last_7_days_active': '近7天活跃',
        'cohort_last_30_days_active': '近30天活跃',
        'cohort_historical_inactive': '历史/不活跃',
        'cohort_reports': '报告',
        'cohort_nightly_report_output': '逐夜报告产出',
        'cohort_historical_reports': '历史报告',
        'cohort_last_7_days_reports': '近7天报告',
        'cohort_received_today': '今日收到',
        'cohort_site_overview': '分中心概览',
        'cohort_site_comparison_description': '各站点设备与受试者分布对比',
        'cohort_sites_unit': '个站点',
        'cohort_site': '站点',
        'cohort_device_count': '设备数',
        'cohort_subject': '受试者',
        'cohort_unassigned_site': '未分配站点',
        'cohort_recruitment_progress_section': '招募进展',
        'cohort_recruitment_data_description': '计划招募可待填写；其余数据来自当前真实受试者。',
        'cohort_set_plan': '设置计划',
        'cohort_enrollment_progress': '累计入组进度',
        'cohort_enrolled': '已入组',
        'cohort_planned_people': '计划人数',
        'cohort_new_this_week': '本周新增',
        'cohort_remaining_slots': '剩余名额',
        'cohort_member_change_7d': '近7天成员变化',
        'cohort_member_change_description': '入组与退出趋势，以及当前队列规模。',
        'cohort_view_subjects': '查看受试者',
        'cohort_opening_monitoring': '期初监测中',
        'cohort_new_entries_7d': '近7天新进入',
        'cohort_resumed_monitoring': '恢复监测',
        'cohort_current_monitoring': '当前监测中',
        'cohort_date': '日期',
        'cohort_new_entries': '新进入',
        'cohort_monitoring_that_day': '当日监测中',
        'cohort_today_pending': '今日待处理',
        'cohort_as_of': '截至',
        'cohort_items_unit': '项',
        'cohort_no_pending_today': '今日没有待处理事项',
        'cohort_collapse_current_issues': '收起当前问题',
        'cohort_expand_remaining_issues': '展开其余',
        'cohort_current_issues_suffix': '项当前问题',
        'cohort_settings_description': '只配置研究管理信息，不改变真实睡眠报告。',
        'cohort_planned_recruitment_people': '计划招募人数',
        'cohort_target_placeholder': '待填写，例如120',
        'cohort_target_optional_hint': '未确定时可以留空，概览会显示“待填写”。',
        'cohort_inclusion_criteria': '纳入标准',
        'cohort_inclusion_placeholder': '纳入标准',
        'cohort_exclusion_criteria': '排除标准',
        'cohort_exclusion_placeholder': '排除标准',
        'cohort_placeholder_suffix': '待填写',
        'cohort_operation_rules': '运营规则',
        'cohort_rules_effect_hint': '保存后直接影响今日待处理与受试者当前问题',
        'cohort_no_report_rule': '连续无报告',
        'cohort_no_report_rule_description': '监测中的受试者连续无报告达到阈值时，生成报告生成问题',
        'cohort_suspected_completion_rule': '疑似完成待确认',
        'cohort_suspected_completion_description': '监测中且长时间无报告时，提示确认是否已完成或提前终止',
        'cohort_cancel': '取消',
        'cohort_save': '保存',
        'cohort_overview_load_failed': '队列概览加载失败',
        'cohort_recruitment_target_missing_prediction': '计划招募人数待填写，填写后自动显示完成率、剩余名额和预计完成时间。',
        'cohort_no_recent_enrollment_prediction': '近7天没有可识别的新入组记录，暂不预测完成时间。',
        'cohort_recruitment_prediction_prefix': '按近7天新增',
        'cohort_recruitment_prediction_middle': '人估算，预计约',
        'cohort_recruitment_prediction_suffix': '周完成招募。',
        'cohort_save_config_failed': '保存队列配置失败',
        'cohort_assistant_title': 'SleepReport 助手',
        'cohort_assistant_subtitle': '操作帮助 · BCG监测垫 · 技术与准确性',
        'cohort_clear_conversation': '清空对话',
        'cohort_assistant_welcome': '你好，我是 SleepReport AI 助手，可以回答关于睡眠监测、指标含义、平台操作的问题。\n\n试试问我：',
        'cohort_prompt_export': '怎么批量导出数据？',
        'cohort_prompt_sleep_efficiency': '睡眠效率怎么算？',
        'cohort_prompt_ahi_normal': 'AHI 多少算正常？',
        'cohort_prompt_missing_days': '怎么看哪天没监测？',
        'cohort_prompt_sleep_latency': '入睡潜伏期是什么？',
        'cohort_prompt_rebind': '怎么换绑设备？',
        'cohort_prompt_filter_person': '怎么按人筛选？',
        'cohort_prompt_hrv_rmssd': 'HRV RMSSD 是什么？',
        'cohort_prompt_deep_sleep_ratio': '深睡占比多少正常？',
        'cohort_prompt_enter_queue': '怎么进入一个队列？',
        'cohort_prompt_mat_principle': '监测垫是什么原理？',
        'cohort_prompt_spo2': '能测血氧吗？',
        'cohort_prompt_ahi_grading': 'AHI 怎么分级？',
        'cohort_prompt_export_raw': '怎么导出原始数据？',
        'cohort_error_rate_limit': '请求过于频繁，请稍后再试',
        'cohort_error_rate_limit_hint': '请求太频繁了，请等几秒后再试。',
        'cohort_error_answer_failed': '抱歉，回答时出现了问题。请稍后重试，或换一种问法。',
        'cohort_close': '关闭',
        'cohort_recovery_unbound': '未进入当前受试者，待确认回收或重新分配',
        'cohort_recovery_completed': '受试者已完成',
        'cohort_recovery_terminated': '受试者提前终止',
        'cohort_recovery_inactive': '历史设备，近30天未活跃',
        'cohort_no_report': '无报告',
        'cohort_close': '关闭',
        'cohort_recovery_unbound': '未进入当前受试者，待确认回收或重新分配',
        'cohort_recovery_completed': '受试者已完成',
        'cohort_recovery_terminated': '受试者提前终止',
        'cohort_recovery_inactive': '历史设备，近30天未活跃',
        'cohort_no_report': '无报告',
        'cohort_source_prefix': '依据：',
        'cohort_assistant_placeholder': '问操作、监测原理或准确性…',
        'cohort_assistant_disclaimer': '产品与技术助手，不替代医生诊断；准确性数字以正式验证材料为准。',
        'cohort_assistant_welcome': '你好，我是 SleepReport 助手。\n\n我可以帮你：\n1. 查找当前页面的操作方法；\n2. 了解BCG睡眠监测垫的技术原理和指标；\n3. 解释准确性、适用范围和能力边界。',
        'cohort_prompt_real_subjects': 'GHABS有多少真实受试者？',
        'cohort_prompt_real_reports': '有多少真实报告？',
        'cohort_prompt_switch_queue': '怎么切换队列？',
        'cohort_prompt_missing_monitoring': '怎么看哪天没监测？',
        'cohort_prompt_active_seven_days': '哪些是近7天活跃？',
        'cohort_prompt_device_history': '怎么看设备历史？',
        'cohort_prompt_filter_subject': '怎么按人筛选？',
        'cohort_prompt_batch_export': '怎么批量导出？',
        'cohort_prompt_open_night_report': '怎么打开单夜报告？',
        'cohort_prompt_enter_queue': '怎么进入一个队列？',
        'cohort_prompt_archived_meaning': '归档队列是什么意思？',
        'cohort_prompt_bcg_principle': '监测垫是什么原理？',
        'cohort_prompt_spo2': '能测血氧吗？',
        'cohort_prompt_accuracy': '准确性怎么样？',
        'cohort_assistant_unparsed': '抱歉，这个问题暂时无法解析。你可以换一种问法。',
        'cohort_assistant_error': '抱歉，刚才回答时出现了异常。页面不会受影响，你可以重新提问，或使用下方快捷问题。',
        'cohort_answer_dropout_definition': '严谨口径：\n• 已完成：按研究方案完成规定的全部监测或随访终点；\n• 提前终止（常被统称为脱落）：入组后，在达到规定终点前永久停止参与，或无法继续获得方案要求的随访数据；\n• 失访：提前终止的一种原因，指按方案规定的联系程序仍无法获得受试者结局或随访数据。\n\n短期漏测、设备故障或暂时联系不上，只能标记为“中断风险”，不能直接算脱落。脱落也不等于从分析中剔除，既往数据如何使用取决于知情同意、方案和分析集定义。',
        'cohort_action_view_monitoring': '查看监测运营',
        'cohort_action_view_overview': '查看队列概览',
        'cohort_action_enter_monitoring': '进入监测运营',
        'cohort_action_enter_report_management': '进入报告管理',
        'cohort_action_choose_queue': '选择队列',
        'cohort_action_view_in_monitoring': '在监测运营中查看',
        'cohort_answer_subject_snapshot_prefix': '安徽一附院真实数据快照：',
        'cohort_answer_historical_subjects': '历史受试者：',
        'cohort_answer_active_30d': '近30天活跃：',
        'cohort_answer_active_7d': '近7天活跃：',
        'cohort_answer_historical_reports': '历史报告：',
        'cohort_answer_no_recruitment_target': '当前没有正式招募目标。',
        'cohort_answer_today_preview': '今日监测预览数据：\n• 应监测：87人\n• 有效报告：65人\n• 无效报告：3人\n• 未上报：19人\n\n65 + 3 + 19 = 87。',
        'cohort_answer_device_preview': '设备运营预览数据：\n• 设备总量：106台\n• 当前使用：87台\n• 使用率：82%\n• 闲置可用：12台\n• 待回收：4台\n• 维护中：3台\n\n这些数字用于交互预览。',
        'cohort_answer_replace_device': '在「监测运营」中找到受试者，点击“更换设备”：\n1. 选择闲置可用设备；\n2. 设置生效时间与原因；\n3. 确认新旧绑定区间。\n\n历史报告仍归原绑定，新报告从生效时间起归新设备。',
        'cohort_answer_monitoring_continuity': '受试者行中的“逐夜监测连续性”可直接查看：\n蓝色=有效监测，黄色=报告无效，灰色=当夜未监测到。\n悬停格子可查看具体夜晚。',
        'cohort_answer_batch_export': '进入「报告管理」并筛出目标受试者，开启批量模式后可导出：\n1. 受试者汇总，一人一行；\n2. 所选受试者的逐夜明细，一晚一行。',
        'cohort_answer_open_night_report': '在报告管理中点击受试者的“查看逐夜”，再点击某一夜的“单夜报告”，即可打开原SleepReport完整报告。返回时会保留原筛选条件。',
        'cohort_answer_switch_queue': '点击左侧当前队列卡片中的“切换队列”，或进入队列选择页。进行中的队列可操作，已归档队列为只读，筹备中队列暂不可进入。',
        'cohort_answer_bcg_principle': '监测垫采用非接触BCG（弹道心冲击图）压电传感。人体躺在床上时，心搏、呼吸和体动会引起床面微小机械振动，传感器采集这些振动后，通过算法反演心率、呼吸、体动、睡眠分期等指标。\n\n它不要求佩戴电极或手环，适合长期居家连续监测。',
        'cohort_source_bcg': '产品能力事实底座：BCG压电床垫采集床面机械振动',
        'cohort_answer_metrics': '监测垫可产出：\n• 睡眠时间、入睡潜伏期、睡后清醒、睡眠效率；\n• 睡眠分期、夜醒、深睡和REM；\n• 心率、HRV、呼吸率；\n• AHI、打鼾和呼吸事件；\n• 体动；\n• 温度、湿度、光照等环境指标。\n\n具体指标可在单夜报告和趋势页查看。',
        'cohort_source_schema': 'dreama睡眠数据schema：睡眠、心率、HRV、呼吸、环境等字段',
        'cohort_answer_spo2': '不能直接测量。当前监测垫没有PPG、SpO₂或ECG硬件：\n• 不能提供真实血氧饱和度；\n• 不能提供PPG波形；\n• 不能分析ECG波形或ST段。\n\n心率、呼吸率、HRV、分期和AHI等指标由BCG床面机械振动信号反演。',
        'cohort_source_hardware_boundary': '硬件能力边界：无PPG、SpO₂、ECG传感器',
        'cohort_answer_accuracy_numbers': '我不能在没有核对原始论文或验证报告时给出具体百分比。不同指标和阈值的结果不同：睡眠分期常看Kappa/准确率，AHI筛查常按≥5、≥15、≥30分别看灵敏度和特异度。\n\n当前能确认的是已开展多中心PSG同步对照验证；如需正式数字，需要指定指标和阈值后回BCGNet论文或验证报告核对。',
        'cohort_source_accuracy_rule': '准确性数字引用规则：按指标、阈值和数据集核对原始材料',
        'cohort_answer_accuracy': '准确性需要按指标分别看，不能用一个“总体准确率”概括。\n\n目前已有的证据方向包括：\n• 与PSG同步采集，对睡眠分期和AHI进行多中心验证；\n• BCGNet相关成果已发表；\n• 团队材料记载联合12家医院、6000+人晚平行数据，但具体准确率、Kappa、灵敏度和特异度在正式对外引用前必须回原始论文或验证报告核对。\n\n因此可以说“经过多中心PSG对照验证”，但不应在未核原文时随意报具体百分比。',
        'cohort_source_bcgnet': 'BCGNet：睡眠分期/AHI验证工作',
        'cohort_source_multicenter': '五季研发材料：多中心PSG平行验证，具体数字引用前核对',
        'cohort_answer_medical_device': '监测垫已取得国家二类医疗器械注册。具体注册证适用范围、产品名称和可用于何种医疗场景，应以注册证原文为准；科研或宣传材料不能把监测和筛查能力扩大表述为确诊能力。',
        'cohort_source_medical_device': '产品事实底座：国家二类医疗器械注册',
        'cohort_answer_diagnosis': 'SleepReport助手可解释产品数据和操作，但不替代医生诊断。AHI、睡眠分期等监测结果可用于筛查、研究和趋势观察；如出现明显异常、持续不适或需要确诊，应结合临床评估及必要的PSG等检查。',
        'cohort_answer_fallback': '我暂时没有在预置知识中找到足够可靠的答案。你可以换一种问法，或问我：\n• 页面怎么操作；\n• BCG监测原理；\n• 能测什么、不能测什么；\n• 睡眠分期或AHI的验证情况。',
        'cohort_status_normal_monitoring': '正常监测',
        'cohort_status_expiring': '即将到期',
        'cohort_status_needs_attention': '需要处理',
        'cohort_subject_preview_title': '的预览数据：',
        'cohort_subject_current_device': '当前设备：',
        'cohort_subject_status': '状态：',
        'cohort_subject_valid_nights': '有效夜：',
        'cohort_subject_adherence': '依从性：',
        'cohort_subject_ahi_median': 'AHI中位数：',
        'cohort_subject_sleep_efficiency': '睡眠效率：',
        'cohort_subject_last_report': '末次报告：',
        'cohort_subject_preview_disclaimer': '以上为原型预览数据。',
        'cohort_metric_report_nights': '报告夜数',
        'cohort_category_report': '报告',
        'cohort_unit_nights': '夜',
        'cohort_metric_data_missing_rate': '数据缺失率',
        'cohort_metric_report_compute_time': '报告计算耗时',
        'cohort_unit_seconds': '秒',
        'cohort_metric_bedtime_clock': '上床时刻',
        'cohort_category_sleep_timing': '睡眠时相',
        'cohort_unit_hours': '小时',
        'cohort_metric_light_off_clock': '关灯时间',
        'cohort_metric_sleep_onset_clock': '入睡时刻',
        'cohort_metric_wake_clock': '醒来时刻',
        'cohort_metric_light_on_clock': '开灯时间',
        'cohort_metric_leave_bed_clock': '离床时刻',
        'cohort_metric_sleep_midpoint': '睡眠中点',
        'cohort_metric_bedtime_variability': '上床时间波动',
        'cohort_unit_minutes': '分钟',
        'cohort_metric_wake_time_variability': '起床时间波动',
        'cohort_metric_sleep_midpoint_variability': '睡眠中点波动',
        'cohort_metric_total_in_bed_minutes': '在床总时长',
        'cohort_category_sleep_duration': '睡眠时长',
        'cohort_metric_total_sleep_minutes': '总睡眠时长',
        'cohort_metric_sleep_onset_latency': '入睡潜伏期',
        'cohort_metric_wake_after_sleep_onset': '睡后清醒时长',
        'cohort_metric_awake_minutes': '清醒时长',
        'cohort_metric_pre_sleep_bed_activity_minutes': '睡前在床活动',
        'cohort_metric_high_light_minutes': '高光照时长',
        'cohort_metric_sleep_debt': '睡眠债务',
        'cohort_metric_daily_sleep_debt': '当日睡眠债务',
        'cohort_metric_sleep_need': '建议睡眠时长',
        'cohort_metric_rem_minutes': 'REM睡眠时长',
        'cohort_category_sleep_architecture': '睡眠结构',
        'cohort_metric_rem_ratio': 'REM睡眠占比',
        'cohort_metric_rem_latency': 'REM潜伏期',
        'cohort_metric_deep_sleep_minutes': '深睡眠时长',
        'cohort_metric_deep_sleep_ratio': '深睡眠占比',
        'cohort_metric_core_sleep_minutes': '核心睡眠时长',
        'cohort_metric_core_sleep_ratio': '核心睡眠占比',
        'cohort_metric_light_sleep_minutes': '浅睡眠时长',
        'cohort_metric_light_sleep_ratio': '浅睡眠占比',
        'cohort_metric_n1_minutes': 'N1睡眠时长',
        'cohort_metric_n1_ratio': 'N1睡眠占比',
        'cohort_metric_n2_minutes': 'N2睡眠时长',
        'cohort_metric_n2_ratio': 'N2睡眠占比',
        'cohort_metric_n3_minutes': 'N3睡眠时长',
        'cohort_metric_n3_ratio': 'N3睡眠占比',
        'cohort_metric_wake_count': '夜间醒来次数',
        'cohort_unit_times': '次',
        'cohort_metric_long_wake_count': '长时间清醒次数',
        'cohort_metric_long_wake_minutes': '长时间清醒总时长',
        'cohort_metric_sleep_efficiency': '睡眠效率',
        'cohort_category_sleep_quality': '睡眠质量',
        'cohort_metric_quality_score': '睡眠质量总分',
        'cohort_unit_points': '分',
        'cohort_metric_sleep_score': '睡眠评分',
        'cohort_metric_regularity_index': '睡眠规律性指数',
        'cohort_metric_sleep_fragmentation_index': '睡眠碎片化指数',
        'cohort_metric_timing_score': '作息时间评分',
        'cohort_metric_tst_score': '睡眠时长评分',
        'cohort_metric_efficiency_score': '睡眠效率评分',
        'cohort_metric_deep_sleep_score': '深睡眠评分',
        'cohort_metric_rem_score': 'REM睡眠评分',
        'cohort_metric_wake_score': '夜醒评分',
        'cohort_metric_onset_score': '入睡评分',
        'cohort_metric_hygiene_score': '睡眠卫生评分',
        'cohort_metric_satisfaction': '睡眠满意度',
        'cohort_metric_restful_score': '安稳度评分',
        'cohort_metric_avg_resp_rate': '平均呼吸率',
        'cohort_category_respiration_snoring': '呼吸与鼾声',
        'cohort_unit_per_minute': '次/分钟',
        'cohort_metric_min_resp_rate': '最低呼吸率',
        'cohort_metric_max_resp_rate': '最高呼吸率',
        'cohort_unit_per_hour': '次/小时',
        'cohort_metric_oahi': '阻塞性AHI',
        'cohort_metric_ahi_nrem': 'NREM期间AHI',
        'cohort_metric_ahi_rem': 'REM期间AHI',
        'cohort_metric_ahi_deep': '深睡期间AHI',
        'cohort_metric_ahi_core': '浅睡期间AHI',
        'cohort_metric_oahi_rem': 'REM期间OAHI',
        'cohort_metric_oahi_nrem': 'NREM期间OAHI',
        'cohort_metric_oahi_core': '浅睡期间OAHI',
        'cohort_metric_oahi_deep': '深睡期间OAHI',
        'cohort_metric_snore_index': '打鼾指数',
        'cohort_metric_snore_event_count': '打鼾事件数',
        'cohort_metric_rrv_mean': '呼吸率变异均值',
        'cohort_metric_respiratory_interval_ri': '呼吸间期RI',
        'cohort_metric_respiratory_interval_sdri': '呼吸间期SDRI',
        'cohort_metric_respiratory_interval_cv': '呼吸间期变异系数',
        'cohort_metric_inspiratory_time_fraction': '吸气时间占比',
        'cohort_metric_avg_heart_rate': '平均心率',
        'cohort_category_heart_rate': '心率',
        'cohort_metric_min_heart_rate': '最低心率',
        'cohort_metric_max_heart_rate': '最高心率',
        'cohort_metric_resting_heart_rate': '静息心率',
        'cohort_metric_hr_rem_avg': 'REM期间平均心率',
        'cohort_metric_hr_deep_avg': '深睡期间平均心率',
        'cohort_metric_hr_core_avg': '核心睡眠期间平均心率',
        'cohort_metric_hr_light_avg': '浅睡期间平均心率',
        'cohort_metric_heart_rate_range': '夜间心率极差',
        'cohort_metric_hrv_rmssd': 'HRV RMSSD均值',
        'cohort_metric_hrv_ratio': 'HRV比率',
        'cohort_metric_hrv_morning': '早间HRV',
        'cohort_metric_hrv_evening': '晚间HRV',
        'cohort_metric_hrv_delta': 'HRV变化量',
        'cohort_metric_mean_rr': '平均RR间期',
        'cohort_metric_nn50_count': 'NN50计数',
        'cohort_metric_lf_power': '低频功率LF',
        'cohort_metric_hf_power': '高频功率HF',
        'cohort_metric_lf_hf_ratio': 'LF/HF比值',
        'cohort_metric_hrv_rem_avg': 'REM期间HRV',
        'cohort_metric_hrv_deep_avg': '深睡期间HRV',
        'cohort_metric_hrv_light_avg': '浅睡期间HRV',
        'cohort_metric_body_movement_count': '体动次数',
        'cohort_category_movement_behavior': '体动与行为',
        'cohort_metric_body_movement_index': '体动指数',
        'cohort_metric_large_movement_count': '大体动次数',
        'cohort_metric_leave_bed_count': '离床次数',
        'cohort_metric_bed_exit_minutes': '离床总时长',
        'cohort_metric_alertness_ratio': '警觉度比例',
        'cohort_metric_avg_temperature': '平均温度',
        'cohort_category_environment': '环境',
        'cohort_metric_min_temperature': '最低温度',
        'cohort_metric_max_temperature': '最高温度',
        'cohort_metric_avg_humidity': '平均湿度',
        'cohort_metric_min_humidity': '最低湿度',
        'cohort_metric_max_humidity': '最高湿度',
        'cohort_metric_avg_illumination': '平均光照',
        'cohort_metric_max_illumination': '最高光照',
        'cohort_metric_thi_score': '温湿度舒适指数',
        'cohort_metric_sleep_sufficiency': '睡眠充足度',
        'cohort_metric_body_repair': '身体修复度',
        'cohort_metric_sleep_stability': '睡眠安稳度',
        'cohort_metric_physiological_stability': '生理平稳度',
        'cohort_metric_af_burden_percent': '房颤负荷',
        'cohort_metric_stable_sleep_percent': '稳定睡眠占比',
        'cohort_metric_light_exposure_percent': '光照影响的睡眠比例',
        'cohort_metric_pre_sleep_light_lx': '睡前光照',
        'cohort_metric_post_sleep_light_lx': '醒后光照',
        'cohort_metric_chronotype': '昼夜节律类型',
        'cohort_metric_daytime_nap_minutes': '日间小睡时长',
        'cohort_metric_recovery_score': '恢复度评分',
        'cohort_category_recovery_long_term': '恢复与长期',
        'cohort_metric_aging_speed': '衰老速度',
        'cohort_metric_biological_age': '生理年龄',
        'cohort_unit_years': '岁',
        'cohort_metric_sleep_age_avg': '睡眠年龄',
        'cohort_metric_weekly_avg_tst': '周均睡眠时长',
        'cohort_metric_weekly_avg_quality': '周均睡眠质量',
        'cohort_metric_weekly_avg_deep': '周均深睡眠',
        'cohort_metric_weekly_avg_ahi': '周均AHI',
        'cohort_metric_weekly_avg_hrv': '周均HRV',
        'cohort_metric_weekly_avg_heart_rate': '周均心率',
        'cohort_metric_weekly_avg_resp': '周均呼吸率',
        'cohort_metric_weekly_avg_regularity': '周均规律性',
        'cohort_metric_weekly_avg_waso': '周均夜醒时长',
        'cohort_metric_weekly_avg_sol': '周均入睡时长',
        'cohort_metric_has_insomnia': '失眠风险标记',
        'cohort_category_insomnia_analysis': '失眠分析',
        'cohort_unit_yes_no': '是/否',
        'cohort_metric_insomnia_onset': '入睡困难型',
        'cohort_metric_insomnia_maintenance': '睡眠维持困难型',
        'cohort_metric_insomnia_early_wake': '早醒型',
        'cohort_metric_insomnia_mixed': '混合型失眠',
        'cohort_all_metrics': '全部',
        'cohort_aggregation_median': '中位数',
        'cohort_aggregation_mean': '平均值',
        'cohort_aggregation_min': '最小值',
        'cohort_aggregation_max': '最大值',
        'cohort_aggregation_latest': '最近一夜',
        'cohort_aggregation_count': '满足夜数',
        'cohort_aggregation_ratio': '满足夜占比',
        'cohort_current_queue': '当前队列',
        'cohort_switch_queue': '切换队列',
        'cohort_return_original': '返回原版',
        'cohort_return_sleepreport_original': '返回 SleepReport 原版',
        'cohort_select_queue_prompt': '请选择队列',
        'cohort_overview': '队列概览',
        'cohort_monitoring_operations': '监测运营',
        'cohort_report_management': '报告管理',
        'cohort_field_dictionary': '睡眠指标词典',
        'cohort_menu_workspace': '研究工作台',
        'cohort_menu_data': '数据资产',
        'cohort_navigation_aria': '科研站导航',
        'cohort_collapse_navigation': '收起科研站导航',
        'cohort_expand_navigation': '展开科研站导航',
        'cohort_select_queue_first': '请先选择队列',
        'cohort_data_load_failed': '队列数据加载失败',
        'cohort_experience_research': '体验科研队列',
        'cohort_data_server': '数据服务器',
        'cohort_back_to_report_management': '← 返回报告管理',
        'cohort_loading_full_report': '正在校验并加载完整报告…',
        'cohort_invalid_night_report_params': '缺少有效的队列、设备号或报告日期',
        'cohort_night_report_unavailable': '这晚完整报告暂时无法打开',
        'cohort_administrator': '管理员',
        'cohort_logout': '退出',
        'cohort_choose_queue': '选择要进入的队列',
        'cohort_queue_scope_description': '进入后，受试者、设备和报告都限定在当前队列范围内。',
        'cohort_search_queue_name': '搜索队列名称',
        'cohort_total_enrolled': '累计入组',
        'cohort_current_active': '当前活跃',
        'cohort_pending': '待处理',
        'cohort_recruitment_progress': '招募进度',
        'cohort_people_unit': '人',
        'cohort_expand_sites': '展开站点',
        'cohort_sites_available': '个站点可选',
        'cohort_collapse': '收起',
        'cohort_expand': '展开',
        'cohort_global_overview': '全局总览',
        'cohort_view_all_site_data': '查看全部站点数据',
        'cohort_enter': '进入',
        'cohort_devices_unit': '台设备',
        'cohort_active_subjects_unit': '名活跃受试者',
        'cohort_last_updated': '最近更新',
        'cohort_read_only_view': '只读查看',
        'cohort_enter_queue': '进入队列',
        'cohort_preparing': '筹备中',
        'cohort_loading_accessible_queues': '正在读取可访问队列…',
        'cohort_no_accessible_queues': '没有可访问的队列',
        'cohort_all_queues': '全部队列',
        'cohort_active_status': '进行中',
        'cohort_archived': '已归档',
        'cohort_archived_read_only': '已归档 · 只读',
        'cohort_queue_list_load_failed': '队列列表加载失败，请稍后重试',
        'cohort_rotation_history': '轮转历史',
        'cohort_historical_rotated_devices': '历史轮转设备',
        'cohort_device_unit': '台',
        'cohort_search_device_subject': '搜索设备号 / 受试者',
        'cohort_rotation_definition': '轮转设备指同一台设备先后至少有 2 名受试者产生过睡眠报告。零报告的测试绑定、误操作和孤立解绑不计入轮转。',
        'cohort_device': '设备',
        'cohort_rotated': '已轮转',
        'cohort_alerts_unit': '项提示',
        'cohort_current_prefix': '当前：',
        'cohort_unbound': '未绑定',
        'cohort_used_by_sequence': '先后使用',
        'cohort_person_unit': '人',
        'cohort_report_intervals_unit': '个报告区间',
        'cohort_events_unit': '条事件',
        'cohort_latest_binding': '最近绑定',
        'cohort_last_report': '末次报告',
        'cohort_view_timeline': '查看时间线 →',
        'cohort_no_rotation_records': '没有轮转记录',
        'cohort_actual_users_unit': '位实际使用者',
        'cohort_current_status': '当前状态',
        'cohort_current_bound': '当前绑定',
        'cohort_current_unbound': '当前未绑定',
        'cohort_current_subject': '当前受试者',
        'cohort_earliest_event': '最早事件',
        'cohort_latest_event': '最近事件',
        'cohort_record_alerts': '记录提示',
        'cohort_record_alerts_explanation': '提示只描述绑定记录缺口或报告归属差异，不据此补全使用者。',
        'cohort_segment_prefix': '第',
        'cohort_actual_usage_segment': '段实际使用记录',
        'cohort_current_use': '当前使用',
        'cohort_ended': '已结束',
        'cohort_binding_time': '绑定时间',
        'cohort_unbinding_time': '解绑时间',
        'cohort_missing_record': '记录缺失',
        'cohort_current': '当前',
        'cohort_usage_duration': '使用时长',
        'cohort_interval_reports': '区间报告',
        'cohort_reports_unit': '份',
        'cohort_report_interval': '报告区间：',
        'cohort_other_bind_operations': '查看其他绑定 / 解绑操作',
        'cohort_operations_unit': '条',
        'cohort_time_error': '时间异常',
        'cohort_days_unit': '天',
        'cohort_hours_unit': '小时',
        'cohort_minutes_unit': '分钟',
        isChinese: true,
        // Tabbar
        'summary': '摘要',
        'health': '健康',
        'details': '当日',
        'consultant': 'AI睡眠顾问',
        'sleep_advisor': 'AI睡眠健管师',
        'my': '我的',
        // 日历
        'sun': '日', 'mon': '一', 'tue': '二', 'wed': '三', 'thu': '四', 'fri': '五', 'sat': '六',
        'jan': '一月', 'feb': '二月', 'mar': '三月', 'apr': '四月', 'may': '五月', 'jun': '六月', 'jul': '七月', 'aug': '八月', 'sep': '九月', 'oct': '十月', 'nov': '十一月', 'dec': '十二月',
        'calendar_today': '今日',
        'stage_axis_awake_time': '清醒时间',
        'stage_axis_rem_sleep': '快速眼动',
        'stage_axis_core_sleep': '核心睡眠',
        'stage_axis_deep_sleep': '深度睡眠',
        // 图表
        'illuminance': '光照',
        'temperature_abbr': '温度',
        'humidity_abbr': '湿度',
        'recent_trend': '近期趋势',
        'movement': '体动',
        'few': '很少',
        'occasional': '偶尔',
        'frequent': '频繁',
        'times': '次',
        'times_abbr': '次',
        'osa_mild': '轻度',
        'osa_moderate': '中度',
        'osa_severe': '重度',
        'blood_oxygen_drop': '整晚估算血氧下降百分比',
        'normal': '正常',
        'pay_attention': '需注意',
        'mild_hypoxia': '轻度低氧',
        'moderate_severe_hypoxia': '中重度低氧',
        'non_sleep': '非睡眠',
        'personal_baseline': '个人基线区间',
        'baseline': '个人基线区间',
        'out_of_baseline': '超出基线区间',
        'sleep_stages': '睡眠分期',
        'apnea_hypopnea_events': '整晚呼吸事件',
        'obstructive_apnea_hypopnea_events': '整晚阻塞型呼吸事件',
        'average': '平均',
        'whole_night_sleeping_heart_rate': '整晚睡眠心率',
        'whole_night_hrv_rmssd': '整晚HRV',
        'whole_night_sleeping_respiratory_rate': '整晚睡眠呼吸频率',
        'nap_sleeping_heart_rate': '小睡心率',
        'nap_hrv_rmssd': '小睡HRV',
        'nap_sleeping_respiratory_rate': '小睡呼吸频率',
        'whole_night_snore_events': '整晚打鼾事件',
        'to': ' 至 ',
        'time_in_bed': '卧床时长',
        'rem_duration': '快速眼动时长',
        'deep_sleep_duration': '深睡时长',
        'in_bed': '上床',
        'get_up': '起床',
        'lowest_hr': '最低心率',
        'lowest_hr_baseline': '最低心率个人基线区间',
        'average_hr': '平均心率',
        'once': '1次',
        'twice': '2次',
        'none': '无',
        'def_evening': '典型夜型',
        'mod_evening': '偏夜型',
        'intermediate': '中间型',
        'mod_morning': '偏晨型',
        'def_morning': '典型晨型',
        'sex_index': '生理性别指数',
        'sleep_inertia': '睡眠惯性',
        'morning_peak': '上午能量高峰',
        'afternoon_dip': '下午能量低谷',
        'stop_caffeine': '停止摄入咖啡因',
        'evening_peak': '夜晚能量高峰',
        'melatonin_window': '褪黑素分泌窗口',
        'sleep_preparation': '睡前放松准备',
        'stop_exercise': '停止剧烈运动',
        'stop_eating': '停止大量进食',
        // 首页
        'index_title': '五季医学睡眠报告',
        'sleep_quality_abbr': '睡眠质量',
        'total_sleep_time_abbr': '总睡眠时长',
        'deep_sleep_duration_abbr': '深睡时长',
        'lowest_heart_rate_abbr': '最低心率',
        'avg_hrv_rmssd_abbr': '心率变异性',
        'avg_respiratory_rate_abbr': '平均呼吸率',
        'ahi_abbr': '呼吸暂停低通气指数',
        'oahi_abbr': '阻塞性呼吸暂停低通气指数',
        'date': '日期',
        'from': '来自',
        'today_summary': '今日摘要',
        'report_summary': '报告摘要',
        'connection': '连接',
        'disconnected': '断开',
        'sleep_score': '睡眠质量',
        'sleep_time': '睡眠时长',
        'deep_sleep': '深睡眠',
        'wake': '清醒',
        'rem': '快速眼动',
        'light': '浅睡',
        'deep': '深睡',
        'active': '活动',
        'leave_bed': '离床',
        'signal_missing': '数据缺失',
        'signal_missing_description': '网络不稳导致信号丢失\n设备正在补传中，请保持通电。',
        'ahi': '呼吸暂停低通气指数(AHI)',
        'oahi': '阻塞性呼吸暂停低通气指数(OAHI)',
        'lowest_heart_rate': '睡眠最低心率',
        'hrv': '心率变异性(HRV)',
        'bpm': '次/分',
        'ms': '毫秒',
        's': '秒',
        'light_ratio': '光照影响',
        'light_ratio_short': '光照影响',
        'temperature': '温度',
        'humidity': '湿度',
        'nodata': '无数据',
        'nodata_abbr': '无',
        'select_feel': '请选择睡眠感受',
        'recorded_feel': '记录的睡眠感受',
        'osa_healthy': '正常',
        'osa_mild_risk': '轻度风险',
        'osa_moderate_risk': '中度风险',
        'osa_severe_risk': '重度风险',
        'status_normal': '正常',
        'status_equal': '持平',
        'status_low': '偏低',
        'status_high': '偏高',
        'status_improved': '提升',
        'status_reduced': '减少',
        'status_insufficient': '不足',
        'status_excessive': '偏多',
        'status_normal': '正常',
        'status_stable': '稳定',
        'status_abnormal': '异常',
        'status_optimal': '适宜',
        'status_below': '偏低', //'低于基线',
        'status_above': '偏高', //'高于基线',
        'status_no_baseline': '无数据',
        'time_min': '分',
        'time_minute': '分钟',
        'time_hr': '时',
        'time_hours': '小时',
        'time_days': '天',
        'err_login': '立即开始使用睡眠监测垫，了解自己的睡眠。请先登录并绑定设备编号。',
        'err_bind': '立即开始使用睡眠监测垫，了解自己的睡眠。请先绑定设备编号。',
        'err_zero': '当前尚无您的睡眠报告。立即开始使用睡眠监测垫，了解今晚的睡眠。',
        'err_network': '网络或服务错误，请稍后刷新重试。',
        'err_go_login': '去登录',
        'err_go_bind': '去绑定',
        'err_go_fill': '去填写',
        'err_contact_service': '联系客服',
        'err_check_device': '查看设备',
        'show_details': '展开',
        'hide_details': '收起',
        'before_2300': '早于23点',
        'irrelevant_activity': '无关的在床活动',
        'less_ten_min': '<10分钟',
        'less_twenty_min': '<20分钟',
        'sustained_wake': '持续清醒时长',
        'sleep_habits': '睡眠行为习惯',
        'sleep_routine': '睡眠作息',
        'dim_before_bedtime': '睡前昏暗环境',
        'bright_after_wakingup': '醒后明亮环境',
        'hygiene_score': '睡眠行为习惯评分',
        'daytime_energy': '日间精力',
        'energy_score': '今日能量',
        'energy_curve': '日间能量曲线',
        'recommended_sleep': '推荐睡眠时长',
        'expected_recovery': '预计恢复周期',
        // 恢复模块（recoveryDetailContent）
        'wakeup_recovery': '醒来恢复',
        'sleep_sufficiency': '睡眠充足度',
        'body_repair': '身体修复度',
        'sleep_stability': '睡眠安稳度',
        'physiology_stability': '生理平稳度',
        'sleep_analysis': '睡眠分析',
        'recovery_analysis': '恢复分析',
        'sleep_metrics': '睡眠指标',
        'sleep_latency': '入睡速度',
        'sleep_interruption_duration': '睡眠中断时长',
        'rem_sleep_duration': '快速眼动时长',
        'sleep_environment_detail': '睡眠环境（温度/湿度/光照）',
        'apnea_hypopnea_index_full': '呼吸暂停低通气指数',
        'lowest_and_average_heart_rate': '最低心率 / 平均心率',
        'average_hrv': '平均HRV',
        'heart_rate_variability': '心率变异性',
        'respiratory_events_distribution': '呼吸事件的分布',
        'autonomic_nervous_system_activity': '自主神经系统活性',
        'rhythm_experimental': '吸/呼周期中的心跳节律(体验版)',
        'hrv_recovery_experimental': 'HRV恢复(体验版)',
        'depression_prediction_index': '抑郁预测指数',
        'sbp_mean': '收缩压均值',
        'sbp_mean_desc': '健康人的夜间平均收缩压通常在120mmHg以下，并且会比白天平均血压低10-20%，称为正常“杓型”血压。夜间血压如果下降不足10%或反而升高（非杓型或反杓型），则提示心血管疾病风险增加。',
        'no_more_data': '没有更多数据',
        'query_failed': '查询出错',
        'previous_week': '前一周',
        'next_week': '后一周',
        'baseline_upper': '基线上限',
        'activity': '活动',
        'predicted_sleep_maintenance_duration': '睡眠预期维持时长',
        'predicted_sleep_duration': '睡着时长预测',
        'inhalation_phase_heartbeat_count': '吸气阶段心跳数',
        'exhalation_phase_heartbeat_count': '呼气阶段心跳数',
        'accumulated_sleep_debt': '累积睡眠负债',
        'daily_sleep_debt': '每日睡眠负债',
        'deep_rem_duration': '深睡 / REM 时长',
        'movement_index': '体动指数',
        // 报告详情页
        'details_title': '睡眠报告详情',
        'trends': '趋势',
        'sleep_parameters': '睡眠分析',
        'sleep_quality': '睡眠质量',
        'sleep_quality_score': '睡眠质量得分',
        'vs_yesterday': '较昨天',
        'vs_weekly_avg': '较周平均',
        // 新版首页（pageHome）
        'sleep': '睡眠',
        'recovery': '恢复',
        'sleep_score_label': '睡眠评分',
        'recovery_score_label': '恢复评分',
        'tap_to_view': '点击查看 →',
        'aging_speed': '衰老速度',
        'system_status': '系统状态',
        'sleep_structure': '睡眠结构',
        'respiratory_health': '呼吸健康',
        'heart_health': '心脏健康',
        'neuro_health': '精神神经健康',
        'sleeping_heart_rate': '睡眠心率',
        'sleeping_hrv': '睡眠心率变异性(HRV)',
        'sleeping_respiratory_rate': '睡眠呼吸频率',
        'sleep_environment': '睡眠环境',
        'data_labs': '更多数据研究',
        'generated': '生成时间',
        'total_sleep_time': '总睡眠时长',
        'sleep_efficiency': '睡眠效率',
        'sleep_onset_latency': '入睡速度',
        'wake_after_sleep_onset': '睡眠中断时长',
        'sleep_disturbance': '睡眠中断',
        'rem_sleep': '快速眼动睡眠',
        'light_sleep': '浅睡眠',
        'sleep_regularity': '睡眠规律性',
        'sleep_wakeup_time': '入睡/醒来时间',
        'nrem_ahi': '非快速眼动期AHI',
        'rem_ahi': '快速眼动期AHI',
        'nrem_oahi': '非快速眼动期OAHI',
        'rem_oahi': '快速眼动期OAHI',
        'avg_hrv_rmssd': '睡眠平均HRV',
        'avg_heart_rate': '睡眠平均心率',
        'avg_respiratory_rate': '平均呼吸频率',
        'avg_temperature': '平均温度',
        'avg_humidity': '平均湿度',
        'lowest': '最低',
        'highest': '最高',
        'light_exposure_ratio': '光照影响的睡眠比例',
        'light_exposure_ratio_short': '光照影响的睡眠',
        'ideal': '理想',
        'good': '良好',
        'fair': '一般',
        'long': '偏长',
        'too_long': '过长',
        'late': '偏晚',
        'too_late': '过晚',
        'short': '偏短',
        'too_short': '过短',
        'low': '偏低',
        'too_low': '过低',
        'little': '偏少',
        'too_little': '过少',
        'dark': '偏暗',
        'too_dark': '过暗',
        'bright': '偏亮',
        'too_bright': '过亮',
        'irregular': '不规律',
        'not_applicable': '暂无',
        'snore': '打鼾',
        'snore_analysis': '打鼾分析',
        'snore_index': '打鼾指数',
        'timing': '就寝时间',
        'daytime_nap': '日间小睡',
        // 新版睡眠详情组件（sleepDetailContent）
        'core_metrics': '核心指标',
        'last_night_sleep_structure': '昨晚睡眠结构',
        'last_night_no_report': '昨晚暂未生成报告',
        'tab_overview': '概览',
        'tab_body': '体征',
        'tab_stages': '分期',
        'tab_environment': '环境',
        'peer_position': '在同龄人中的位置',
        // 我的页（reportMyNew）
        'realtime_monitoring': '实时监测',
        'realtime_monitor_data_title': '实时监测数据',
        'realtime_heart_rate': '实时心率',
        'avg_heart_rate_unit': '平均心率（次/分）',
        'avg_respiratory_rate_unit': '平均呼吸率（次/分）',
        'other_data': '其他数据',
        'out_of_bed': '离开',
        'effective_time': '有效时间',
        'recommend_friend': '推荐好友',
        'my_reports': '我的报告',
        'sleep_breathing_report_analysis': '睡眠呼吸报告分析',
        'device_connected': '已连接设备',
        'device_online': '设备在线',
        'device_offline': '设备离线',
        'wifi_pending_config': '待配置',
        'wifi_configured': '已配置',
        'not_connected': '未连接',
        'friend_unit': '位亲友',
        'sleep_advisor_tagline': '基于睡眠监测与循证干预，陪你一步步重建好睡眠',
        'wechat_search_wuji': '微信搜一搜：五季医学',
        'nap_details': '小睡详情',
        'daytime_nap_duration': '小睡时长',
        'nap': '小睡',
        'night_sleep': '夜间睡眠',
        // 数据研究页
        'data_lab_title': '数据研究',
        'data_lab_trend_title': '数据研究',
        'back': '返回',
        'about_data_lab': '关于数据研究指标',
        'about_data_lab_details': '展示供科研评价目的的测试指标和功能，旨在为研究人员提供更多具有医学和科研价值的指标，也供有兴趣的用户更深入的探索个人健康数据。',
        'ah_events_distribution': '呼吸事件的分布',
        'avg_hrv_lfhf': '平均HRV LF/HF',
        'light_sleep_ahi': '浅睡期AHI',
        'deep_sleep_ahi': '深睡期AHI',
        'rr_plot': 'RR间期散点图',
        'rrv_plot': '呼吸间期散点图',
        'rrv': '呼吸率变异性',
        'avg_rrv': '平均呼吸率变异性',
        'resp_interval': '呼吸间期(RI)',
        'resp_sdri': '呼吸间期标准差(SDRI)',
        'resp_cv': '呼吸变异系数(CV%)',
        'resp_dc': '吸气时间分数(DC%)',
        'hrv_rri': '平均心博(RR)间期',
        'hrv_sdnn': 'RR间期标准差(SDNN)',
        'hrv_nn50': '相邻RR间期差>50次数(NN50)',
        'hrv_pnn50': 'NN50占比(pNN50)',
        'odi': '氧减指数(ODI)',
        'light_sleep_odi': '浅睡期ODI',
        'deep_sleep_odi': '深睡期ODI',
        'rem_odi': '快速眼动期ODI',
        'nrem_odi': '非快速眼动期ODI',
        'oxygen': '血氧',
        'whole_night': '整晚',
        'rem_latency': '快速眼动睡眠潜伏期',
        'cpc_index': '心肺协同指数',
        'cpc': '心肺协同',
        'cpc_coupling': '心肺耦合',
        'stable_sleep_ratio': '稳定睡眠占比',
        'sleep_entry': '入睡过程曲线',
        'sleep_entry_awake': '清醒',
        'sleep_entry_asleep': '睡着',
        'time_to_wakeup': '自然睡醒剩余时长',
        'wake_index': '清醒指数',
        'chronotype': '晨夜节律分型',
        'sleep_and_sex': '睡眠活动与生理性别',
        'circadian_rhythm': '昼夜节律',
        'circadian_strength_index': '昼夜节律强度',
        'ans_activity': '自主神经系统活性',
        'sns': '交感神经',
        'pns': '副交感神经',
        'hrv_recovery': 'HRV恢复',
        'hrv_morning': '晨间HRV',
        'hrv_evening': '夜间HRV',
        // 顾问页
        'consultant_title': 'AI睡眠顾问',
        'beta': '测试版',
        'enter_your_question': '输入您想了解的问题',
        'for_reference_only': '仅供参考，不作为医疗依据。如有疑问请咨询医师。',
        // 我的设置页
        'account_settings': '个人设置',
        'fill_in_personal_information': '填写个人信息',
        'update_personal_information': '更新个人信息',
        'bind_your_device': '绑定设备',
        'device_settings': '设备设置',
        'set_up_wifi': '配置设备的WiFi',
        'check_device_status': '查看设备状态',
        'view_manual': '使用说明',
        'times_per_hour': '次/时',
        'contact_customer_service': '联系客服',
        'forward_to_friends': '推荐给好友',
        'please_fill_in': '请填写',
        'please_set_up': '建议配置',
        'long_press_to_follow': '长按二维码关注公众号，睡眠报告自动推送。',
        'qr_overlay_long_press': '长按二维码',
        'qr_overlay_auto_push_reports': '自动推送睡眠报告',
        'qr_overlay_add_sleep_advisor': '添加助眠师·袁好梦',
        'sleep_advisor': '长按添加助眠师微信',
        'sleep_advisor_desc': '长按二维码添加助眠师',
        'sleep_advisor_title': '助眠师·袁好梦',
        'sleep_advisor_intro': '基于睡眠监测与循证干预，陪你一步步重建好睡眠',
        'binded_to': '已绑定',
        'not_binded': '尚未绑定',
        'please_login': '请先登录',
        'logout': '退出登录',
        'confirm_logout': '确定要退出登录吗？',
        'please_pair': '请先绑定设备',
        'please_authorize': '请同意授权才可正常使用',
        'register_and_login': '点击注册/登录',
        'wechat_version_low': '微信版本过低，请升级后再试',
        'getting_started': '打开新用户向导',
        'help_support': '帮助与支持',
        // 趋势页
        'health_trend_title': '趋势',
        'full_trend': '更多长期趋势',
        'about_baseline': '关于个人基线',
        'baseline_intro1': '个人基线区间展示了你的睡眠指标在大多数时间里的表现是怎样的，参考个人基线区间可以帮助了解睡眠指标的稳定性并识别异常的波动。',
        'baseline_intro2': '图表中的绿色区域表示过去60天中80%时间里的数据区间。例如，您的睡眠质量分数的个人基线区间是{vlow} - {vhigh}，这意味着在过去60天中，有80%的时间您的睡眠质量分数在{vlow}到{vhigh}之间。',
        // 长期趋势页
        'trend_title': '长期趋势',
        'month': '月',
        'year': '年',
        'previous_month': '前一月',
        'next_month': '后一月',
        'previous_year': '前一年',
        'next_year': '后一年',
        'basic_sleep_parameters': '睡眠指标',
        'rem_and_deep_duration': '快速眼动和深睡时长',
        'sleep_stages_duration': '各睡眠分期的时长',
        'sleep_stages_ahi': '不同睡眠分期的AHI',
        'lowest_and_average_heart_rate': '最低心率与平均心率',
        'lowest_hr_time': '最低心率的时间',
        'awakenings': '睡眠中断次数',
        // 个人信息页
        'personal_info_title': '填写个人信息',
        'personal_info_intro': '为了更好的提供睡眠数据的分析和解读，我们需要了解您的个人基本信息。',
        'personal_info_intro_for_friend1': '为了更好的提供睡眠数据的分析和解读，我们需要了解使用者的基本信息。',
        'personal_info_intro_for_friend2': '为了更好的提供睡眠数据的分析和解读，我们需要了解使用者的基本信息。\n\n请为编号为 <b>{did}</b> 的监测垫的使用者提供下述信息。',
        'need_personal_info': '请完善个人信息',
        'profile': '个人信息',
        'gender': '性别',
        'choose_gender': '请选择性别',
        'date_of_birth': '出生日期',
        'choose_dob': '请选择出生日期',
        'height': '身高',
        'choose_height': '请选择身高',
        'weight': '体重',
        'choose_weight': '请选择体重',
        'bmi': '身高体重指数(BMI)',
        'ever_diagnosed': '是否在医院确诊过以下睡眠障碍',
        'please_select': '请选择',
        'diagnose_none': '没有确诊过以下睡眠疾病',
        'diagnose_insomnia': '失眠',
        'diagnose_chronic_insomnia': '慢性失眠障碍',
        'diagnose_short_term_insomnia': '短期失眠障碍',
        'diagnose_insomnia_unspecified': '其他失眠障碍',
        'diagnose_breathing_disorder': '睡眠相关呼吸障碍',
        'diagnose_csa': '中枢性睡眠呼吸暂停综合征',
        'diagnose_osa': '阻塞性睡眠呼吸暂停',
        'diagnose_hypoxemia': '睡眠相关肺泡低通气障碍及睡眠相关低氧血症',
        'diagnose_other': '其他',
        'diagnose_hypersomnolence': '中枢嗜睡性疾病(如发作性睡病、过度睡眠等)',
        'diagnose_rhythm': '睡眠-清醒昼夜节律障碍',
        'diagnose_parasomnia': '异态睡眠',
        'diagnose_movement': '睡眠相关运动障碍',
        'diagnose_other_disorder': '其他类型睡眠障碍',
        'saving': '保存中',
        'save': '保存',
        'cancel': '取消',
        'confirm': '确定',
        'cm': '厘米',
        'kg': '公斤',
        'male': '男',
        'female': '女',
        'item': '项',
        'items': '项',
        'not_saved': '还没有保存',
        'confirm_not_to_save': '您修改了个人信息，是否确认不保存？',
        'error_saving': '保存出错',
        'save_completed': '保存完成',
        // 绑定设备页
        'pair_device_title': '绑定设备',
        'pair_device_intro': `每个用户只可绑定一个睡眠监测垫。设备的编号贴在主控盒的背面，为7位数字。\n\n如果要绑定新监测垫，可以直接输入新编号。如果将监测垫交给他人使用，需要先解除绑定。`,
        'new_device_number': '新的7位数字编号',
        'unpair': '解除绑定',
        'paired_with': '已绑定设备',
        'not_paired': '尚未绑定',
        'not_login': '尚未登录',
        'confirm_unpair': '确认解除绑定',
        'confirm_no_reports': '解除后，您将无法再看到这台设备上采集生成的睡眠报告。',
        'unpair_succeeded': '解除绑定成功',
        'unpair_failed': '解除绑定出错',
        'service_error': '服务出错',
        'pair_succeeded': '绑定成功',
        'pair_failed': '绑定出错',
        'already_paired': '该设备已被绑定',
        'please_unpair_first': '当前已绑定设备，请先解除绑定后再绑定新设备',
        'invalid_number': '编号错误，请检查您的输入。',
        'input_seven_digit': '请输入7位有效编号。',
        'invalid_scan': '未识别编号',
        // 蓝牙配置页
        'setup_wifi_title': '配置网络',
        'setup_wifi_intro0': '<p>配置监测垫的WiFi无线网络连接，以便及时获得睡眠监测数据。</p>',
        'setup_wifi_intro1': `<ol style="padding-left:16px;"><li>请长按主控盒背面按钮（约5秒），直到指示灯变为蓝色闪烁。</li><li style="margin-top:8px;">等待一段时间，您的设备名 <b>wuji-mat1-7位数字</b> 将显示在下方。</li></ol>`,
        'setup_wifi_intro1_m2': `<ol style="padding-left:16px;"><li>请长按主控盒屏幕下方按钮（约5秒），直到弹出WiFi配置界面。</li><li style="margin-top:8px;">等待数秒，您的设备名 <b>wuji-mat2-7位数字</b> 将显示在下方。</li></ol>`,
        'setup_wifi_intro2': `<p>请在下方点击您的设备名，等待配对成功。</p>`,
        'setup_wifi_intro3': `<p>请在下方选择您的WiFi，并输入密码。</p>`,
        'setup_wifi_intro4': `<p>正在建立WiFi连接，这可能需要一段时间，请稍候。</p>`,
        'select_device': '识别的设备：',
        'select_wifi': '请选择无线网络',
        'choose_wifi_connect': '选择要使用的无线网络',
        'password': '请输入密码',
        'input_password': 'WiFi密码',
        'log_enabled': '调试日志已打开',
        'bluetooth_error': '蓝牙功能出错：',
        'other_devices': '搜索设备：',
        'scanning': '正在搜索您的设备...',
        'scanning_more': '正在搜索更多设备...',
        'wait_while_saving': '保存中，请稍候',
        'select_wifi_first': '先选择WiFi',
        'input_password_please': '请输入密码',
        'connected': '已连接',
        'getting_service': '读取服务...',
        'get_service_completed': '读取服务成功',
        'getting_params': '读取服务参数...',
        'get_params_completed': '读取服务参数成功',
        'getting_wifi_list': '读取无线网络...',
        'wifi_items': '个无线网络',
        'no_available_wifi': '没有可用的无线网络',
        'wait_while_connecting': '正在连接WiFi，请稍候',
        'setup_completed': '配置成功',
        'back_of_controller': '背面',
        'front_of_controller': '正面',
        'led': '指示灯',
        'pair_button': '配网按钮',
        'dlg_bluetooth_error': '蓝牙功能出错',
        'dlg_make_sure_wechat_permission': '请确认打开允许微信使用蓝牙功能的相关权限。',
        'dlg_phone_low_no_bluetooth': '您的手机版本过低，不支持使用蓝牙。请更换手机后再试。',
        'dlg_refused_mp_bluetooth': '您拒绝了小程序使用蓝牙功能。请重新进入本页面，并在弹出提示时选择“允许”。',
        'dlg_no_permission_bluetooth': '因您的权限设置，无法使用蓝牙。请点击小程序右上角•••菜单>设置>蓝牙，并选择“使用小程序时允许”。',
        'dlg_no_bluetooth': '无法使用蓝牙，请先在手机设置中打开蓝牙功能。',
        'dlg_check_wechat_bluetooth': '还需要检查手机系统 “设置>隐私与安全性>蓝牙”中，是否允许微信使用蓝牙。',
        'dlg_check_location_permission': '部分安卓手机在使用蓝牙功能时，请确保先打开定位服务和允许微信使用“位置信息”和“附近设备”权限。',
        'dlg_connection_failed': '连接失败',
        'dlg_retry_connection': '请确认指示灯是蓝色闪烁状态，然后重试。',
        'dlg_ble_connection_failed': '蓝牙连接失败',
        'dlg_check_ble_retry': '请检查手机蓝牙工作正常，然后重试。',
        'dlg_wifi_scan_timeout': '扫描WiFi超时',
        'dlg_retry_wifi_scan': '请确认指示灯是蓝色闪烁状态，然后重试。',
        'dlg_no_available_wifi': '没有可用的WiFi',
        'dlg_open_router': '请确保已打开WiFi无线路由器，并重新设置。确认指示灯是蓝色闪烁状态，然后重试。',
        'dlg_ble_disconnected': '蓝牙连接断开',
        'dlg_pwd_wrong': 'WiFi密码错误',
        'dlg_check_password_retry': '请确认输入的密码是否正确，重新进行配置。',
        'dlg_error_connecting_wifi': '连接WiFi时发生错误',
        'dlg_ensure_wifi': '请确认WiFi可用，且输入的密码正确。确认指示灯是蓝色闪烁状态，然后重试。',
        'flashing_blue': '蓝灯闪烁',
        'flashing_green': '绿灯闪烁：正在连接WiFi',
        'solid_green': '绿灯常亮：WiFi连接成功',
        'long_press': '长按按钮',
        'wifi_status': 'WiFi状态',
        // 设备状态页
        'device_status_title': '设备状态',
        'device_id_label': '编号',
        'check_device': '检查设备',
        'device_status': '设备状态',
        'id_number': '编号:',
        'network_type': '网络类型',
        'last_seen_network_type': '最近连接的网络类型',
        'cellular_signal_quality': '蜂窝信号质量',
        'wifi_signal_quality': 'WiFi信号质量',
        'realtime_data': '实时监测数据',
        'timestamp': '有效时间',
        'bed_status': '在床状态',
        'status_in_bed': '在床',
        'status_out_of_bed': '离床',
        'status_na': '无',
        'status_measure': '测量中',
        'status_unknown': '未知',
        'status_connected': '正常',
        'status_no_connection': '无连接',
        'realtime_hr': '心率',
        'realtime_rr': '呼吸率',
        'troubleshooting': '查看故障排除说明',
        'resolve_no_connection': '如何解决设备无连接',
        'resolve_poor_signal': '如何解决网络信号不佳',
        'recommend_wifi': '为获得更实时稳定的睡眠数据，建议配置WiFi联网。',
        'connecting': '正在连接',
        'type_wifi': 'WiFi无线网络',
        'type_cellular': '内置蜂窝网络',
        'signal_excellent': '良好',
        'signal_good': '中等',
        'signal_weak': '较弱',
        'signal_no': '不可用',
        'error_connecting_service': '连接服务器出错',
        'please_wait': '请稍候...',
        'tip_nodata': `<p>如果不能正常显示监测数据，或出现数据时有时无的情况，请按下列操作进行排除：</p>
                <ol style="padding-left:16px; margin-top:8px;"><li>重新接入监测垫的电源，注意请使用5V 2A规格USB电源适配器；</li>
                <li>接入电源后，指示灯将先闪烁、后持续点亮约30秒，然后熄灭。这说明设备在正常工作；</li>
                <li>监测垫默认使用内置蜂窝网络（电信运营商）采集睡眠监测数据。在遇到网络信号质量不佳时，会影响数据的准确监测。请配置监测垫使用WiFi连接；</li>
                <li>若仍然不能正常显示监测数据，请联系我们为您服务。</li></ol>`, 
        'tip_low_signal': `<p>监测垫默认使用内置蜂窝网络（电信运营商）采集睡眠监测数据。在遇到蜂窝信号质量不佳时，会影响睡眠数据的准确监测。此时请配置监测垫使用WiFi连接。</p>
            <p style="margin-top: 6px;">配置WiFi后，如果信号表现为不佳（只有一格），说明监测垫可能距离WiFi路由器较远，或室内墙体阻碍信号，需考虑调整WiFi路由器的摆放，使其更靠近监测垫位置。</p>`,
        // 说明书
        'user_manual_title': '睡眠监测垫使用说明',
        'choose_model': '选择您的监测垫型号',
        'choose_model_link': '选择型号说明',
        'model_selections': '选择监测垫型号，以显示相应的说明',
        'with_screen': '带有显示屏幕',
        // 健康页
        'health_title': '健康',
        'sleep_checkup_title': '睡眠体检',
        'health_header': '基于长期监测数据，追踪睡眠健康轨迹，洞察呼吸和心血管等系统的健康状态及潜在风险。',
        'health_footer': '健康板块并非做出诊断，也不应作为治疗疾病的依据。建议您在做出医疗决策前，咨询专业医师。',
        'osa': '阻塞性睡眠呼吸暂停',
        'sleep_apnea_syndrome': '呼吸暂停综合症',
        'osa_possible_healthy': '阻塞性睡眠呼吸暂停低风险',
        'osa_possible_mild': '疑似轻度阻塞性睡眠呼吸暂停',
        'osa_possible_moderate': '疑似中度阻塞性睡眠呼吸暂停',
        'osa_possible_severe': '疑似重度阻塞性睡眠呼吸暂停',
        'comment_nodata': '正在积累您的监测数据，请保持连续进行睡眠监测14天以上。',
        'ahi_comment_no_risk': '近期AHI显示阻塞性睡眠呼吸暂停<b>低风险</b>，建议持续关注这一指标，保持良好的生活习惯。',
        'ahi_comment_possible_risk': '部分AHI偏高，建议采用侧卧睡姿、减少烟酒摄入、控制体重、避免摄入镇静类药物等。',
        'ahi_comment_mild_risk': '近期AHI显示疑似<b>轻度</b>阻塞性睡眠呼吸暂停，建议及时调整生活方式，如采用侧卧睡姿、减少烟酒摄入、控制体重、避免摄入镇静类药物等，并在必要的时候前往专业医疗机构进行进一步咨询和检查。',
        'ahi_comment_moderate_risk': '近期AHI显示疑似<b>中度</b>阻塞性睡眠呼吸暂停，建议及时调整生活方式，如采用侧卧睡姿、减少烟酒摄入、控制体重、避免摄入镇静类药物等，并前往专业医疗机构进行详细检查。',
        'ahi_comment_severe_risk': '近期AHI显示疑似<b>重度</b>阻塞性睡眠呼吸暂停，建议尽快就医进行详细诊断，并与医生讨论适合的治疗方案，如使用持续正压通气（CPAP）设备或其他干预措施。',
        'afib': '房颤检测',
        'afib_screening': '房颤筛查',
        'afib_burden': '房颤负荷',
        'whole_night_afib_events': '整晚房颤事件',
        'afib_event': '房颤事件',
        'afib_description': '房颤（AFib）是心率不齐的最常见的形式，表现为心脏的上下腔室跳动不同步。房颤本身通常并不危及生命，但是一种需要严肃对待和干预的健康状况。研究表明持续时长超过5分钟的房颤事件会显著增加中风风险，并且随着持续时长增加，风险逐渐升高。\n\n房颤负荷测量睡眠期间处于疑似房颤状态的时长占总睡眠时长的百分比。需要注意的是，房颤不代表心跳始终不规律，因此即使是较低的房颤负荷也需要引起重视，请在【健康】板块的房颤负荷指标下进一步了解近期房颤事件发生情况。\n\n此功能不能替代临床诊断。若检测到房颤发生，建议前往专业医疗机构进行进一步咨询和检查。',
        'no_afib_signs': '未检测到房颤迹象',
        'detected_afib_signs': '存在房颤迹象',
        'no_afib_signs_comment': '近期心跳节律数据中未检测到房颤迹象，建议持续关注这一指标，关注您的心脏健康。',
        'detected_afib_signs_comment': '心跳数据中识别到可能意味着房颤迹象的异常节律。房颤是一种需要严肃对待和干预的健康状况，如果您没有已知房颤病史，建议前往专业医疗机构进行进一步咨询和检查。',
        'afib_5_min': '近期持续时长超过5分钟的房颤事件次数：',
        'afib_longest': '近期最长房颤事件持续时长：',
        'sleep_health': '睡眠健康',
        'sleep_age': '睡眠年龄',
        'real_age': '真实年龄',
        'age': '年龄',
        'risk_multiplier': '健康风险比（HR）',
        // 亲友
        'friends_and_family': '亲友功能',
        'share_access': '授权给亲友',
        'my_follows': '我关注的亲友',
        'following': '关注',
        'following_people': '人',
        'followed_by': '被',
        'followed_by_people': '人关注',
        'followed_by_intro': '您可将下方显示的8位授权码告知您的亲友，对方即可在小程序中关注和查看您的全部睡眠报告。\n\n您也可以随时移除亲友对您的睡眠报告的查看权限。',
        'my_auth_code': '我的授权码',
        'share_code_p1': '10分钟内有效。可点击',
        'share_code_here': '这里',
        'share_code_p2': '转发给您的亲友。',
        'my_followers': '关注我的亲友',
        'remove': '移除',
        'follow_time': '添加时间：',
        'err_and_retry': '服务错误请重试',
        'remove_succeeded': '移除成功',
        'remove_failed': '移除失败请重试',
        'confirm_remove': '确认移除',
        'confirm_removal_of': '确认移除',
        'confirm_removal_p2': '吗？',
        'following_intro': '您可以关注亲友的睡眠报告。\n\n如果亲友已经使用小程序绑定监测垫：\n1. 您需要向亲友索要授权码（8位字母数字）；\n2. 在下方输入授权码，10分钟内有效。\n\n如果要关注的监测垫没有被绑定，请直接输入监测垫背面的设备编号。',
        'alias': '别名',
        'alias_placeholder': '请输入别名',
        'auth_code_or_device': '授权码或设备编号',
        'revoked': '失效',
        'device': '设备',
        'length_control': '不超过7个字母或汉字',
        'letters_control': '只能包含中文、英文字母和数字',
        'input_valid_code': '请输入正确的授权码或设备编号',
        'added_successfully': '添加成功',
        'limit_exceeded': '超过数量限制',
        'add_failed': '添加失败，请重试',
        'no_follow_self': '不能关注自己哦',
        'code_expired': '授权码超时',
        'code_invalid': '授权码错误',
        'confirm_follow': '确认关注',
        'confirm_follow_p1': '确认关注',
        'confirm_follow_p2': '吗？',

        // ===== Phase1 i18n补全 =====
        // 浮动菜单
        'switch_friend': '切换亲友',
        'current_badge': '当前',
        // 首页补全
        'last_night': '昨晚',
        'that_night': '当晚',
        'confirm_auth_code': '确认授权码',
        'user_info_title': '用户信息',
        'user_info_desc': '用于完善昵称/头像，以便更好地提供服务',
        'update_btn': '更新',
        'not_now': '暂不',
        'cannot_forward': '不可转发',
        'share_report_suffix': '睡眠报告',
        'share_from': '来自',
        // 健康页补全
        'neuro_brain': '神经/大脑',
        'respiratory_system': '呼吸系统',
        'cardiac_function': '心脏机能',
        'status_healthy': '健康',
        'status_abnormal': '异常',
        'keep_monitoring_14days_prefix': '请保持睡眠监测约14天，以获取',
        'keep_monitoring_14days_suffix': '数据',
        'keep_monitoring_month_prefix': '请保持睡眠监测约一个月，以获取',
        'keep_monitoring_month_suffix': '数据',
        'your_aging_speed_prefix': '您的衰老速度',
        'years_per_year': '岁/年',
        'pace_same_as_peers': '与同龄人持平',
        'pace_slower_than_peers': '慢于同龄人',
        'pace_faster_than_peers': '快于同龄人',
        'aligned_with_real_age': '与真实年龄相符',
        'age_higher_by': '偏高',
        'age_lower_by': '偏低',
        'age_unit': '岁',
        'above_real_age': '高于真实年龄',
        'below_real_age': '低于真实年龄',
        // agingPaceCard 衰老速度卡片
        'aging_pace_title': '衰老速度',
        'aging_speed_accelerate': '加速',
        'aging_speed_accelerate_label': '加速',
        'aging_speed_normal': '正常',
        'aging_speed_normal_label': '正常',
        'aging_speed_decelerate': '减缓',
        'aging_speed_decelerate_label': '较慢',
        'aging_speed_reverse': '逆龄',
        'aging_speed_slow': '慢速',
        'aging_speed_fast': '快速',
        'trend_28d_prefix': '近28天趋势',
        'insomnia_dual_trend_title': '近 30 天入睡速度与睡眠中断趋势',
        'sleep_onset_trend_title': '入睡速度',
        'sleep_disturbance_trend_title': '睡眠中断',
        'sleep_efficiency_trend_title': '睡眠效率',
        'chart_meta_30d_min': '近30天 | 分钟',
        'chart_meta_30d_percent': '近30天 | %',
        'aging_pace_label_same_recent': '今日状态与近期持平',
        'aging_pace_label_worse_recent': '今日状态比近期更差',
        'aging_pace_label_better_recent': '今日状态比近期更好',
        'aging_pace_dimension_sleep_quality': '睡眠质量',
        'aging_pace_dimension_sleep_structure': '睡眠结构',
        'aging_pace_dimension_cardiovascular': '心血管',
        'aging_pace_dimension_respiratory': '呼吸',
        'aging_pace_factor_efficiency': '睡眠效率',
        'aging_pace_factor_interruption': '睡眠中断',
        'aging_pace_factor_fragmentation': '睡眠碎片化',
        'aging_pace_factor_duration': '睡眠时长',
        'aging_pace_factor_deep_sleep': '深度睡眠',
        'aging_pace_factor_n1_sleep': 'N1浅睡',
        'aging_pace_factor_n2_sleep': 'N2睡眠',
        'aging_pace_factor_light_stages': '浅睡分期',
        'aging_pace_factor_rem_sleep': 'REM睡眠',
        'aging_pace_factor_heart_rate': '心率',
        'aging_pace_factor_hrv_time': '心率变异性(时域)',
        'aging_pace_factor_hrv_freq': '心率变异性(频域)',
        'aging_pace_factor_hrv': '心率变异性',
        'aging_pace_factor_respiratory_rate': '呼吸率',
        'aging_pace_factor_ahi': '呼吸暂停',
        'accelerate_factors': '加速因素',
        'decelerate_factors': '减缓因素',
        'top_accelerate_factor': '最大加速因素',
        'top_decelerate_factor': '最大减缓因素',
        'accelerate_pct': '加速',
        'decelerate_pct': '减缓',
        'tug_hint_accelerate': '拖你衰老的力量',
        'tug_hint_decelerate': '帮你减缓的力量',
        'no_significant_factor': '暂无明显因素',
        'view_all_factors': '查看全部因素',
        'collapse_factors': '收起',
        'unit_years_per_year': '岁/年',
        'summary_pace_flat': '昨晚的睡眠让你的衰老速度与同龄人基本持平',
        'summary_pace_fast_prefix': '昨晚的睡眠在加速你的衰老',
        'summary_pace_slow_prefix': '昨晚的睡眠在减缓你的衰老',
        'summary_mainly_because': '，主要是',
        'summary_and': '和',
        'factor_icon_frag': '碎',
        'factor_icon_eff': '效',
        'factor_icon_interruption': '断',
        'factor_icon_dur': '时',
        'factor_icon_light': '浅',
        'factor_icon_deep': '深',
        'factor_icon_n1': 'N1',
        'factor_icon_n2': 'N2',
        'factor_icon_rem': 'REM',
        'factor_icon_resp': '呼',
        'factor_icon_heart': '心',
        'factor_icon_hrv_time': '时',
        'factor_icon_hrv_freq': '频',
        'factor_icon_quality': '质',
        'factor_icon_structure': '构',
        'factor_desc_fragmentation': '夜间觉醒偏多，睡眠更容易被打断',
        'factor_desc_efficiency': '睡着比例会直接影响整夜恢复效率',
        'factor_desc_interruption': '夜间清醒时长偏多，容易削弱睡眠连续性与恢复效果',
        'factor_desc_duration': '总睡时长会直接影响夜间修复',
        'factor_desc_light_stages': '浅睡占比会影响整夜恢复质量',
        'factor_desc_deep_sleep': '深睡修复能力会影响身体恢复',
        'factor_desc_n1_sleep': 'N1浅睡比例会影响睡眠稳定性与恢复质量',
        'factor_desc_n2_sleep': 'N2睡眠比例会影响睡眠结构与恢复效率',
        'factor_desc_rem_sleep': '快速眼动睡眠会影响夜间恢复与认知修复',
        'factor_desc_respiratory_rate': '呼吸节律会影响整夜生理负担',
        'factor_desc_ahi': '呼吸事件越少，越有利于夜间恢复',
        'factor_desc_hrv_time': '心率变异性时域指标会影响自主神经恢复状态',
        'factor_desc_hrv_freq': '心率变异性频域指标会影响交感与副交感平衡',
        'factor_desc_hrv': '自主神经恢复越好，越有利于减缓衰老',
        'factor_desc_heart_rate': '夜间心率越平稳，身体负担越轻',
        'factor_desc_sleep_quality': '整体睡眠质量会影响恢复节奏',
        'factor_desc_sleep_structure': '睡眠结构会影响修复与恢复平衡',
        'factor_desc_respiratory': '呼吸状态会影响夜间恢复负担',
        'factor_desc_cardiovascular': '心血管状态会影响身体恢复压力',
        'factor_desc_accelerate_default': '该因素正在推高昨晚的衰老速度',
        'factor_desc_decelerate_default': '该因素正在帮助减缓昨晚的衰老速度',
        'sleep_heart_rate': '睡眠心率',
        'sleep_breathing': '睡眠呼吸',
        'sleep_hygiene': '睡眠卫生',
        'wx_no_nickname_toast': '微信未返回昵称，可在个人信息中手动填写',
        'compared_higher': '比真实年龄高',
        'compared_lower': '比真实年龄低',
        'your_sleep_age_is': '您的睡眠年龄为',
        'health_risk_is': '健康风险约为健康同龄人的',
        'health_risk_times': '倍',
        'health_risk_lower_than': '健康风险约比健康同龄人低',
        'health_risk_lower_suffix': '%',
        'mild_snoring': '轻度打鼾',
        'moderate_snoring': '中度打鼾',
        'severe_snoring': '重度打鼾',
        'no_snoring': '不打鼾',
        'not_found_afib': '未发现',
        'cpc_low': '偏低',
        'avoid_freq_retry': '请避免频繁操作',
        // === wuji_manager-org 后台专有 ===
        'logout': '退出登录',
        'unknown_user': '未知用户',
        'switch_language': '切换语言',
        'device_management': '设备管理',
        'report_management': '报告管理',
        'user_management': '用户管理',
        'medical_dictionary': '医学指标词典',
        // -- 登录/注册页 --
        'welcome_use': '欢迎使用',
        'wuji_sleep_workstation': '五季医学睡眠监测工作站',
        'login_account': '登录账号',
        'please_input_account': '请输入账号',
        'please_input_password': '请输入密码',
        'please_input_phone': '请输入手机号',
        'please_input_valid_phone': '请输入正确的手机号',
        'please_input_verification_code': '请输入验证码',
        'phone_number': '手机号',
        'verification_code': '验证码',
        'send_verification_code': '发送验证码',
        'resend_after_seconds': '秒后重新发送',
        'remember_password': '记住密码',
        'forgot_password': '忘记密码？',
        'login': '登录',
        'register_account': '注册账号',
        'phone_code_login': '手机验证码登录',
        'use_password_login': '使用密码登录',
        'login_failed': '登录失败',
        'login_success_loading': '登录成功！正在加载用户信息',
        'error': '错误',
        'login_err_wrong_credentials': '登录失败。请输入正确的用户或密码，在非微信浏览器中使用',
        'login_err_network': '登录失败，请检查网络或稍后再试。',
        'login_err_no_response': '服务器未响应，请稍后再试。',
        'wrong_user_or_password': '用户或密码错误',
        'send_code_failed': '发送验证码失败',
        // -- 第1批：OrgDashboard / ReportList --
        'total_devices': '总设备',
        'online_devices': '在线设备',
        'offline_devices': '离线设备',
        'today_report_success': '今日报告成功',
        'baseline_abnormal': '基线异常',
        'sd_card_error': 'SD卡故障',
        'packaging_noise': '封装噪声',
        'search_device_number': '搜索设备号',
        'search': '搜索',
        'filter_by_org': '机构筛选:',
        'please_select_org': '请选择机构',
        'device_status': '设备状态:',
        'report_generated': '已生成报告',
        'report_not_generated': '未生成报告',
        'all': '全部',
        'status_online': '在线',
        'status_offline': '离线',
        'attention_viewing': '在看',
        'enter_batch_mode': '进入批量模式',
        'exit_batch_mode': '退出批量模式',
        'settings': '设置',
        'edit': '编辑',
        'edit_info': '编辑信息',
        'delete': '删除',
        'save': '保存',
        'cancel': '取消',
        'confirm': '确定',
        'close': '关闭',
        'confirm_download': '确认下载',
        'confirm_update': '确认修改',
        'download_report': '下载报告',
        'scan_block_btn': '屏蔽扫码',
        'scan_unblock_btn': '取消屏蔽',
        'scan_block_tip': '将选中设备的扫码看报告权限关闭，用户扫码进入小程序时将无法查看报告',
        'scan_unblock_tip': '恢复选中设备的扫码看报告权限',
        'scan_blocked_label': '已屏蔽扫码',
        'scan_blocked_tip': '已屏蔽用户扫码看报告（小程序端将不显示）',
        'print': '打印',
        'pillow_control': '枕头控制',
        'device_prefix': '设备：',
        'department': '科室:',
        'department_empty': '科室: --',
        'bed_number': '床位号',
        'bed_number_colon': '床位号:',
        'remarks': '备注信息',
        'remarks_colon': '备注信息:',
        'report_update_time': '报告更新时间',
        'name_colon': '姓名:',
        'age_colon': '年龄:',
        'gender_colon': '性别:',
        'height_colon': '身高:',
        'weight_colon': '体重:',
        'ethnicity_colon': '民族:',
        'birthdate_colon': '出生日期:',
        'gender_male': '男',
        'gender_female': '女',
        'unit': '单位',
        'please_input_name': '请输入姓名',
        'please_input_bed_number': '请输入床位号',
        'please_input_height': '请输入身高',
        'please_input_weight': '请输入体重',
        'please_input_remarks': '请输备注信息',
        'please_input_new_password': '请输入新密码',
        'please_select': '请选择',
        'please_select_ethnicity': '请选择或搜索民族',
        'start_date': '开始日期',
        'end_date': '结束日期',
        'select_date': '选择日期',
        'select_date_range': '选择日期范围',
        'date_col': '日期',
        'questionnaire_history': '问卷历史记录',
        'view_history': '查看历史记录',
        'no_history': '暂无历史记录',
        'fill_questionnaire': '填写问卷',
        'select_questionnaire_type': '选择问卷类型',
        'patient_name': '患者姓名',
        'psqi_title': '匹兹堡睡眠质量指数 (PSQI)',
        'ess_title': '嗜睡量表 (ESS)',
        'psqi_desc': '评估最近一个月的睡眠质量',
        'ess_desc': '评估日间嗜睡程度',
        'psqi_total_score': 'PSQI总分',
        'psqi_submitted_at': 'PSQI提交时间',
        'ess_total_score': 'ESS总分',
        'ess_submitted_at': 'ESS提交时间',
        'password_update': '密码修改',
        'initial_password_hint': '您的密码是初始密码，请修改密码。',
        'password_min_length_hint': '请确保密码至少6位。',
        'device_info_settings': '设备信息设置',
        'field_name': '字段名称',
        'field_value': '字段值',
        'add_custom_field': '添加自定义字段',
        'download_range_hint': '提示：如果不选择日期范围，将下载所有历史报告数据。',
        'loading': '加载中',
        'loading_dot': '加载中...',
        // -- ReportList 补充 --
        'date_range_colon': '日期范围:',
        'clinical_indicators_colon': '临床指标:',
        'heart_rate': '心率',
        'view_detail': '查看详情',
        'search_device_id': '搜索设备ID...',
        'search_device_id_short': '搜索设备ID',
        // -- 注册 / 找回密码 / C端 Dashboard 补充 --
        'use_phone_code_login': '使用手机验证码登录',
        'register': '注册',
        'register_with_phone_password': '使用手机号及密码注册',
        'register_account_phone_pwd': '使用手机号及密码注册账号',
        'register_account_with_code': '使用手机验证码注册账号',
        'have_account_go_login': '已有账号，去登录',
        'retrieve_password': '找回密码',
        'save_new_password': '保存新密码',
        'please_input_password_again': '请再次输入密码',
        'go_bind': '+去绑定',
        'wuji_sleep_report': '五季医学睡眠报告',
        'wuji_sleep_monitor_device': '五季医学睡眠监护仪',
        'today': '今天',
        'realtime_rr_title': '实时呼吸率',
        'realtime_hr_title': '实时心率',
        'not_bound_arrow': '尚未绑定>',
        'sign_out': '登出',
        'sleep_monitor': '睡眠监护仪',
        'welcome_tagline': '立即开始使用睡眠监护仪，了解自己的睡眠。',
        'binding_number': '绑定编号',
        'network_signal': '网络信号质量',
        'background_image': '背景图',
        'device_info': '设备信息',
        'please_bind_first': '请先绑定设备编号。',
        'select_report_date': '选择报告日期',
        // -- 批2：报告详情 + Pillow + 用户管理 --
        'ahi_14d_trend': 'AHI近14天趋势图',
        'ess_score': 'ESS 评分',
        'imu_monitor': 'IMU 数据监控',
        'psqi_score': 'PSQI 评分',
        'x_axis_angle': 'X轴角度:',
        'y_axis_angle': 'Y轴角度:',
        'personal_info': '个人信息',
        'subjective_awakenings': '主观清醒次数',
        'subjective_sleep_quality': '主观睡眠质量',
        'supine_ahi': '仰睡AHI',
        'supine_snore_index': '仰睡打鼾指数',
        'supine_snore_energy': '仰睡鼾声能量',
        'position_abnormal': '位置异常',
        'movement_chart': '体动图',
        'movement_index_abnormal': '体动指数异常',
        'weight_setting_kg': '体重设置 (kg)',
        'experience_survey': '体验问卷',
        'lateral_ahi': '侧睡AHI',
        'lateral_snore_index': '侧睡打鼾指数',
        'lateral_ratio': '侧睡比例',
        'lateral_snore_energy': '侧睡鼾声能量',
        'sleep_onset_speed': '入睡速度',
        'other_abnormal': '其他异常',
        'birthdate': '出生日期',
        'delete_field': '删除字段',
        'action_done': '动作完成',
        'pressure_abnormal': '压阻异常',
        'pressure_posture_abnormal': '压阻睡姿异常',
        'raw_data': '原始数据',
        'sleep_stages_duration_title': '各睡眠阶段的时长',
        'respiratory_events_t': '呼吸事件',
        'respiratory_events_abnormal': '呼吸事件异常',
        'respiratory_detection_abnormal': '呼吸识别异常',
        'in_bed_t': '在床',
        'basic_info': '基本信息',
        'note': '备注',
        'remarks_empty': '备注信息: --',
        'head_stretch_intervention': '头伸干预',
        'head_stretch_duration': '头伸干预时长',
        'head_stretch_count': '头伸干预次数',
        'name': '姓名',
        'not_bound': '尚未绑定',
        'left_right_intervention': '左右干预',
        'left_right_duration': '左右干预时长',
        'left_right_count': '左右干预次数',
        'bound_device': '已绑定设备',
        'bound_device_colon': '已绑定设备：',
        'intervention': '干预',
        'pre_intervention_1min': '干预前1分钟',
        'pre_intervention_5min': '干预前5分钟',
        'post_intervention_1min': '干预后1分钟',
        'post_intervention_5min': '干预后5分钟',
        'intervention_duration': '干预时长',
        'intervention_metrics': '干预期间指标',
        'pillow_report': '干预枕报告',
        'pillow_comfort': '干预枕舒适度',
        'intervention_count': '干预次数',
        'intervention_type': '干预类型',
        'intervention_stats': '干预统计',
        'start_time': '开始时间',
        'current_weight': '当前体重',
        'current_status_colon': '当前状态：',
        'rem_and_deep_duration_t': '快速眼动和深睡时长',
        'total_intervention_duration': '总干预时长',
        'total_sleep_time_t': '总睡眠时间',
        'snore_events_abnormal': '打鼾事件异常',
        'snore_index_t': '打鼾指数',
        'snore_index_14d_trend': '打鼾指数近14天趋势图',
        'batch_unbind': '批量解绑',
        'report_failed': '报告失败',
        'report_abnormal': '报告异常',
        'report_detail': '报告详情',
        'taro_view': '移动端视图',
        'taro_view_hint': '嵌入移动端（app.wuji.com），随主页面日期/语言联动',
        'mobile_report_session_missing': '机构登录会话已失效，请重新登录后查看移动端报告',
        'metric': '指标',
        'date_range_hint_90d_100dev': '提示：请选择日期范围（最多 90 天），单次最多 100 个设备。',
        'search_user_phone_device': '搜索用户名/手机号/设备ID...',
        'search_colon': '搜索：',
        'actions': '操作',
        'data_missing': '数据缺失',
        'overall': '整体',
        'whole_night_report': '整夜报告',
        'whole_night_stats': '整夜统计',
        'whole_night_snore_energy': '整夜鼾声能量',
        'no_intervention_data': '暂无干预数据',
        'update_settings': '更新设置',
        'monthly_trend': '月趋势',
        'unbound_device': '未绑定设备',
        'pillow_control_panel': '枕头控制面板',
        'pillow_status': '枕头状态',
        'bind_device_hint_long': '每个用户只能绑定一个睡眠监测设备，设备的编号贴在主控盒的背面，为7位数字。如果要更换新的监测设备，可以输入新编号。如果要将监测设备交给他人使用，需要先解除绑定。',
        'bind_device_hint_generic': '每个用户只能绑定一个设备,设备的编号贴在主控盒的背面，为7位数字。如果要更换新的设备，可以输入新编号。如果要将设备交给他人使用，需要先解除绑定。',
        'per_round_intervention_stats': '每轮干预统计',
        'awakenings_count_duration': '清醒次数/时长',
        'fsm_3_0': '状态机3_0',
        'birthday': '生日',
        'birthday_colon': '生日:',
        'username': '用户名',
        'user_mgmt_title': '用户管理',
        'efficacy_metrics': '疗效指标统计',
        'efficacy_tag': '疗效标签',
        'sleep_analysis_report': '睡眠分析报告',
        'sleep_respiratory_rate': '睡眠呼吸频率',
        'sleep_hrv': '睡眠心率变异性',
        'sleep_efficiency_t': '睡眠效率',
        'sleep_physiology_metrics': '睡眠期生理指标',
        'ok': '确定',
        'strategy': '策略',
        'bind_device': '绑定设备',
        'end_time': '结束时间',
        'edit_field_name': '编辑字段名称',
        'edit_user_info': '编辑用户信息',
        'self_pillow_comfort': '自用枕舒适度',
        'comfort_description': '舒适度描述',
        'spo2_t': '血氧',
        'unbind': '解绑',
        'unbind_full': '解除绑定',
        'device_no_colon': '设备号:',
        'please_select_date': '请先选择日期',
        'please_input_7digit': '请输入7位数字编号',
        'please_input_value': '请输入值',
        'please_input_field_name': '请输入字段名称',
        'please_input_username': '请输入用户名',
        'please_select_valid_date_raw': '请选择一个有效的报告日期以查看原始数据。',
        'please_select_gender': '请选择性别',
        'round': '轮次',
        'running_status': '运行状态',
        'select_download_type': '选择下载类型：',
        'select_download_option': '选择下载选项',
        'select_date_to_view': '选择日期查看报告',
        'select_birthday': '选择生日',
        'snore_index_alt': '鼾声指数',
        'snore_count': '鼾声次数',
        'snore_energy': '鼾声能量',
        'snore_detection_abnormal': '鼾声识别异常',
        'no_last_night_data': '昨晚没有您的睡眠监测数据，可能是由于监护仪的网络连接断开。',
        'check_device_status_hint': '请在【我的-查看设备状态】确认设备状态及解决方式。',
        'please_input': '请输入',
        // -- 批6：mustache / vbind / 数组字面量 --
        'obstructive_short': '阻塞性',
        'expand_filter': '展开筛选',
        'collapse_filter': '收起筛选',
        'select_all': '全选',
        'deselect_all': '取消全选',
        'not_set': '未设置',
        'no_name': '未填写姓名',
        'no_username': '暂无用户名',
        'no_phone': '暂无手机号',
        'bluetooth_available': '蓝牙可用',
        'bluetooth_unavailable': '蓝牙不可用',
        'searching': '搜索中...',
        'search_device': '搜索设备',
        'unknown_device': '未知设备',
        'connecting': '正在连接',
        'connect': '连接',
        'configuring': '配置中...',
        'start_config': '开始配网',
        'select_all_channels': '- (选择全部通道)',
        'generating': '生成中...',
        'download_pdf': '下载 PDF',
        'cohort_export_night_pdf': '导出单夜报告',
        'cohort_night_pdf_hint': '服务器生成全部 PDF 并打包为 ZIP，本页只接收压缩包；请保持此页面打开。单晚下载仍逐份生成。',
        'cohort_pdf_export_all': '导出全部 PDF（ZIP）',
        'cohort_pdf_download_zip': '重新下载 ZIP',
        'cohort_pdf_exporting': '服务器正在生成 PDF：',
        'cohort_pdf_packing_zip': '正在打包 ZIP：',
        'cohort_pdf_cancelled': '已取消，未下载 ZIP。已处理：',
        'cohort_pdf_complete': '全部 PDF 已生成，正在下载 ZIP：',
        'cohort_pdf_incomplete': '部分夜晚没有放进 ZIP。请检查失败项。已处理：',
        'cohort_pdf_timeout': '报告加载或生成超时',
        'cohort_pdf_render_failed': '报告加载或生成失败',
        'cohort_pdf_config_failed': '设备分类配置加载失败，未生成 PDF',
        'cohort_pdf_report_failed': '报告数据缺失、无效或加载失败',
        'cohort_pdf_auth_failed': '登录失效或无导出权限',
        'cohort_pdf_archive_failed': 'ZIP 打包或下载失败，请重试。',
        'cohort_pdf_unauthorized': '登录已失效，请重新登录后重试。',
        'cohort_pdf_forbidden': '无导出权限或无法访问该受试者，请联系管理员。',
        'cohort_pdf_not_found': '报告不存在，请刷新报告列表。',
        'cohort_pdf_conflict': '报告归属或数据已变化，请刷新列表后重试。',
        'cohort_pdf_busy': 'PDF 服务器繁忙，请稍后重试。',
        'cohort_pdf_unavailable': 'PDF 服务暂不可用，请稍后重试。',
        'cohort_pdf_gateway_timeout': '服务器生成超时，请重试；持续失败请联系管理员。',
        'cohort_pdf_single_complete': '服务器 PDF 已生成并下载。',
        'cohort_pdf_single_cancelled': '已取消，未下载 PDF。',
        'cohort_export_night_pdf_action': '导出 PDF',
        'required_field': '必填',
        'optional_field': '可选',
        // -- 批7：评估/诊断/等级/民族 --
        'unknown': '未知',
        'moderate': '中等',
        'poor': '不佳',
        'worse': '较差',
        'unavailable': '不可用',
        // ESS / 嗜睡分级
        'ess_normal_range': '正常范围：您的日间嗜睡程度在正常范围内。',
        'ess_mild_drowsy': '轻度嗜睡：您可能存在轻度的日间嗜睡。',
        'ess_moderate_drowsy': '中度嗜睡：您存在中度的日间嗜睡，建议就医检查。',
        'ess_severe_drowsy': '重度嗜睡：您存在严重的日间嗜睡，强烈建议就医检查。',
        // GAD-7 焦虑分级
        'gad_no_anxiety': '无焦虑',
        'gad_mild_anxiety': '轻度焦虑',
        'gad_moderate_anxiety': '中度焦虑',
        'gad_severe_anxiety': '重度焦虑',
        // MEQ-SA 晨型夜型
        'meq_definitely_evening': '绝对夜晚型',
        'meq_moderately_evening': '中度夜晚型',
        'meq_intermediate': '中间型',
        'meq_moderately_morning': '中度清晨型',
        'meq_definitely_morning': '绝对清晨型',
        // PHQ-9 抑郁分级
        'phq_no_depression': '无抑郁',
        'phq_mild_depression': '轻度抑郁',
        'phq_moderate_depression': '中度抑郁',
        'phq_moderate_severe_depression': '中重度抑郁',
        'phq_severe_depression': '重度抑郁',
        // 图表指标全名
        'total_sleep_time_tst': '总睡眠时长,TST',
        'sleep_efficiency_se': '睡眠效率,SE',
        'sleep_onset_sol': '入睡速度,SOL',
        'sleep_interruption_waso': '睡眠中断,WASO',
        'sleep_fragmentation_sfi': '睡眠碎片化,SFI',
        'sfi_unit': '次/小时',
        'snore_index_si': '鼾声指数,SI',
        'sleep_avg_rr': '睡眠平均呼吸率',
        'rem_latency_label': '快速眼动睡眠潜伏期',
        'sleep_regularity_sri': '睡眠规律性,SRI',
        'has_report': '有报告',
        // MEQ-SA 时段选项
        'meq_time_20_21': '晚上8点至9点（20:00-21:00h）',
        'meq_time_21_2215': '晚上9点至10点15分（21:00-22:15h）',
        'meq_time_08_10': '早上8点至10点（08:00-10:00h）',
        'meq_very_good': '很好的表现',
        'meq_fair_performance': '还行的表现',
        'meq_hard': '难以执行',
        'meq_very_hard': '非常难以执行',
        // -- 批8：ECharts 图表 name / text / categories --
        'register_err_network': '注册失败，请检查网络或稍后再试。',
        'password_err_network': '密码修改失败，请检查网络或稍后再试。',
        'activity': '活动',
        'off_pillow': '离枕',
        'sleep_posture': '睡姿',
        'snoring': '打鼾',
        'snore_events_short': '打鼾事件',
        'respiratory_events_short': '呼吸事件',
        'deep_sleep_short': '深睡',
        'light_sleep_short': '浅睡',
        'rem_short': '快速眼动',
        'time_seconds': '时间 (秒)',
        'angle_deg': '角度 (°)',
        'x_angle': 'X轴角度',
        'y_angle': 'Y轴角度',
        'imu_angle_data': 'IMU 角度数据',
        'yesterday': '昨天',
        'login_failed_semi': '登录失败;',
        // -- 批9：报告详情 ECharts + tab + 生理指标 --
        'sleep_report_detail': '睡眠报告详情',
        'device_online_tab': '设备在线',
        'birth_gender': '出生性别',
        'sleep_onset_latency_label': '入睡潜伏期',
        'wake_after_sleep_onset_label': '入睡后觉醒',
        'rem_latency_full': '快速眼动睡眠潜伏期',
        'sleep_regularity_index_label': '睡眠规律指数',
        'sleep_fragmentation_label': '睡眠碎片化指数',
        'sleep_stages_label': '睡眠阶段',
        // 时间单位
        'hour_char': '时',
        'minute_char': '分',
        'minutes_suffix': '分钟',
        'times_suffix': '次',
        'minutes_times_fmt': '分钟(次)',
        'years_suffix': '岁',
        // 环境图表
        'avg_temperature': '平均温度',
        'avg_humidity': '平均湿度',
        'light_affect_ratio': '光照影响的睡眠比例',
        // 生理指标图表
        'sleep_min_hr': '睡眠最低心率',
        'sleep_avg_hr': '睡眠平均心率',
        'sleep_hrv_rmssd': '睡眠期HRV_RMSSD',
        'sleep_hrv_lfhf': '睡眠期HRV_LF/HF',
        'bpm_unit': '次/分',
        'ms_unit': '毫秒',
        'whole_night_hrv_rmssd_t': '整晚HRV RMSSD',
        'whole_night_rr_t': '整晚睡眠呼吸频率',
        'whole_night_hr_t': '整晚睡眠心率',
        'avg_prefix': '平均',
        'lowest_prefix': '最低',
        'blood_oxygen_drop_t': '整晚估算血氧下降百分比',
        'spo2_fluctuation': '血氧波动',
        'body_movement': '体动',
        'department_colon_display': '部门：',
        'last_report_prefix': '最近报告',
        'ethnicity': '民族',
        // -- chart.js 补充 --
        'start_word': '开始',
        'end_word': '结束',
        'times_unit': '次',
        'stage': '分期',
        'month_char': '月',
        'whole_night_cpc': '整晚心肺协同指数',
        'whole_night_snore': '整晚鼾声事件',
        'recent_hr_trend': '近期睡眠心率趋势',
        'recent_rr_trend': '近期睡眠呼吸频率趋势',
        'recent_hrv_trend': '近期HRV RMSSD趋势',
        'recent_min_hr_trend': '近期最低心率趋势',
        'ahi_full_label': '呼吸暂停低通指数',
        'ahi_full_label_comma': '呼吸暂停低通指数,AHI',
        // -- ReportList 临床指标 tags --
        'tag_mild_osa': '轻度OSA',
        'tag_moderate_osa': '中度OSA',
        'tag_severe_osa': '重度OSA',
        'tag_long_sleep_latency': '睡眠潜伏期长',
        'tag_short_sleep_time': '睡眠时间不足',
        'tag_long_awake': '觉醒时间长',
        'tag_high_light_ratio': '浅睡占比高',
        'tag_low_deep_ratio': '深睡占比低',
        'tag_low_rem_ratio': 'REM占比低',
        'to_word': '至',
        'whole_night_ahi_events': '整晚呼吸暂停低通气事件',
        'apnea_hypopnea_events_short': '呼吸暂停低通气事件',
        'whole_night_ahi_events_full': '整晚呼吸暂停低通气事件',
        'whole_night_oahi_events_full': '整晚阻塞性呼吸暂停低通气事件',
        // -- 批11：混合中文+mustache --
        'second_suffix': '秒',
        'last_update_colon': '上次更新:',
        'channel_colon': '通道:',
        'no_history_paren': '(无历史)',
        'current_wifi_colon': '当前选择的 WiFi:',
        'load_failed_colon': '加载失败:',
        'gen_time_colon': '生成时间:',
        'avg_sleep_hr_colon': '平均睡眠心率:',
        'avg_sleep_rr_colon': '平均睡眠呼吸频率:',
        'prev_word': '前一',
        'next_word': '后一',
        'ahi_index_paren_prefix': '呼吸暂停低通指数（',
        'count_times': '次',
        'resend_after_seconds_suffix': 's后重新发送',
        'wake_count_prefix': '次 / ',
        // -- 批5：ElMessage toast --
        'save_success': '保存成功',
        'save_failed': '保存失败',
        'save_failed_retry': '保存失败，请重试',
        'fetch_data_failed': '获取数据失败',
        'fetch_data_failed_colon': '获取数据失败:',
        'op_failed_retry': '操作失败，请重试',
        'update_failed': '更新失败',
        'set_failed_retry': '设置失败，请重试',
        'please_answer_all': '请回答所有问题',
        'please_fill_all_sleep_questions': '请完整填写所有睡眠问题的评估',
        'please_select_one_device': '请先选择一个设备',
        'please_select_at_least_one_device': '请选择至少一个设备',
        'please_select_at_least_one_user': '请选择至少一个用户',
        'please_select_unbind_user': '请选择要解绑的用户',
        'please_select_template_to_delete': '请选择要删除的模板',
        'please_select_import_type_first': '请先选择导入类型',
        'please_select_range_before_download': '请选择日期范围后再下载',
        'please_select_report_date_toast': '请选择报告日期',
        'fetch_report_info_failed': '获取报告信息失败',
        'fetch_report_list_failed': '获取报告列表失败',
        'fetch_report_detail_failed': '获取报告详情失败',
        'fetch_report_data_failed_retry': '获取报告数据失败，请稍后重试',
        'fetch_report_date_list_failed': '获取报告日期列表失败',
        'fetch_history_failed': '获取历史记录失败',
        'fetch_org_list_failed': '获取机构列表失败',
        'fetch_trend_failed': '获取趋势数据失败',
        'fetch_device_status_failed': '获取设备状态失败',
        'fetch_cmd_failed_use_default': '获取控制指令码失败，使用默认配置',
        'fetching_report_data': '正在获取报告数据，请稍候...',
        'generating_report_data': '正在生成报告数据，请稍候...',
        'processing_data_fetching_questionnaire': '正在处理数据并获取问卷信息...',
        'fetching_user_info': '正在获取用户信息...',
        'fetching_user_details': '正在获取用户详细信息...',
        'device_no_report_data': '该设备暂无报告数据',
        'report_date_format_error': '报告日期格式错误',
        'backend_data_format_error': '后端返回数据格式错误',
        'data_not_loaded_retry': '数据尚未加载完成，请稍候再试',
        'report_download_success': '报告下载成功',
        'download_report_failed_retry': '下载报告失败，请重试',
        'no_data_to_download': '没有数据可下载',
        'no_night_report_to_download': '没有整夜报告数据可下载',
        'no_experience_survey_to_download': '没有体验问卷数据可下载',
        'no_intervention_event_to_download': '没有干预事件数据可下载',
        'max_100_devices_per_export': '单次最多导出 100 个设备，请减少选择数量',
        'max_90_days_range': '日期范围最多 90 天，请缩小范围',
        'questionnaire_submit_success': '问卷提交成功',
        'password_change_success': '密码修改成功',
        'password_change_failed_retry': '密码修改失败，请重试',
        'login_expired': '登录已过期，请重新登录',
        'select_in_print_dialog': '请在弹出的打印对话框中选择',
        'print_failed_retry': '打印失败，请重试',
        'weight_set_success': '体重设置成功',
        'missing_user_id': '缺少用户ID，无法更新',
        'user_update_success': '用户更新成功',
        'user_no_openid': '该用户没有 openid，无法查看报告',
        'confirm_unbind': '确定要解除设备绑定吗？',
        'unbind_success': '解绑成功',
        'unbind_failed': '解绑失败',
        'selected_no_bound_users': '选中的用户中没有已绑定设备的用户',
        'selected_no_bound_devices': '选中的用户中没有绑定设备',
        'batch_unbind_failed': '批量解绑失败',
        'only_xlsx_allowed': '只支持上传 .xlsx 格式文件!',
        'file_max_10mb': '文件大小不能超过 10MB!',
        'file_upload_success': '文件上传成功',
        'file_upload_failed': '文件上传失败',
        'template_download_success': '模板下载成功',
        'template_download_failed': '模板下载失败',
        'select_template_or_save_as': '请选择一个模板名称，或使用“另存为”创建新模板',
        'input_new_template_name': '输入新模板名称',
        'template_name_min_2_chars': '模板名称至少需要2个字符',
        'template_name_exists': '模板名称已存在，请使用其他名称',
        // -- 批3：波形 + 问卷 + 打印 + Excel + 边角 --
        'total_sleep_time_alt': '总睡眠时间',
        'realtime_tracking': '实时跟踪',
        'zoom_display': '放大显示',
        'align_seconds': '整秒对齐',
        'data_transpose': '数据转置',
        'display_channels': '显示通道：',
        'display_template': '显示模板：',
        'select_channel_template': '选择通道模板',
        'save_as': '另存为',
        'save_series_data': '保存series数据',
        'switch_mode': '切换模式',
        'refresh_list': '刷新列表',
        'clear_log': '清除日志',
        'debug_log': '调试日志',
        'issue_description': '问题描述',
        'situation_description': '情况描述',
        'move_up': '上移',
        'move_down': '下移',
        'share_link': '分享链接',
        'view': '查看',
        'reset': '重置',
        'description': '说明',
        'instructions': '使用说明',
        'advanced_options': '高级选项',
        'detail_info': '详细信息',
        'template': '模板',
        'start_colon': '开始:',
        'end_colon': '结束:',
        'select_time': '选择时间',
        'sleep_quality_t': '睡眠质量',
        'sleep_score_t': '睡眠评分',
        'sleep_time_t': '睡眠时间',
        'total_sleep_duration': '总睡眠时长',
        'sleep_interruption': '睡眠中断',
        'sleep_fragmentation': '睡眠碎片化',
        'sleep_avg_hrv': '睡眠平均心率变异性',
        'hrv_label': '心率变异性 (HRV)',
        'deep_sleep_t': '深度睡眠',
        'deep_sleep_alt': '深睡眠',
        'light_sleep_t': '浅睡眠',
        'awake': '清醒',
        'stage_durations': '各睡眠阶段时长',
        'score': '评分',
        'lights_off_time': '关灯时间',
        'lights_on_time': '开灯时间',
        'light_t': '光照',
        'hr_icon': '心率图标',
        'rr_icon': '呼吸图标',
        'sleep_icon': '睡眠图标',
        'hour_unit': '小时',
        'year_unit': '年',
        'month_unit': '月',
        'and_word': '与',
        'no_value': '无',
        'no_value_alt': '没有',
        'not_at_all_alt': '完全没有',
        'never': '完全不会',
        'serial_no': '序号',
        'page_1': '第 1 页',
        'page_2': '第 2 页',
        'page_3': '第 3 页',
        'page_4': '第 4 页',
        'notes_colon': '注意事项：',
        'api_auth_hint': '提示：如果接口需要鉴权，可在 URL 加上',
        'please_pass_via_url': '请使用 URL 传入',
        'please_input_device_date_first': '请在上方输入设备号与日期后查看原始数据。',
        'params_incomplete': '参数不完整',
        'params_example': '参数，例如：',
        'example': '示例：',
        'back_prev_step': '回到上一步',
        'ess_full_title': 'Epworth 嗜睡量表 (ESS)',
        'phq9_full_title': '抑郁症状筛查量表 (PHQ-9)',
        'gad7_full_title': '广泛性焦虑量表 (GAD-7)',
        'meqsa_full_title': '清晨型和夜晚型问卷自评量表 (MEQ-SA)',
        'psqi_q1': '1. 近1个月，您通常晚上几点上床睡觉？',
        'psqi_q2': '2. 近1个月，从上床到入睡通常需要多少时间？',
        'psqi_q3': '3. 近1个月，您通常早上几点起床？',
        'psqi_q4': '4. 近1个月，每夜通常实际睡眠多少小时（不等于卧床时间）？',
        'psqi_q5': '5. 近1个月，您经常出现以下情况吗？',
        'psqi_q6': '6. 近1个月，您如何评价自己的睡眠质量？',
        'psqi_q7': '7.过去一个月，你是否经常要服药(包括从以医生处方或者在外面药店购买)才能入睡?',
        'psqi_q8': '8. 近1个月，您常感到困倦吗？',
        'psqi_q9': '9. 近1个月，您做事情的精力不足吗？',
        'psqi_q5a': 'a) 入睡困难',
        'psqi_q5b': 'b) 夜间易醒或早醒',
        'psqi_q5c': 'c) 夜间去厕所',
        'psqi_q5d': 'd) 呼吸不畅',
        'psqi_q5e': 'e) 咳嗽或鼾声高',
        'psqi_q5f': 'f) 感觉冷',
        'psqi_q5g': 'g) 感觉热',
        'psqi_q5h': 'h) 做恶梦',
        'psqi_q5i': 'i) 疼痛不适',
        'psqi_q5j': 'j) 其它影响睡眠的事情',
        'freq_less_1_per_week': '&lt;1次/周',
        'freq_1_2_per_week': '1-2次/周',
        'freq_3_plus_per_week': '≥3次/周',
        'none_past_month': '过去一个月没有',
        'less_than_once_week': '&lt;每周平均不足一个晚上',
        'once_twice_week': '每周平均一或两个晚上',
        'three_plus_week': '每周平均三个或更多晚上',
        'very_good': '很好',
        'fairly_good': '较好',
        'fairly_bad': '较差',
        'very_bad': '很差',
        'ess_never_doze': '从不打瞌睡',
        'ess_slight': '偶尔打瞌睡',
        'ess_moderate': '经常打瞌睡',
        'ess_high': '总是打瞌睡',
        'ess_instruction': '在下列情况下你打瞌睡(不仅仅是感到疲倦)的可能如何？这是指你最近几月的通常生活情况。',
        'ess_q1': '坐着看书、看报或看电视时',
        'ess_q2': '坐着看电影或看演出时',
        'ess_q3': '坐着不活动（如在公共场合、会议、剧场等）',
        'ess_q4': '连续乘车超过1小时',
        'ess_q5': '下午休息时躺下休息',
        'ess_q6': '坐着与人交谈时',
        'ess_q7': '午餐后安静坐着时（未饮酒）',
        'ess_q8': '开车时遇到交通阻塞需要停车几分钟',
        'psqi_sl_within_15': '15分钟以内',
        'psqi_sl_16_30': '16-30分钟',
        'psqi_sl_31_45': '31-45分钟',
        'psqi_sl_46_60': '46-60分钟',
        'psqi_sl_61_90': '61-90分钟',
        'psqi_sl_91_120': '91-120分钟',
        'psqi_sl_121_150': '121-150分钟',
        'psqi_sl_over_150': '150分钟以上',
        'view_report': '查看报告',
        'no_report': '暂无报告',
        'app_title': '五季医学',
        'several_days': '几天',
        'more_than_half_days': '一半以上的日子',
        'nearly_every_day': '几乎每天',
        'phq_gad_instruction': '在过去的两周里，你生活中以下症状出现的频率有多少？',
        'gad7_instruction': '下面的问题是想了解近两周内您的焦虑状况如何。根据下面7个问题回答，选择符合您的选项的数字。',
        'psqi_intro': '下面一些问题是关于您最近1个月的睡眠情况，请选择或填写最符合您近1个月实际情况的答案。',
        'meqsa_instruction': '请选出最能形容你在过去几周的感受的句子，并选择相应的数字。',
        'meqsa_note': '假如你最近没有做过其中的某些事情，请试着填上它们可能会给你带来多大的影响。',
        'please_select_sleep_time': '请选择入睡时间',
        'occasionally_alt': '偶尔有',
        'sometimes_alt': '有时有',
        'frequently_alt': '经常有',
        'some_days': '有几天',
        'more_than_half_time': '一半以上的时间',
        'wifi_password': 'WiFi 密码',
        'wifi_config': 'WiFi 配置',
        'please_input_wifi_password': '请输入 WiFi 密码',
        'bluetooth_config': '蓝牙配网',
        'device_search': '设备搜索',
        'device_no': '设备号',
        'example_device_no': '例如：A123456',
        'execute_task': '执行任务',
        'excel_column_name': 'Excel列名',
        'excel_import_instructions': 'Excel导入使用说明',
        'excel_file_management': 'Excel文件管理',
        'excel_header_row_hint': 'Excel首行为字段名，请勿删除或修改',
        'upload_excel': '上传Excel文件',
        'download_template': '下载模板',
        'only_xlsx_supported': '仅支持 .xlsx 格式文件',
        'support_xlsx': '支持 .xlsx 格式',
        'drag_excel_here': '将Excel文件拖到此处，或',
        'drag_or_click_upload': '将填好的Excel文件拖拽到上传区域或点击上传',
        'click_to_upload': '点击上传',
        'click_download_template_hint': '点击"下载模板"获取标准格式的Excel模板',
        'import_steps': '导入步骤：',
        'fill_template_note': '在模板中填入数据，注意必填字段不能为空',
        'field_mapping_config': '字段映射配置',
        'field_description': '字段说明：',
        'custom_fields_hint': '如需自定义字段，请勾选"自动映射未知字段"',
        'auto_map_unknown': '自动映射未知字段（使用Excel首行作为字段名）',
        'required': '必填',
        'required_not_empty': '必填字段不能为空，否则导入失败',
        'preference_strategy': '偏好策略',
        'please_select_import_type': '请选择导入类型',
        'please_select_input_params': '请选择或输入参数',
        'please_select_option': '请选择选项',
        'select_import_type_hint': '选择要导入的数据类型（设备管理、用户管理或偏好策略）',
        'device_mgmt_fields': '设备管理字段：',
        'field_device_no_desc': '设备编号：设备唯一标识（必填）',
        'field_work_status_desc': '工作状态：可用/停用/维修等',
        'field_org_desc': '组织机构：设备所属机构',
        'field_version_desc': '版本号：设备软件版本',
        'field_device_notes_desc': '备注：设备相关备注信息',
        'user_mgmt_fields': '用户管理字段：',
        'field_user_id_desc': '用户：用户标识（必填）',
        'field_username_desc': '用户名：用户姓名',
        'field_user_device_desc': '设备：绑定的设备编号',
        'field_user_org_desc': '机构：所属机构',
        'field_phone_desc': '电话：联系电话',
        'option_word': '选项',
        'system_field': '系统字段',
        'device_mgmt_alt': '设备管理',
        'date_yyyy_mm_dd': '日期（YYYY-MM-DD）',
        'zero_param_anchor': '0">参数：',
        'zero_option_anchor': '0">选项：',
        'cohort_dictionary_eyebrow': '睡眠医学术语',
        'cohort_dictionary_title_fallback': '睡眠医学指标词典',
        'cohort_dictionary_subtitle_fallback': '从医学问题出发，通俗理解睡眠、呼吸、心率与恢复指标',
        'cohort_dictionary_version_aria': '词典版本信息',
        'cohort_dictionary_concept_count': '个医学概念',
        'cohort_dictionary_data_item_count': '个临床数据项',
        'cohort_dictionary_updated_at': '更新于',
        'cohort_dictionary_version_unknown': '—',
        'cohort_dictionary_disclaimer_summary': '了解数据来源与医学边界',
        'cohort_dictionary_search_aria': '搜索医学术语',
        'cohort_dictionary_search_placeholder': '搜索术语或字段名，例如 AHI / 睡眠效率',
        'cohort_dictionary_clear_search_aria': '清空搜索',
        'cohort_dictionary_clear_search': '清除',
        'cohort_dictionary_loading': '正在加载医学术语…',
        'cohort_dictionary_load_failed': '术语词典加载失败',
        'cohort_dictionary_retry': '重新加载',
        'cohort_dictionary_retry_later': '请稍后重试',
        'cohort_dictionary_overview_kicker': '全景概览',
        'cohort_dictionary_overview_title': '查看医学分类与实际字段的完整树形关系',
        'cohort_dictionary_overview_description_prefix': '从',
        'cohort_dictionary_topic_count': '个医学分类',
        'cohort_dictionary_overview_description_middle': '展开到',
        'cohort_dictionary_overview_description_and': '和',
        'cohort_dictionary_overview_description_suffix': '，可拖动、缩放并点击分支。',
        'cohort_dictionary_open_tree': '打开树形图',
        'cohort_dictionary_topic_tabs_aria': '医学问题分类',
        'cohort_dictionary_tabs_scroll_hint': '左右滑动查看更多',
        'cohort_dictionary_search_found': '找到',
        'cohort_dictionary_search_related': '，关联',
        'cohort_dictionary_expand': '展开',
        'cohort_dictionary_collapse': '收起',
        'cohort_dictionary_explanation_suffix': '的医学解释',
        'cohort_dictionary_view_full_content': '查看完整内容',
        'cohort_dictionary_definition': '定义',
        'cohort_dictionary_metric_notes': '指标说明',
        'cohort_dictionary_interpretation': '如何理解',
        'cohort_dictionary_formula': '计算/口径',
        'cohort_dictionary_clinical_data_items': '临床数据项',
        'cohort_dictionary_empty_title': '没有找到匹配的医学概念',
        'cohort_dictionary_empty_hint': '可尝试搜索中文术语、缩写或临床数据项',
        'cohort_dictionary_tree_eyebrow': '睡眠医学指标词典',
        'cohort_dictionary_tree_title': '医学指标与实际字段全景树',
        'cohort_dictionary_tree_reset': '复位视图',
        'cohort_dictionary_tree_close': '关闭树形图',
        'cohort_dictionary_tree_desktop_tip': '拖动画布移动 · 滚轮或双指缩放 · 点击节点展开 / 收起；默认展示到概念层',
        'cohort_dictionary_tree_mobile_tip': '单指拖动 · 双指缩放 · 点击分类展开概念；默认展示到分类层',
        'cohort_dictionary_tree_root_mobile': '睡眠指标',
        'cohort_dictionary_tree_root': '睡眠医学指标',
        'cohort_dictionary_tree_root_kind': '医学指标总览',
        'cohort_dictionary_metric_kind': '指标',
        'cohort_dictionary_clinical_data_item_kind': '临床数据项',
        'cohort_dictionary_clinical_item_kind': '临床数据项',
        'cohort_dictionary_report_field_kind': '报告字段',
    },
    'en': {
        "cohort_registered_status_scope": "Status cards count current registered records, not historical patients",
        "cohort_registered_active": "Records · monitoring",
        "cohort_registered_completed": "Records · completed",
        "cohort_registered_terminated": "Records · terminated",
        "cohort_registered_status_detail": "Current non-removed registered identities, not historical patients",
        "cohort_registered_subjects": "Registered subjects",
        "cohort_confirmed_enrollment": "Confirmed enrollment",
        "cohort_institution_confirmed": "Institution-confirmed enrollment",
        "cohort_reconciliation_source": "Confirmation reference: ",
        "cohort_snapshot_fixed": "Fixed as-of snapshot. New records or name edits do not increase it automatically; further reconciliation is required.",
        "cohort_current_registered_count": "Current registered records:",
        "cohort_scopes_not_additive": "These scopes are not additive. Record statuses do not partition cumulative patients.",
        "cohort_registered_only_scope": "Counts current registered identities. Records may be reused, so this is not a historical patient count.",
        "cohort_enrollment_invalid": "Invalid enrollment snapshot; administrator review required. Registered count is not a substitute.",
        "cohort_weekly_enrollment": "New enrollments this week (unverified)",
        "cohort_history_unavailable": "Verifiable patient enrollment and transition history is unavailable. New, resumed, completed and terminated counts for the past 7 days are not inferred. Only current record statuses are shown below.",

        "research_trend_sleep_age": "Sleep age",
        "research_trend_aging_speed": "Aging speed",
        "research_trend_recovery": "Recovery score",
        "research_trend_years": "years",
        "research_trend_years_per_year": "years/year",
        "research_trend_28d": "28-day trend",

        "cohort_null_report_read_hint": "This report has no subject identity. Report data is available, but patient profile editing and PDF are not supported.",
        "cohort_null_report_pdf_hint": "Reports without subject identity do not support PDF. Only the selected real subjects will be exported.",
        "cohort_null_report_stage_hint": "Stage export requires a real subject identity. Nightly report data and raw channels remain available.",

        "cohort_device_reports_scope": "Current filter scope",
        "cohort_device_reports_count_unit": "reports",
        "cohort_device_reports_exporting": "Loading all filtered reports…",
        "cohort_device_reports_export": "Export all filtered reports XLSX",
        "cohort_device_reports_export_scope": "Export scope (all filtered reports, not this page)",
        "cohort_device_reports_loading": "Loading reports…",
        "cohort_device_reports_empty": "No reports in this scope.",
        "cohort_device_reports_view_metrics": "View all report metrics",
        "cohort_device_reports_paging": "Report pages",
        "cohort_device_reports_select_org": "Select a cohort organization first.",
        "cohort_device_reports_all_sites": "All sites",
        "cohort_device_reports_all_devices": "All devices",
        "cohort_device_reports_open_date": "Any date",
        "cohort_device_reports_cancelled": "Export cancelled. No file was downloaded.",
        "cohort_device_reports_no_access": "This account cannot view reports.",
        "cohort_device_reports_load_failed": "Could not load reports. Previous data was cleared. Please search again.",
        "cohort_device_reports_date_error": "Start date must not be after end date.",
        "cohort_device_reports_exported": "All filtered reports exported; report count",
        "cohort_device_reports_export_failed": "Export failed or the report scope changed. No incomplete file was downloaded. Refresh and retry.",
        "clinical_heading": "Laboratory, examinations and orders",
        "clinical_import": "Import clinical documents",
        "clinical_close": "Close panel",
        "clinical_upload": "Choose files to import",
        "clinical_refresh": "Refresh list",
        "clinical_upload_hint": "PNG, JPEG or PDF, up to 10 MiB per file. Multiple files are processed sequentially.",
        "clinical_all_sites": "All sites",
        "clinical_transcription_only": "Transcribes source laboratory results, examinations and clinical orders for human review only. No treatment recommendations. Stored separately from sleep reports.",
        "clinical_queued": "Queued",
        "clinical_processing": "Uploading and recognizing…",
        "clinical_uploaded": "Recognition saved",
        "clinical_failed": "Failed",
        "clinical_loading": "Loading clinical documents…",
        "clinical_empty": "No clinical documents yet. Import directly; no sleep report is required.",
        "clinical_confirmed": "Human-confirmed",
        "clinical_draft": "Draft awaiting review",
        "clinical_view_edit": "View / review and edit",
        "clinical_downloading": "Downloading…",
        "clinical_source": "Download original",
        "clinical_pages": "Clinical document pages",
        "clinical_previous": "Previous",
        "clinical_next": "Next",
        "clinical_edit": "Edit and confirm",
        "clinical_preview": "Confirmed data preview",
        "clinical_close_editor": "Close editor",
        "clinical_warnings": "Recognition and identity warnings (check the original)",
        "clinical_PATIENT_NAME_MISMATCH": "The source patient name differs from the current subject profile. Editing the name does not remove this warning.",
        "clinical_PATIENT_NAME_UNVERIFIED": "The report or profile lacks a name; name verification is unavailable. Ownership remains with the selected subject identity.",
        "clinical_nullable_hint": "Leave unknown content blank. Preserve inequalities, ranges and qualitative laboratory values. Do not infer codes, units or reference ranges.",
        "clinical_type": "Document type",
        "clinical_type_laboratory": "Laboratory",
        "clinical_type_examination": "Examination",
        "clinical_type_order": "Orders (source transcription)",
        "clinical_remove_row": "Remove row",
        "clinical_add_row": "Add row",
        "clinical_ack": "I have checked the original and selected subject identity, acknowledge the name mismatch and confirm document ownership.",
        "clinical_saving": "Confirming and saving…",
        "clinical_save": "Confirm and save full record",
        "clinical_saved": "Human confirmation saved.",
        "clinical_conflict": "Someone else updated this record. Your edits remain intact and did not overwrite the server. Reload the latest version and review again.",
        "clinical_reload_discard": "Discard edits and load latest",
        "clinical_discard": "Discard unsaved changes?",
        "clinical_file_size": "File exceeds 10 MiB. Choose a smaller file.",
        "clinical_file_type": "Only PNG, JPEG and PDF files are supported.",
        "clinical_load_failed": "Failed to load clinical documents. Retry.",
        "clinical_upload_failed": "Upload or recognition failed. Check the file and retry.",
        "clinical_save_failed": "Confirmation failed. Your edits are retained.",
        "clinical_download_failed": "Original download failed. Retry.",
        "clinical_invalid_date": "Report date must be valid YYYY-MM-DD. Leave blank if uncertain.",
        "clinical_field_title": "Title",
        "clinical_field_patientName": "Patient name on report",
        "clinical_field_reportDate": "Report date",
        "clinical_field_rawText": "Raw recognized text (expand to view / edit)",
        "clinical_field_name": "Test name",
        "clinical_field_code": "Source code",
        "clinical_field_value": "Result (text)",
        "clinical_field_unit": "Unit",
        "clinical_field_referenceRange": "Reference range",
        "clinical_field_flag": "Flag",
        "clinical_field_findings": "Findings",
        "clinical_field_conclusion": "Conclusion",
        "clinical_field_modality": "Modality",
        "clinical_field_bodyPart": "Body part",
        "clinical_field_treatment": "Source treatment order",
        "clinical_field_drug": "Drug",
        "clinical_field_dose": "Dose",
        "clinical_field_route": "Route",
        "clinical_field_frequency": "Frequency",
        "clinical_field_start": "Start (source text)",
        "clinical_field_end": "End (source text)",
        "clinical_field_status": "Order status",
        'cohort_profile_add': 'Add basic info',
        'cohort_profile_edit': 'Edit basic info',
        'cohort_profile_unset': 'Not provided',
        'cohort_profile_unknown': 'Unknown',
        'cohort_profile_age_mode': 'Age entry mode',
        'cohort_profile_age_only': 'Age only',
        'cohort_profile_optional_hint': 'All fields are optional; leave a field blank to clear it.',
        'cohort_profile_derived_bmi': 'BMI (calculated)',
        'cohort_profile_remarks_hint': 'Optional multiline remarks (up to 2,000 characters)',
        'cohort_profile_discard': 'Discard your unsaved changes?',
        'cohort_profile_unsaved': 'Unsaved changes',
        'cohort_profile_discard_button': 'Discard changes',
        'cohort_profile_keep_editing': 'Keep editing',
        'cohort_profile_invalid_text': 'Check text lengths and control characters (name 128, ethnicity 64, remarks 2,000 characters).',
        'cohort_profile_invalid_sex': 'Choose male, female, unknown, or leave sex blank.',
        'cohort_profile_invalid_number': 'Use whole numbers: age 0–130 years, height 30–250 cm, weight 1–500 kg.',
        'cohort_profile_invalid_date': 'Enter a valid date from 1900 through today; birthdate age must not exceed 130.',
        'cohort_profile_load_failed': 'Unable to load basic info',
        'cohort_profile_loading': 'Loading basic info…',
        'cohort_profile_retry': 'Reload',
        'cohort_profile_missing_context': 'Historical subject identity is missing; basic info cannot be loaded or edited.',
        'cohort_profile_export_detail': 'Subject profile (age evaluated at latest report date; age-only observations retain their reference date)',
        'cohort_profile_summary': 'View / edit basic info',
        'cohort_realtime': 'Realtime monitoring',
        'cohort_realtime_unavailable': 'Realtime monitoring is unavailable for this cohort.',
        'cohort_realtime_polling': 'Refreshes every 5 seconds while this page is visible',
        'cohort_realtime_paused': 'Updates paused; return to this page to fetch fresh data',
        'cohort_realtime_search': 'Search bed, current subject or device',
        'cohort_realtime_all': 'All',
        'cohort_realtime_onbed': 'On bed',
        'cohort_realtime_offbed': 'Off bed',
        'cohort_realtime_unknown': 'Not yet known',
        'cohort_realtime_state': 'Bed occupancy',
        'cohort_realtime_subject': 'Current subject',
        'cohort_realtime_hr': 'Heart rate (bpm)',
        'cohort_realtime_status_unavailable': 'Unavailable',
        'cohort_realtime_hr_label': 'Heart rate',
        'cohort_realtime_rr_label': 'Respiratory rate',
        'cohort_realtime_hr_unit': 'bpm',
        'cohort_realtime_rr_unit': '/min',
        'cohort_realtime_rr': 'Respiratory rate (/min)',
        'cohort_realtime_source_time': 'Last monitoring time',
        'cohort_realtime_stale': 'Current status unavailable',
        'cohort_realtime_error': 'Refresh failed; current measurements unavailable. Retrying automatically',
        'cohort_realtime_empty': 'No devices match these filters',
        'cohort_realtime_loading': 'Updating monitoring data…',
        'cohort_realtime_updated': 'Page refreshed at',
        'cohort_realtime_counts': 'Device overview (all matching devices)',
        'cohort_realtime_devices': 'Total devices',
        'cohort_realtime_page_size': 'Devices per page',
        'cohort_realtime_refresh': 'Refresh now',
        'cohort_realtime_channels': 'Independent channels',
        'cohort_realtime_hrv_estimate': 'HRV RMSSD (5-minute estimate)',
        'cohort_realtime_hrv_window': 'Measurement window',
        'cohort_realtime_hrv_explanation': 'Measurement window shown; quality is the existing algorithm result, not raw-data completeness. Not instantaneous.',
        'cohort_movement_recent': 'Movement status · past 5 minutes',
        'cohort_movement_insufficient': 'Insufficient data',
        'cohort_movement_not_detected': 'No movement detected',
        'cohort_movement_detected': 'Movement detected',
        'cohort_movement_coverage': 'Monitoring coverage',
        'cohort_movement_seconds': 's',
        'cohort_movement_past_five': 'Past 5 min',
        'cohort_movement_count': '{count} episodes',
        'cohort_movement_observed_count': '{count} observed',
        'cohort_movement_distribution': 'Movement over the past 30 minutes',
        'cohort_movement_thirty_ago': '30 min ago',
        'cohort_movement_now': 'Now',
        'cohort_movement_coverage_incomplete': 'Incomplete coverage; count may be incomplete',
        'cohort_movement_timeline_gaps': 'Hatching means missing coverage or uncertain onsets, not absence of movement.',
        'cohort_movement_count_explanation': 'Counts represent continuous movement episodes, not individual turns.',
        'cohort_movement_count_incomplete': 'Uncertain count: episode onset data missing',
        'cohort_realtime_movement': 'Moving now',
        'cohort_realtime_moving_yes': 'Yes',
        'cohort_realtime_moving_no': 'No',
        'cohort_realtime_channel_unavailable': 'No available data',
        'cohort_realtime_channel_time_unverified': 'Time not verified',
        'cohort_realtime_channel_read_failed': 'Read unavailable',
        'cohort_realtime_note': 'For monitoring reference only, not a substitute for clinical assessment or alarms. — means no current measurement is available.',

        // Cohort module
        'cohort_numeric_metric': 'Numeric metric',
        'cohort_boolean_metric': 'Boolean metric',
        'cohort_exit_batch_mode': 'Exit batch mode',
        'cohort_enter_batch_mode': 'Enter batch mode',
        'cohort_deselect_all': 'Deselect all',
        'cohort_select_all_results': 'Select all filtered results',
        'cohort_select_fields_export': 'Select fields and export (',
        'cohort_export_raw_data_prefix': 'Export raw data (',
        'cohort_selected_people_suffix': ' subjects)',
        'cohort_conditions_active': 'conditions active',
        'cohort_filtered_out': 'Filtered',
        'cohort_collapse_advanced_filters': 'Collapse advanced filters',
        'cohort_expand_advanced_filters': 'Expand advanced filters',
        'cohort_real_metrics_unit': 'real Wuji Data metrics',
        'cohort_categories_unit': 'categories',
        'cohort_no_unit': 'No unit',
        'cohort_page_prefix': 'Page',
        'cohort_page_of': '/',
        'cohort_page_suffix': '',
        'cohort_total_prefix': 'Total',
        'cohort_selected_fields_prefix': 'Selected',
        'cohort_fields_unit': 'fields',
        'cohort_will_export': 'Will export',
        'cohort_subjects_unit': 'subjects',
        'cohort_found': 'Found',
        'cohort_integrated_metrics_unit': 'integrated metrics',
        'cohort_selected_metrics_unit': 'metrics selected',
        'cohort_nightly_report_suffix': 'Nightly reports',
        'cohort_ahi_all': 'All AHI',
        'cohort_ahi_normal': '<5 Normal',
        'cohort_ahi_mild': '5–15 Mild',
        'cohort_ahi_moderate': '15–30 Moderate',
        'cohort_ahi_severe': '≥30 Severe',
        'cohort_quick_report_7': 'Report nights ≥7',
        'cohort_quick_low_efficiency': 'Average sleep efficiency <80%',
        'cohort_quick_short_sleep': 'Average sleep <6 hours',
        'cohort_quick_high_hr': 'Average heart rate ≥70',
        'cohort_quick_no_report_7d': 'No reports for 7 consecutive days',
        'cohort_tag_mild_osa': 'Mild OSA',
        'cohort_tag_moderate_osa': 'Moderate OSA',
        'cohort_tag_severe_osa': 'Severe OSA',
        'cohort_tag_insufficient_nights': 'Insufficient report nights',
        'cohort_tag_consecutive_missing': 'Consecutive missing nights',
        'cohort_tag_short_sleep': 'Insufficient sleep duration',
        'cohort_tag_low_efficiency': 'Low sleep efficiency',
        'cohort_tag_high_sleep_hr': 'High sleeping heart rate',
        'cohort_report_data_load_failed': 'Failed to load report data',
        'cohort_nightly_reports_load_failed': 'Failed to load nightly reports',
        'cohort_night_report_module_load_failed': 'The nightly report page could not load. Refresh the page, then reopen the report for the same device and date.',
        'cohort_night_report_navigation_failed': 'Unable to open the nightly report. Please try again; if it still fails, refresh the page and retry.',
        'cohort_aggregation_help_median': 'Median across all nights in the selected date range; less affected by individual outlier nights',
        'cohort_aggregation_help_mean': 'Mean across all nights in the selected date range',
        'cohort_aggregation_help_min': 'Minimum in the selected date range',
        'cohort_aggregation_help_max': 'Maximum in the selected date range',
        'cohort_aggregation_help_latest': 'Value from the latest night in the selected date range',
        'cohort_operator_equal': 'Equals',
        'cohort_operator_gte': 'Greater than or equal to',
        'cohort_operator_lte': 'Less than or equal to',
        'cohort_operator_gt': 'Greater than',
        'cohort_operator_lt': 'Less than',
        'cohort_operator_between': 'Between',
        'cohort_no_data': 'No data',
        'cohort_signal_none': 'No signal',
        'cohort_signal_weak': 'Weak',
        'cohort_signal_medium': 'Medium',
        'cohort_signal_good': 'Good',
        'cohort_signal_excellent': 'Excellent',
        'cohort_signal_unknown': 'Unknown',
        'cohort_signal_label': ' signal: ',
        'cohort_signal_bars': 'bars',
        'cohort_wifi_recommendation': 'Signal is weak; WiFi is recommended',
        'cohort_exporting_raw_data': 'Exporting raw data...',
        'cohort_raw_export_success': 'Raw data exported successfully',
        'cohort_raw_export_failed': 'Failed to export raw data',
        'cohort_loading_nightly_data': 'Loading nightly data...',
        'cohort_load_nightly_data_failed': 'Failed to load nightly data',
        'cohort_no_nightly_data_selected': 'Selected subjects have no nightly report data',
        'cohort_exporting_count_prefix': 'Exporting',
        'cohort_raw_files_suffix': 'raw files...',
        'cohort_export_complete': 'Export complete:',
        'cohort_success': 'succeeded',
        'cohort_failed': 'failed',
        'cohort_export_success_prefix': 'Successfully exported',
        'cohort_raw_files_unit': 'raw files',
        'cohort_export_subject_id': 'Subject ID',
        'cohort_export_stable_id_detail': 'Stable masked ID within the cohort',
        'cohort_export_name': 'Name / masked name',
        'cohort_export_name_detail': 'Display name in the current cohort',
        'cohort_export_current_device': 'Current device ID',
        'cohort_export_current_device_detail': 'Subject’s current primary device',
        'cohort_export_window_detail': 'First and last report dates after filtering',
        'cohort_export_nights_detail': 'Number of reports in the time window',
        'cohort_export_ahi_label': 'Median AHI',
        'cohort_export_ahi_detail': 'Median of nightly AHI',
        'cohort_export_efficiency_detail': 'Mean nightly sleep efficiency',
        'cohort_export_sleep_duration': 'Average total sleep duration',
        'cohort_unit_minutes_detail': 'Unit: minutes',
        'cohort_unit_bpm_detail': 'Unit: bpm',
        'cohort_export_last_report_detail': 'Latest report date in the time window',
        'cohort_export_tags': 'Summary tags',
        'cohort_export_tags_detail': 'Multi-night aggregate tags',
        'cohort_export_night_device_detail': 'Device used for the nightly report',
        'cohort_export_report_date_detail': 'Report date',
        'cohort_window_separator': 'to',
        'cohort_historical_subjects': 'Historical subjects',
        'cohort_reports_detail_suffix': 'reports',
        'cohort_total_people_prefix': 'Total',
        'cohort_previous_devices_prefix': 'Previous devices',
        'cohort_reported': 'Report',
        'cohort_no_report': 'No report',
        'cohort_historical_report_suffix': 'historical reports',
        'cohort_source': 'Source: ',
        'cohort_operation_rules_source': 'Cohort operation rules',
        'cohort_current_operation_alert': 'Current operation alert',
        'cohort_device_issue': 'Device issue',
        'cohort_active_devices_7d': 'Devices active in last 7 days',
        'cohort_active_devices_30d': 'Devices active in last 30 days',
        'cohort_unbound_devices_hint_prefix': 'Of these,',
        'cohort_unbound_devices_hint_suffix': 'are not assigned to current subjects; view them in the paginated list below',
        'cohort_view_all_devices': 'View all',
        'cohort_unassigned_label': 'Unassigned:',
        'cohort_selected_device_prefix': 'Selected',
        'cohort_unbound_subject': 'No bound subject',
        'cohort_unassigned': 'Unassigned',
        'cohort_usage_records_unit': 'segments',
        'cohort_usage_record_suffix': 'usage segment',
        'cohort_enter_batch_mode': 'Batch actions',
        'cohort_exit_batch_mode': 'Exit batch actions',
        'cohort_batch_unbind': 'Batch unbind',
        'cohort_batch_download_reports': 'Download reports',
        'cohort_unbind_device': 'Unbind device',
        'cohort_device_action_replace': 'Replace',
        'cohort_device_action_unbind': 'Unbind',
        'cohort_device_action_bind': 'Bind',
        'cohort_device_action_history': 'History',
        'cohort_device_unbound': 'Unbound',
        'cohort_last_unbind_prefix': 'Last: ',
        'cohort_device_history_loading': 'Loading device history…',
        'cohort_no_device_history': 'No device history',
        'cohort_usage_interval': 'Usage interval',
        'cohort_end_reason': 'End reason',
        'cohort_unknown_source': 'Unknown source',
        'cohort_retry': 'Retry',
        'cohort_saving': 'Saving…',
        'cohort_bed_label': 'Bed',
        'cohort_bed_history': 'Bed history',
        'cohort_edit_bed': 'Edit bed',
        'cohort_bed_edit_success': 'Bed updated',
        'cohort_bed_edit_failed': 'Failed to edit bed',
        'cohort_gender': 'Gender',
        'cohort_not_set': 'Not set',
        'cohort_male': 'Male',
        'cohort_female': 'Female',
        'cohort_birthdate': 'Birth date',
        'cohort_height_cm': 'Height (cm)',
        'cohort_weight_kg': 'Weight (kg)',
        'cohort_confirm_unbind_subject': 'Unbind the current device? Historical reports will be retained.',
        'cohort_unbind_success': 'Device unbound',
        'cohort_unbind_failed': 'Failed to unbind device',
        'cohort_selected_no_bound_devices': 'Selected subjects have no bound devices',
        'cohort_confirm_batch_unbind_prefix': 'Batch unbind ',
        'cohort_batch_unbind_success': 'Batch unbind completed',
        'cohort_no_reports_to_download': 'No reports available for selected devices',
        'cohort_batch_download_failed': 'Failed to download reports',
        'cohort_rebind_device': 'Replace device',
        'cohort_bind_device': 'Bind device',
        'cohort_subject_list_load_failed': 'Failed to load subject list',
        'cohort_all_subjects_tab': 'All',
        'cohort_history_monitoring_tab': 'Historical monitoring',
        'cohort_pending_confirmation': 'Pending confirmation',
        'cohort_device_list_load_failed': 'Failed to load device list',
        'cohort_assign_success_prefix': 'Assigned',
        'cohort_assign_success_middle': 'devices to',
        'cohort_assign_failed': 'Assignment failed',
        'cohort_unassign_success_prefix': 'Removed site assignment from',
        'cohort_unassign_success_suffix': 'devices',
        'cohort_unassign_failed': 'Failed to remove assignment',
        'cohort_device_history_load_failed': 'Failed to load device history',
        'cohort_rebind_failed': 'Failed to rebind device',
        'cohort_add_subject_failed': 'Failed to add subject',
        'cohort_update_status_failed': 'Failed to update status',
        'cohort_save_note_failed': 'Failed to save note',
        'cohort_delete_note_failed': 'Failed to delete note',
        'cohort_subject_report_filter': 'Subject report filters',
        'cohort_report_filter_description': 'Limit reports by date, aggregate to one row per subject, then filter subjects by multi-night metrics.',
        'cohort_batch_scope_hint': 'All batch actions apply only to currently filtered subjects',
        'cohort_filter_subjects': 'Filter subjects',
        'cohort_filter_and_hint': 'Different dimensions are combined with AND; after selecting metrics, click “Add selected” at the bottom of the dialog.',
        'cohort_reset': 'Reset',
        'cohort_ahi_median_category': 'Median AHI category',
        'cohort_quick_filters': 'Quick filters',
        'cohort_multi_select_and_hint': 'Multiple selections allowed; conditions are combined with AND',
        'cohort_save_current_filters': 'Save current filters',
        'cohort_manage': 'Manage',
        'cohort_sort_latest_report_desc': 'Latest report: newest first',
        'cohort_sort_report_nights_desc': 'Report nights: most first',
        'cohort_sort_ahi_desc': 'Median AHI: high to low',
        'cohort_sort_sleep_efficiency_asc': 'Average sleep efficiency: low to high',
        'cohort_metric_conditions': 'Metric conditions',
        'cohort_add_metric_condition': '+ Add metric condition',
        'cohort_subject_aggregate_value': 'Subject aggregate value',
        'cohort_yes': 'Yes',
        'cohort_no': 'No',
        'cohort_delete': 'Delete',
        'cohort_no_metric_conditions': 'No dictionary metric conditions added',
        'cohort_multi_night_tags': 'Multi-night tags',
        'cohort_any_tag': 'Any tag',
        'cohort_all_tags': 'All tags',
        'cohort_signal': 'Signal',
        'cohort_pending_reupload': 'Pending reupload',
        'cohort_completeness': 'Completeness',
        'cohort_device_status_hint': 'The first line is the report device ID. The second line is average nightly-report completeness in the selected window.',
        'cohort_completeness_hint': 'Raw-data completeness within the latest nightly report window.',
        'cohort_completeness_missing_hint': 'No usable completeness result is available for the latest night.',
        'cohort_latest_completeness_hint': 'Latest nightly report; pending time counts only queue overlap within its report window.',
        'cohort_latest_completeness_full_hint': 'The latest nightly report is complete; no pending detail is shown.',
        'cohort_missing_data': 'Missing',
        'cohort_no_pending_reupload': 'No pending reupload',
        'cohort_pending_reupload_hint': 'Waiting to restore data. The duration is the amount of missing data, not a completion countdown.',
        'cohort_reupload_active_hint': 'Restoring data now. The duration is the amount of missing data, not a completion countdown.',
        'cohort_reupload_active': 'Reuploading',
        'cohort_reupload_pending': 'Pending',
        'cohort_reupload_scope_night': 'Night may be affected',
        'cohort_reupload_scope_night_hint': 'Includes a sleep period and may affect report completeness.',
        'cohort_reupload_scope_day': 'Daytime/outside window',
        'cohort_reupload_scope_day_hint': 'Outside sleep periods and does not affect current report completeness.',
        'cohort_reupload_scope_mixed': 'Night + outside window',
        'cohort_reupload_scope_mixed_hint': 'Partly includes a sleep period and may affect report completeness.',
        'cohort_reupload_scope_unknown': 'Time window unknown',
        'cohort_reupload_scope_unknown_hint': 'Cannot yet determine whether a sleep period is included.',
        'cohort_report_window': 'Report window',
        'cohort_ahi_median': 'Median AHI',
        'cohort_average_sleep_efficiency': 'Average sleep efficiency',
        'cohort_average_duration': 'Average duration',
        'cohort_multi_night_summary_tags': 'Multi-night summary tags',
        'cohort_actions': 'Actions',
        'cohort_view_nights': 'View nights',
        'cohort_no_matching_subjects': 'No matching subjects',
        'cohort_previous_page': 'Previous',
        'cohort_next_page': 'Next',
        'cohort_save_quick_filter': 'Save quick filter',
        'cohort_save_filter_description': 'Save the current dates, cohort statuses, AHI, quick tags, and metric conditions.',
        'cohort_filter_name': 'Filter name',
        'cohort_manage_quick_filters': 'Manage quick filters',
        'cohort_researcher_saved_filters': 'Filter combinations saved by the researcher.',
        'cohort_apply': 'Apply',
        'cohort_no_custom_filters': 'No custom filters',
        'cohort_select_export_fields': 'Select export fields',
        'cohort_export_level_hint': 'Choose the export level, then select the required fields.',
        'cohort_subject_summary': 'Subject summary',
        'cohort_nightly_details': 'Nightly details',
        'cohort_stage_details': 'Sleep stage details',
        'cohort_stage_startTime': 'Start time (local time)',
        'cohort_stage_endTime': 'End time (local time)',
        'cohort_stage_duration': 'Duration (seconds)',
        'cohort_stage_displayStage': 'Sleep stage',
        'cohort_stage_export_hint': 'One row per stage segment; times use the user local timezone recorded in each report',
        'cohort_stage_export_busy': 'Exporting…',
        'cohort_stage_export_missing': 'Final sleep stage data is unavailable',
        'cohort_stage_export_identity_error': 'Report ownership changed. Refresh and retry.',

        'cohort_select_all': 'Select all',
        'cohort_clear': 'Clear',
        'cohort_export_excel': 'Export Excel',
        'cohort_select_available_metrics': 'Select integrated metrics',
        'cohort_metric_picker_description': 'Only metrics with real fields in the current Anhui cohort snapshot that can be used for filtering are shown.',
        'cohort_metric_picker_filterable_only': 'Only Wuji Data metrics that can currently be filtered are shown',
        'cohort_confirm_add': 'Add selected',
        'cohort_total_sleep': 'Total sleep',
        'cohort_single_night_report': 'Nightly report',
        'cohort_export_raw_data': 'Export raw data',
        'cohort_subject_device': 'Subject / device',
        'cohort_name_id_device_placeholder': 'Name / ID / device ID',
        'cohort_report_start_date': 'Report start date',
        'cohort_report_end_date': 'Report end date',
        'cohort_queue_status': 'Cohort status',
        'cohort_ahi_median_value': 'Median AHI',
        'cohort_average_sleep_duration': 'Average sleep duration',
        'cohort_average_sleep_heart_rate': 'Average sleeping heart rate',
        'cohort_sort': 'Sort',
        'cohort_threshold': 'Threshold',
        'cohort_upper_limit': 'Upper limit',
        'cohort_filter_name_example': 'Example: Monitoring or completed + AHI ≥15',
        'cohort_metric_search_placeholder': 'Search: HRV, REM, respiratory rate, temperature, sleep age…',
        'cohort_delete_subject': 'Delete subject',
        'cohort_deleting_subject': 'Deleting…',
        'cohort_delete_subject_confirmation': 'This removes the subject from Research subject lists and statistics and releases their currently bound device. Historical sleep reports and the user identity are retained, not deleted. This cannot be undone in this page. Continue?',
        'cohort_delete_subject_success': 'Subject removed from Research; historical reports retained',
        'cohort_delete_subject_failed': 'Failed to delete subject. Please retry.',
        'cohort_delete_subject_reload_failed': 'Subject removed, but the list could not refresh. Please reload the page.',
        'cohort_add_subject': 'Add subject',
        'cohort_device_operations': 'Device operations',
        'cohort_subject_notes': 'Subject / notes',
        'cohort_existing_report_interval': 'Existing report interval',
        'cohort_last_30_nights_status': 'Last 30 nights',
        'cohort_current_issues': 'Current issues',
        'cohort_add_note': '+ Add note',
        'cohort_last_30_nights_legend': 'Last 30 nights: blue = report · gray = no report',
        'cohort_20_per_page': '20/page',
        'cohort_50_per_page': '50/page',
        'cohort_100_per_page': '100/page',
        'cohort_device_operations_description': 'View current devices, rotation history, and site assignments',
        'cohort_current_device': 'Current device',
        'cohort_site_assignment': 'Site assignment',
        'cohort_pending_recovery_confirmation': 'Recover/confirm',
        'cohort_pending_recovery_devices': 'Devices to recover/confirm',
        'cohort_recovery_devices_description': 'Includes devices whose subjects have ended, devices inactive for 30 days, and devices not assigned to current subjects.',
        'cohort_no_recovery_devices': 'No devices currently need recovery.',
        'cohort_assign': 'Assign',
        'cohort_unassign': 'Unassign',
        'cohort_subject_device_history': 'Subject device usage history',
        'cohort_previous_devices': 'Previous devices',
        'cohort_all_usage_records': 'All usage records',
        'cohort_device_history_explanation': 'The current device is not counted as a previous device. The entry is shown only when another device was confirmed as used. Isolated unbindings and records without a confirmed user are excluded.',
        'cohort_effective_date': 'Effective date',
        'cohort_new_device_id': 'New device ID',
        'cohort_replacement_reason': 'Replacement reason',
        'cohort_please_select': 'Please select',
        'cohort_reason_device_failure': 'Original device failure',
        'cohort_reason_device_recovery': 'Device recovery',
        'cohort_reason_device_lost': 'Device lost',
        'cohort_reason_organization_change': 'Organization change',
        'cohort_reason_data_correction': 'Data correction',
        'cohort_other': 'Other',
        'cohort_notes': 'Notes',
        'cohort_rebind_explanation': 'Historical reports remain under the original device and time interval; the new device applies only after the effective date.',
        'cohort_confirm_rebind': 'Confirm rebind',
        'cohort_add_subject_description': 'Create the cohort member first; sleep reports remain automatically associated by the device data source.',
        'cohort_name_or_masked_name': 'Name or masked name',
        'cohort_hospital_record_number': 'Hospital / medical record number',
        'cohort_device_id': 'Device ID',
        'cohort_study_group': 'Study group',
        'cohort_add_subject_default_hint': 'New subjects default to Monitoring. No nightly reports are produced until a device is assigned; a device ID can be added later.',
        'cohort_add': 'Add',
        'cohort_subject_note': 'Subject note',
        'cohort_note_privacy_hint': 'Record hospital numbers, medical record numbers, departments, wards, study groups, and other locating information.',
        'cohort_delete_note': 'Delete note',
        'cohort_unique_bound_identities': 'Unique bound identities',
        'cohort_all_nightly_reports': 'All nightly reports',
        'cohort_unlinked_identity': 'Unlinked identity',
        'cohort_reports_without_bound_identity': 'Reports exist without a bound identity',
        'cohort_monitoring_search_placeholder': 'Search name / subject ID / device ID / notes',
        'cohort_site_name_placeholder': 'Enter site name',
        'cohort_new_device_placeholder': 'Enter new device ID',
        'cohort_handover_note_placeholder': 'Optional handover notes',
        'cohort_masked_name_example': 'Example: Z*** M***',
        'cohort_patient_locator_hint': 'Used to locate the patient',
        'cohort_device_optional_hint': 'May be left unassigned',
        'cohort_study_group_example': 'Example: Observation group',
        'cohort_location_note_placeholder': 'Department, ward, responsible person, or other locating information',
        'cohort_note_example': 'Example: Hospital No. ZY20260812; Respiratory Department; Sleep Center ward; Project A',
        'cohort_current_site': 'Current site:',
        'cohort_global_view': 'Global view',
        'cohort_settings': 'Cohort settings',
        'cohort_progress': 'Cohort progress',
        'cohort_status_adjust_hint': 'Adjust each subject’s status in Monitoring Operations',
        'cohort_planned_recruitment': 'Planned recruitment',
        'cohort_current_completion': 'Completed',
        'cohort_to_be_filled': 'Not set',
        'cohort_real_bound_identities': 'Unique identities with real bindings',
        'cohort_monitoring': 'Monitoring',
        'cohort_reports_in_last_30_days': ' subjects had reports in the last 30 days',
        'cohort_completed': 'Completed',
        'cohort_completed_exit_detail': 'Leave the active cohort after completing the plan',
        'cohort_early_termination': 'Early termination',
        'cohort_termination_detail': 'Did not complete protocol-required follow-up',
        'cohort_device_ledger_activity': 'Device inventory and activity',
        'cohort_device_ledger': 'Device inventory',
        'cohort_last_7_days_active': 'Active in last 7 days',
        'cohort_last_30_days_active': 'Active in last 30 days',
        'cohort_historical_inactive': 'Historical/inactive',
        'cohort_reports': 'Reports',
        'cohort_nightly_report_output': 'Nightly report output',
        'cohort_historical_reports': 'Historical reports',
        'cohort_last_7_days_reports': 'Reports in last 7 days',
        'cohort_received_today': 'Received today',
        'cohort_site_overview': 'Site overview',
        'cohort_site_comparison_description': 'Compare device and subject distribution across sites',
        'cohort_sites_unit': 'sites',
        'cohort_site': 'Site',
        'cohort_device_count': 'Devices',
        'cohort_subject': 'Subject',
        'cohort_unassigned_site': 'Unassigned site',
        'cohort_recruitment_progress_section': 'Recruitment progress',
        'cohort_recruitment_data_description': 'The recruitment target may be left unset; other data comes from real subjects in the current cohort.',
        'cohort_set_plan': 'Set plan',
        'cohort_enrollment_progress': 'Enrollment progress',
        'cohort_enrolled': 'Enrolled',
        'cohort_planned_people': 'Planned',
        'cohort_new_this_week': 'New this week',
        'cohort_remaining_slots': 'Remaining slots',
        'cohort_member_change_7d': 'Member changes in last 7 days',
        'cohort_member_change_description': 'Enrollment and exit trends, plus current cohort size.',
        'cohort_view_subjects': 'View subjects',
        'cohort_opening_monitoring': 'Monitoring at start',
        'cohort_new_entries_7d': 'New in last 7 days',
        'cohort_resumed_monitoring': 'Resumed monitoring',
        'cohort_current_monitoring': 'Currently monitoring',
        'cohort_date': 'Date',
        'cohort_new_entries': 'New entries',
        'cohort_monitoring_that_day': 'Monitoring that day',
        'cohort_today_pending': 'Pending today',
        'cohort_as_of': 'As of',
        'cohort_items_unit': 'items',
        'cohort_no_pending_today': 'No pending items today',
        'cohort_collapse_current_issues': 'Collapse current issues',
        'cohort_expand_remaining_issues': 'Show remaining',
        'cohort_current_issues_suffix': 'current issues',
        'cohort_settings_description': 'Configure study-management information only; real sleep reports are not changed.',
        'cohort_planned_recruitment_people': 'Planned recruitment',
        'cohort_target_placeholder': 'Not set, e.g. 120',
        'cohort_target_optional_hint': 'Leave blank if undecided; the overview will display “Not set”.',
        'cohort_inclusion_criteria': 'Inclusion criteria',
        'cohort_inclusion_placeholder': 'Inclusion criterion',
        'cohort_exclusion_criteria': 'Exclusion criteria',
        'cohort_exclusion_placeholder': 'Exclusion criterion',
        'cohort_placeholder_suffix': 'not set',
        'cohort_operation_rules': 'Operation rules',
        'cohort_rules_effect_hint': 'Saved rules directly affect today’s pending items and current subject issues',
        'cohort_no_report_rule': 'Consecutive nights without reports',
        'cohort_no_report_rule_description': 'Create a report-generation issue when a monitored subject reaches the threshold for consecutive nights without reports',
        'cohort_suspected_completion_rule': 'Suspected completion to confirm',
        'cohort_suspected_completion_description': 'When a monitored subject has no reports for a long time, prompt confirmation of completion or early termination',
        'cohort_cancel': 'Cancel',
        'cohort_save': 'Save',
        'cohort_overview_load_failed': 'Failed to load cohort overview',
        'cohort_recruitment_target_missing_prediction': 'Set a recruitment target to automatically display completion rate, remaining slots, and estimated completion time.',
        'cohort_no_recent_enrollment_prediction': 'No identifiable new enrollments were found in the last 7 days, so completion time is not estimated.',
        'cohort_recruitment_prediction_prefix': 'Based on',
        'cohort_recruitment_prediction_middle': 'new enrollments in the last 7 days, recruitment is estimated to finish in about',
        'cohort_recruitment_prediction_suffix': 'weeks.',
        'cohort_save_config_failed': 'Failed to save cohort configuration',
        'cohort_assistant_title': 'SleepReport Assistant',
        'cohort_assistant_subtitle': 'How-to help · BCG sensor pad · Technology and accuracy',
        'cohort_clear_conversation': 'Clear conversation',
        'cohort_assistant_welcome': 'Hi, I\'m the SleepReport AI Assistant. I can answer questions about sleep monitoring, metric definitions, and platform operations.\n\nTry asking me:',
        'cohort_prompt_export': 'How to batch export data?',
        'cohort_prompt_sleep_efficiency': 'How is sleep efficiency calculated?',
        'cohort_prompt_ahi_normal': 'What AHI level is normal?',
        'cohort_prompt_missing_days': 'How to check which days have no monitoring?',
        'cohort_prompt_sleep_latency': 'What is sleep onset latency?',
        'cohort_prompt_rebind': 'How to rebind a device?',
        'cohort_prompt_filter_person': 'How to filter by subject?',
        'cohort_prompt_hrv_rmssd': 'What is HRV RMSSD?',
        'cohort_prompt_deep_sleep_ratio': 'What deep sleep ratio is normal?',
        'cohort_prompt_enter_queue': 'How to enter a cohort?',
        'cohort_prompt_mat_principle': 'How does the monitoring mat work?',
        'cohort_prompt_spo2': 'Can it measure SpO2?',
        'cohort_prompt_ahi_grading': 'How is AHI graded?',
        'cohort_prompt_export_raw': 'How to export raw data?',
        'cohort_error_rate_limit': 'Too many requests, please wait',
        'cohort_error_rate_limit_hint': 'Too many requests. Please wait a few seconds and try again.',
        'cohort_error_answer_failed': 'Sorry, something went wrong. Please try again later or rephrase your question.',
        'cohort_close': 'Close',
        'cohort_recovery_unbound': 'Not assigned to current subject, pending recovery or reassignment',
        'cohort_recovery_completed': 'Subject completed',
        'cohort_recovery_terminated': 'Subject terminated early',
        'cohort_recovery_inactive': 'Historical device, inactive for 30+ days',
        'cohort_no_report': 'No reports',
        'cohort_close': 'Close',
        'cohort_recovery_unbound': 'Not assigned to current subject, pending recovery or reassignment',
        'cohort_recovery_completed': 'Subject completed',
        'cohort_recovery_terminated': 'Subject terminated early',
        'cohort_recovery_inactive': 'Historical device, inactive for 30+ days',
        'cohort_no_report': 'No reports',
        'cohort_source_prefix': 'Source: ',
        'cohort_assistant_placeholder': 'Ask about operations, monitoring principles, or accuracy…',
        'cohort_assistant_disclaimer': 'Product and technical assistant only; not a substitute for medical diagnosis. Accuracy figures are subject to formal validation materials.',
        'cohort_assistant_welcome': 'Hello, I am the SleepReport Assistant.\n\nI can help you:\n1. Find instructions for the current page;\n2. Understand the principles and metrics of the BCG sleep monitoring pad;\n3. Explain accuracy, intended use, and capability boundaries.',
        'cohort_prompt_real_subjects': 'How many real subjects are in GHABS?',
        'cohort_prompt_real_reports': 'How many real reports are there?',
        'cohort_prompt_switch_queue': 'How do I switch cohorts?',
        'cohort_prompt_missing_monitoring': 'How can I see which nights were not monitored?',
        'cohort_prompt_active_seven_days': 'Which subjects were active in the last 7 days?',
        'cohort_prompt_device_history': 'How do I view device history?',
        'cohort_prompt_filter_subject': 'How do I filter by subject?',
        'cohort_prompt_batch_export': 'How do I export in bulk?',
        'cohort_prompt_open_night_report': 'How do I open a nightly report?',
        'cohort_prompt_enter_queue': 'How do I enter a cohort?',
        'cohort_prompt_archived_meaning': 'What does an archived cohort mean?',
        'cohort_prompt_bcg_principle': 'How does the monitoring pad work?',
        'cohort_prompt_spo2': 'Can it measure blood oxygen?',
        'cohort_prompt_accuracy': 'How accurate is it?',
        'cohort_assistant_unparsed': 'Sorry, I could not interpret that question. Please try rephrasing it.',
        'cohort_assistant_error': 'Sorry, an error occurred while answering. The page is unaffected; you can ask again or use one of the suggested questions below.',
        'cohort_answer_dropout_definition': 'Strict definitions:\n• Completed: completed all monitoring or follow-up endpoints required by the study protocol;\n• Early termination (often grouped under dropout): permanently stopped participating after enrollment but before the required endpoint, or protocol-required follow-up data can no longer be obtained;\n• Lost to follow-up: one reason for early termination, meaning outcomes or follow-up data remain unavailable after the protocol-defined contact procedures.\n\nShort monitoring gaps, device failures, or temporary loss of contact should only be marked as an interruption risk, not as dropout. Dropout also does not automatically mean exclusion from analysis; use of prior data depends on informed consent, the protocol, and analysis-set definitions.',
        'cohort_action_view_monitoring': 'View monitoring operations',
        'cohort_action_view_overview': 'View cohort overview',
        'cohort_action_enter_monitoring': 'Open monitoring operations',
        'cohort_action_enter_report_management': 'Open report management',
        'cohort_action_choose_queue': 'Choose a cohort',
        'cohort_action_view_in_monitoring': 'View in monitoring operations',
        'cohort_answer_subject_snapshot_prefix': 'Real-data snapshot from Anhui First Affiliated Hospital:',
        'cohort_answer_historical_subjects': 'Historical subjects: ',
        'cohort_answer_active_30d': 'Active in last 30 days: ',
        'cohort_answer_active_7d': 'Active in last 7 days: ',
        'cohort_answer_historical_reports': 'Historical reports: ',
        'cohort_answer_no_recruitment_target': 'There is currently no formal recruitment target.',
        'cohort_answer_today_preview': 'Today’s monitoring preview:\n• Expected monitoring: 87 subjects\n• Valid reports: 65\n• Invalid reports: 3\n• Not reported: 19\n\n65 + 3 + 19 = 87.',
        'cohort_answer_device_preview': 'Device operations preview:\n• Total devices: 106\n• In use: 87\n• Utilization: 82%\n• Available: 12\n• Pending recovery: 4\n• Under maintenance: 3\n\nThese figures are for the interactive preview.',
        'cohort_answer_replace_device': 'Find the subject in Monitoring Operations and click “Replace device”:\n1. Select an available device;\n2. Set the effective date and reason;\n3. Confirm the old and new binding intervals.\n\nHistorical reports remain under the original binding, and new reports are attributed to the new device from the effective date.',
        'cohort_answer_monitoring_continuity': 'Use “nightly monitoring continuity” in the subject row:\nBlue = valid monitoring, yellow = invalid report, gray = no monitoring that night.\nHover over a cell to see the specific night.',
        'cohort_answer_batch_export': 'Open Report Management, filter the target subjects, and enable batch mode to export:\n1. Subject summary, one subject per row;\n2. Nightly details for selected subjects, one night per row.',
        'cohort_answer_open_night_report': 'In Report Management, click “View nights” for a subject, then click “Nightly report” for a night to open the full original SleepReport. Your filters are preserved when you return.',
        'cohort_answer_switch_queue': 'Click “Switch cohort” in the current-cohort card on the left, or open the cohort selection page. Active cohorts are editable, archived cohorts are read-only, and preparing cohorts cannot be entered yet.',
        'cohort_answer_bcg_principle': 'The monitoring pad uses non-contact BCG (ballistocardiography) piezoelectric sensing. Heartbeats, breathing, and body movements create tiny mechanical vibrations on the bed surface. The sensor captures these vibrations, and algorithms derive heart rate, respiration, movement, sleep stages, and other metrics.\n\nNo electrodes or wristbands are required, making it suitable for long-term continuous monitoring at home.',
        'cohort_source_bcg': 'Product capability basis: BCG piezoelectric mattress captures mechanical bed-surface vibrations',
        'cohort_answer_metrics': 'The monitoring pad can produce:\n• Sleep timing, sleep onset latency, wake after sleep onset, and sleep efficiency;\n• Sleep stages, awakenings, deep sleep, and REM;\n• Heart rate, HRV, and respiratory rate;\n• AHI, snoring, and respiratory events;\n• Body movement;\n• Environmental metrics such as temperature, humidity, and illumination.\n\nSpecific metrics are available in nightly reports and trend pages.',
        'cohort_source_schema': 'Dreama sleep-data schema: sleep, heart rate, HRV, respiration, environment, and related fields',
        'cohort_answer_spo2': 'It cannot measure these directly. The current pad has no PPG, SpO₂, or ECG hardware:\n• It cannot provide true blood oxygen saturation;\n• It cannot provide PPG waveforms;\n• It cannot analyze ECG waveforms or ST segments.\n\nHeart rate, respiratory rate, HRV, sleep stages, and AHI are derived from BCG bed-surface vibration signals.',
        'cohort_source_hardware_boundary': 'Hardware boundary: no PPG, SpO₂, or ECG sensors',
        'cohort_answer_accuracy_numbers': 'I cannot provide a specific percentage without checking the original paper or validation report. Results differ by metric and threshold: sleep staging commonly uses Kappa/accuracy, while AHI screening evaluates sensitivity and specificity at thresholds such as ≥5, ≥15, and ≥30.\n\nWhat can be confirmed is that multicenter synchronized PSG validation has been conducted. Formal figures require checking the BCGNet paper or validation report for the specified metric and threshold.',
        'cohort_source_accuracy_rule': 'Accuracy citation rule: verify original materials by metric, threshold, and dataset',
        'cohort_answer_accuracy': 'Accuracy must be assessed separately for each metric and cannot be summarized by one “overall accuracy” figure.\n\nCurrent evidence includes:\n• Synchronized PSG collection with multicenter validation of sleep staging and AHI;\n• Published BCGNet results;\n• Team materials describing parallel data from 12 hospitals and more than 6,000 person-nights, though accuracy, Kappa, sensitivity, and specificity must be checked against the original paper or validation report before formal external citation.\n\nIt is appropriate to say “validated against PSG in multiple centers,” but not to quote arbitrary percentages without checking the source.',
        'cohort_source_bcgnet': 'BCGNet: sleep staging/AHI validation work',
        'cohort_source_multicenter': 'Five Seasons R&D materials: multicenter parallel PSG validation; verify figures before citation',
        'cohort_answer_medical_device': 'The monitoring pad has obtained China Class II medical-device registration. The exact intended use, product name, and permitted medical scenarios must follow the registration certificate. Research or promotional materials must not overstate monitoring or screening as diagnostic capability.',
        'cohort_source_medical_device': 'Product fact basis: China Class II medical-device registration',
        'cohort_answer_diagnosis': 'The SleepReport Assistant can explain product data and operations but cannot replace a physician’s diagnosis. Monitoring results such as AHI and sleep stages may support screening, research, and trend observation. Marked abnormalities, persistent symptoms, or diagnostic needs require clinical assessment and, when necessary, PSG or other examinations.',
        'cohort_answer_fallback': 'I could not find a sufficiently reliable answer in the preset knowledge. Try rephrasing, or ask about:\n• How to use the page;\n• BCG monitoring principles;\n• What the device can and cannot measure;\n• Validation of sleep staging or AHI.',
        'cohort_status_normal_monitoring': 'Normal monitoring',
        'cohort_status_expiring': 'Expiring soon',
        'cohort_status_needs_attention': 'Needs attention',
        'cohort_subject_preview_title': ' preview data:',
        'cohort_subject_current_device': 'Current device: ',
        'cohort_subject_status': 'Status: ',
        'cohort_subject_valid_nights': 'Valid nights: ',
        'cohort_subject_adherence': 'Adherence: ',
        'cohort_subject_ahi_median': 'Median AHI: ',
        'cohort_subject_sleep_efficiency': 'Sleep efficiency: ',
        'cohort_subject_last_report': 'Last report: ',
        'cohort_subject_preview_disclaimer': 'The above is prototype preview data.',
        'cohort_metric_report_nights': 'Report nights',
        'cohort_category_report': 'Report',
        'cohort_unit_nights': 'nights',
        'cohort_metric_data_missing_rate': 'Data missing rate',
        'cohort_metric_report_compute_time': 'Report processing time',
        'cohort_unit_seconds': 'seconds',
        'cohort_metric_bedtime_clock': 'Bedtime',
        'cohort_category_sleep_timing': 'Sleep timing',
        'cohort_unit_hours': 'hours',
        'cohort_metric_light_off_clock': 'Lights-off time',
        'cohort_metric_sleep_onset_clock': 'Sleep onset time',
        'cohort_metric_wake_clock': 'Wake time',
        'cohort_metric_light_on_clock': 'Lights-on time',
        'cohort_metric_leave_bed_clock': 'Leave-bed time',
        'cohort_metric_sleep_midpoint': 'Sleep midpoint',
        'cohort_metric_bedtime_variability': 'Bedtime variability',
        'cohort_unit_minutes': 'minutes',
        'cohort_metric_wake_time_variability': 'Wake-time variability',
        'cohort_metric_sleep_midpoint_variability': 'Sleep-midpoint variability',
        'cohort_metric_total_in_bed_minutes': 'Total time in bed',
        'cohort_category_sleep_duration': 'Sleep duration',
        'cohort_metric_total_sleep_minutes': 'Total sleep duration',
        'cohort_metric_sleep_onset_latency': 'Sleep onset latency',
        'cohort_metric_wake_after_sleep_onset': 'Wake after sleep onset',
        'cohort_metric_awake_minutes': 'Awake duration',
        'cohort_metric_pre_sleep_bed_activity_minutes': 'Pre-sleep in-bed activity',
        'cohort_metric_high_light_minutes': 'High-light exposure duration',
        'cohort_metric_sleep_debt': 'Sleep debt',
        'cohort_metric_daily_sleep_debt': 'Daily sleep debt',
        'cohort_metric_sleep_need': 'Recommended sleep duration',
        'cohort_metric_rem_minutes': 'REM sleep duration',
        'cohort_category_sleep_architecture': 'Sleep architecture',
        'cohort_metric_rem_ratio': 'REM sleep ratio',
        'cohort_metric_rem_latency': 'REM latency',
        'cohort_metric_deep_sleep_minutes': 'Deep sleep duration',
        'cohort_metric_deep_sleep_ratio': 'Deep sleep ratio',
        'cohort_metric_core_sleep_minutes': 'Core sleep duration',
        'cohort_metric_core_sleep_ratio': 'Core sleep ratio',
        'cohort_metric_light_sleep_minutes': 'Light sleep duration',
        'cohort_metric_light_sleep_ratio': 'Light sleep ratio',
        'cohort_metric_n1_minutes': 'N1 sleep duration',
        'cohort_metric_n1_ratio': 'N1 sleep ratio',
        'cohort_metric_n2_minutes': 'N2 sleep duration',
        'cohort_metric_n2_ratio': 'N2 sleep ratio',
        'cohort_metric_n3_minutes': 'N3 sleep duration',
        'cohort_metric_n3_ratio': 'N3 sleep ratio',
        'cohort_metric_wake_count': 'Night awakenings',
        'cohort_unit_times': 'times',
        'cohort_metric_long_wake_count': 'Long awakenings',
        'cohort_metric_long_wake_minutes': 'Total long-awake duration',
        'cohort_metric_sleep_efficiency': 'Sleep efficiency',
        'cohort_category_sleep_quality': 'Sleep quality',
        'cohort_metric_quality_score': 'Sleep quality total score',
        'cohort_unit_points': 'points',
        'cohort_metric_sleep_score': 'Sleep score',
        'cohort_metric_regularity_index': 'Sleep regularity index',
        'cohort_metric_sleep_fragmentation_index': 'Sleep fragmentation index',
        'cohort_metric_timing_score': 'Sleep timing score',
        'cohort_metric_tst_score': 'Sleep duration score',
        'cohort_metric_efficiency_score': 'Sleep efficiency score',
        'cohort_metric_deep_sleep_score': 'Deep sleep score',
        'cohort_metric_rem_score': 'REM sleep score',
        'cohort_metric_wake_score': 'Awakening score',
        'cohort_metric_onset_score': 'Sleep onset score',
        'cohort_metric_hygiene_score': 'Sleep hygiene score',
        'cohort_metric_satisfaction': 'Sleep satisfaction',
        'cohort_metric_restful_score': 'Restfulness score',
        'cohort_metric_avg_resp_rate': 'Average respiratory rate',
        'cohort_category_respiration_snoring': 'Respiration and snoring',
        'cohort_unit_per_minute': 'breaths/min',
        'cohort_metric_min_resp_rate': 'Minimum respiratory rate',
        'cohort_metric_max_resp_rate': 'Maximum respiratory rate',
        'cohort_unit_per_hour': 'events/hour',
        'cohort_metric_oahi': 'Obstructive AHI',
        'cohort_metric_ahi_nrem': 'AHI during NREM',
        'cohort_metric_ahi_rem': 'AHI during REM',
        'cohort_metric_ahi_deep': 'AHI during deep sleep',
        'cohort_metric_ahi_core': 'AHI during light sleep',
        'cohort_metric_oahi_rem': 'OAHI during REM',
        'cohort_metric_oahi_nrem': 'OAHI during NREM',
        'cohort_metric_oahi_core': 'OAHI during light sleep',
        'cohort_metric_oahi_deep': 'OAHI during deep sleep',
        'cohort_metric_snore_index': 'Snoring index',
        'cohort_metric_snore_event_count': 'Snoring event count',
        'cohort_metric_rrv_mean': 'Mean respiratory-rate variability',
        'cohort_metric_respiratory_interval_ri': 'Respiratory interval RI',
        'cohort_metric_respiratory_interval_sdri': 'Respiratory interval SDRI',
        'cohort_metric_respiratory_interval_cv': 'Respiratory interval coefficient of variation',
        'cohort_metric_inspiratory_time_fraction': 'Inspiratory time fraction',
        'cohort_metric_avg_heart_rate': 'Average heart rate',
        'cohort_category_heart_rate': 'Heart rate',
        'cohort_metric_min_heart_rate': 'Minimum heart rate',
        'cohort_metric_max_heart_rate': 'Maximum heart rate',
        'cohort_metric_resting_heart_rate': 'Resting heart rate',
        'cohort_metric_hr_rem_avg': 'Average heart rate during REM',
        'cohort_metric_hr_deep_avg': 'Average heart rate during deep sleep',
        'cohort_metric_hr_core_avg': 'Average heart rate during core sleep',
        'cohort_metric_hr_light_avg': 'Average heart rate during light sleep',
        'cohort_metric_heart_rate_range': 'Nighttime heart-rate range',
        'cohort_metric_hrv_rmssd': 'Mean HRV RMSSD',
        'cohort_metric_hrv_ratio': 'HRV ratio',
        'cohort_metric_hrv_morning': 'Morning HRV',
        'cohort_metric_hrv_evening': 'Evening HRV',
        'cohort_metric_hrv_delta': 'HRV change',
        'cohort_metric_mean_rr': 'Mean RR interval',
        'cohort_metric_nn50_count': 'NN50 count',
        'cohort_metric_lf_power': 'Low-frequency power LF',
        'cohort_metric_hf_power': 'High-frequency power HF',
        'cohort_metric_lf_hf_ratio': 'LF/HF ratio',
        'cohort_metric_hrv_rem_avg': 'HRV during REM',
        'cohort_metric_hrv_deep_avg': 'HRV during deep sleep',
        'cohort_metric_hrv_light_avg': 'HRV during light sleep',
        'cohort_metric_body_movement_count': 'Body movement count',
        'cohort_category_movement_behavior': 'Movement and behavior',
        'cohort_metric_body_movement_index': 'Body movement index',
        'cohort_metric_large_movement_count': 'Large movement count',
        'cohort_metric_leave_bed_count': 'Bed-exit count',
        'cohort_metric_bed_exit_minutes': 'Total bed-exit duration',
        'cohort_metric_alertness_ratio': 'Alertness ratio',
        'cohort_metric_avg_temperature': 'Average temperature',
        'cohort_category_environment': 'Environment',
        'cohort_metric_min_temperature': 'Minimum temperature',
        'cohort_metric_max_temperature': 'Maximum temperature',
        'cohort_metric_avg_humidity': 'Average humidity',
        'cohort_metric_min_humidity': 'Minimum humidity',
        'cohort_metric_max_humidity': 'Maximum humidity',
        'cohort_metric_avg_illumination': 'Average illumination',
        'cohort_metric_max_illumination': 'Maximum illumination',
        'cohort_metric_thi_score': 'Temperature-humidity comfort index',
        'cohort_metric_sleep_sufficiency': 'Sleep sufficiency',
        'cohort_metric_body_repair': 'Body repair',
        'cohort_metric_sleep_stability': 'Sleep stability',
        'cohort_metric_physiological_stability': 'Physiological stability',
        'cohort_metric_af_burden_percent': 'AF burden',
        'cohort_metric_stable_sleep_percent': 'Stable sleep ratio',
        'cohort_metric_light_exposure_percent': 'Sleep light exposure ratio',
        'cohort_metric_pre_sleep_light_lx': 'Pre-sleep illumination',
        'cohort_metric_post_sleep_light_lx': 'Post-sleep illumination',
        'cohort_metric_chronotype': 'Chronotype',
        'cohort_metric_daytime_nap_minutes': 'Daytime nap duration',
        'cohort_metric_recovery_score': 'Recovery score',
        'cohort_category_recovery_long_term': 'Recovery and long-term',
        'cohort_metric_aging_speed': 'Aging speed index',
        'cohort_metric_biological_age': 'Biological age',
        'cohort_unit_years': 'years',
        'cohort_metric_sleep_age_avg': 'Sleep age',
        'cohort_metric_weekly_avg_tst': 'Weekly average sleep duration',
        'cohort_metric_weekly_avg_quality': 'Weekly average sleep quality',
        'cohort_metric_weekly_avg_deep': 'Weekly average deep sleep',
        'cohort_metric_weekly_avg_ahi': 'Weekly average AHI',
        'cohort_metric_weekly_avg_hrv': 'Weekly average HRV',
        'cohort_metric_weekly_avg_heart_rate': 'Weekly average heart rate',
        'cohort_metric_weekly_avg_resp': 'Weekly average respiratory rate',
        'cohort_metric_weekly_avg_regularity': 'Weekly average regularity',
        'cohort_metric_weekly_avg_waso': 'Weekly average awake duration',
        'cohort_metric_weekly_avg_sol': 'Weekly average sleep-onset duration',
        'cohort_metric_has_insomnia': 'Insomnia risk flag',
        'cohort_category_insomnia_analysis': 'Insomnia analysis',
        'cohort_unit_yes_no': 'yes/no',
        'cohort_metric_insomnia_onset': 'Sleep-onset insomnia',
        'cohort_metric_insomnia_maintenance': 'Sleep-maintenance insomnia',
        'cohort_metric_insomnia_early_wake': 'Early-awakening insomnia',
        'cohort_metric_insomnia_mixed': 'Mixed insomnia',
        'cohort_all_metrics': 'All',
        'cohort_aggregation_median': 'Median',
        'cohort_aggregation_mean': 'Mean',
        'cohort_aggregation_min': 'Minimum',
        'cohort_aggregation_max': 'Maximum',
        'cohort_aggregation_latest': 'Latest night',
        'cohort_aggregation_count': 'Matching nights',
        'cohort_aggregation_ratio': 'Matching-night ratio',
        'cohort_current_queue': 'Current cohort',
        'cohort_switch_queue': 'Switch cohort',
        'cohort_return_original': 'Return to original',
        'cohort_return_sleepreport_original': 'Return to original SleepReport',
        'cohort_select_queue_prompt': 'Please select a cohort',
        'cohort_overview': 'Cohort overview',
        'cohort_monitoring_operations': 'Monitoring operations',
        'cohort_report_management': 'Report management',
        'cohort_field_dictionary': 'Sleep metrics dictionary',
        'cohort_menu_workspace': 'Research workspace',
        'cohort_menu_data': 'Data assets',
        'cohort_navigation_aria': 'Research station navigation',
        'cohort_collapse_navigation': 'Collapse research station navigation',
        'cohort_expand_navigation': 'Expand research station navigation',
        'cohort_select_queue_first': 'Please select a cohort first',
        'cohort_data_load_failed': 'Failed to load cohort data',
        'cohort_experience_research': 'Explore research cohorts',
        'cohort_data_server': 'data server',
        'cohort_back_to_report_management': '← Back to report management',
        'cohort_loading_full_report': 'Validating and loading the full report…',
        'cohort_invalid_night_report_params': 'A valid cohort, device ID, and report date are required',
        'cohort_night_report_unavailable': 'The full report for this night is temporarily unavailable',
        'cohort_administrator': 'Administrator',
        'cohort_logout': 'Log out',
        'cohort_choose_queue': 'Choose a cohort',
        'cohort_queue_scope_description': 'Subjects, devices, and reports will be limited to the selected cohort.',
        'cohort_search_queue_name': 'Search cohort name',
        'cohort_total_enrolled': 'Total enrolled',
        'cohort_current_active': 'Currently active',
        'cohort_pending': 'Pending',
        'cohort_recruitment_progress': 'Recruitment progress',
        'cohort_people_unit': 'people',
        'cohort_expand_sites': 'Show sites',
        'cohort_sites_available': 'sites available',
        'cohort_collapse': 'Collapse',
        'cohort_expand': 'Expand',
        'cohort_global_overview': 'Global overview',
        'cohort_view_all_site_data': 'View data from all sites',
        'cohort_enter': 'Enter',
        'cohort_devices_unit': 'devices',
        'cohort_active_subjects_unit': 'active subjects',
        'cohort_last_updated': 'Last updated',
        'cohort_read_only_view': 'View only',
        'cohort_enter_queue': 'Enter cohort',
        'cohort_preparing': 'Preparing',
        'cohort_loading_accessible_queues': 'Loading accessible cohorts…',
        'cohort_no_accessible_queues': 'No accessible cohorts',
        'cohort_all_queues': 'All cohorts',
        'cohort_active_status': 'Active',
        'cohort_archived': 'Archived',
        'cohort_archived_read_only': 'Archived · Read only',
        'cohort_queue_list_load_failed': 'Failed to load cohorts. Please try again later.',
        'cohort_rotation_history': 'Rotation history',
        'cohort_historical_rotated_devices': 'Historically rotated devices',
        'cohort_device_unit': 'devices',
        'cohort_search_device_subject': 'Search device ID / subject',
        'cohort_rotation_definition': 'A rotated device is one that has produced sleep reports for at least two subjects over time. Test bindings with no reports, accidental operations, and isolated unbindings are excluded.',
        'cohort_device': 'Device',
        'cohort_rotated': 'Rotated',
        'cohort_alerts_unit': 'alerts',
        'cohort_current_prefix': 'Current: ',
        'cohort_unbound': 'Unbound',
        'cohort_used_by_sequence': 'Used by',
        'cohort_person_unit': 'people',
        'cohort_report_intervals_unit': 'report intervals',
        'cohort_events_unit': 'events',
        'cohort_latest_binding': 'Latest binding',
        'cohort_last_report': 'Last report',
        'cohort_view_timeline': 'View timeline →',
        'cohort_no_rotation_records': 'No rotation records',
        'cohort_actual_users_unit': 'actual users',
        'cohort_current_status': 'Current status',
        'cohort_current_bound': 'Currently bound',
        'cohort_current_unbound': 'Currently unbound',
        'cohort_current_subject': 'Current subject',
        'cohort_earliest_event': 'Earliest event',
        'cohort_latest_event': 'Latest event',
        'cohort_record_alerts': 'Record alerts',
        'cohort_record_alerts_explanation': 'Alerts only describe gaps in binding records or differences in report attribution; they are not used to infer users.',
        'cohort_segment_prefix': 'No.',
        'cohort_actual_usage_segment': 'actual usage segment',
        'cohort_current_use': 'Current use',
        'cohort_ended': 'Ended',
        'cohort_binding_time': 'Binding time',
        'cohort_unbinding_time': 'Unbinding time',
        'cohort_missing_record': 'Missing record',
        'cohort_current': 'Current',
        'cohort_usage_duration': 'Usage duration',
        'cohort_interval_reports': 'Reports in interval',
        'cohort_reports_unit': 'reports',
        'cohort_report_interval': 'Report interval: ',
        'cohort_other_bind_operations': 'View other bind / unbind operations',
        'cohort_operations_unit': 'operations',
        'cohort_time_error': 'Invalid time',
        'cohort_days_unit': 'd',
        'cohort_hours_unit': 'h',
        'cohort_minutes_unit': 'm',
        isEn: true,
        // Tabbar
        'summary': 'Summary',
        'health': 'Health',
        'details': 'Daily',
        'consultant': 'AI Consultant',
        'sleep_advisor': 'AI Sleep Consultant',
        'my': 'My',
        // 日历
        'sun': 'SUN', 'mon': 'MON', 'tue': 'TUE', 'wed': 'WED', 'thu': 'THU', 'fri': 'FRI', 'sat': 'SAT',
        'jan': 'Jan', 'feb': 'Feb', 'mar': 'Mar', 'apr': 'Apr', 'may': 'May', 'jun': 'Jun', 'jul': 'Jul', 'aug': 'Aug', 'sep': 'Sep', 'oct': 'Oct', 'nov': 'Nov', 'dec': 'Dec',
        'calendar_today': 'Today',
        'stage_axis_awake_time': 'Awake Time',
        'stage_axis_rem_sleep': 'REM Sleep',
        'stage_axis_core_sleep': 'Core Sleep',
        'stage_axis_deep_sleep': 'Deep Sleep',
        // 图表
        'illuminance': 'Illuminance',
        'temperature_abbr': 'Temp',
        'humidity_abbr': 'RH',
        'recent_trend': 'Recent Trend',
        'movement': 'Movement',
        'few': 'Few',
        'occasional': 'Occasional',
        'frequent': 'Frequent',
        'times': ' times',
        'times_abbr': '',
        'osa_mild': 'Mild',
        'osa_moderate': 'Moderate',
        'osa_severe': 'Severe',
        'blood_oxygen_drop': "Estimated Oxygen Desaturation",
        'normal': 'Normal',
        'pay_attention': 'Pay Attention',
        'mild_hypoxia': 'Mild Hypoxia',
        'moderate_severe_hypoxia': 'Moderate-Severe Hypoxia',
        'non_sleep': 'Non-Sleep',
        'personal_baseline': 'Personal Baseline',
        'baseline': 'Baseline',
        'out_of_baseline': 'Above/Below',
        'sleep_stages': 'Sleep Stages',
        'apnea_hypopnea_events': 'Apnea-Hypopnea Events',
        'obstructive_apnea_hypopnea_events': 'Obstructive Apnea-Hypopnea Events',
        'average': "Average ",
        'whole_night_sleeping_heart_rate': "Overnight Heart Rate",
        'whole_night_hrv_rmssd': 'Sleeping HRV',
        'whole_night_sleeping_respiratory_rate': "Overnight Respiratory Rate",
        'nap_sleeping_heart_rate': "Nap Heart Rate",
        'nap_hrv_rmssd': 'Sleeping HRV',
        'nap_sleeping_respiratory_rate': "Nap Respiratory Rate",
        'whole_night_snore_events': 'Snore Events',
        'to': ' To ',
        'time_in_bed': 'Time in Bed',
        'rem_duration': 'REM Sleep',
        'deep_sleep_duration': 'Deep Sleep',
        'in_bed': 'In Bed ',
        'get_up': 'Get Up ',
        'lowest_hr': 'Lowest HR',
        'lowest_hr_baseline': 'Lowest HR Baseline',
        'average_hr': 'Average HR',
        'once': 'Once',
        'twice': 'Twice',
        'none': 'None',
        'def_evening': 'Definite Evening',
        'mod_evening': 'Moderate Evening',
        'intermediate': 'Intermediate',
        'mod_morning': 'Moderate Morning',
        'def_morning': 'Definite Morning',
        'sex_index': 'Physiological Sex Index',
        'sleep_inertia': 'Sleep Inertia',
        'morning_peak': 'Morning Peak',
        'afternoon_dip': 'Afternoon Dip',
        'stop_caffeine': 'Stop Caffeine Intake',
        'evening_peak': 'Evening Peak',
        'melatonin_window': 'Melatonin Window',
        'sleep_preparation': 'Wind-down',
        'stop_exercise': 'Avoid Intense Exercise',
        'stop_eating': 'Avoid Late Meals',
        // 首页
        'index_title': 'Daily Report',
        'sleep_quality_abbr': 'Sleep Quality',
        'total_sleep_time_abbr': 'Total Sleep',
        'deep_sleep_duration_abbr': 'Deep Sleep',
        'lowest_heart_rate_abbr': 'Lowest HR',
        'avg_hrv_rmssd_abbr': 'Heart Rate Variability',
        'avg_respiratory_rate_abbr': 'Avg RR',
        'ahi_abbr': 'Apnea-Hypopnea Index',
        'oahi_abbr': 'Obstructive Apnea-Hypopnea Index',
        'date': 'Date',
        'from': 'From',
        'today_summary': 'Today',
        'report_summary': 'Summary',
        'connection': 'Network',
        'disconnected': 'Disconnected',
        'sleep_score': 'Score',
        'sleep_time': 'Total Sleep',
        'deep_sleep': 'Deep Sleep',
        'wake': 'Awake',
        'rem': 'REM',
        'light': 'Light',
        'deep': 'Deep',
        'active': 'Active',
        'leave_bed': 'Away',
        'signal_missing': 'Data Missing',
        'signal_missing_description': 'Signal lost due to unstable network.\nDevice is re-uploading, please keep it powered on.',
        'ahi': 'Apnea-Hypopnea Index (AHI)',
        'oahi': 'Obstructive Apnea-Hypopnea Index (OAHI)',
        'lowest_heart_rate': 'Lowest Heart Rate',
        'hrv': 'Heart Rate Variability',
        'bpm': 'bpm',
        'ms': 'ms',
        's': 's',
        'light_ratio': 'Light Exposure',
        'light_ratio_short': 'Light Exposure',
        'temperature': 'Temperature',
        'humidity': 'Humidity',
        'nodata': 'Unavailable',
        'nodata_abbr': 'N/A',
        'select_feel': 'Rate Your Sleep',
        'recorded_feel': 'Sleep Rating',
        'osa_healthy': 'Normal',
        'osa_mild_risk': 'Mild Risk',
        'osa_moderate_risk': 'Moderate Risk',
        'osa_severe_risk': 'Severe Risk',
        'status_normal': 'Normal',
        'status_equal': 'Neutral',
        'status_low': 'Low',
        'status_high': 'High',
        'status_improved': 'Improved',
        'status_reduced': 'Reduced',
        'status_insufficient': 'Insufficient',
        'status_excessive': 'Elevated',
        'status_normal': 'Normal',
        'status_stable': 'Stable',
        'status_abnormal': 'Abnormal',
        'status_optimal': 'Good',
        'status_below': 'Low', //'Below Baseline',
        'status_above': 'High', //'Above Baseline',
        'status_no_baseline': 'Unavailable',
        'time_min': " min",
        'time_minute': 'm',
        'time_hr': 'h ',
        'time_hours': ' hour(s)',
        'time_days': ' day(s)',
        'err_login': 'Start using Sleep Tracking Mat today to know your sleep better. Please register and pair your mat.',
        'err_bind': 'Start using Sleep Tracking Mat today to know your sleep better. Please pair your mat.',
        'err_zero': 'No sleep report yet. Start using Sleep Tracking Mat today to know your sleep better.',
        'err_network': 'Network or service error. Please refresh to try again.',
        'err_go_login': 'Register',
        'err_go_bind': 'Pair Mat',
        'err_go_fill': 'Fill Out Form',
        'err_contact_service': 'Contact Us',
        'err_check_device': 'Check Connection',
        'show_details': 'Show Details',
        'hide_details': 'Hide Details',
        'before_2300': 'Before 23:00',
        'irrelevant_activity': 'Activities in Bed',
        'less_ten_min': '<10 Min',
        'less_twenty_min': '<20 Min',
        'sustained_wake': 'Sustained Wakefulness',
        'sleep_habits': 'Sleep Hygiene',
        'sleep_routine': 'Sleep Routine',
        'dim_before_bedtime': 'Dim before Bed',
        'bright_after_wakingup': 'Waking up Bright',
        'hygiene_score': 'Sleep Habits Score',
        'daytime_energy': 'Daytime Energy',
        'energy_score': 'Energy Potential',
        'energy_curve': 'Energy Schedule',
        'recommended_sleep': 'Recommended Sleep Duration',
        'expected_recovery': 'Estimated Recovery Period',
        // recoveryDetailContent
        'wakeup_recovery': 'Wake-up Recovery',
        'sleep_sufficiency': 'Sleep Sufficiency',
        'body_repair': 'Body Repair',
        'sleep_stability': 'Sleep Stability',
        'physiology_stability': 'Physiological Stability',
        'sleep_analysis': 'Sleep Analysis',
        'recovery_analysis': 'Recovery Analysis',
        'sleep_metrics': 'Sleep Metrics',
        'sleep_latency': 'Sleep Latency',
        'sleep_interruption_duration': 'Sleep Interruptions',
        'rem_sleep_duration': 'REM Sleep Duration',
        'sleep_environment_detail': 'Sleep Environment (Temp/Humidity/Light)',
        'apnea_hypopnea_index_full': 'Apnea Hypopnea Index',
        'lowest_and_average_heart_rate': 'Lowest / Avg Heart Rate',
        'average_hrv': 'Average HRV',
        'heart_rate_variability': 'Heart Rate Variability',
        'respiratory_events_distribution': 'Distribution of Respiratory Events',
        'autonomic_nervous_system_activity': 'Autonomic Nervous System Activity',
        'rhythm_experimental': 'Cardiac Rhythm in Breathing Cycle (Experimental)',
        'hrv_recovery_experimental': 'HRV Recovery (Experimental)',
        'depression_prediction_index': 'Depression Prediction Index',
        'sbp_mean': 'Mean Systolic Blood Pressure',
        'sbp_mean_desc': 'In healthy individuals, average nighttime systolic blood pressure is typically below 120 mmHg and 10-20% lower than the daytime average, known as a normal dipping blood pressure pattern. If nighttime blood pressure drops by less than 10% or instead rises, it suggests increased cardiovascular risk.',
        'no_more_data': 'No More Data',
        'query_failed': 'Query Failed',
        'previous_week': "Prev",
        'next_week': "Next",
        'baseline_upper': "Baseline Upper",
        'activity': 'Activity',
        'predicted_sleep_maintenance_duration': 'Predicted Sleep Maintenance',
        'predicted_sleep_duration': 'Predicted Sleep Duration',
        'inhalation_phase_heartbeat_count': 'Heartbeats During Inhalation',
        'exhalation_phase_heartbeat_count': 'Heartbeats During Exhalation',
        'accumulated_sleep_debt': 'Accumulated Sleep Debt',
        'daily_sleep_debt': 'Daily Sleep Debt',
        'deep_rem_duration': 'Deep / REM Duration',
        'movement_index': 'Movement Index',
        // 报告详情页
        'details_title': 'Details',
        'trends': 'Trends',
        'sleep_parameters': 'Sleep Parameters',
        'sleep_quality': 'Sleep Quality',
        'sleep_quality_score': 'Sleep Quality Score',
        'vs_yesterday': 'vs Yesterday',
        'vs_weekly_avg': 'vs Weekly Avg',
        // New Home (pageHome)
        'sleep': 'Sleep',
        'recovery': 'Recovery',
        'sleep_score_label': 'Sleep Score',
        'recovery_score_label': "Recovery",
        'tap_to_view': "Tap to view",
        'aging_speed': 'Aging Speed',
        'system_status': 'System Status',
        'sleep_structure': 'Sleep Stages',
        'respiratory_health': 'Respiratory Health',
        'heart_health': 'Heart Health',
        'neuro_health': 'Neuro Health',
        'sleeping_heart_rate': "Sleep Heart Rate",
        'sleeping_hrv': 'Sleeping HRV',
        'sleeping_respiratory_rate': "Sleep Respiratory Rate",
        'sleep_environment': 'Sleep Environment',
        'data_labs': 'Data Research Lab',
        'generated': 'Generated',
        'total_sleep_time': 'Total Sleep Time',
        'sleep_efficiency': 'Sleep Efficiency',
        'sleep_onset_latency': 'Sleep Onset Latency',
        'wake_after_sleep_onset': 'Sleep Interruptions',
        'sleep_disturbance': 'Disturbance',
        'rem_sleep': 'REM Sleep',
        'light_sleep': 'Light Sleep',
        'sleep_regularity': 'Sleep Regularity',
        'sleep_wakeup_time': 'Sleep Onset/Wake Up',
        'nrem_ahi': 'NREM AHI',
        'rem_ahi': 'REM AHI',
        'nrem_oahi': 'NREM OAHI',
        'rem_oahi': 'REM OAHI',
        'avg_hrv_rmssd': 'Avg HRV',
        'avg_heart_rate': 'Avg Heart Rate',
        'avg_respiratory_rate': 'Avg Respiratory Rate',
        'avg_temperature': 'Avg Temperature',
        'avg_humidity': 'Avg Humidity',
        'lowest': "Lowest ",
        'highest': 'Highest',
        'light_exposure_ratio': 'Light Exposure',
        'light_exposure_ratio_short': 'Light Exposure',
        'ideal': 'Ideal',
        'good': 'Good',
        'fair': 'Fair',
        'long': 'Long',
        'too_long': 'Long',
        'late': 'Late',
        'too_late': 'Late',
        'short': 'Short',
        'too_short': 'Short',
        'low': 'Low',
        'too_low': 'Low',
        'little': 'Short',
        'too_little': 'Short',
        'dark': 'Dim',
        'too_dark': 'Dim',
        'bright': 'Bright',
        'too_bright': 'Bright',
        'irregular': 'Irreg',
        'not_applicable': 'N/A',
        'snore': 'Snore',
        'snore_analysis': "Snoring Analysis",
        'snore_index': "Snoring Index",
        'timing': 'Timing',
        'daytime_nap': 'Daytime Nap',
        // sleepDetailContent
        'core_metrics': 'Key Metrics',
        'last_night_sleep_structure': 'Last Night Sleep Stages',
        'last_night_no_report': 'Report not yet generated for last night',
        'tab_overview': 'Overview',
        'tab_body': 'Vitals',
        'tab_stages': 'Stages',
        'tab_environment': 'Environment',
        'peer_position': 'Among peers',
        // reportMyNew
        'realtime_monitoring': 'Realtime Monitoring',
        'realtime_monitor_data_title': 'Realtime Data',
        'realtime_heart_rate': 'Heart Rate',
        'avg_heart_rate_unit': 'Avg HR (bpm)',
        'avg_respiratory_rate_unit': 'Avg RR (/min)',
        'other_data': 'Other Data',
        'out_of_bed': 'Out of Bed',
        'effective_time': 'Effective Time',
        'recommend_friend': 'Recommend Friend',
        'my_reports': 'My Reports',
        'sleep_breathing_report_analysis': 'Sleep Breathing Report Analysis',
        'device_connected': 'Device Connected',
        'device_online': 'Device Online',
        'device_offline': 'Device Offline',
        'wifi_pending_config': 'Pending',
        'wifi_configured': 'Configured',
        'not_connected': 'Disconnected',
        'friend_unit': ' friends',
        'sleep_advisor_tagline': 'Based on sleep monitoring and evidence-based interventions, we’ll help you rebuild healthy sleep step by step.',
        'wechat_search_wuji': 'Search on WeChat: Five Seasons Medical',
        'nap_details': 'Details of Nap',
        'daytime_nap_duration': 'Nap Duration',
        'nap': 'Nap',
        'night_sleep': 'Nighttime Sleep',
        // 数据研究页
        'data_lab_title': 'Data Lab',
        'data_lab_trend_title': 'Data Lab',
        'back': 'Back',
        'about_data_lab': 'About Metrics in Data Lab',
        'about_data_lab_details': 'Metrics for research evaluation purposes are displayed here, aiming to provide researchers with more metrics with medical and scientific research value, and also allowing interested users to explore personal health data more deeply.',
        'ah_events_distribution': 'Apnea-Hypopnea Events',
        'avg_hrv_lfhf': 'Avg HRV LF/HF',
        'light_sleep_ahi': 'N1 & N2 AHI',
        'deep_sleep_ahi': 'N3 AHI',
        'rr_plot': 'HRV Poincaré Plot',
        'rrv_plot': 'RRV Poincaré Plot',
        'rrv': 'Respiratory Rate Variability',
        'avg_rrv': 'Average Respiratory Rate Variability',
        'resp_interval': 'Respiratory Interval(RI)',
        'resp_sdri': 'Standard Deviation of RI',
        'resp_cv': 'Coefficient of Variation of RI(CV%)',
        'resp_dc': 'Duty Cycle(DC%)',
        'hrv_rri': 'Mean RR Interval',
        'hrv_sdnn': 'SDNN',
        'hrv_nn50': 'NN50 per hour',
        'hrv_pnn50': 'pNN50',
        'odi': 'Oxygen Desaturation Index (ODI)',
        'light_sleep_odi': 'N1 & N2 ODI',
        'deep_sleep_odi': 'N3 ODI',
        'rem_odi': 'REM ODI',
        'nrem_odi': 'NREM ODI',
        'oxygen': 'Oxygen',
        'whole_night': 'All night',
        'rem_latency': 'REM Latency',
        'cpc_index': 'Cardiopulmonary Coupling Index',
        'cpc': 'Cardiopulmonary Coupling',
        'cpc_coupling': 'Cardiopulmonary Coupling (CPC)',
        'stable_sleep_ratio': 'Stable Sleep',
        'sleep_entry': 'Sleep Onset Process',
        'sleep_entry_awake': 'Awake',
        'sleep_entry_asleep': 'Asleep',
        'time_to_wakeup': 'Remaining Time to Natural Awakening',
        'wake_index': 'Wakefulness Index',
        'chronotype': 'Chronotype',
        'sleep_and_sex': 'Sleep and Physiological Sex',
        'circadian_rhythm': 'Circadian Rhythm',
        'circadian_strength_index': 'Circadian Strength Index',
        'ans_activity': 'Autonomic Nervous System Activity',
        'sns': 'SNS',
        'pns': 'PNS',
        'hrv_recovery': 'HRV Recovery',
        'hrv_morning': 'Morning HRV',
        'hrv_evening': 'Evening HRV',
        // 顾问页
        'consultant_title': 'AI Consultant',
        'beta': 'beta',
        'enter_your_question': 'Enter your question',
        'for_reference_only': 'For reference only. If in doubt, please consult your physician.',
        // 我的设置页
        'account_settings': 'Account Settings',
        'fill_in_personal_information': 'Fill in Personal Info',
        'update_personal_information': 'Update Personal Info',
        'bind_your_device': 'Pair Device',
        'device_settings': 'Device Settings',
        'set_up_wifi': 'Set Up WiFi',
        'check_device_status': 'Check Device Status',
        'view_manual': 'User Manual',
        'times_per_hour': 'times/hr',
        'contact_customer_service': 'Customer Service',
        'forward_to_friends': 'Forward to Friends',
        'please_fill_in': 'Recommended',
        'please_set_up': 'Recommended',
        'long_press_to_follow': 'Long press the QR code to follow @FiveSeasonsMedical and your sleep reports will be automatically pushed.',
        'qr_overlay_long_press': 'Long Press QR Code',
        'qr_overlay_auto_push_reports': 'Auto-push Sleep Reports',
        'qr_overlay_add_sleep_advisor': 'Add Sleep Advisor · Yuan Haomeng',
        'sleep_advisor': 'Sleep Advisor - Yuan Haomeng',
        'sleep_advisor_desc': 'Long press QR code to add sleep advisor',
        'sleep_advisor_title': 'Sleep Advisor · Yuan Haomeng',
        'sleep_advisor_intro': 'Based on sleep monitoring and evidence-based intervention, accompany you step by step to rebuild good sleep',
        'binded_to': 'Paired ',
        'not_binded': 'N/A',
        'please_login': 'Please Login',
        'logout': 'Logout',
        'confirm_logout': 'Are you sure you want to logout?',
        'please_pair': 'Please Pair',
        'please_authorize': 'Please Authorize',
        'register_and_login': 'Register/Login',
        'wechat_version_low': 'Please update WeChat version',
        'getting_started': 'Getting Started',
        'help_support': 'Help & Support',
        // 趋势页
        'health_trend_title': 'Trends',
        'full_trend': 'Long-term Trends',
        'about_baseline': 'About Personal Baseline',
        'baseline_intro1': 'The personal baseline shows how your sleep metrics typically perform most of the time. Referring to the personal baseline can help you understand the stability of your sleep metrics and identify any abnormal fluctuations.',
        'baseline_intro2': 'The green area in the chart represents the data range for 80% of the time over the past 60 days. For example, your personal baseline for sleep quality score is {vlow} - {vhigh}, which means that 80% of the time in the past 60 days, your sleep quality score was between {vlow} and {vhigh}.',
        // 长期趋势页
        'trend_title': 'Long-term Trends',
        'month': 'Month',
        'year': 'Year',
        'previous_month': "Prev",
        'next_month': 'Next',
        'previous_year': "Prev",
        'next_year': 'Next',
        'basic_sleep_parameters': 'Basic Parameters',
        'rem_and_deep_duration': 'REM & Deep Sleep Duration',
        'sleep_stages_duration': 'Durations of Sleep Stages',
        'sleep_stages_ahi': 'AHI of Sleep Stages',
        'lowest_and_average_heart_rate': 'Lowest and Average Heart Rate',
        'lowest_hr_time': 'Time of Lowest Heart Rate',
        'awakenings': 'Awakenings',
        // 个人信息页
        'personal_info_title': 'Personal Info',
        'personal_info_intro': 'To better analyze and interpret your sleep data, we need to learn more about you.',
        'personal_info_intro_for_friend1': 'To better analyze and interpret the sleep data, we need to learn more about the user.',
        'personal_info_intro_for_friend2': 'To better analyze and interpret the sleep data, we need to learn more about the user.\n\nPlease provide the following information for the user of the mat with ID <b>{did}</b>.',
        'need_personal_info': 'Complete Your Profile',
        'profile': 'Profile',
        'gender': "Sex",
        'choose_gender': 'Please select',
        'date_of_birth': 'Date of Birth',
        'choose_dob': 'Please select',
        'height': 'Height',
        'choose_height': 'Please select',
        'weight': 'Weight',
        'choose_weight': 'Please select',
        'bmi': 'Body Mass Index(BMI)',
        'ever_diagnosed': 'Ever been diagnosed with sleep disorders',
        'please_select': 'Please select',
        'diagnose_none': 'Not been diagnosed with any sleep disorders',
        'diagnose_insomnia': 'Insomnia disorders',
        'diagnose_chronic_insomnia': 'Chronic insomnia',
        'diagnose_short_term_insomnia': 'Short-term insomnia',
        'diagnose_insomnia_unspecified': 'Insomnia disorders, unspecified',
        'diagnose_breathing_disorder': 'Sleep-related breathing disorders',
        'diagnose_csa': 'Central sleep apnoea',
        'diagnose_osa': 'Obstructive sleep apnoea',
        'diagnose_hypoxemia': 'Sleep-related hypoventilation or hypoxemia disorders',
        'diagnose_other': 'Other sleep disorders',
        'diagnose_hypersomnolence': 'Hypersomnolence disorders (Narcolepsy, Hypersomnia, etc)',
        'diagnose_rhythm': 'Circadian rhythm sleep-wake disorders',
        'diagnose_parasomnia': 'Parasomnia disorders',
        'diagnose_movement': 'Sleep-related movement disorders',
        'diagnose_other_disorder': 'Other sleep disorders (specified and unspecified)',
        'saving': 'Saving',
        'save': 'Save',
        'cancel': 'Cancel',
        'confirm': 'Confirm',
        'cm': ' cm',
        'kg': ' kg',
        'male': 'Male',
        'female': 'Female',
        'item': ' Item',
        'items': ' Items',
        'not_saved': 'Close without saving',
        'confirm_not_to_save': 'Changes you made have not been saved. Close without saving?',
        'error_saving': 'Error Saving Changes',
        'save_completed': 'Saved',
        // 绑定设备页
        'pair_device_title': 'Pair Device',
        'pair_device_intro': `Enter the 7-digit number printed on the back of the controller, and press Confirm to pair.\n\nEach mat can only be paired with one user. If you transfer your mat to another user, press Unpair first.`,
        'new_device_number': '7-digit number',
        'unpair': 'Unpair',
        'paired_with': 'Paired with ',
        'not_paired': 'Not paired',
        'not_login': 'Please Login first',
        'confirm_unpair': 'Confirm Unpair',
        'confirm_no_reports': 'After unpairing, you will no longer be able to view the sleep reports generated by this device.',
        'unpair_succeeded': 'Unpair Succeeded',
        'unpair_failed': 'Unpair Failed',
        'service_error': 'Service Error',
        'pair_succeeded': 'Pair Succeeded',
        'pair_failed': 'Pair Failed',
        'already_paired': 'Already paired',
        'please_unpair_first': 'You already paired a device. Please unpair it first before pairing a new one.',
        'invalid_number': 'Invalid number, please check your input.',
        'input_seven_digit': 'Please input a 7-digit number.',
        'invalid_scan': 'Invalid',
        // 蓝牙配置页
        'setup_wifi_title': 'Set Up WiFi',
        'setup_wifi_intro0': '<p>Set up WiFi for a more stable data connection.</p>',
        'setup_wifi_intro1': `<ol style="padding-left:16px;"><li>Press and hold the button on the back of the controller for 5 seconds, until the indicator light begins flashing blue.</li><li style="margin-top:8px;">Wait 5-10 seconds for the device name <i><b>wuji-mat1-7digit</b></i> to appear below. </li></ol>`,
        'setup_wifi_intro1_m2': `<ol style="padding-left:16px;"><li>Press and hold the button under the screen for 5 seconds, until the WiFi window pops up.</li><li style="margin-top:8px;">Wait 5-10 seconds for the device name <i><b>wuji-mat1-7digit</b></i> to appear below. </li></ol>`,
        'setup_wifi_intro2': `<p>Please tap your device name, and wait for bluetooth pairing to complete.</p>`,
        'setup_wifi_intro3': `<p>Please select your WiFi, and enter the password.</p>`,
        'setup_wifi_intro4': `<p>Trying connecting to WiFi. This might take a while, please wait.</p>`,
        'select_device': 'Found device(s):',
        'select_wifi': 'Choose your WiFi',
        'choose_wifi_connect': 'Choose your WiFi',
        'password': 'Password',
        'input_password': 'WiFi Password',
        'log_enabled': 'Log Enabled',
        'bluetooth_error': 'Bluetooth Function Error:',
        'other_devices': 'Scan Devices:',
        'scanning': 'Searching for your device...',
        'scanning_more': 'Searching for other devices...',
        'wait_while_saving': 'Saving, Please Wait',
        'select_wifi_first': 'Select WiFi first',
        'input_password_please': 'Please enter password',
        'connected': 'Connected',
        'getting_service': 'Getting Services...',
        'get_service_completed': 'Getting Services Completed',
        'getting_params': 'Getting Params...',
        'get_params_completed': 'Getting Params Completed',
        'getting_wifi_list': 'Getting WiFi List...',
        'wifi_items': ' WiFi(s)',
        'no_available_wifi': 'No available WiFi',
        'wait_while_connecting': 'Connecting WiFi, Please Wait',
        'setup_completed': 'Setup Completed',
        'back_of_controller': 'Back',
        'front_of_controller': 'Front',
        'led': 'LED',
        'pair_button': 'Pair Button',
        'dlg_bluetooth_error': 'Bluetooth Error',
        'dlg_make_sure_wechat_permission': 'Please ensure that the corresponding permission settings to allow WeChat to use Bluetooth are enabled.',
        'dlg_phone_low_no_bluetooth': 'Your mobile phone version is too low to support Bluetooth. Please try again with a different phone.',
        'dlg_refused_mp_bluetooth': 'You have denied this mini-program to access Bluetooth. Please re-enter this page and select Allow when the prompt appears.',
        'dlg_no_permission_bluetooth': 'Bluetooth cannot be accessed due to your permission settings. Please tap the right-top corner ••• > Settings > Bluetooth, and select Allow.',
        'dlg_no_bluetooth': 'Bluetooth is unavailable. Please enable Bluetooth in your phone settings first.',
        'dlg_check_wechat_bluetooth': ' Also check your phone system settings under Settings > Privacy & Security > Bluetooth to ensure that WeChat is allowed to use Bluetooth.',
        'dlg_check_location_permission': 'For some Android devices, when using Bluetooth, please ensure that location services are enabled and that WeChat is granted permission to access Location Information and Nearby Devices.',
        'dlg_connection_failed': 'Connection Failed',
        'dlg_retry_connection': 'Please ensure the blue indicator light is flashing, then try again.',
        'dlg_ble_connection_failed': 'Bluetooth Connection Failed',
        'dlg_check_ble_retry': 'Please ensure Bluetooth on your phone is working correctly, and try again.',
        'dlg_wifi_scan_timeout': 'Timeout Scanning WiFi',
        'dlg_retry_wifi_scan': 'Please ensure the blue indicator light is flashing, then try again.',
        'dlg_no_available_wifi': 'WiFi Unavailable',
        'dlg_open_router': 'Please ensure the WiFi router is turned on, and try again.',
        'dlg_ble_disconnected': 'Bluetooth Disconnected',
        'dlg_pwd_wrong': 'Wrong WiFi Password',
        'dlg_check_password_retry': 'Please verify the password, and try again.',
        'dlg_error_connecting_wifi': 'Error Connecting WiFi',
        'dlg_ensure_wifi': 'Please ensure the WiFi is available and the entered password is correct. And try again',
        'flashing_blue': 'Flashing Blue',
        'flashing_green': 'Flashing Green: Connecting to WiFi',
        'solid_green': 'Solid Green: Connection established',
        'long_press': 'Long Press',
        'wifi_status': 'WiFi Status',
        // 设备状态页
        'device_status_title': 'Device Status',
        'device_id_label': 'ID',
        'check_device': 'Check Device',
        'device_status': 'Device Status',
        'id_number': 'No.',
        'network_type': 'Network Type',
        'last_seen_network_type': 'Last Seen Network Type',
        'cellular_signal_quality': 'Cellular Signal',
        'wifi_signal_quality': 'WiFi Signal',
        'realtime_data': 'Realtime Data',
        'timestamp': 'Timestamp',
        'bed_status': 'Bed Status',
        'status_in_bed': 'In Bed',
        'status_out_of_bed': 'Out of Bed',
        'status_na': 'N/A',
        'status_measure': 'Measuring',
        'status_unknown': 'Unknown',
        'status_connected': 'Connected',
        'status_no_connection': 'Disconnected',
        'realtime_hr': 'Heart Rate',
        'realtime_rr': 'Resp Rate',
        'troubleshooting': 'Troubleshooting',
        'resolve_no_connection': 'How to resolve connection issues',
        'resolve_poor_signal': 'How to resolve poor network signal',
        'recommend_wifi': 'To obtain more real-time and stable data, it is recommended to setup WiFi connection.',
        'connecting': 'Connecting',
        'type_wifi': 'WiFi',
        'type_cellular': 'Built-in Cellular',
        'signal_excellent': 'Excellent',
        'signal_good': 'Good',
        'signal_weak': 'Weak',
        'signal_no': 'Not available',
        'error_connecting_service': 'Service Error',
        'please_wait': 'Please wait',
        'tip_nodata': `<p>If the realtime data does not display correctly or appears intermittently, please troubleshoot as follows:</p>
                <ol style="padding-left:16px; margin-top:8px;"><li>Reconnect the power supply of the mat, using a 5V 2A USB power adapter.</li>
                <li>After connecting the power, the indicator light will blink, then stay on for about 30 seconds before turning off. This indicates that the device is operating normally.</li>
                <li>The mat uses a built-in cellular network by default to collect sleep tracking data. Poor network signal quality may affect data accuracy. Setting up a WiFi connection is recommended.</li>
                <li>If the realtime data still does not display correctly, please contact customer service for assistance.</li></ol>`, 
        'tip_low_signal': `<p>The mat uses a built-in cellular network by default to collect sleep tracking data. Poor network signal quality may affect data accuracy. In this case, please setup a WiFi connection. </p>
            <p style="margin-top: 6px;">After configuring WiFi, if the signal strength is weak (only one bar), it may indicate that the mat is too far from the WiFi router or that indoor walls are obstructing the signal. Consider repositioning the WiFi router to be closer to the mat.</p>`,
        // 说明书
        'user_manual_title': 'User Manual',
        'choose_model': 'Select Model',
        'choose_model_link': 'Select Model Instructions',
        'model_selections': 'Select your model to view manuals',
        'with_screen': 'with Touch Screen',
        // 健康页
        'health_title': 'Health',
        'sleep_checkup_title': 'Sleep Checkup',
        'health_header': 'Track sleep health trajectory and uncover potential health risks based on long-term data.',
        'health_footer': 'It is important to note that the Health section is not intended to make diagnoses and should not be used as the basis for disease treatment. It is recommended that you consult a healthcare professional before making medical decisions.',
        'osa': 'Obstructive Sleep Apnea (OSA)',
        'sleep_apnea_syndrome': 'Sleep Apnea Syndrome',
        'osa_possible_healthy': 'Low Risk of OSA',
        'osa_possible_mild': 'Possible Mild OSA',
        'osa_possible_moderate': 'Possible Moderate OSA',
        'osa_possible_severe': 'Possible Severe OSA',
        'comment_nodata': 'Currently accumulating your health data, please continue sleep monitoring for at least 14 days.',
        'ahi_comment_no_risk': 'Recent AHI show no signs of obstructive sleep apnea. It is recommended that you continue to monitor this metric and maintain healthy lifestyle habits.',
        'ahi_comment_possible_risk': 'Some AHI values are elevated. It is recommended to adopt side-sleeping, reduce smoking and alcohol intake, control your weight, and avoid sedative medications.',
        'ahi_comment_mild_risk': 'Recent AHI indicate possible mild obstructive sleep apnea. It is recommended that you promptly adjust your lifestyle — for example, adopt side-sleeping, reduce smoking and alcohol intake, control your weight, and avoid sedative medications — and, if necessary, seek further consultation and examination at a professional medical institution.',
        'ahi_comment_moderate_risk': 'Recent AHI indicate possible moderate obstructive sleep apnea. It is recommended that you promptly adjust your lifestyle — for example, adopt side-sleeping, reduce smoking and alcohol intake, control your weight, and avoid sedative medications — and undergo a detailed examination at a professional medical institution.',
        'ahi_comment_severe_risk': 'Recent AHI indicate possible severe obstructive sleep apnea. It is recommended that you seek medical attention promptly for a detailed diagnosis, and discuss with your doctor appropriate treatment options, such as the use of continuous positive airway pressure (CPAP) devices or other interventions.',
        'afib': 'Atrial Fibrillation Detection',
        'afib_screening': 'AFib Screening',
        'afib_burden': 'AFib Burden',
        'whole_night_afib_events': 'AFib Episodes',
        'afib_event': 'AFib Episodes',
        'afib_description': 'Atrial Fibrillation (AFib) is the most common form of arrhythmia, characterized by an unsynchronized beating of the heart’s upper and lower chambers. AFib itself usually isn\'t life-threatening, but it\'s a serious medical condition that needs proper treatment. Research indicates that AFib episodes lasting more than 5 minutes significantly increase the risk of stroke, with the risk growing as the duration increases.\n\nAFib Burden measures the percentage of total sleep time during which you are in a suspected AFib state. Please note that AFib does not mean that your heartbeat is always irregular; even a low AFib burden warrants attention. For more details on recent AFib episodes, please refer to the Health section.\n\nThis feature is not a substitute for clinical diagnosis. If AFib is detected, it is recommended that you seek further consultation and examination at a professional medical institution.',
        'no_afib_signs': 'No Signs of AFib Detected',
        'detected_afib_signs': 'Signs of AFib Detected',
        'no_afib_signs_comment': 'Recent heart rhythm data show no signs of AFib. It is recommended to continue monitoring this indicator.',
        'detected_afib_signs_comment': 'Your heart show signs of irregular rhythms suggestive of AFib. If your haven\'t been diagnosed with AFib, it is recommended that you seek further consultation and examination at a professional medical institution.',
        'afib_5_min': 'Recent AFib episodes lasting more than 5 minutes: ',
        'afib_longest': 'Recent longest AFib episode duration: ',
        'sleep_health': 'Sleep Health',
        'sleep_age': 'Sleep Age',
        'real_age': 'Chronological Age',
        'age': 'Age',
        'risk_multiplier': 'Hazard Ratio of Health Risk',
        // 亲友
        'friends_and_family': 'Friends & Family',
        'share_access': 'Share Access',
        'my_follows': 'My Follows',
        'following': 'Following ',
        'following_people': '',
        'followed_by': 'Followed by ',
        'followed_by_people': '',
        'followed_by_intro': 'You can share the 8-character authorization code below with a friend or family member, they’ll be able to follow and view all your sleep reports. \n\nYou can revoke their access at any time.',
        'my_auth_code': 'Authorization Code',
        'share_code_p1': 'Valid for 10 minutes. Tap ',
        'share_code_here': 'here',
        'share_code_p2': ' to share.',
        'my_followers': 'Followed By',
        'remove': 'Remove',
        'follow_time': 'Added at: ',
        'remove_succeeded': 'Remove Succeeded',
        'remove_failed': 'Remove Failed',
        'confirm_remove': 'Confirm Removal',
        'confirm_removal_of': 'Confirm removal of ',
        'confirm_removal_p2': ' ?',
        'following_intro': 'You can follow the sleep reports of your friends or family.\n\nIf your friend has already paired their device:\n1. Ask them for their 8-character authorization code.\n2. Enter the code below within 10 minutes.\n\nIf the device hasn’t been paired yet, simply enter the 7-digit ID printed on the back of the controller.',
        'alias': 'Alias',
        'alias_placeholder': 'Please input alias',
        'auth_code_or_device': 'Auth code',
        'revoked': 'Revoked',
        'device': 'Device ',
        'length_control': 'No more than 7 letters',
        'letters_control': 'Letters and numbers only',
        'input_valid_code': 'Please enter a valid authorization code or device ID.',
        'added_successfully': 'Added Successfully',
        'limit_exceeded': 'Limit Exceeded',
        'add_failed': 'Add Failed',
        'no_follow_self': 'Can\'t follow yourself.',
        'code_expired': 'Code Expired',
        'code_invalid': 'Invalid Code',
        'confirm_follow': 'Confirm Follow',
        'confirm_follow_p1': 'Confirm to follow ',
        'confirm_follow_p2': ' ?',
        'avoid_freq_retry': 'Please avoid submitting frequently',
        'err_and_retry': 'Service error, please retry',
        // === wuji_manager-org admin specific ===
        'logout': 'Logout',
        'unknown_user': 'Unknown User',
        'switch_language': 'Switch Language',
        'device_management': 'Devices',
        'report_management': 'Reports',
        'user_management': 'Users',
        'medical_dictionary': 'Medical Dictionary',
        // -- Login / Register --
        'welcome_use': 'Welcome',
        'wuji_sleep_workstation': 'Five Seasons Sleep Monitoring Workstation',
        'login_account': 'Sign In',
        'please_input_account': 'Please enter your username',
        'please_input_password': 'Please enter your password',
        'please_input_phone': 'Please enter phone number',
        'please_input_valid_phone': 'Please enter a valid phone number',
        'please_input_verification_code': 'Please enter the verification code',
        'phone_number': 'Phone Number',
        'verification_code': 'Verification Code',
        'send_verification_code': 'Send Code',
        'resend_after_seconds': 's to resend',
        'remember_password': 'Remember me',
        'forgot_password': 'Forgot password?',
        'login': 'Sign In',
        'register_account': 'Sign up',
        'phone_code_login': 'Phone code login',
        'use_password_login': 'Use password login',
        'login_failed': "Sign-in failed",
        'login_success_loading': 'Login successful, loading user info...',
        'error': 'Error',
        'login_err_wrong_credentials': 'Login failed. Please verify your credentials and avoid using WeChat browser.',
        'login_err_network': 'Login failed. Please check your network or retry later.',
        'login_err_no_response': 'Server did not respond. Please retry later.',
        'wrong_user_or_password': 'Wrong account or password',
        'send_code_failed': 'Failed to send code',
        // -- Batch 1: OrgDashboard / ReportList --
        'total_devices': 'Total Devices',
        'online_devices': 'Online',
        'offline_devices': 'Offline',
        'today_report_success': "Today's Reports",
        'baseline_abnormal': 'Baseline Anomaly',
        'sd_card_error': 'SD Card Error',
        'packaging_noise': 'Packaging Noise',
        'search_device_number': 'Search device no.',
        'search': 'Search',
        'filter_by_org': 'Filter by Org:',
        'please_select_org': 'Please select organization',
        'device_status': 'Status:',
        'report_generated': 'Reported',
        'report_not_generated': 'Not Reported',
        'all': 'All',
        'status_online': 'Online',
        'status_offline': 'Offline',
        'attention_viewing': 'Viewing',
        'enter_batch_mode': 'Batch Mode',
        'exit_batch_mode': 'Exit Batch Mode',
        'settings': 'Settings',
        'edit': 'Edit',
        'edit_info': "Edit Profile",
        'delete': 'Delete',
        'save': 'Save',
        'cancel': 'Cancel',
        'confirm': 'Confirm',
        'close': 'Close',
        'confirm_download': 'Confirm Download',
        'confirm_update': 'Confirm Update',
        'download_report': 'Download Report',
        'scan_block_btn': 'Block Scan',
        'scan_unblock_btn': 'Unblock Scan',
        'scan_block_tip': 'Block selected devices from being scanned to view reports in the mini-program',
        'scan_unblock_tip': 'Restore scan-to-view permission for selected devices',
        'scan_blocked_label': 'Scan Blocked',
        'scan_blocked_tip': 'Users cannot view reports by scanning QR code (mini-program will hide content)',
        'print': 'Print',
        'pillow_control': 'Pillow Control',
        'device_prefix': "Device: ",
        'department': 'Dept:',
        'department_empty': 'Dept: --',
        'bed_number': 'Bed No.',
        'bed_number_colon': 'Bed No.:',
        'remarks': 'Remarks',
        'remarks_colon': 'Remarks:',
        'report_update_time': 'Last Report',
        'name_colon': 'Name:',
        'age_colon': 'Age:',
        'gender_colon': 'Gender:',
        'height_colon': 'Height:',
        'weight_colon': 'Weight:',
        'ethnicity_colon': 'Ethnicity:',
        'birthdate_colon': 'Birthdate:',
        'gender_male': 'Male',
        'gender_female': 'Female',
        'unit': 'Unit',
        'please_input_name': 'Please enter name',
        'please_input_bed_number': 'Please enter bed number',
        'please_input_height': 'Please enter height',
        'please_input_weight': 'Please enter weight',
        'please_input_remarks': 'Please enter remarks',
        'please_input_new_password': 'Please enter new password',
        'please_select': 'Please select',
        'please_select_ethnicity': 'Please select or search ethnicity',
        'start_date': 'Start Date',
        'end_date': 'End Date',
        'select_date': 'Select Date',
        'select_date_range': 'Select Date Range',
        'date_col': 'Date',
        'questionnaire_history': 'Questionnaire History',
        'view_history': 'View History',
        'no_history': 'No history',
        'fill_questionnaire': "Fill Out Questionnaire",
        'select_questionnaire_type': 'Select Type',
        'patient_name': 'Patient Name',
        'psqi_title': 'Pittsburgh Sleep Quality Index (PSQI)',
        'ess_title': 'Epworth Sleepiness Scale (ESS)',
        'psqi_desc': 'Evaluate sleep quality of the past month',
        'ess_desc': 'Evaluate daytime sleepiness',
        'psqi_total_score': 'PSQI Total Score',
        'psqi_submitted_at': 'PSQI Submitted',
        'ess_total_score': 'ESS Total Score',
        'ess_submitted_at': 'ESS Submitted',
        'password_update': 'Change Password',
        'initial_password_hint': 'You are using the initial password. Please change it.',
        'password_min_length_hint': 'Password must be at least 6 characters.',
        'device_info_settings': 'Device Info',
        'field_name': 'Field Name',
        'field_value': 'Field Value',
        'add_custom_field': 'Add Custom Field',
        'download_range_hint': 'Note: If no date range selected, all history will be downloaded.',
        'loading': "Loading…",
        'loading_dot': 'Loading...',
        // -- ReportList extras --
        'date_range_colon': 'Date Range:',
        'clinical_indicators_colon': 'Clinical Metrics:',
        'heart_rate': 'Heart Rate',
        'view_detail': 'View Detail',
        'search_device_id': 'Search device ID...',
        'search_device_id_short': 'Search device ID',
        // -- Register / Retrieve Password / C-end Dashboard --
        'use_phone_code_login': 'Sign in with code',
        'register': 'Register',
        'register_with_phone_password': 'Register with phone & password',
        'register_account_phone_pwd': 'Register with phone & password',
        'register_account_with_code': 'Register with verification code',
        'have_account_go_login': 'Have an account? Sign in',
        'retrieve_password': 'Retrieve Password',
        'save_new_password': 'Save New Password',
        'please_input_password_again': 'Please enter password again',
        'go_bind': "Pair Mat",
        'wuji_sleep_report': 'Five Seasons Sleep Report',
        'wuji_sleep_monitor_device': 'Five Seasons Sleep Monitor',
        'today': 'Today',
        'realtime_rr_title': 'Real-time Respiratory Rate',
        'realtime_hr_title': 'Real-time Heart Rate',
        'not_bound_arrow': 'Not bound >',
        'sign_out': 'Sign out',
        'sleep_monitor': 'Sleep Monitor',
        'welcome_tagline': 'Start using the sleep monitor and understand your sleep now.',
        'binding_number': 'Bind Device No.',
        'network_signal': 'Network Signal',
        'background_image': 'Background',
        'device_info': 'Device Info',
        'please_bind_first': 'Please bind a device first.',
        'select_report_date': 'Select Report Date',
        // -- Batch 2: ReportDetail + Pillow + UserManagement --
        'ahi_14d_trend': 'AHI 14-day Trend',
        'ess_score': 'ESS Score',
        'imu_monitor': 'IMU Monitor',
        'psqi_score': 'PSQI Score',
        'x_axis_angle': 'X Angle:',
        'y_axis_angle': 'Y Angle:',
        'personal_info': 'Personal Info',
        'subjective_awakenings': 'Subjective Awakenings',
        'subjective_sleep_quality': 'Subjective Sleep Quality',
        'supine_ahi': 'Supine AHI',
        'supine_snore_index': "Supine Snoring Index",
        'supine_snore_energy': 'Supine Snore Energy',
        'position_abnormal': 'Position Abnormal',
        'movement_chart': 'Movement Chart',
        'movement_index_abnormal': 'Movement Index Abnormal',
        'weight_setting_kg': 'Weight (kg)',
        'experience_survey': 'Experience Survey',
        'lateral_ahi': 'Lateral AHI',
        'lateral_snore_index': "Lateral Snoring Index",
        'lateral_ratio': 'Lateral Ratio',
        'lateral_snore_energy': 'Lateral Snore Energy',
        'sleep_onset_speed': 'Sleep Onset',
        'other_abnormal': 'Other Abnormal',
        'birthdate': "Date of Birth",
        'delete_field': 'Delete Field',
        'action_done': 'Action Completed',
        'pressure_abnormal': 'Pressure Abnormal',
        'pressure_posture_abnormal': 'Pressure Posture Abnormal',
        'raw_data': 'Raw Data',
        'sleep_stages_duration_title': 'Sleep Stage Durations',
        'respiratory_events_t': 'Respiratory Events',
        'respiratory_events_abnormal': 'Respiratory Events Abnormal',
        'respiratory_detection_abnormal': 'Respiratory Detection Abnormal',
        'in_bed_t': 'In Bed',
        'basic_info': 'Basic Info',
        'note': 'Note',
        'remarks_empty': 'Remarks: --',
        'head_stretch_intervention': 'Head-stretch Intervention',
        'head_stretch_duration': 'Head-stretch Duration',
        'head_stretch_count': 'Head-stretch Count',
        'name': 'Name',
        'not_bound': 'Not bound',
        'left_right_intervention': 'Side-to-side Intervention',
        'left_right_duration': 'Side-to-side Duration',
        'left_right_count': 'Side-to-side Count',
        'bound_device': 'Bound Device',
        'bound_device_colon': 'Bound Device:',
        'intervention': 'Intervention',
        'pre_intervention_1min': 'Pre-intervention 1min',
        'pre_intervention_5min': 'Pre-intervention 5min',
        'post_intervention_1min': 'Post-intervention 1min',
        'post_intervention_5min': 'Post-intervention 5min',
        'intervention_duration': 'Intervention Duration',
        'intervention_metrics': 'During-intervention Metrics',
        'pillow_report': 'Pillow Report',
        'pillow_comfort': 'Pillow Comfort',
        'intervention_count': 'Intervention Count',
        'intervention_type': 'Intervention Type',
        'intervention_stats': 'Intervention Stats',
        'start_time': 'Start Time',
        'current_weight': 'Current Weight',
        'current_status_colon': 'Current Status:',
        'rem_and_deep_duration_t': 'REM & Deep Sleep Duration',
        'total_intervention_duration': 'Total Intervention Duration',
        'total_sleep_time_t': 'Total Sleep Time',
        'snore_events_abnormal': 'Snore Events Abnormal',
        'snore_index_t': "Snoring Index",
        'snore_index_14d_trend': "Snoring Index 14-day Trend",
        'batch_unbind': 'Batch Unbind',
        'report_failed': 'Report Failed',
        'report_abnormal': 'Report Abnormal',
        'report_detail': 'Report Detail',
        'taro_view': 'Mobile View',
        'taro_view_hint': 'Embedded mobile view (app.wuji.com), synced with main page date & language',
        'mobile_report_session_missing': 'Your organization session is unavailable. Sign in again to view the mobile report.',
        'metric': 'Metric',
        'date_range_hint_90d_100dev': 'Please select a date range (max 90 days, max 100 devices per export).',
        'search_user_phone_device': 'Search username / phone / device ID...',
        'search_colon': 'Search:',
        'actions': 'Actions',
        'data_missing': 'Data Missing',
        'overall': 'Overall',
        'whole_night_report': "Overnight Report",
        'whole_night_stats': "Overnight Stats",
        'whole_night_snore_energy': "Overnight Snoring Energy",
        'no_intervention_data': 'No intervention data',
        'update_settings': 'Update Settings',
        'monthly_trend': 'Monthly Trend',
        'unbound_device': 'No Device Bound',
        'pillow_control_panel': 'Pillow Control Panel',
        'pillow_status': 'Pillow Status',
        'bind_device_hint_long': 'Each user can bind only one sleep monitor. The 7-digit device number is on the back of the control box. To switch device, enter a new number. To let someone else use the device, unbind first.',
        'bind_device_hint_generic': 'Each user can bind only one device. The 7-digit device number is on the back of the control box. To switch device, enter a new number. To let someone else use the device, unbind first.',
        'per_round_intervention_stats': 'Per-round Intervention Stats',
        'awakenings_count_duration': 'Awakenings / Duration',
        'fsm_3_0': 'FSM 3_0',
        'birthday': 'Birthday',
        'birthday_colon': 'Birthday:',
        'username': 'Username',
        'user_mgmt_title': 'User Management',
        'efficacy_metrics': 'Efficacy Metrics',
        'efficacy_tag': 'Efficacy Tag',
        'sleep_analysis_report': 'Sleep Analysis Report',
        'sleep_respiratory_rate': 'Sleep Respiratory Rate',
        'sleep_hrv': 'Sleep HRV',
        'sleep_efficiency_t': 'Sleep Efficiency',
        'sleep_physiology_metrics': 'Sleep Physiological Metrics',
        'ok': 'OK',
        'strategy': 'Strategy',
        'bind_device': 'Bind Device',
        'end_time': 'End Time',
        'edit_field_name': 'Edit Field Name',
        'edit_user_info': 'Edit User Info',
        'self_pillow_comfort': 'Own-pillow Comfort',
        'comfort_description': 'Comfort Description',
        'spo2_t': 'SpO₂',
        'unbind': 'Unbind',
        'unbind_full': 'Unbind',
        'device_no_colon': 'Device No.:',
        'please_select_date': 'Please select date first',
        'please_input_7digit': 'Please enter 7-digit number',
        'please_input_value': 'Please enter value',
        'please_input_field_name': 'Please enter field name',
        'please_input_username': 'Please enter username',
        'please_select_valid_date_raw': 'Please select a valid report date to view raw data.',
        'please_select_gender': 'Please select gender',
        'round': 'Round',
        'running_status': 'Running Status',
        'select_download_type': 'Download Type:',
        'select_download_option': 'Download Options',
        'select_date_to_view': "Select a date to view the report",
        'select_birthday': 'Select Birthday',
        'snore_index_alt': "Snoring Index",
        'snore_count': 'Snore Count',
        'snore_energy': 'Snore Energy',
        'snore_detection_abnormal': 'Snore Detection Abnormal',
        'no_last_night_data': 'No sleep monitoring data for last night. The monitor may have been disconnected from the network.',
        'check_device_status_hint': 'Please go to My → Device Status to check the device status and find solutions.',
        'please_input': 'Please enter',
        // -- Batch 6: mustache / vbind / array literals --
        'obstructive_short': 'Obstructive',
        'expand_filter': 'Expand Filter',
        'collapse_filter': 'Collapse Filter',
        'select_all': 'Select All',
        'deselect_all': 'Deselect All',
        'not_set': 'Not set',
        'no_name': 'No name',
        'no_username': 'No username',
        'no_phone': 'No phone',
        'bluetooth_available': 'Bluetooth Available',
        'bluetooth_unavailable': 'Bluetooth Unavailable',
        'searching': 'Searching...',
        'search_device': 'Search Device',
        'unknown_device': 'Unknown Device',
        'connecting': 'Connecting',
        'connect': "Network",
        'configuring': "Configuring…",
        'start_config': "Start setup",
        'select_all_channels': '- (Select all channels)',
        'generating': 'Generating...',
        'download_pdf': 'Download PDF',
        'cohort_export_night_pdf': 'Export nightly reports',
        'cohort_night_pdf_hint': 'The server generates every PDF and returns one ZIP. Keep this page open to receive it. Individual downloads are still generated one at a time.',
        'cohort_pdf_export_all': 'Export all PDFs (ZIP)',
        'cohort_pdf_download_zip': 'Download ZIP again',
        'cohort_pdf_exporting': 'Generating PDFs on server:',
        'cohort_pdf_packing_zip': 'Packing ZIP:',
        'cohort_pdf_cancelled': 'Cancelled. No ZIP downloaded. Processed:',
        'cohort_pdf_complete': 'All PDFs generated. Downloading ZIP:',
        'cohort_pdf_incomplete': 'Some nights were left out of the ZIP. Check the failed items. Processed:',
        'cohort_pdf_timeout': 'Report loading or generation timed out',
        'cohort_pdf_render_failed': 'Report loading or generation failed',
        'cohort_pdf_config_failed': 'Device classification configuration unavailable; PDF not generated',
        'cohort_pdf_report_failed': 'Report data missing, invalid or unavailable',
        'cohort_pdf_auth_failed': 'Session expired or export permission denied',
        'cohort_pdf_archive_failed': 'ZIP creation or download failed. Please retry.',
        'cohort_pdf_unauthorized': 'Session expired. Sign in again and retry.',
        'cohort_pdf_forbidden': 'No export permission or subject access. Contact your administrator.',
        'cohort_pdf_not_found': 'Report not found. Refresh the report list.',
        'cohort_pdf_conflict': 'Report identity or data changed. Refresh the list and retry.',
        'cohort_pdf_busy': 'PDF server is busy. Retry later.',
        'cohort_pdf_unavailable': 'PDF service is temporarily unavailable. Retry later.',
        'cohort_pdf_gateway_timeout': 'Server generation timed out. Retry; contact your administrator if it persists.',
        'cohort_pdf_single_complete': 'Server PDF generated and downloaded.',
        'cohort_pdf_single_cancelled': 'Cancelled. No PDF downloaded.',
        'cohort_export_night_pdf_action': 'Export PDF',
        'required_field': 'Required',
        'optional_field': 'Optional',
        // -- Batch 7: assessment / diagnosis / ethnicity --
        'unknown': 'Unknown',
        'moderate': 'Moderate',
        'poor': 'Poor',
        'worse': 'Worse',
        'unavailable': 'Unavailable',
        'ess_normal_range': 'Normal range: Your daytime sleepiness is within the normal range.',
        'ess_mild_drowsy': 'Mild sleepiness: You may experience mild daytime drowsiness.',
        'ess_moderate_drowsy': 'Moderate sleepiness: You have moderate daytime drowsiness. Medical consultation is recommended.',
        'ess_severe_drowsy': 'Severe sleepiness: You have severe daytime drowsiness. Medical consultation is strongly recommended.',
        'gad_no_anxiety': 'No Anxiety',
        'gad_mild_anxiety': 'Mild Anxiety',
        'gad_moderate_anxiety': 'Moderate Anxiety',
        'gad_severe_anxiety': 'Severe Anxiety',
        'meq_definitely_evening': 'Definitely Evening Type',
        'meq_moderately_evening': 'Moderately Evening Type',
        'meq_intermediate': 'Intermediate Type',
        'meq_moderately_morning': 'Moderately Morning Type',
        'meq_definitely_morning': 'Definitely Morning Type',
        'phq_no_depression': 'No Depression',
        'phq_mild_depression': 'Mild Depression',
        'phq_moderate_depression': 'Moderate Depression',
        'phq_moderate_severe_depression': 'Moderately Severe Depression',
        'phq_severe_depression': 'Severe Depression',
        'total_sleep_time_tst': 'Total Sleep Time',
        'sleep_efficiency_se': 'Sleep Efficiency',
        'sleep_onset_sol': 'Sleep Onset Latency',
        'sleep_interruption_waso': 'Sleep Interruptions',
        'sleep_fragmentation_sfi': 'Sleep Fragmentation Index',
        'sfi_unit': 'events/hour',
        'snore_index_si': "Snoring Index",
        'sleep_avg_rr': 'Avg Sleep Respiratory Rate',
        'rem_latency_label': 'REM Sleep Latency',
        'sleep_regularity_sri': 'Sleep Regularity Index',
        'has_report': 'With Report',
        'meq_time_20_21': '8:00–9:00 PM (20:00–21:00h)',
        'meq_time_21_2215': '9:00–10:15 PM (21:00–22:15h)',
        'meq_time_08_10': '8:00–10:00 AM (08:00–10:00h)',
        'meq_very_good': 'Very Good Performance',
        'meq_fair_performance': 'Fair Performance',
        'meq_hard': 'Difficult',
        'meq_very_hard': 'Very Difficult',
        // -- Batch 8: ECharts name / text / categories --
        'register_err_network': 'Registration failed. Please check network or retry later.',
        'password_err_network': 'Password change failed. Please check network or retry later.',
        'activity': 'Activity',
        'off_pillow': 'Off Pillow',
        'sleep_posture': 'Sleep Posture',
        'snoring': 'Snoring',
        'snore_events_short': 'Snore Events',
        'respiratory_events_short': 'Respiratory Events',
        'deep_sleep_short': 'Deep',
        'light_sleep_short': 'Light',
        'rem_short': 'REM',
        'time_seconds': 'Time (s)',
        'angle_deg': 'Angle (°)',
        'x_angle': 'X Angle',
        'y_angle': 'Y Angle',
        'imu_angle_data': 'IMU Angle Data',
        'yesterday': 'Yesterday',
        'login_failed_semi': 'Login failed;',
        // -- Batch 9: ReportDetail ECharts + tab + physiological metrics --
        'sleep_report_detail': 'Sleep Report Detail',
        'device_online_tab': 'Online',
        'birth_gender': "Sex",
        'sleep_onset_latency_label': 'Sleep Onset Latency',
        'wake_after_sleep_onset_label': 'Sleep Interruptions',
        'rem_latency_full': 'REM Sleep Latency',
        'sleep_regularity_index_label': 'Sleep Regularity Index',
        'sleep_fragmentation_label': 'Sleep Fragmentation Index',
        'sleep_stages_label': 'Sleep Stages',
        'hour_char': 'h',
        'minute_char': 'min',
        'minutes_suffix': ' min',
        'times_suffix': " event",
        'minutes_times_fmt': 'min (times)',
        'years_suffix': ' yr',
        'avg_temperature': 'Avg Temperature',
        'avg_humidity': 'Avg Humidity',
        'light_affect_ratio': "Sleep Affected by Light",
        'sleep_min_hr': 'Min Sleep Heart Rate',
        'sleep_avg_hr': 'Avg Sleep Heart Rate',
        'sleep_hrv_rmssd': 'Sleep HRV RMSSD',
        'sleep_hrv_lfhf': 'Sleep HRV LF/HF',
        'bpm_unit': " bpm",
        'ms_unit': " ms",
        'whole_night_hrv_rmssd_t': "Overnight HRV RMSSD",
        'whole_night_rr_t': "Overnight Respiratory Rate",
        'whole_night_hr_t': "Overnight Heart Rate",
        'avg_prefix': 'Avg ',
        'lowest_prefix': 'Min ',
        'blood_oxygen_drop_t': "Overnight SpO₂ Desaturation",
        'spo2_fluctuation': 'SpO₂ Fluctuation',
        'body_movement': 'Body Movement',
        'department_colon_display': 'Dept:',
        'last_report_prefix': 'Last Report',
        'ethnicity': 'Ethnicity',
        // -- chart.js supplements --
        'start_word': 'Start',
        'end_word': 'End',
        'times_unit': ' times',
        'stage': 'Stage',
        'month_char': 'mo',
        'whole_night_cpc': "Overnight CPC",
        'whole_night_snore': "Overnight Snoring Events",
        'recent_hr_trend': 'Recent Sleep HR Trend',
        'recent_rr_trend': 'Recent Sleep Respiratory Rate Trend',
        'recent_hrv_trend': 'Recent HRV RMSSD Trend',
        'recent_min_hr_trend': 'Recent Min HR Trend',
        'ahi_full_label': 'Apnea-Hypopnea Index',
        'ahi_full_label_comma': 'Apnea-Hypopnea Index, AHI',
        // -- ReportList clinical indicator tags --
        'tag_mild_osa': 'Mild OSA',
        'tag_moderate_osa': 'Moderate OSA',
        'tag_severe_osa': 'Severe OSA',
        'tag_long_sleep_latency': 'Long Sleep Latency',
        'tag_short_sleep_time': 'Insufficient Sleep',
        'tag_long_awake': 'Long Awake',
        'tag_high_light_ratio': 'High Light Sleep Ratio',
        'tag_low_deep_ratio': 'Low Deep Sleep Ratio',
        'tag_low_rem_ratio': 'Low REM Ratio',
        'to_word': 'to',
        'whole_night_ahi_events': "Overnight Apnea-Hypopnea Events",
        'apnea_hypopnea_events_short': 'Apnea-Hypopnea Events',
        'whole_night_ahi_events_full': "Overnight Apnea-Hypopnea Events",
        'whole_night_oahi_events_full': "Overnight Obstructive Apnea-Hypopnea Events",
        // -- Batch 11: mixed-mustache residuals --
        'second_suffix': ' s',
        'last_update_colon': 'Last Update:',
        'channel_colon': 'Channel:',
        'no_history_paren': '(No history)',
        'current_wifi_colon': 'Current WiFi:',
        'load_failed_colon': 'Load failed:',
        'gen_time_colon': 'Generated:',
        'avg_sleep_hr_colon': 'Avg Sleep HR:',
        'avg_sleep_rr_colon': 'Avg Sleep RR:',
        'prev_word': 'Prev',
        'next_word': 'Next',
        'ahi_index_paren_prefix': 'Apnea-Hypopnea Index (',
        'count_times': 'times',
        'resend_after_seconds_suffix': 's to resend',
        'wake_count_prefix': ' times / ',
        // -- Batch 5: ElMessage toast --
        'save_success': 'Saved successfully',
        'save_failed': 'Save failed',
        'save_failed_retry': 'Save failed, please retry',
        'fetch_data_failed': 'Failed to fetch data',
        'fetch_data_failed_colon': 'Failed to fetch data:',
        'op_failed_retry': 'Operation failed, please retry',
        'update_failed': 'Update failed',
        'set_failed_retry': 'Setting failed, please retry',
        'please_answer_all': 'Please answer all questions',
        'please_fill_all_sleep_questions': 'Please complete all sleep evaluation questions',
        'please_select_one_device': 'Please select a device first',
        'please_select_at_least_one_device': 'Please select at least one device',
        'please_select_at_least_one_user': 'Please select at least one user',
        'please_select_unbind_user': 'Please select users to unbind',
        'please_select_template_to_delete': 'Please select template(s) to delete',
        'please_select_import_type_first': 'Please select import type first',
        'please_select_range_before_download': 'Please select a date range before downloading',
        'please_select_report_date_toast': 'Please select a report date',
        'fetch_report_info_failed': 'Failed to fetch report info',
        'fetch_report_list_failed': 'Failed to fetch report list',
        'fetch_report_detail_failed': 'Failed to fetch report detail',
        'fetch_report_data_failed_retry': 'Failed to fetch report data, please retry',
        'fetch_report_date_list_failed': 'Failed to fetch report date list',
        'fetch_history_failed': 'Failed to fetch history',
        'fetch_org_list_failed': 'Failed to fetch organization list',
        'fetch_trend_failed': 'Failed to fetch trend data',
        'fetch_device_status_failed': 'Failed to fetch device status',
        'fetch_cmd_failed_use_default': 'Failed to fetch command codes, using defaults',
        'fetching_report_data': 'Fetching report data, please wait...',
        'generating_report_data': 'Generating report data, please wait...',
        'processing_data_fetching_questionnaire': 'Processing data and fetching questionnaire...',
        'fetching_user_info': 'Fetching user info...',
        'fetching_user_details': 'Fetching user details...',
        'device_no_report_data': 'This device has no report data',
        'report_date_format_error': 'Invalid report date format',
        'backend_data_format_error': 'Backend data format error',
        'data_not_loaded_retry': 'Data is still loading, please retry',
        'report_download_success': 'Report downloaded successfully',
        'download_report_failed_retry': 'Download failed, please retry',
        'no_data_to_download': 'No data available for download',
        'no_night_report_to_download': 'No whole-night report data to download',
        'no_experience_survey_to_download': 'No experience survey data to download',
        'no_intervention_event_to_download': 'No intervention event data to download',
        'max_100_devices_per_export': 'Max 100 devices per export, please reduce selection',
        'max_90_days_range': 'Date range must be within 90 days',
        'questionnaire_submit_success': 'Questionnaire submitted successfully',
        'password_change_success': 'Password changed successfully',
        'password_change_failed_retry': 'Password change failed, please retry',
        'login_expired': 'Login expired, please log in again',
        'select_in_print_dialog': 'Please select option in the print dialog',
        'print_failed_retry': 'Print failed, please retry',
        'weight_set_success': 'Weight set successfully',
        'missing_user_id': 'User ID is missing, cannot update',
        'user_update_success': 'User updated successfully',
        'user_no_openid': 'This user has no openid, cannot view report',
        'confirm_unbind': "Unbind this device?",
        'unbind_success': "Unbound successfully",
        'unbind_failed': 'Unbind failed',
        'selected_no_bound_users': 'None of the selected users has a bound device',
        'selected_no_bound_devices': 'No bound device among selected users',
        'batch_unbind_failed': 'Batch unbind failed',
        'only_xlsx_allowed': 'Only .xlsx files are allowed',
        'file_max_10mb': 'File size cannot exceed 10MB',
        'file_upload_success': 'File uploaded successfully',
        'file_upload_failed': 'File upload failed',
        'template_download_success': 'Template downloaded successfully',
        'template_download_failed': 'Template download failed',
        'select_template_or_save_as': 'Please select a template, or use "Save As" to create a new one',
        'input_new_template_name': 'Enter new template name',
        'template_name_min_2_chars': 'Template name must be at least 2 characters',
        'template_name_exists': 'Template name already exists, please use a different one',
        // -- Batch 3: Waveform + Questionnaires + Print + Excel --
        'total_sleep_time_alt': 'Total Sleep Time',
        'realtime_tracking': 'Real-time tracking',
        'zoom_display': 'Zoom',
        'align_seconds': 'Align to seconds',
        'data_transpose': 'Transpose',
        'display_channels': 'Channels:',
        'display_template': 'Template:',
        'select_channel_template': 'Select channel template',
        'save_as': 'Save As',
        'save_series_data': 'Save series data',
        'switch_mode': 'Switch Mode',
        'refresh_list': 'Refresh',
        'clear_log': 'Clear Log',
        'debug_log': 'Debug Log',
        'issue_description': 'Issue Description',
        'situation_description': 'Description',
        'move_up': 'Move Up',
        'move_down': 'Move Down',
        'share_link': 'Share Link',
        'view': 'View',
        'reset': 'Reset',
        'description': 'Description',
        'instructions': 'Instructions',
        'advanced_options': 'Advanced Options',
        'detail_info': 'Details',
        'template': 'Template',
        'start_colon': 'Start:',
        'end_colon': 'End:',
        'select_time': 'Select Time',
        'sleep_quality_t': 'Sleep Quality',
        'sleep_score_t': 'Sleep Score',
        'sleep_time_t': 'Sleep Time',
        'total_sleep_duration': "Total Sleep",
        'sleep_interruption': 'Sleep Interruption',
        'sleep_fragmentation': 'Sleep Fragmentation',
        'sleep_avg_hrv': 'Avg Sleep HRV',
        'hrv_label': 'Heart Rate Variability (HRV)',
        'deep_sleep_t': 'Deep Sleep',
        'deep_sleep_alt': 'Deep Sleep',
        'light_sleep_t': 'Light Sleep',
        'awake': 'Awake',
        'stage_durations': 'Sleep Stage Durations',
        'score': 'Score',
        'lights_off_time': "Lights Out",
        'lights_on_time': "Lights On",
        'light_t': 'Light',
        'hr_icon': 'HR',
        'rr_icon': 'RR',
        'sleep_icon': 'Sleep',
        'hour_unit': 'h',
        'year_unit': 'y',
        'month_unit': 'm',
        'and_word': '~',
        'no_value': 'None',
        'no_value_alt': 'None',
        'not_at_all_alt': 'Not at all',
        'never': 'Never',
        'serial_no': 'No.',
        'page_1': 'Page 1',
        'page_2': 'Page 2',
        'page_3': 'Page 3',
        'page_4': 'Page 4',
        'notes_colon': 'Notes:',
        'api_auth_hint': 'Note: If the API requires authentication, append to URL:',
        'please_pass_via_url': 'Please pass via URL',
        'please_input_device_date_first': 'Enter device number and date above to view raw data.',
        'params_incomplete': 'Incomplete parameters',
        'params_example': 'parameters, e.g.:',
        'example': 'Example:',
        'back_prev_step': 'Back',
        'ess_full_title': 'Epworth Sleepiness Scale (ESS)',
        'phq9_full_title': 'Patient Health Questionnaire (PHQ-9)',
        'gad7_full_title': 'Generalized Anxiety Disorder Scale (GAD-7)',
        'meqsa_full_title': 'Morningness-Eveningness Questionnaire Self-Assessment (MEQ-SA)',
        'psqi_q1': '1. In the past month, what time have you usually gone to bed at night?',
        'psqi_q2': '2. In the past month, how long (in minutes) has it usually taken you to fall asleep each night?',
        'psqi_q3': '3. In the past month, what time have you usually gotten up in the morning?',
        'psqi_q4': '4. In the past month, how many hours of actual sleep did you get per night (not time in bed)?',
        'psqi_q5': '5. In the past month, how often have you had the following trouble?',
        'psqi_q6': '6. In the past month, how would you rate your sleep quality overall?',
        'psqi_q7': '7. In the past month, how often have you taken medicine (prescribed or over-the-counter) to help you sleep?',
        'psqi_q8': '8. In the past month, how often have you had trouble staying awake while driving, eating, or engaging in social activity?',
        'psqi_q9': '9. In the past month, how much of a problem has it been for you to keep up enough enthusiasm to get things done?',
        'psqi_q5a': 'a) Cannot get to sleep within 30 minutes',
        'psqi_q5b': 'b) Wake up in the middle of the night or early morning',
        'psqi_q5c': 'c) Have to get up to use the bathroom',
        'psqi_q5d': 'd) Cannot breathe comfortably',
        'psqi_q5e': 'e) Cough or snore loudly',
        'psqi_q5f': 'f) Feel too cold',
        'psqi_q5g': 'g) Feel too hot',
        'psqi_q5h': 'h) Have bad dreams',
        'psqi_q5i': 'i) Have pain',
        'psqi_q5j': 'j) Other reasons affecting sleep',
        'freq_less_1_per_week': '&lt;1/week',
        'freq_1_2_per_week': '1-2/week',
        'freq_3_plus_per_week': '≥3/week',
        'none_past_month': 'Not during the past month',
        'less_than_once_week': 'Less than once a week',
        'once_twice_week': 'Once or twice a week',
        'three_plus_week': 'Three or more times a week',
        'very_good': 'Very Good',
        'fairly_good': 'Fairly Good',
        'fairly_bad': 'Fairly Bad',
        'very_bad': 'Very Bad',
        'ess_never_doze': 'Would never doze',
        'ess_slight': 'Slight chance of dozing',
        'ess_moderate': 'Moderate chance of dozing',
        'ess_high': 'High chance of dozing',
        'ess_instruction': 'How likely are you to doze off or fall asleep in the following situations (not just feeling tired)? This refers to your usual way of life in recent months.',
        'ess_q1': 'Sitting and reading a book, newspaper, or watching TV',
        'ess_q2': 'Sitting watching a movie or a show',
        'ess_q3': 'Sitting inactive in a public place (e.g., meeting, theatre, cinema)',
        'ess_q4': 'As a passenger in a car for an hour without a break',
        'ess_q5': 'Lying down to rest in the afternoon when circumstances permit',
        'ess_q6': 'Sitting and talking to someone',
        'ess_q7': 'Sitting quietly after a lunch without alcohol',
        'ess_q8': 'In a car, while stopped for a few minutes in traffic',
        'psqi_sl_within_15': 'Within 15 min',
        'psqi_sl_16_30': '16–30 min',
        'psqi_sl_31_45': '31–45 min',
        'psqi_sl_46_60': '46–60 min',
        'psqi_sl_61_90': '61–90 min',
        'psqi_sl_91_120': '91–120 min',
        'psqi_sl_121_150': '121–150 min',
        'psqi_sl_over_150': 'More than 150 min',
        'view_report': 'View Report',
        'no_report': 'No Report',
        'app_title': 'Five Seasons Sleep Monitoring',
        'several_days': 'Several days',
        'more_than_half_days': 'More than half the days',
        'nearly_every_day': 'Nearly every day',
        'phq_gad_instruction': 'Over the last 2 weeks, how often have you been bothered by the following problems?',
        'gad7_instruction': 'The following questions assess your anxiety in the past 2 weeks. Answer the 7 questions by selecting the number that best describes your situation.',
        'psqi_intro': 'The following questions relate to your sleep habits during the past month. Please choose or fill in the most accurate answer based on your actual experience.',
        'meqsa_instruction': 'Choose the sentence that best describes how you have felt in the past few weeks, and select the corresponding number.',
        'meqsa_note': 'If you haven\'t done some of these things recently, try to estimate how much impact they might have on you.',
        'please_select_sleep_time': 'Please select sleep time',
        'occasionally_alt': 'Occasionally',
        'sometimes_alt': 'Sometimes',
        'frequently_alt': 'Frequently',
        'some_days': 'Some days',
        'more_than_half_time': 'More than half the time',
        'wifi_password': 'WiFi Password',
        'wifi_config': 'WiFi Config',
        'please_input_wifi_password': 'Please enter WiFi password',
        'bluetooth_config': 'Bluetooth Setup',
        'device_search': 'Device Search',
        'device_no': 'Device No.',
        'example_device_no': 'e.g. A123456',
        'execute_task': 'Execute Task',
        'excel_column_name': 'Excel Column',
        'excel_import_instructions': 'Excel Import Instructions',
        'excel_file_management': 'Excel File Management',
        'excel_header_row_hint': 'First row contains field names. Do not delete or modify it.',
        'upload_excel': 'Upload Excel',
        'download_template': 'Download Template',
        'only_xlsx_supported': 'Only .xlsx files are supported',
        'support_xlsx': 'Supports .xlsx',
        'drag_excel_here': 'Drop Excel file here, or',
        'drag_or_click_upload': 'Drag and drop the filled Excel to upload area, or click to upload',
        'click_to_upload': 'Click to upload',
        'click_download_template_hint': 'Click "Download Template" to get the standard Excel template',
        'import_steps': 'Import Steps:',
        'fill_template_note': 'Fill in data in the template. Required fields cannot be empty.',
        'field_mapping_config': 'Field Mapping',
        'field_description': 'Field Description:',
        'custom_fields_hint': 'For custom fields, check "Auto-map unknown fields"',
        'auto_map_unknown': 'Auto-map unknown fields (use Excel header row as field name)',
        'required': 'Required',
        'required_not_empty': 'Required fields cannot be empty or the import will fail',
        'preference_strategy': 'Preference Strategy',
        'please_select_import_type': 'Please select import type',
        'please_select_input_params': 'Please select or input parameters',
        'please_select_option': 'Please select option',
        'select_import_type_hint': 'Select data type to import (Device / User / Preference Strategy)',
        'device_mgmt_fields': 'Device Management Fields:',
        'field_device_no_desc': 'Device Number: unique device identifier (required)',
        'field_work_status_desc': 'Work Status: Available / Disabled / Under Repair, etc.',
        'field_org_desc': 'Organization: organization owning the device',
        'field_version_desc': 'Version: device software version',
        'field_device_notes_desc': 'Notes: device-related remarks',
        'user_mgmt_fields': 'User Management Fields:',
        'field_user_id_desc': 'User: user identifier (required)',
        'field_username_desc': 'Username: user\'s name',
        'field_user_device_desc': 'Device: bound device number',
        'field_user_org_desc': 'Organization: user\'s organization',
        'field_phone_desc': 'Phone: contact phone number',
        'option_word': 'Option',
        'system_field': 'System Field',
        'device_mgmt_alt': 'Device Management',
        'date_yyyy_mm_dd': 'Date (YYYY-MM-DD)',
        'zero_param_anchor': 'Parameters:',
        'zero_option_anchor': 'Options:',
        'cohort_dictionary_eyebrow': 'Sleep Medicine Terms',
        'cohort_dictionary_title_fallback': 'Sleep Medicine Metrics Dictionary',
        'cohort_dictionary_subtitle_fallback': 'Understand sleep, breathing, heart rate, and recovery metrics through clinical questions',
        'cohort_dictionary_version_aria': 'Dictionary version information',
        'cohort_dictionary_concept_count': 'medical concepts',
        'cohort_dictionary_data_item_count': 'clinical data items',
        'cohort_dictionary_updated_at': 'Updated',
        'cohort_dictionary_version_unknown': '—',
        'cohort_dictionary_disclaimer_summary': 'Learn about data sources and medical boundaries',
        'cohort_dictionary_search_aria': 'Search sleep medicine terms',
        'cohort_dictionary_search_placeholder': 'Search terms or field names, e.g. AHI / sleep efficiency',
        'cohort_dictionary_clear_search_aria': 'Clear search',
        'cohort_dictionary_clear_search': 'Clear',
        'cohort_dictionary_loading': 'Loading medical terms…',
        'cohort_dictionary_load_failed': 'Failed to load the terminology dictionary',
        'cohort_dictionary_retry': 'Reload',
        'cohort_dictionary_retry_later': 'Please try again later',
        'cohort_dictionary_overview_kicker': 'Panoramic overview',
        'cohort_dictionary_overview_title': 'View the complete tree from medical categories to report fields',
        'cohort_dictionary_overview_description_prefix': 'Expand from',
        'cohort_dictionary_topic_count': 'medical categories',
        'cohort_dictionary_overview_description_middle': 'to',
        'cohort_dictionary_overview_description_and': 'and',
        'cohort_dictionary_overview_description_suffix': ', with pan, zoom, and branch expand/collapse.',
        'cohort_dictionary_open_tree': 'Open tree view',
        'cohort_dictionary_topic_tabs_aria': 'Medical question categories',
        'cohort_dictionary_tabs_scroll_hint': 'Swipe horizontally for more',
        'cohort_dictionary_search_found': 'Found',
        'cohort_dictionary_search_related': 'medical concepts, linked to',
        'cohort_dictionary_expand': 'Expand',
        'cohort_dictionary_collapse': 'Collapse',
        'cohort_dictionary_explanation_suffix': 'medical explanation',
        'cohort_dictionary_view_full_content': 'View full content',
        'cohort_dictionary_definition': 'Definition',
        'cohort_dictionary_metric_notes': 'Metric notes',
        'cohort_dictionary_interpretation': 'How to interpret',
        'cohort_dictionary_formula': 'Calculation / definition',
        'cohort_dictionary_clinical_data_items': 'Clinical data items',
        'cohort_dictionary_empty_title': 'No matching medical concepts found',
        'cohort_dictionary_empty_hint': 'Try searching an English term, abbreviation, or clinical data item',
        'cohort_dictionary_tree_eyebrow': 'Sleep Medicine Metrics Dictionary',
        'cohort_dictionary_tree_title': 'Panoramic tree of metrics and report fields',
        'cohort_dictionary_tree_reset': 'Reset view',
        'cohort_dictionary_tree_close': 'Close tree view',
        'cohort_dictionary_tree_desktop_tip': 'Drag to pan · scroll or pinch to zoom · click nodes to expand / collapse; concepts shown by default',
        'cohort_dictionary_tree_mobile_tip': 'Drag with one finger · pinch to zoom · tap categories to expand concepts; categories shown by default',
        'cohort_dictionary_tree_root_mobile': 'Sleep metrics',
        'cohort_dictionary_tree_root': 'Sleep medicine metrics',
        'cohort_dictionary_tree_root_kind': 'Medical metrics overview',
        'cohort_dictionary_metric_kind': 'Metric',
        'cohort_dictionary_clinical_data_item_kind': 'Clinical data item',
        'cohort_dictionary_clinical_item_kind': 'Clinical item',
        'cohort_dictionary_report_field_kind': 'Report field',

        // ===== Phase1 i18n补全 =====
        // Float menu
        'switch_friend': 'Switch User',
        'current_badge': 'Current',
        // Home page
        'last_night': 'Last Night',
        'that_night': 'That Night',
        'confirm_auth_code': 'Confirm Auth Code',
        'user_info_title': 'User Profile',
        'user_info_desc': 'To update your nickname and avatar for better service',
        'update_btn': 'Update',
        'not_now': 'Not Now',
        'cannot_forward': 'Cannot Forward',
        'share_report_suffix': 'Sleep Report',
        'share_from': 'from ',
        // Health page
        'neuro_brain': 'Neuro/Brain',
        'respiratory_system': 'Respiratory',
        'cardiac_function': 'Cardiac',
        'status_healthy': 'Healthy',
        'status_abnormal': 'Abnormal',
        'keep_monitoring_14days_prefix': 'Please monitor for at least 14 days to obtain ',
        'keep_monitoring_14days_suffix': ' data',
        'keep_monitoring_month_prefix': 'Please monitor for about a month to obtain ',
        'keep_monitoring_month_suffix': ' data',
        'your_aging_speed_prefix': 'Your aging speed is ',
        'years_per_year': ' years/year',
        'pace_same_as_peers': 'Same as peers',
        'pace_slower_than_peers': 'Slower than peers',
        'pace_faster_than_peers': 'Faster than peers',
        'aligned_with_real_age': 'Aligned with Chronological Age',
        'age_higher_by': '',
        'age_lower_by': '',
        'age_unit': ' yrs',
        'above_real_age': 'Above Chronological Age',
        'below_real_age': 'Below Chronological Age',
        // agingPaceCard
        'aging_pace_title': 'Aging Speed',
        'aging_speed_accelerate': 'Accelerating',
        'aging_speed_accelerate_label': 'Accelerated Aging',
        'aging_speed_normal': 'Normal',
        'aging_speed_normal_label': 'Normal Aging',
        'aging_speed_decelerate': 'Decelerating',
        'aging_speed_decelerate_label': 'Decelerated Aging',
        'aging_speed_reverse': 'Reverse Aging',
        'aging_speed_slow': 'Slow',
        'aging_speed_fast': 'Fast',
        'trend_28d_prefix': '28-day trend',
        'insomnia_dual_trend_title': '30-day sleep onset and disturbance trends',
        'sleep_onset_trend_title': 'Sleep Onset',
        'sleep_disturbance_trend_title': 'Sleep Disturbance',
        'sleep_efficiency_trend_title': 'Sleep Efficiency',
        'chart_meta_30d_min': '30 Days | min',
        'chart_meta_30d_percent': '30 Days | %',
        'aging_pace_label_same_recent': 'In line with recent trend',
        'aging_pace_label_worse_recent': 'Worse than recent trend',
        'aging_pace_label_better_recent': 'Better than recent trend',
        'aging_pace_dimension_sleep_quality': 'Sleep Quality',
        'aging_pace_dimension_sleep_structure': 'Sleep Structure',
        'aging_pace_dimension_cardiovascular': 'Cardiovascular',
        'aging_pace_dimension_respiratory': 'Respiratory',
        'aging_pace_factor_efficiency': 'Sleep Efficiency',
        'aging_pace_factor_interruption': 'Sleep Interruption',
        'aging_pace_factor_fragmentation': 'Sleep Fragmentation',
        'aging_pace_factor_duration': 'Sleep Duration',
        'aging_pace_factor_deep_sleep': 'Deep Sleep',
        'aging_pace_factor_n1_sleep': 'N1 Sleep',
        'aging_pace_factor_n2_sleep': 'N2 Sleep',
        'aging_pace_factor_light_stages': 'Light Sleep Stages',
        'aging_pace_factor_rem_sleep': 'REM Sleep',
        'aging_pace_factor_heart_rate': 'Heart Rate',
        'aging_pace_factor_hrv_time': 'HRV (Time Domain)',
        'aging_pace_factor_hrv_freq': 'HRV (Frequency Domain)',
        'aging_pace_factor_hrv': 'Heart Rate Variability',
        'aging_pace_factor_respiratory_rate': 'Respiratory Rate',
        'aging_pace_factor_ahi': 'AHI',
        'accelerate_factors': 'Accelerating factors',
        'decelerate_factors': 'Decelerating factors',
        'top_accelerate_factor': 'Top accelerating factor',
        'top_decelerate_factor': 'Top decelerating factor',
        'accelerate_pct': 'Accel.',
        'decelerate_pct': 'Decel.',
        'tug_hint_accelerate': 'Forces aging you',
        'tug_hint_decelerate': 'Forces slowing aging',
        'no_significant_factor': 'No significant factor',
        'view_all_factors': 'View all factors',
        'collapse_factors': 'Collapse',
        'unit_years_per_year': 'yrs/yr',
        'summary_pace_flat': "Last night's sleep kept your aging speed on par with peers",
        'summary_pace_fast_prefix': "Last night's sleep accelerated your aging",
        'summary_pace_slow_prefix': "Last night's sleep decelerated your aging",
        'summary_mainly_because': ', mainly due to ',
        'summary_and': ' and ',
        'factor_icon_frag': 'Fr',
        'factor_icon_eff': 'Ef',
        'factor_icon_interruption': 'In',
        'factor_icon_dur': 'Du',
        'factor_icon_light': 'Lt',
        'factor_icon_deep': 'Dp',
        'factor_icon_n1': 'N1',
        'factor_icon_n2': 'N2',
        'factor_icon_rem': 'RM',
        'factor_icon_resp': 'Rs',
        'factor_icon_heart': 'Hr',
        'factor_icon_hrv_time': 'TD',
        'factor_icon_hrv_freq': 'FD',
        'factor_icon_quality': 'Ql',
        'factor_icon_structure': 'St',
        'factor_desc_fragmentation': 'Frequent awakenings disrupting sleep continuity',
        'factor_desc_efficiency': 'Sleep efficiency directly impacts overnight recovery',
        'factor_desc_interruption': 'Longer wake time during the night can weaken sleep continuity and reduce recovery quality',
        'factor_desc_duration': 'Total sleep duration affects nightly repair',
        'factor_desc_light_stages': 'Light sleep proportion affects recovery quality',
        'factor_desc_deep_sleep': 'Deep sleep repair capacity impacts body recovery',
        'factor_desc_n1_sleep': 'N1 sleep proportion affects sleep stability and recovery quality',
        'factor_desc_n2_sleep': 'N2 sleep proportion affects sleep structure and recovery efficiency',
        'factor_desc_rem_sleep': 'REM sleep affects overnight recovery and cognitive restoration',
        'factor_desc_respiratory_rate': 'Breathing rhythm affects nightly physiological burden',
        'factor_desc_ahi': 'Fewer respiratory events support better nightly recovery',
        'factor_desc_hrv_time': 'HRV time-domain metrics affect autonomic recovery status',
        'factor_desc_hrv_freq': 'HRV frequency-domain metrics affect sympathetic and parasympathetic balance',
        'factor_desc_hrv': 'Better autonomic recovery helps slow aging',
        'factor_desc_heart_rate': 'Steadier nighttime heart rate means less body burden',
        'factor_desc_sleep_quality': 'Overall sleep quality affects recovery rhythm',
        'factor_desc_sleep_structure': 'Sleep structure affects repair and recovery balance',
        'factor_desc_respiratory': 'Respiratory status affects nightly recovery burden',
        'factor_desc_cardiovascular': 'Cardiovascular status affects body recovery pressure',
        'factor_desc_accelerate_default': 'This factor is increasing your aging speed',
        'factor_desc_decelerate_default': 'This factor is helping slow your aging speed',
        'sleep_heart_rate': 'Sleep Heart Rate',
        'sleep_breathing': 'Sleep Breathing',
        'sleep_hygiene': 'Sleep Hygiene',
        'wx_no_nickname_toast': 'WeChat did not return nickname, you can fill in manually in profile',
        'compared_higher': '',
        'compared_lower': '',
        'your_sleep_age_is': 'Your Sleep Age is ',
        'health_risk_is': 'health risk is approximately ',
        'health_risk_times': ' times that of healthy peers',
        'health_risk_lower_than': 'health risk is approximately ',
        'health_risk_lower_suffix': '% lower than healthy peers',
        'mild_snoring': 'Mild Snoring',
        'moderate_snoring': 'Moderate Snoring',
        'severe_snoring': 'Severe Snoring',
        'no_snoring': 'No Snoring',
        'not_found_afib': 'Not Found',
        'cpc_low': 'Low',
    }
};

export const tipTexts = {
    "zh-Hans": {
        "quality": { 
            title: "睡眠质量", 
            text: `睡眠质量得分是基于您每天的睡眠数据在六个关键维度上的评估综合得出的。这包括总睡眠时长、睡眠效率、入睡速度、睡眠中断、深睡眠和快速眼动睡眠。这个综合得分旨在帮助您快速的了解您睡眠质量的表现和变化。\n\n虽然我们为每天提供了一个得分，我们强烈建议您更加关注这些维度的周、月甚至更长时间段的趋势，帮助您更全面的了解您的睡眠。` ,
            changelog: [{
                title: '2024/06/13更新',
                text: `为更合理的评估睡眠质量，对睡眠质量得分进行如下优化调整：\n1. 增加睡眠效率、快速眼动睡眠时长在得分中作为参考维度; \n2. 参考用户实际年龄，对不同年龄段的睡眠质量评价更合理。为了更准确了解自己的睡眠，请在【我的】-【更新个人信息】中填写自己的出生年月。`,
            }],
        }, 
        "recovery_baseline": {
            title: "关于个人基线",
            paragraphs: [
                "个人基线用于描述你在较长时间范围内（例如近 60 天）某项指标“通常会落在哪个区间”。它更像是你的个人常态范围，而不是人群统一标准。",
                "当趋势点长期高于或低于个人基线区间时，可能提示近期状态或外界因素（压力、疾病、作息变化、饮酒/运动等）导致指标出现了异常波动。建议结合最近几天的变化与自身感受综合判断。",
            ],
        },
        "recovery_score": {
            title: "恢复评分",
            paragraphs: [
                "恢复评分衡量的是你的身体在一夜睡眠中恢复了多少精力，与你晨起时的真实感受更贴近。",
                "它从四个维度综合评估：睡眠充足度（睡眠时长与睡眠负债）、身体修复度（深睡与REM等关键睡眠结构）、睡眠安稳度（夜间觉醒与体动）、生理平稳度（心率变异性、心肺耦合等自主神经指标）。",
                "与睡眠评分的区别：睡眠评分侧重评价睡眠过程本身的质量，恢复评分侧重评价睡眠带来的实际恢复效果。",
                "同一晚睡眠，两个分数可能不同。比如睡眠时间短但深睡比例高，睡眠评分可能一般，但恢复评分可能不错。",
            ],
        },
        "tst":{ 
            title: "总睡眠时长", 
            text: `Total Sleep Time（TST），总记录时间内的实际睡眠时间，所有快速眼动期和非快速眼动期睡眠时间的总和。合适的睡眠时长取决于多种因素，尤其是年龄。一般18-65岁成年人建议的睡眠时长为7-9小时，65岁以上建议为7-8小时。请注意，这些建议是一般性的，因为每个人的生活方式和身体状况都有所不同，实际所需睡眠时长也会不同。\n\n建立规律的作息时间、创造适宜的睡眠环境、睡前避免咖啡因和刺激性物质、午睡尽量控制在20-30分钟以内，这些建议可帮助维持健康的睡眠时长。` 
        }, 
        "se": { 
            title: "睡眠效率", 
            text: `Sleep Efficiency（SE），睡眠期间实际用于睡眠的时间比例，睡眠效率 = 总睡眠时长/T。其中分母T是指从准备入睡（即就寝时间）到最终醒来且没有再次入睡意图的时间，不包含在床上进行与睡眠无关的活动时长（如使用手机等），也不包含夜间离床的时长。\n\n睡眠效率为 85% 或更高被认为是正常的，而睡眠效率高于 90% 则被认为是非常好的。较长的入睡速度和睡眠中断是导致睡眠效率低的主要原因。` 
        }, 
        "sol": { 
            title: "入睡速度", 
            text: `入睡速度 Sleep Onset Latency（SOL）测量入睡用时，也称为睡眠潜伏期 ，是指上床睡觉后到入睡所需的时间。理想情况下，睡眠潜伏期应在 10 到 20 分钟之间。即使没有疲倦的主观感觉，人在需要睡眠时一般也会更快入睡。睡眠潜伏期很短的人有可能有睡眠不足的情况；过长（大于20-30分钟）意味着失眠或发生了其他影响入睡能力的健康问题。\n\n限制睡前屏幕使用时间、制定规律的睡前习惯、限制入睡前的运动、使用冥想或呼吸练习等心理放松技巧，可帮助缩短入睡时间并提高睡眠质量。` 
        }, 
        "waso": { 
            title: "睡眠中断", 
            text: `睡眠中断 Wake after Sleep Onset（WASO）测量入睡后清醒的总分钟数，一定程度的 WASO 是正常的，但夜间清醒时间过长或碎片化会大大降低睡眠质量，影响次日白天的精力，工作和学习表现。\n\n导致入睡后清醒时间增加的原因有很多，包括焦虑和压力、睡眠障碍、不规律的作息、过度饮食或饮酒，及其他健康问题或疾病。了解这些因素并采取相应的改善措施，如维持规律的作息时间、改善睡眠环境、减少压力等，有助于改善睡眠质量，减少夜间醒来的次数和时间。` 
        }, 
        "disturbance": { 
            title: "睡眠中断", 
            text: `睡眠中断测量入睡后清醒的总分钟数Wake after Sleep Onset（WASO）和清醒的次数（Awakenings），一定程度的睡眠中断是正常的，但夜间清醒时间过长或清醒次数过多带来的睡眠碎片化会大大降低睡眠质量，影响次日白天的精力，工作和学习表现。\n\n导致入睡后清醒时间和次数增加的原因有很多，包括焦虑和压力、睡眠障碍、不规律的作息、过度饮食或饮酒，及其他健康问题或疾病。了解这些因素并采取相应的改善措施，如维持规律的作息时间、改善睡眠环境、减少压力等，有助于改善睡眠质量，减少夜间醒来的次数和时间。` 
        }, 
        "sri": { 
            title: "睡眠规律性", 
            text: `睡眠规律性由睡眠规律指数 (SRI) 计算，测量您在最近7天内睡眠开始与结束时间的稳定性。睡眠规律性对睡眠质量有着显著的影响，维持规律的睡眠时间和作息习惯可以帮助调整生物钟，促进更健康的睡眠模式，对睡眠质量有积极的作用，同时对健康、安全和工作表现也很重要。研究发现，不规律的睡眠与多种不良后果有关，包括心脏自主调节、炎症、新陈代谢、心理健康以及表现和认知功能等方面。\n\n调整睡眠规律性的第一步是保证充足的睡眠的前提下选择固定的就寝和起床时间，即使是周末也要保持，虽然可能需要一些时间适应，这是正常的；同时养成良好的睡眠卫生习惯，逐渐适应期望的就寝时间，发展为稳定健康的睡眠模式。` 
        }, 
        "stage": { 
            title: "睡眠分期", 
            text: `睡眠是由非快速眼动睡眠（NREM sleep）和快速眼动睡眠（REM sleep）往复循环组成的。\n\n快速眼动睡眠是大脑活动最高的睡眠阶段，大部分梦境发生在这期间，除了控制呼吸、心率和眼球运动的肌肉外，身体的大部分肌肉都处于麻痹状态。\n\n非快速眼动睡眠则包含浅睡眠和深睡眠。浅睡眠在睡眠中占主导地位，在此阶段心跳和呼吸减缓，体温降低；深睡眠也称慢波睡眠，在此阶段，呼吸和心率降至最低水平，大脑活动减慢，是身体与大脑修复、代谢调节的关键时期。深睡眠一般占总睡眠时间的10-25%，统计表明深睡眠可能随年龄增长每10年减少2%，年轻成年人每晚可能经历80-100分钟的深度睡眠，而60岁以上老年人深度睡眠时间可能少于20分钟。`
        }, 
        "ahi": { 
            title: "呼吸暂停低通气指数 (AHI)", 
            text: `阻塞性睡眠呼吸暂停（OSA）是一种以睡眠打鼾伴呼吸暂停和日间思睡为主要临床表现的睡眠呼吸疾病，患病率为2%～4%。该病可引起间歇性低氧、高碳酸血症以及睡眠结构紊乱，并可导致高血压、冠心病、心律失常、脑血管病、认知功能障碍、2型糖尿病等多器官多系统损害。研究表明，未经治疗的重度OSA患者病死率比普通人群高3.8倍。\n
成人OSA的诊断通常参考呼吸暂停-低通气指数（AHI）数值。AHI表示睡眠中每小时发生的呼吸暂停和低通气的平均次数，通过呼吸暂停和低通气事件（持续10秒以上）的总数除以睡眠的总时间来计算。成人的AHI数值分为三类，分别对应不同的 OSA 严重程度：\n轻度：5≤AHI<15\n中度：15≤AHI<30\n重度：AHI≥30`,
            note: `*参考：\n成人阻塞性睡眠呼吸暂停多学科诊疗指南 [J] . 中华医学杂志,2018,98 (24): 1902-1914. DOI: 10.3760 cma.j.issn.0376-249. 2018.24.003` 
        }, 
        "ahi_new": { 
            title: "呼吸暂停低通气指数 (AHI)", 
            text: `睡眠呼吸暂停（Sleep Apnea, SA）是一种以睡眠打鼾伴呼吸暂停和日间思睡为主要临床表现的睡眠呼吸疾病，通常由睡眠中上气道完全或部分阻塞和（或）呼吸中枢驱动降低导致。该病可引起间歇性低氧、高碳酸血症以及睡眠结构紊乱，并可导致高血压、冠心病、心律失常、脑血管病、认知功能障碍、2型糖尿病等多器官多系统损害。睡眠呼吸暂停包括阻塞性睡眠呼吸暂停（Obstructive Sleep Apnea, OSA）和中枢性睡眠呼吸暂停（Central Sleep Apnea,CSA）两种类型，其中更常见的类型为OSA。
成人睡眠呼吸暂停诊断通常参考呼吸暂停-低通气指数（AHI）数值。AHI表示睡眠中每小时发生的呼吸暂停和低通气的平均次数，通过呼吸暂停和低通气事件（持续10秒以上）的总数除以睡眠的总时间来计算。成人的AHI数值分为三类，分别对应不同的OSA 严重程度：\n
轻度：5≤AHI<15\n
中度：15≤AHI<30\n
重度：AHI≥30\n
同时，产品会基于对过去一个月的 AHI 历史数据的综合评估，提供睡眠呼吸暂停风险等级提示。该提示帮助用户了解自身睡眠呼吸状况，不构成医学诊断，亦不能作为医学诊断依据。如需进行医疗决策，建议咨询专业医师。
\n`,
            note: `*参考：\n成人阻塞性睡眠呼吸暂停多学科诊疗指南 ［J］.中华医学杂志，2018,98 （24）： 1902-1914.\nDOI: 10.3760cma.j.issn.0376-249. 2018.24.003` 
        }, 
        "oahi": { 
            title: "阻塞性呼吸暂停低通气指数 (OAHI)", 
            text: `儿童阻塞性睡眠呼吸暂停（OSA）是指儿童（1-18岁）睡眠过程中频繁发生部分或完全上气道阻塞，干扰儿童的正常通气和睡眠结构而引起的一系列病理生理变化。主要表现为打鼾、睡眠时憋气或张口呼吸，严重时可出现夜间惊醒、白天注意力不集中、学习困难、情绪异常及生长发育迟缓。\n
            儿童OSA的主要病因通常为腺样体和/或扁桃体肥大，也可能与肥胖、颅面畸形、神经肌肉疾病等因素有关。OSA如果得不到及时的诊断和有效的干预，将导致一系列严重的并发症，如颌面发育异常（腺样体面容）、行为异常、学习障碍、生长发育落后、神经认知损伤、内分泌代谢失调、高血压和肺动脉高压，甚至增加成年期心血管事件的风险等。因此，儿童OSA的早发现、早诊断和早干预对改善预后意义重大。\n
            儿童OSA的诊断通常参考阻塞性呼吸暂停低通气指数（OAHI）数值，OAHI定义为睡眠中平均每小时发生阻塞型呼吸暂停事件、混合型呼吸暂停事件与阻塞型低通气的次数之和。其严重程度分级如下：\n轻度：1<OAHI≤5\n中度：5<OAHI≤10\n重度：OAHI>10`,
            note: `*参考：\n中国儿童阻塞性睡眠呼吸暂停诊断与治疗指南 [J]. 中华耳鼻咽喉头颈外科杂志, 2020, 55(8): 729-747. DOI: 10.3760/cma.j.cn115330-20200521-00431` 
        }, 
        "osa": { 
            title: "阻塞性睡眠呼吸暂停（OSA）", 
            text: `阻塞性睡眠呼吸暂停（OSA）是一种以睡眠打鼾伴呼吸暂停和日间思睡为主要临床表现的睡眠呼吸疾病，患病率为2%～4%。该病可引起间歇性低氧、高碳酸血症以及睡眠结构紊乱，并可导致高血压、冠心病、心律失常、脑血管病、认知功能障碍、2型糖尿病等多器官多系统损害。研究表明，未经治疗的重度OSA患者病死率比普通人群高3.8倍。\n
            成人OSA的诊断通常参考呼吸暂停低通气指数（AHI）数值。AHI表示睡眠中每小时发生的呼吸暂停和低通气事件的平均次数。AHI数值分为三类，分别对应不同的 OSA 严重程度：\n轻度：5≤AHI<15\n中度：15≤AHI<30\n重度：AHI≥30\n
            儿童OSA的诊断通常参考阻塞性呼吸暂停低通气指数（OAHI）数值，OAHI定义为睡眠中平均每小时发生阻塞型呼吸暂停事件、混合型呼吸暂停事件与阻塞型低通气的次数之和。其严重程度分级如下：\n轻度：1<OAHI≤5\n中度：5<OAHI≤10\n重度：OAHI>10\n
            阻塞性睡眠呼吸暂停通过过去30天内的数据综合评估（需要不少于14天的有效数据），请保持连续进行监测。`,
            note: `*参考：\n成人阻塞性睡眠呼吸暂停多学科诊疗指南 [J] . 中华医学杂志,2018,98 (24): 1902-1914. DOI: 10.3760 cma.j.issn.0376-249. 2018.24.003\n中国儿童阻塞性睡眠呼吸暂停诊断与治疗指南 [J]. 中华耳鼻咽喉头颈外科杂志, 2020, 55(8): 729-747. DOI: 10.3760/cma.j.cn115330-20200521-00431` 
        }, 
        "ahi2345": { 
            title: "睡眠阶段与呼吸事件", 
            text: `上呼吸道塌陷和阻塞性睡眠呼吸暂停（OSA）的严重程度在睡眠不同阶段会有所变化。其中快速眼动（REM）睡眠占总睡眠时间的20%-25%，与影响上气道功能的生理变化密切相关，在此期间全身肌张力降低，从而增加了上气道塌陷的可能性。\n\n此外，与非快速眼动（NREM）睡眠相比，REM睡眠期间的呼吸事件通常更长、更频繁，并且血氧降低的幅度可能更大。实际上，有10%-37%的被诊断为OSA的患者仅在REM睡眠中出现呼吸暂停和/或低通气事件。因此，了解不同睡眠阶段中的AHI情况对于OSA的评估和治疗会提供一定的帮助。`
        }, 
        "hr": { 
            title: "睡眠心率", 
            text: `睡眠时，人的心率通常会低于日间静息心率，平均可能低至每分钟 40 至 50 次。大多数成年人的静息心率在每分钟 40 至 100 次之间，进入深度睡眠时的心率可能比静息心率低约 20% 至 30%。\n\n跟踪睡眠状态下心率的长期趋势和是否超出个人基线区间，可以了解身体适应性、整体健康表现的异常与波动，或其他需引起注意的健康状况。稳定的保持在个人基线范围内是最好的，虽然更低的睡眠最低心率通常意味着更好的心血管健康水平和身体素质，但低于基线区间太多也可能反映异常的健康状况；高出基线区间的情况更加需要引起注意，可以反映低质量的睡眠、疾病，或睡前不适合的饮食及锻炼习惯。`,
            note: `*睡眠最低心率个人基线区间范围取自过去2个月内积累的数据。` 
        }, 
        "hrv": { 
            title: "睡眠心率变异性", 
            text: `心率变异性（HRV）测量心跳间隔波动，反映心脏自主神经系统功能。HRV是心跳间隔波动的主要指标，通常高值代表更好的心血管功能和抗压能力，低值则与抑郁、焦虑及心血管疾病风险增加相关。事实上，HRV的高低是相对的，取决于许多个人因素（如年龄、性别、昼夜节律、压力反应模式等），没有适用于所有人的标准。因此更有意义的是关注HRV是否保持在个人历史基线范围中，持续超出或低于个人的历史基线都可能暗示身体对压力的适应性或健康状况发生了变化。其中低于历史基线的情况更加需要引起关注，但短期内高出历史基线过多也可能反映异常的健康状况。\n\n• HRV值在个人基线范围内的上升趋势可能表明个体的自我调节能力在增强，可能因为合理的饮食、锻炼或优质的睡眠，身体能够更好地适应压力或恢复到了更健康的状态。\n\n• HRV值在个人基线范围内的下降趋势可能表明个体的自我调节能力受到了某些因素的影响，如压力过大、情绪波动、睡眠质量差等；吸烟、饮酒或某些药物也可能会造成HRV降低。`,
            note: `*HRV个人基线区间范围取自过去2个月内积累的数据。` 
        }, 
        "hrvlh": { 
            title: "HRV LF/HF", 
            text: `自律神经系统调节心率、血压、呼吸和消化，分为交感神经（应激）和副交感神经（放松）系统。HRV LF/HF比值可以用来衡量交感神经和副交感神经活动比例，其中：\n\n• LF/HF比值的下降趋势可能意味着副交感神经系统正在占主导地位，身体可能正在从压力中恢复，或者处于一种更加放松的状态。\n\n• LF/HF比值的上升趋势可能意味着交感神经系统正在占主导地位，身体可能正在应对压力，或处于一种更加活跃或紧张的状态。`,
        }, 
        "rr": { 
            title: "睡眠呼吸频率", 
            text: `健康成年人呼吸频率（每分钟呼吸的次数）一般为 12-20 次/分钟，睡眠时的呼吸频率通常会低于日间呼吸频率。\n\n与心率一样，呼吸频率是一种生命体征指标，可以洞察一个人的整体健康状况。健康成年人的呼吸频率在夜间变化不大，因此与个人基线相比突然的变化可能暗示身体受到压力、睡眠质量下降或出现其他需引起注意的健康状况，对于发现异常情况十分重要。同时，比起低于基线区间的情况，高出基线区间的情况更加需要引起关注，如在发烧或焦虑等健康异常状况下，呼吸频率可能会升高，但短期内低于基线区间太多也可能反映异常的健康状况。`,
            note: `*睡眠呼吸频率个人基线区间范围取自过去2个月内积累的数据。` 
        }, 
        "env": { 
            title: "睡眠环境", 
            text: `合适的睡眠环境对于获得良好的睡眠质量至关重要。睡眠环境监测您睡眠期间环境中的温度、湿度、光照指标，帮助您了解您的环境是否处于最适宜睡眠的条件。\n\n研究表明，适宜的睡眠温度范围为 15-23°C，湿度范围为 40-60%；尽可能在光照强度小于 1lx 的黑暗环境中入睡，开灯睡觉会干扰睡眠周期，导致睡眠更加碎片化。`
        }, 
        "env_temp": { 
            title: "环境温度", 
            text: `合适的睡眠环境对于获得良好的睡眠质量至关重要。研究表明，适宜的睡眠环境温度范围为 15-23°C。`
        }, 
        "env_humi": { 
            title: "环境湿度", 
            text: `合适的睡眠环境对于获得良好的睡眠质量至关重要。研究表明，适宜的睡眠环境湿度范围为 40-60%。`
        }, 
        "env_illu": { 
            title: "环境光照",
            text: `合适的睡眠环境对于获得良好的睡眠质量至关重要。尽可能在光照强度小于1lx即完全黑暗的环境中入睡，高于3lx的光照环境会干扰睡眠周期，导致睡眠更加碎片化。\n\n勒克斯lx是反映光照强度的一种单位。作为参考，通常晴天室内的光照强度为100-1000lx，阴天室内的光照强度为5-50lx，室内60w白炽灯环境下的光照强度约为70-80lx。`
        }, 
        "env_illu_beforesleep": { 
            title: "睡前昏暗环境",
            text: `测量睡前1小时内睡眠环境光照强度。光线是调控褪黑素分泌的核心因素，睡前较亮的环境会影响褪黑素的分泌，影响正常入睡，长期可能会导致昼夜节律障碍。建议睡前30-60分钟进入昏暗的环境，并进行一些放松身心的活动，如冥想、呼吸练习、听轻松的音乐、阅读纸质书籍等，从而可以发出该睡觉了的信号，让身体和大脑逐渐放松，顺利进入睡眠准备状态。\n\n需要注意的是，因监测垫仅能监测到卧室环境光照，因此建议若睡前不在卧室的情况下，也应在相应的环境中遵循睡前进入昏暗环境的建议。\n\n因监测垫主控盒上的光照传感器的摆放及离光源的距离会影响读出的光照强度数据，建议尽可能将主控盒正面朝上/朝外、且无遮挡的摆放在靠近环境光源的位置（如靠近窗户或灯光的床头一侧），以还原接近实际情况的光照强度；若因无法满足适宜的放置位置，导致光照强度数据相比实际环境偏低，可以将监测数据作为最低标准的参考建议，睡前进入尽可能昏暗的环境。`
        }, 
        "env_illu_aftersleep": { 
            title: "醒后明亮环境",
            text: `测量醒后30分钟内环境光照强度。晨间光照是重置生物钟的核心信号，早晨醒来后若没有继续睡眠的想法，建议尽快拉开窗帘让自然光线进入房间，或打开明亮的灯光，这会有助于更快的从睡眠惯性中清醒，同时帮助维持正常的昼夜节律。醒来后长时间处于<100 lx的昏暗环境（如关着窗帘和灯玩手机），可能导致昼夜节律延迟、白天精力不足，长期可能发展为昼夜节律障碍。\n\n需要注意的是，因监测垫仅能监测到卧室环境光照，因此建议若醒后离开卧室的情况下，也应在相应的环境中遵循醒后尽快进入明亮环境的建议。\n\n因监测垫主控盒上的光照传感器的摆放及离光源的距离会影响读出的光照强度数据，建议尽可能将主控盒正面朝上/朝外、且无遮挡的摆放在靠近环境光源的位置（如靠近窗户或灯光的床头一侧），以还原接近实际情况的光照强度；若因无法满足适宜的放置位置，导致光照强度数据相比实际环境偏低，可以将监测数据作为最低标准的参考建议，醒后尽快进入明亮的自然光线环境中。`
        }, 
        "intention_total": { 
            title: "与睡眠无关的在床活动",
            text: `测量在床上进行与睡眠无关活动的时长。上床后就尽快躺下就寝，自然入睡，减少在床上的其它活动（如玩手机、工作等），这能够让你把睡眠和床更紧密的联系起来，建立“床=睡眠”的条件反射，有利于快速入睡，也有益于整体睡眠质量的提升。`
        }, 
        "longwake_total": { 
            title: "持续清醒时长",
            text: `测量在床上尝试入睡但睡不着的清醒状态超过20分钟的情况。当失眠时，不要因为急切地想补足睡眠而强迫自己入睡，无法入睡的情况下持续卧床会强化焦虑与床的错误关联，加剧失眠。\n\n建议超过20分钟仍未睡着的话就应该离床进行一些低刺激的放松活动（如静坐、听白噪音），避免屏幕蓝光、工作及剧烈运动，待睡意明显（眼皮沉重、思维迟缓）再返床。坚持4周以上可以逐渐缩短入睡时间，重建“床=睡眠”的条件反射。\n\n需注意的是，这里的20分钟并不建议通过持续的查看手表、手机来严格执行，根据自己的体感估计即可。`
        }, 
        "hygiene": {
            title: "睡眠行为习惯",
            paragraphs: [
                `睡眠行为习惯评分从睡眠作息和睡眠环境两个维度进行评价，旨在帮助用户理解有助于睡眠质量的一系列行为习惯和环境条件，长期践行可以帮助逐渐提高睡眠质量和日间精力水平。`,
                `评价标准基于失眠认知行为疗法（CBTi）的建议和原则，CBTi是国内外睡眠医学领域权威机构及失眠诊疗指南推荐的首选非药物干预手段，大量随机对照试验和系统评价显示，坚持4-8周的CBTi可显著缩短入睡时长、提高睡眠效率及主观睡眠感受，70%～80%的失眠患者症状得到显著改善，长期疗效显著优于药物。\n
            CBTi包含以下5个部分：`,
                `- 睡眠限制疗法：通过根据个体平均睡眠时间严格限定床上时间，并根据睡眠效率动态调整卧床时长，以增强睡眠驱动力，逐步巩固连续睡眠；`,
                `- 刺激控制疗法：建立“床-睡眠”的条件反射，有困意再上床，避免在床上进行与睡眠无关的活动，超过20分钟难以入睡则起床，每天保持固定的就寝-起床时间；`,
                `- 认知重构疗法：纠正对睡眠的错误认知（如“必须睡够8小时”或“失眠会引发灾难”），减少过度关注睡眠的努力和焦虑，建立合理的睡眠期望；`,
                `- 睡眠卫生教育：规律作息、避免睡前刺激性饮食或活动、睡前营造安静昏暗的卧室氛围，减少妨碍睡眠的行为和环境因素；`,
                `- 放松练习：运用渐进性肌肉放松、呼吸练习、可视化想象或正念练习等方法，缓解身心紧张，帮助快速进入和维持睡眠状态。\n\n睡眠行为习惯评价涵盖了CBTi除放松练习和认知重构以外的全部指导原则。`,
                `需要提醒的是，在开始调整睡眠行为习惯的初期，可能会出现睡眠不足、日间困倦等感受，这属于正常的适应过程，但随着4-8周调整过程的推进，这些不适感受会逐渐改善直至消失。若在调整过程中感到困难，可根据自身生活和工作的实际情况，评估适合自己的的调整节奏及对于睡眠行为习惯建议的参考程度。`
            ]
        },
        "satisfaction": { 
            title: "睡眠感受", 
            text: `记录每日的主观睡眠感受，是了解整体睡眠情况有价值的参考因素之一。每日睡眠报告生成后的当天内（24点前），可以根据醒后或白天的主观感觉，输入或修改睡眠感受。`
        }, 
        "deep": { 
            title: "深睡眠", 
            text: `通常睡眠是由非快速眼动睡眠（NREM sleep）和快速眼动睡眠（REM sleep）往复循环组成的。\n\n非快速眼动睡眠包含浅睡眠和深睡眠。浅睡眠在睡眠阶段中占主导地位，在此阶段心跳和呼吸减缓，体温降低；深睡眠也称慢波睡眠，在此阶段，呼吸和心率降至最低水平，大脑活动减慢，是身体与大脑修复、代谢调节的关键时期。深睡眠一般占总睡眠时间的10-25%，统计表明深睡眠可能随年龄增长每10年减少2%，年轻成年人每晚可能经历 80-100 分钟的深睡眠，而 60 岁以上老年人深度睡眠时间可能少于 20 分钟。`
        }, 
        "rem": { 
            title: "快速眼动睡眠", 
            text: `通常睡眠是由非快速眼动睡眠（NREM sleep）和快速眼动睡眠（REM sleep）往复循环组成的。\n\n快速眼动睡眠是大脑活动最高的睡眠阶段，大部分梦境发生在这期间。除了控制呼吸、心率和眼球运动的肌肉外，身体的大部分肌肉都处于麻痹状态。快速眼动睡眠一般占总睡眠时间的20-25%，统计表明快速眼动睡眠可能随年龄增长轻微减少，年轻成年人每晚可能经历90-120分钟的快速眼动睡眠，而60岁以上老年人可能少于40分钟。`
        }, 
        "spo2": {
            title: "整晚血氧波动估算值",
            text: `血氧水平是血液中所携带的氧气含量，表明氧气在全身分配是否充足，因此可以反应总体健康状况。\n\n睡眠期间的血氧水平通常保持相对稳定，较个人基线相比小幅度波动是正常的（绿色区域或少量的黄色区域）；但如果睡眠中发生呼吸暂停、低通气事件或肺部问题，血氧水平可能会因为进入身体的氧气减少而下降，较个人基线产生较大幅度的波动（大量的黄色区域）。如果图表上经常出现较大幅度的波动并且伴有阻塞性睡眠呼吸暂停风险提示，需要引起注意。`,
            note: `*注意，血氧数据并非直接测量，而是利用睡眠期间心跳与呼吸活动经推算得出，仅供参考。`
        },
        "odi": {
            title: "氧减指数（ODI）",
            text: `氧减指数（ODI）‌是指在整夜睡眠期间，每小时平均发生的氧减次数。这个指标通过监测您的血氧饱和度的变化，来评估您是否有睡眠呼吸暂停的风险。如果ODI持续较高(>5)，并且伴有阻塞性睡眠呼吸暂停风险提示，需要引起注意。`
        },
        "rem_latency": {
            title: "快速眼动睡眠潜伏期",
            text: `指从入睡开始到进入快速眼动睡眠（REM）阶段所需的时间。快速眼动睡眠是睡眠中的一个关键阶段，与做梦、记忆巩固和情绪调节相关。\n\n该指标通常在60～120分钟之间，较短可能是睡眠不足、某些睡眠障碍（如嗜睡症）或白天过度嗜睡的表现；较长则可能表明在睡眠阶段转换上存在困难，这可能与压力、睡眠中断或其他潜在的睡眠问题有关。平衡的快速眼动睡眠潜伏期表明睡眠周期运转良好，对整体的休息质量和认知功能非常重要。如果该指标持续偏离正常范围，需要引起注意。`
        },
        "snore_index": {
            title: "打鼾指数",
            text: `打鼾指数（Snore Index, SI）是指在睡眠过程中每小时发生的打鼾事件的平均次数，用于评估打鼾的严重程度。\n\n长期打鼾的人中约有1/3患有OSA（AHI>5)，打鼾但AHI<5的情况通常是单纯打鼾（AHI指标请参考【呼吸健康】>【呼吸暂停低通气指数】版块）。对于单纯打鼾来说，经常打鼾也可能带来健康风险，由于打鼾引起的颈动脉及其周围组织长期震动，经常打鼾人的颈动脉硬化风险比健康人群高10倍。生活方式的改变，例如减肥、睡前避免饮酒、或侧睡，可以帮助改善打鼾的情况。\n\n打鼾指数的一般参考范围：\n<50：不打鼾\n50-150：轻度打鼾\n150-350：中度打鼾\n>350：重度打鼾`,
            note: `*监测垫通过检测枕下特定频率震动信号的方式识别打鼾，而非通过麦克风采集声音。这种独特的方式一方面保证了对您打鼾的准确识别不会受到床伴打鼾的影响，另一方面保护了隐私。`
        },
        "timing": {
            title: "就寝时间",
            text: `就寝时间测量准备开始睡眠的时间，也即停止其他活动、准备自然入睡的时间。研究表明，规律早睡早起的睡眠模式与更好的心理健康和较低的多种健康问题风险相关（如心血管疾病、糖尿病、抑郁等），而晚睡型个体则可能面临更高的健康风险。\n\n调整合理的就寝时间，可以通过避免晚间咖啡因和屏幕蓝光、确保良好的睡眠环境、白天多晒太阳、适量运动、睡前放松身心等方式，逐步调整作息。\n\n若需大幅调整作息，建议以15分钟/天的幅度逐步改变。`
        },
        "rrv": {
            title: "呼吸率变异性",
            text: `正常呼吸表现出相对稳定的呼吸频率。呼吸频率的变化称为呼吸率变异性（Respiratory Rate Variability, RRV）。呼吸率的变化是一个重要的生理指标，通常与健康状况相关。`
        },
        "nap": {
            title: "日间小睡",
            text: `小睡功能可识别日间进行的15分钟以上、3小时以内的短暂睡眠。日间适当时长的小睡能提高注意力、增强认知功能、改善情绪，建议小睡时长不超过30分钟，以免影响夜间睡眠。小睡可以提升当天的睡眠质量评分，但仅限于19点前发生的小睡。`,
        },
        "age": { 
            title: "睡眠年龄", 
            text: `睡眠年龄是五季医学特有的创新指标，不依赖真实年龄输入，仅通过睡眠中的心跳、呼吸等生理信号，计算出反映整体生理健康状态的“生理年龄”。\n
            采用的深度学习算法在超过6万人的睡眠数据上训练及验证，在健康人群上与真实年龄高度一致，而其与真实年龄的差距能够反映近期的整体健康状况。我们基于一项长达17年、6000多人的队列研究数据发现，睡眠年龄较真实年龄偏高的程度与全因死亡风险上升显著相关，高出5年及10年对应的风险比(Hazard Ratio, HR)分别为1.18及1.40，即全因死亡风险分别上升18%及40%。根据该队列数据的拟合结果，我们也给出了您与健康同龄人相比的健康风险比(HR of all cause health risk)。\n
            睡眠年龄反映的是近期整体生理状态，会随着生活方式、健康状况等相对缓慢地变化。如果开始采取一些改善健康的生活方式干预措施（如规律作息、增加运动等），这些改变可能需要数周时间才会在数据上显现出来，但持续的努力将积累为可见的积极变化。\n
            睡眠年龄通过过去30天内的数据综合评估（需要不少于14天的有效数据），请保持连续进行监测。`,
        },
        "insomnia_health": {
            title: "失眠",
            text: `失眠通常指入睡困难、夜间易醒或醒后难以再次入睡，并进一步影响白天精力、注意力或情绪状态。页面中的失眠展板主要结合入睡速度、睡眠中断时长和夜醒次数等客观趋势，帮助识别近期是否存在持续波动。\n\n这些结果用于健康提示和长期观察，不直接构成医学诊断。若相关表现每周频繁出现并持续较长时间，同时伴有明显的白天功能受损，建议结合专业医生评估。`,
        },
        "aging_speed": {
            title: "衰老速度",
            text: `衰老速度，是身体老化快慢的实时反馈。\n\n五季每天通过睡眠、心脏和呼吸数据，算出一个数字：昨晚让身体变年轻了，还是变老了。\n\n1 代表自然衰老的正常节奏, 每过一年，身体就老一岁。小于 1 说明老得比自然节奏慢，小于 0 就是在逆龄。超过 1 说明衰老在加速，数字越大老得越快。\n\n少熬一次夜，明天这个数字可能就会变好。五季还会拆解出哪些因素在加速衰老、哪些在帮助减速，指明改善方向。`,
        },
        "afib": {
            title: '房颤检测',
            text: `房颤（AFib）是心率不齐的一种类型，表现为心脏的上下腔室跳动不同步。房颤是一种需要重视的身体状况，可以导致卒中、心衰等疾病的风险增加。房颤的症状可能表现为心悸和胸部不适，也可能表现为更不易察觉的全身疲劳、运动困难、气短或头晕，甚至有一些有房颤状况的人表现为毫无症状。\n
            房颤负荷是通过检测睡眠期间具有迹象的不规则心率，进而统计疑似房颤状态的时长占总监测时长的比例。研究表明，健康的生活方式在减轻房颤负荷上有重要作用，可能增加房颤负荷的因素包含摄入过量的咖啡因/酒精、缺乏锻炼、睡眠不足、超重、脱水以及其他可以引起精神压力的因素，可能降低房颤负荷的因素包含健康饮食、保持健康体重、充足的睡眠及保持规律且强度适中的运动习惯等。\n
            在存在房颤迹象时，会展示过去30天内持续超过5分钟的房颤事件次数、最长的一次房颤事件的时长，帮助每个人更确切的理解自己的房颤风险。\n
            *房颤检测不能替代临床诊断。若检测到房颤发生，建议前往专业医疗机构进行进一步咨询和检查。`
        },
        // Lab Page
        "cpc": {
            title: '心肺协同指数',
            text: `心肺协同指数是通过分析您的心率和呼吸模式之间的关联性，预估心肺之间的协同程度。\n\n高心肺协同指数表示心脏和肺部的协同工作良好，通常是心肺功能健康、身体状况良好的标志；低心肺协同指数表明心肺之间的协同减弱，可能与压力、疲劳或潜在的心肺健康问题有关。`,
        },
        // Health Page: CPC（稳定睡眠占比）专用说明
        "cpc_health": {
            title: '心肺耦合（CPC）',
            text: `心肺耦合指标测量心肺协同程度高的睡眠阶段占总睡眠时长的比例。\n\n心肺耦合（CPC）是通过分析心跳与呼吸节律的同步性，来评估自主神经系统调节效能的生理指标。呼吸与心跳节律高度同步对应稳定的深度睡眠，代表神经系统深度放松；反之，若两者节律失调则代表低协同，通常预示交感神经过度兴奋，与慢性压力、生理疲劳或系统性功能退化密切相关。`,
        },
        "stable_sleep": {
            title: '稳定睡眠',
            text: '稳定睡眠是心肺协同程度高的睡眠阶段。稳定睡眠占比指整晚睡眠过程中，稳定睡眠时长占睡眠总时长的比例。',
        },
        "sleep_entry": {
            title: '入睡过程曲线',
            text: `入睡过程曲线反映您入睡过程的难易程度，如果您能从清醒状态较快转移至睡眠状态，说明您容易进入睡眠；如果您的状态转移较缓、存在反复或花费时间过长，说明您可能存在一定的入睡问题。`,
        },
        "sleep_need": {
            title: '自然睡醒剩余时长',
            text: `预测每一时刻距离自然醒来还需要多久。数值根据不同时刻的睡眠状态不断变化。数值越高，说明还需要继续休息；当逐渐降低并接近零时，则意味着正在接近自然醒来的状态。通过观察这个指标，可以了解整晚睡眠是否连贯充足，以及是否出现了夜间醒来或睡眠不安稳的情况。它像睡眠的“进度条”，可直观感受是否“睡够了”，离自然醒来还有多远。`,
        },
        "sex_index": {
            title: '生理性别指数',
            text: `睡眠活动的生理性别指数就像睡眠的“生理性别指纹”，通过分析心跳、呼吸、体动等生理活动，判断出使用者更接近男性还是女性的典型睡眠特征。就像通过外貌识别性别一样，不同生理性别在睡眠中会留下独特的生物印记。`,
        },
        "resp_ri": {
            title: '呼吸间期',
            text: `呼吸间期（Respiratory Interval，RI）表示两次呼吸之间的时间间隔，是呼吸节律最基础的衡量指标。它直接反映了呼吸频率的快慢——RI 越长，呼吸越慢；RI越短，呼吸越快。健康成年人在安静状态下，RI通常在3到5秒之间，对应的呼吸频率约为每分钟12到20次。较短的RI可能出现在运动、紧张或呼吸急促时；而显著延长的RI则可能提示呼吸抑制、深度睡眠或某些病理状态。保持适中的RI是正常呼吸功能和自主神经系统平衡的重要体现。`,
        },
        "resp_sdri": {
            title: '呼吸间期标准差',
            text: `呼吸间期标准差（Standard Deviation of Respiratory Interval, SDRI）是衡量呼吸节律变化幅度的重要指标，用于反映每次呼吸之间时间间隔的波动大小。对于健康成年人在安静或自然睡眠状态下，SDRI通常在 100 到 400 毫秒 之间，说明呼吸既规律又具有适度的灵活性。\n\n若SDRI值偏低（低于 100 毫秒），可能表示呼吸过于单一、节律受限，常见于深度睡眠或机械通气状态；而偏高的SDRI（超过400毫秒）则可能提示呼吸不稳定，与情绪波动、睡眠障碍或自主神经调节紊乱有关。`,
        },
        "resp_cv": {
            title: '呼吸变异系数',
            text: `呼吸变异系数（Coefficient of Variation，CV）是衡量呼吸节律稳定性的重要指标，反映每次呼吸之间时间间隔的波动程度。正常情况下，CV通常在 2% 到 10% 之间，说明呼吸规律、节奏自然。较低的CV（<2%）可能意味着呼吸过于单一，常见于机械通气或深度抑制状态；而较高的CV（>10–12%）则表明呼吸节律波动较大，可能与睡眠不稳、情绪紧张或神经调节异常有关。适度的呼吸变异性是健康的表现，但若CV长期偏高或过低，可能提示身体处于压力状态或某种潜在异常。`,
        },
        "resp_dc": {
            title: '吸气时间分数',
            text: `吸气时间分数（Duty Cycle，DC）表示一次完整呼吸周期中吸气所占的时间比例，是衡量呼吸节律平衡性的重要指标。正常成年人在安静状态下，吸气通常比呼气略短，DC值一般在30%到45%之间，意味着每次呼吸中约三分之一到一半的时间用于吸气。较高的DC（>50%）可能表示吸气过度或呼气不足，常见于紧张、呼吸困难或某些肺功能异常状态；而较低的DC（<30%）则可能提示呼气过长，与疲劳、气道阻力增加有关。`,
        },
        "hrv_rri": {
            title: '平均心博间期',
            text: `平均心博(RR)间期是指两次连续心跳之间的平均时间间隔，反映心跳的平均速度。正常情况下，睡眠时段RR间期应该是稳定的，通常在900-1200ms之间（对应心率50-67次/分）。如果较高（如>1400ms），代表心率偏缓，通常意味着更深度的睡眠或运动员般强壮的心脏，但过高也可能与心脏病变如窦房结功能障碍等有关；如果较低（如<700ms）代表心率偏快，则可能说明睡眠质量差、压力或潜在健康问题。`,
        },
        "hrv_sdnn": {
            title: 'SDNN',
            text: `SDNN是RR间期的标准差，反映整体心率变异性和波动情况。正常范围一般为50-150ms。如果SDNN过低（如 <30ms），可能表明压力过大或自主神经功能受损（如慢性疾病等），而较高（如>150ms）则一般出现在深度睡眠或某些特殊生理状态下，通常说明良好的自主神经调节能力。`,
        },
        "hrv_nn50": {
            title: 'NN50',
            text: `NN50是指相邻RR间期差超过50毫秒的次数（此处显示每小时的均值），反映短期心率变异性。具体数值会因人而异呈现很大差异，通常与年龄和健康状况相关。通常来讲，大于100次/小时表明具有良好的心脏健康和自主神经系统功能；过低的数值（<20次/小时）可能提示心脏健康问题或自主神经功能不良。`,
        },
        "hrv_pnn50": {
            title: 'pNN50',
            text: `pNN50是NN50占总RR间期的百分比，同样表示短期心率变异性，反映自主神经系统活性。其相比NN50是个更标准化的指标，通常在睡眠研究中更受关注。正常范围一般为10%-30%。过低的数值（<5%）可能意味着睡眠质量不佳、压力或自主神经失调；而高的数值通常无害，表示良好的心脏健康和自主神经系统功能。`,
        },
        "ans_activity": {
            title: '自主神经系统活性',
            text: `交感神经活性：如同身体的“应激油门”，当其活性升高时，身体会呈现清醒、紧张、兴奋、焦虑等反应，这里通过心率变异性的低频成分来评估。若夜间交感神经活性偏高，会让大脑难以放松，进而引发入睡困难、睡眠浅或易醒等问题。\n\n副交感神经活性：就像身体的“智能刹车”，能调节身体进入放松、恢复状态，这里采用心率变异性高频成分进行评估。夜间副交感神经活性较高时，能帮助身体深度放松，同时降低心率、促进消化吸收和细胞修复。`,
        },
        "sleep_dur": {
            title: '睡眠进度偏差',
            text: `表示当前的睡眠进展是否符合整晚应有的节奏。数值接近0时，说明睡眠节奏平稳；数值偏高表示当前进度相对较慢，需要更多时间才能完成睡眠，也可能是由于睡眠被提前中断而导致的偏差；数值偏低则可能意味着进展过快，出现了提前醒来或不稳定的趋势。`,
        },
        "strength": {
            title: '昼夜节律强度',
            text: `节律强度是评价睡眠中"生物钟"的稳定程度。\n\n简单来说：如果分值接近100，说明身体的自带闹钟运行良好，具体表现为容易自然入睡、整夜安睡不惊醒、深睡和浅睡周期合理；\n\n如果分值接近0，则表示生物钟出现失调，可能出现入睡困难、频繁醒来或过早清醒等情况，长期可能导致日间注意力降低、情绪易波动等问题。\n\n建议通过规律作息时间、白天适当运动和多晒太阳等方法，帮助身体找回稳定的节奏。`,
        },
        "hrv_recovery": {
            title: 'HRV恢复',
            text: `通过HRV角度所反映的睡眠恢复程度，其值为晨间HRV减去夜间HRV，用颜色箭头表示。箭头起点为夜间HRV，终点为晨间HRV，绿色代表正值，黄色代表负值，箭头长度代表差值幅度。\n\n夜间HRV反映当日压力积累，如数值偏低可能预示过度疲惫、深夜进食、剧烈运动或睡前工作；晨间HRV反映经过一夜睡眠后身心压力恢复水平，更能反映早晨醒来时的感受。\n
            HRV恢复为正值时，可能代表整夜睡眠带来较好的恢复，但也应参考晨间HRV数值是否恢复到和平时数值接近或更高的状态，低于平时的数值可能表示因前一天压力较大，通过良好睡眠带来的恢复也是有限的。\n
            HRV恢复接近0时，如果夜间HRV和晨间HRV都和平时的数值接近或更高，则可认为需恢复的空间不大，在前一天压力水平较低的情况下低恢复值是很常见的；如果都低于平时的数值，可能表明前一天经历较大的压力且未能通过睡眠得到有效的恢复。\n
            HRV恢复为负值时，可能表明睡眠不足、质量差，或者出现了需要关注的健康情况。`,
        },
        "meq": {
            title: '清晨-夜晚节律分型',
            text: `清晨-夜晚节律分型是基于当晚数据推测出的睡眠作息类型，共包含晨型、偏晨型、中立型、偏夜型和夜型五类，反映了在日常生活中偏向早睡早起或晚睡晚起的倾向。\n\n晨型与偏晨型通常更适合在早时间段入睡和醒来，清晨精神状态较好；偏夜型与夜型则往往倾向于在较晚时间入睡，早起时可能感到困倦；中立型则居中，作息节奏与常见社会时间安排较为接近。\n\n通过了解自己的清晨-夜晚睡眠类型，可以更好地认识自身的作息偏好，有针对性地调整生活习惯，优化睡眠与日常节奏的匹配度。`,
        },
        "wakeprob": {
            title: '清醒指数',
            text: `通过监测整夜睡眠深浅变化，反映维持连续睡眠的能力。\n\n数值接近0时代表处于深度无中断睡眠；数值升高提示可能处于浅睡或接近清醒状态；当数值达到1时则记录为实际清醒（如起夜或看手机）。\n\n您可通过曲线中的尖峰位置定位潜在觉醒时刻——尖峰高度越高、宽度越宽，代表清醒程度越明显；尖峰回落速度则反映重新入睡的难易程度。优质睡眠通常表现为曲线长期稳定在低位，仅有少数窄幅波动；若出现频繁高位震荡或密集尖峰，则提示睡眠连续性差，可能与夜间频繁体动、环境干扰或睡眠障碍相关，此类碎片化睡眠可能导致次日困倦、注意力下降等问题。`,
        },
        "energy_score": {
            title: '今日能量',
            text: `今日能量指标基于近期的睡眠节律和睡眠时长，并结合个体化的睡眠需求，评估当日整体的身体与认知状态的恢复水平。数值越高，代表当天更可能感到精力充沛、思维清晰、反应敏捷。能量水平偏低往往与近期作息不规律或持续睡眠不足有关，恢复至较高水平需要连续一段时间的规律作息与充足睡眠的积累，单次补觉虽有一定帮助，但难以快速弥补长期的睡眠债。`,
            changelog: [{
                title: "推荐睡眠时长", 
                text: `为您个性化推荐的建议睡眠时长。系统初始设定的推荐睡眠时长基于符合您年龄的一般需求，可作为调整作息的参考。由于个体对睡眠的实际需求存在差异，您可根据自身感受和实际情况进行个性化调整，以更好地支持健康与高效的日间状态。` ,
            }, {
                title: '预计恢复周期',
                text: `预计恢复周期基于您的个体睡眠需求与累积睡眠负债得出，评估预计需要多少天连续获得充足睡眠才能恢复至高能量状态，用以参考设定切实可行的恢复节奏。`,
            }]
        },
        "energy_curve": {
            title: "日间能量曲线", 
            text: `进一步细致地呈现一天内不同时间段的精力波动，提示当天的高峰时段和低谷时段，即何时最为清醒，可相应安排较高强度的体力脑力活动；何时精力较低，可提前安排短暂小憩，或避免重要工作等；以及褪黑素分泌窗口（也即建议就寝的时间），有助于利用自己的生物钟节律更合理地安排工作与休息，逐渐进入规律作息-良好日间状态的正向循环。` ,
            changelog: [{
                title: "睡眠惯性", 
                text: `睡眠惯性是指刚醒来时短暂的迷糊和迟钝状态，在这个阶段感到反应变慢、注意力不集中，是身体从睡眠状态过渡到清醒状态的自然过程。减少睡眠惯性的方法包括保持规律作息、避免在深睡眠阶段醒来、保证充足睡眠，并在起床后尽快接触自然光或进行简单活动，加快清醒过程。` ,
            }, {
                title: '上午能量高峰',
                text: `一天中思维最为清晰和专注的阶段，拥有最高的身体和认知表现，建议安排较高强度的体力脑力活动或处理重要事项。坚持规律及充足的睡眠有助于使这个阶段的能量水平更高。`,
            }, {
                title: '停止摄入咖啡因',
                text: `睡前10小时建议避免摄入咖啡因。咖啡因半衰期约5-6小时，10小时后可能仍有四分之一无法完全代谢。建议摄入咖啡因饮品的时间为早晨，下午则应避免饮用咖啡和茶，以减少对晚上睡眠的干扰。`,
            }, {
                title: '下午能量低谷',
                text: `一天中精力较低的阶段，可提前安排短暂小憩（如午睡20分钟），避免重要的工作，也可以在这个阶段进行放松、社交活动，缓解身心的疲惫，帮助身体恢复能量。`,
            }, {
                title: '夜晚能量高峰',
                text: `一天中思维最为清晰和专注的阶段，拥有最高的身体和认知表现，可以用来处理重要事项。这个阶段的结束意味着是时候开始放松身心、逐渐平静思绪了。`,
            }, {
                title: '停止正餐或大量进食',
                text: `睡前3小时内建议避免进食。接近睡眠时间的进食，尤其是油腻或高热量食物，会加重消化负担，影响入睡和睡眠质量。建议晚餐清淡、时间适宜，以保证睡眠质量。`,
            }, {
                title: '停止剧烈运动',
                text: `睡前1小时内建议避免运动。运动时间对睡眠的影响因人而异，建议尽量在白天完成锻炼。白天即使仅运动10分钟也会有改善睡眠质量的效果。`,
            }, {
                title: '睡前放松准备',
                text: `已接近建议入睡时间（褪黑素分泌窗口），建议通过冥想、呼吸练习等方式开始睡前放松，并保持环境昏暗、远离电子设备。`,
            }, {
                title: '褪黑素分泌窗口',
                text: `褪黑素窗口是指您最适合入睡的一段时间，这段时间对应大脑开始自然分泌褪黑素的时点，也就是身体发出的“该休息了”的信号。褪黑素是一种在黑暗环境中在大脑中的松果体产生的激素，褪黑素分泌窗口内更容易快速入睡、减少夜间醒来，从而提升整体睡眠质量。根据您近期的睡眠节律和睡眠时长，可估算出每日的褪黑素窗口，从而确定自然的“入睡最佳时机”。\n\n需要注意的是，褪黑素窗口反映的是您近期的生物节律，并非表示只要在这个时间段内入睡就可以。若经常在窗口的后段甚至结束时才入睡，生物节律会逐渐延后，褪黑素分泌时间也会随之推迟，不利于长期的节律稳定。可以通过每天提前15分钟开始准备入睡的方式逐步调整作息节奏，逐渐实现在23点前就寝。随着作息的逐渐前移，褪黑素分泌窗口也会随之提前，白天的能量曲线也会相应变化，有助于早晨更快的清醒和日间的持续精力。`,
            }],
        }
    },
    "en": {
        "quality": { 
            title: "Sleep Quality Score", 
            text: `The sleep quality score is derived from a comprehensive assessment of your daily sleep data across six key dimensions. These include total sleep duration, sleep efficiency, sleep onset latency, sleep interruptions, deep sleep and REM sleep. This composite score is designed to help you quickly understand the quality of your sleep and its variations. \n\nWhile a daily score is provided, we strongly recommend focusing on the trends over weekly, monthly, or even longer periods to gain a more comprehensive understanding of your sleep.` ,
        }, 
        "recovery_baseline": {
            title: "About Personal Baseline",
            paragraphs: [
                "Your personal baseline describes the range where a metric typically falls over a longer period (e.g., the past 60 days). It reflects your own normal range rather than a population-wide standard.",
                "If trend points stay above or below the personal baseline range for a while, it may indicate abnormal fluctuations caused by recent status or external factors (stress, illness, schedule changes, alcohol/exercise, etc.). Consider the recent trend together with how you feel.",
            ],
        },
        "recovery_score": {
            title: "Recovery Score",
            paragraphs: [
                "The recovery score reflects how much energy your body regained during a night's sleep, and it is often closer to how you actually feel when you wake up.",
                "It evaluates recovery across four dimensions: sleep sufficiency (sleep duration and sleep debt), body repair (key sleep architecture such as deep sleep and REM), sleep stability (nighttime awakenings and movement), and physiological steadiness (autonomic indicators such as heart rate variability and cardiopulmonary coupling).",
                "Unlike the sleep score, which focuses on the quality of the sleep process itself, the recovery score focuses on the actual restorative effect produced by that sleep.",
                "The two scores can differ on the same night. For example, if total sleep time is short but deep sleep proportion is high, the sleep score may be average while the recovery score can still be fairly good.",
            ],
        },
        "tst":{ 
            title: "Total Sleep Time", 
            text: `Total Sleep Time (TST) refers to the actual amount of sleep within the total recording period, encompassing all REM and non-REM sleep stages. The appropriate duration of sleep depends on various factors, especially age. Generally, it is recommended that adults aged 18-65 get 7-9 hours of sleep, while those aged 65 and older are advised to get 7-8 hours. Please note that these recommendations are general guidelines, as individual lifestyle and health conditions can vary, and the actual amount of sleep needed may differ.\n\nEstablishing a regular sleep schedule, creating a conducive sleep environment, avoiding caffeine and stimulants before bedtime, and limiting naps to 20-30 minutes can help maintain a healthy sleep duration.` 
        }, 
        "se": { 
            title: "Sleep Efficiency", 
            text: `Sleep Efficiency (SE) is the proportion of time spent actually sleeping during the total time spent in bed. Sleep efficiency is calculated as: Sleep Efficiency = Total Sleep Time / Time in Bed. \n\nA sleep efficiency of 85% or higher is considered normal, while a sleep efficiency above 90% is regarded as excellent. Prolonged sleep onset latency and sleep interruptions are the primary factors that contribute to low sleep efficiency.` 
        }, 
        "sol": { 
            title: "Sleep Onset Latency", 
            text: `Sleep Onset Latency (SOL) measures the time it takes to fall asleep. It refers to the time from getting into bed to the onset of sleep. Ideally, sleep latency should be between 10 and 20 minutes. Even without a subjective feeling of tiredness, people generally fall asleep more quickly when they need sleep. A very short sleep latency might indicate sleep deprivation, while a prolonged latency (greater than 20-30 minutes) could signify insomnia or other health issues affecting the ability to fall asleep. \n\nLimiting screen time before bed, establishing a regular bedtime routine, avoiding exercise before sleep, and using psychological relaxation techniques such as meditation or breathing exercises can help reduce sleep onset latency and improve sleep quality.` 
        }, 
        "waso": { 
            title: "Wake After Sleep Onset", 
            text: `Wake After Sleep Onset (WASO) measures the total number of minutes awake after initially falling asleep. Some degree of WASO is normal, but prolonged or fragmented wakefulness during the night can significantly reduce sleep quality, impacting daytime energy, work, and learning performance. \n\nThere are many factors that can increase wakefulness after sleep onset, including anxiety and stress, sleep disorders, irregular sleep schedules, overeating or excessive alcohol consumption, and other health issues or medical conditions. Understanding these factors and taking appropriate steps to address them, such as maintaining a regular sleep schedule, improving the sleep environment, and reducing stress, can help improve sleep quality by reducing the frequency and duration of nighttime awakenings.` 
        }, 
        "disturbance": { 
            title: "Sleep Disturbance", 
            text: `Sleep disturbance measures the duration and frequency of nitghttime awakenings during sleep, known as Wake After Sleep Onset (WASO) and Awakenings. WASO refers to the total number of minutes awake after initially falling asleep. Awakenings refers to the total number of times awake after initially falling asleep. Some degree of WASO and Awakenings is normal, but prolonged or fragmented wakefulness during the night can significantly reduce sleep quality, impacting daytime energy, work, and learning performance.\n\nThere are many factors that can increase wakefulness after sleep onset, including anxiety and stress, sleep disorders, irregular sleep schedules, overeating or excessive alcohol consumption, and other health issues or medical conditions. Understanding these factors and taking appropriate steps to address them, such as maintaining a regular sleep schedule, improving the sleep environment, and reducing stress, can help improve sleep quality by reducing the frequency and duration of nighttime awakenings.` 
        }, 
        "sri": { 
            title: "Sleep Regularity", 
            text: `Sleep regularity is calculated using the Sleep Regularity Index (SRI), which measures the consistency of your sleep onset and wake-up times over the past 7 days. Sleep regularity has a significant impact on sleep quality; maintaining a consistent sleep schedule and routine helps regulate your biological clock, promotes healthier sleep patterns, and positively influences sleep quality. It is also crucial for overall health, safety, and work performance. Research has found that irregular sleep patterns are associated with various negative outcomes, including heart rate variability, inflammation, metabolism, mental health, and cognitive performance.\n\nThe first step in improving sleep regularity is to establish consistent bedtimes and wake-up times while ensuring adequate sleep, even on weekends. Although it may take some time to adjust, this is normal. Additionally, practicing good sleep hygiene and gradually aligning your bedtime with your desired schedule can help you develop a stable and healthy sleep pattern.` 
        }, 
        "stage": { 
            title: "Sleep Stages", 
            text: `Our sleep is composed of multiple cycles of non-rapid eye movement (NREM) sleep and rapid eye movement (REM) sleep. \n\nREM sleep is the stage of sleep where brain activity is at its peak, and most dreaming occurs. During this stage, most of the body’s muscles are paralyzed, except for those controlling breathing, heart rate, and eye movements. \n\nNREM sleep includes both light sleep and deep sleep. Light sleep is the dominant phase in the sleep cycle, during which the heart rate and breathing slow down, and body temperature decreases. Deep sleep, also known as slow-wave sleep, is the phase where breathing and heart rate reach their lowest levels, brain activity slows down, and the body and brain undergo essential repair and metabolic regulation.Deep sleep generally constitutes 10-25% of total sleep time. Statistics indicate that deep sleep may decrease by about 2% per decade with age. Young adults may experience 80-100 minutes of deep sleep per night, while older adults over 60 years of age may get less than 20 minutes of deep sleep.`
        }, 
        "ahi": { 
            title: "Apnea-Hypopnea Index (AHI)", 
            text: `Obstructive Sleep Apnea (OSA) is a sleep-related breathing disorder characterized by snoring accompanied by episodes of apnea and excessive daytime sleepiness. The prevalence of OSA is estimated to be 2% to 4%. This condition can cause intermittent hypoxia, hypercapnia, and disruption of sleep architecture, leading to multiple organ and system damage, including hypertension, coronary artery disease, arrhythmias, cerebrovascular disease, cognitive impairment, and type 2 diabetes. Studies have shown that the mortality rate of untreated patients with severe OSA is 3.8 times higher than that of the general population.\n
            The diagnosis of OSA typically relies on the Apnea-Hypopnea Index (AHI). AHI represents the average number of apnea and hypopnea episodes per hour of sleep, calculated by dividing the total number of apnea and hypopnea events (each lasting more than 10 seconds) by the total sleep time. The AHI values for adults are categorized into three levels, corresponding to different severities of OSA:\nMild: 5≤AHI<15\nModerate: 15≤AHI<30\nSevere: AHI≥30`
        }, 
        "oahi": { 
            title: "Obstructive Apnea-Hypopnea Index (OAHI)", 
            text: `Pediatric obstructive sleep apnea (OSA) is defined as the frequent occurrence of partial or complete upper‑airway obstruction during sleep in children aged 1–18 years, which interferes with normal ventilation and sleep architecture and leads to a range of pathophysiological changes. It chiefly presents as snoring, gasping spells, or mouth breathing during sleep; in severe cases, children may experience nocturnal arousals, daytime inattention, learning difficulties, emotional disturbances, and impaired growth and development.\n
            The primary etiology of pediatric OSA is typically adenoid and/or tonsillar hypertrophy, although factors such as obesity, craniofacial malformations, and neuromuscular disorders may also contribute. If OSA is not diagnosed promptly and effectively managed, it can give rise to serious complications, including craniofacial dysmorphia (“adenoid facies”), behavioral abnormalities, learning disabilities, growth failure, neurocognitive impairment, endocrine and metabolic dysfunction, systemic hypertension, pulmonary hypertension, and even an increased risk of cardiovascular events in adulthood. Therefore, early detection, diagnosis, and intervention of pediatric OSA are crucial for improving long‑term outcomes.\n
            Diagnosis is usually based on the obstructive apnea–hypopnea index (OAHI), defined as the average number of obstructive apneas, mixed apneas, and obstructive hypopneas per hour of sleep. Severity is classified as follows:\nMild：1<OAHI≤5\nModerate：5<OAHI≤10\nSevere：OAHI>10`
        }, 
        "osa": { 
            title: "Obstructive Sleep Apnea (OSA)", 
            text: `Obstructive Sleep Apnea (OSA) is a sleep-related breathing disorder characterized by snoring accompanied by episodes of apnea and excessive daytime sleepiness. The prevalence of OSA is estimated to be 2% to 4%. This condition can cause intermittent hypoxia, hypercapnia, and disruption of sleep architecture, leading to multiple organ and system damage, including hypertension, coronary artery disease, arrhythmias, cerebrovascular disease, cognitive impairment, and type 2 diabetes. Studies have shown that the mortality rate of untreated patients with severe OSA is 3.8 times higher than that of the general population.\n
            Diagnosis of adult OSA is generally based on the apnea–hypopnea index (AHI), defined as the average number of apneas and hypopneas per hour of sleep. Severity is classified as:\nMild: 5≤AHI<15\nModerate: 15≤AHI<30\nSevere: AHI≥30\n
            Diagnosis of pediatric OSA is generally based on the obstructive apnea–hypopnea index (OAHI), defined as the average number of obstructive apneas, mixed apneas, and obstructive hypopneas per hour of sleep. Severity is classified as:\nMild：1<OAHI≤5\nModerate：5<OAHI≤10\nSevere：OAHI>10\n
            OSA is assessed through a evaluation of data from the past 30 days (requiring at least 14 days of valid data). Please continue monitoring consistently.`
        }, 
        "ahi2345": { 
            title: "Apnea-Hypopnea Events and Sleep Stages",
            text: `The severity of upper airway collapse and Obstructive Sleep Apnea (OSA) varies during different sleep stages. Rapid Eye Movement (REM) sleep, which accounts for 20%-25% of total sleep time, is closely associated with physiological changes that affect upper airway function. During REM sleep, there is a reduction in muscle tone throughout the body, which increases the likelihood of upper airway collapse. \n\nAdditionally, apnea-hypopnea events during REM sleep are typically longer and more frequent compared to those during Non-Rapid Eye Movement (NREM) sleep, and the reductions in blood oxygen levels may be more significant. In fact, 10%-37% of patients diagnosed with OSA exhibit apneas and/or hypopneas exclusively during REM sleep. Therefore, understanding the Apnea-Hypopnea Index (AHI) during different sleep stages is crucial for the assessment and treatment of OSA.`
        }, 
        "hr": { 
            title: "Sleeping Heart Rate", 
            text: `During sleep, a person's heart rate typically falls below their daytime resting heart rate, averaging as low as 40 to 50 beats per minute. Most adults have a resting heart rate between 40 to 100 beats per minute, and the heart rate during deep sleep may be about 20% to 30% lower than the resting heart rate. \n\nTracking long-term trends in heart rate during sleep and any deviations from personal baseline ranges can provide insights into the body's adaptability, overall health anomalies and fluctuations, or other health concerns that may require attention. Maintaining a stable heart rate within personal baseline ranges is ideal, although a lower minimum heart rate during sleep usually indicates better cardiovascular health and physical fitness. However, heart rates significantly below the baseline may indicate abnormal health conditions; rates above the baseline are particularly concerning, as they may reflect poor sleep quality, illness, or unsuitable dietary and exercise habits before sleep.`,
            note: `* The personal baseline of lowest sleeping heart rate is based on data gathered from the past two months.` 
        }, 
        "hrv": { 
            title: "Heart Rate Variability", 
            text: `Heart Rate Variability (HRV) measures the fluctuation between heartbeats, reflecting the function of the autonomic nervous system. Higher values typically indicate better cardiovascular function and stress resilience, while lower values may be associated with increased risks of depression, anxiety, and cardiovascular diseases. In fact, HRV levels are relative and depend on many individual factors, such as age, gender, circadian rhythms, and stress response patterns, and there are no universal standards applicable to everyone. It is more meaningful to monitor whether HRV remains within an individual's historical baseline range. Consistently exceeding or falling below one's historical baseline can suggest changes in the body's adaptability to stress or overall health. A decrease below the historical baseline warrants particular attention, but an excessively high HRV in the short term can also indicate abnormal health conditions. \n\n• An upward trend in HRV within the personal baseline range may indicate an enhancement in an individual's self-regulation abilities, possibly due to a balanced diet, exercise, or quality sleep, allowing the body to better adapt to stress or return to a healthier state. \n\n• Conversely, a downward trend within the baseline range could suggest that the individual's self-regulation capacity is being impacted by factors such as excessive stress, emotional fluctuations, poor sleep quality; smoking, drinking, or certain medications could also cause a reduction in HRV.`,
            note: `* The personal baseline of HRV is based on data gathered from the past two months.` 
        }, 
        "hrvlh": { 
            title: "HRV LF/HF", 
            text: `The autonomic nervous system regulates heart rate, blood pressure, breathing, and digestion, and is divided into the sympathetic (stress response) and parasympathetic (relaxation response) systems. The LF/HF ratio in Heart Rate Variability (HRV) can be used to measure the balance between sympathetic and parasympathetic nervous activities:\n\n• A declining trend in the LF/HF ratio may indicate that the parasympathetic nervous system is becoming more dominant, suggesting that the body might be recovering from stress or entering a more relaxed state.\n\n• An increasing trend in the LF/HF ratio may suggest that the sympathetic nervous system is becoming more dominant, indicating that the body might be responding to stress, or is in a more active or tense state.`,
        }, 
        "rr": { 
            title: "Sleeping Respiratory Rate", 
            text: `Healthy adults typically have a respiratory rate of 12-20 breaths per minute, and this rate usually decreases during sleep compared to daytime breathing rates.\n\nLike heart rate, respiratory rate is a vital sign that can provide insights into an individual's overall health. In healthy adults, the respiratory rate doesn't vary significantly overnight, so sudden changes compared to personal baselines might indicate the body is under stress, experiencing a decline in sleep quality, or other health issues that require attention. Notably, rates exceeding the baseline range often warrant more concern. For instance, an increased respiratory rate can occur in conditions like fever or anxiety. However, a significant drop below the baseline in the short term might also reflect abnormal health conditions.`,
            note: `* The personal baseline of sleeping respiratory rate is based on data gathered from the past two months.` 
        }, 
        "env": { 
            title: "Sleep Environment", 
            text: `An appropriate sleep environment is crucial for achieving good sleep quality. Monitoring the temperature, humidity, and light levels in your environment during sleep can help you determine if your surroundings are optimally set for sleep.\n\nResearch indicates that the ideal temperature range for sleep is 15-23°C, and the ideal humidity range is 40-60%. It’s best to sleep in as dark an environment as possible, with light intensity less than 1 Lx. Sleeping with the lights on can disrupt your sleep cycle, leading to more fragmented sleep.`
        }, 
        "env_temp": { 
            title: "Environment Temperature", 
            text: `An appropriate sleep environment is crucial for achieving good sleep quality. Research indicates that the ideal temperature range for sleep is 15-23°C.`
        }, 
        "env_humi": { 
            title: "Environment Humidity", 
            text: `An appropriate sleep environment is crucial for achieving good sleep quality. Research indicates that the ideal humidity range is 40-60%.`
        }, 
        "env_illu": { 
            title: "Environment Light", 
            text: `An appropriate sleep environment is crucial for achieving good sleep quality. It’s best to sleep in as dark an environment as possible, with light intensity less than 1 Lx. Sleeping with the lights on can disrupt your sleep cycle, leading to more fragmented sleep.\n\nLux (lx), or illuminance, is a unit that measures light intensity. For reference, the typical indoor light intensity on a sunny day is typically between 100 and 1,000 lx, while on a cloudy day it ranges from 5 to 50 lx. The light intensity under a 60W incandescent bulb indoors is approximately 70–80 lux.`
        }, 
        "env_illu_beforesleep": { 
            title: "Dim environment before bedtime",
            text: `This measures the light intensity in your sleep environment during the hour before bedtime. Light is a key factor in regulating melatonin secretion. Exposure to bright light before sleep can suppress melatonin production, making it harder to fall asleep and potentially contributing to or worsening circadian rhythm disorders over time. It is recommended to stay in a dim environment for 30–60 minutes before bed and engage in relaxing activities such as meditation, breathing exercises, listening to calming music, or reading a physical book. These signals help your body and brain wind down and prepare for sleep.\n\nPlease note that the sensor on the controller only measures light levels in the bedroom. If you are in a different environment before bed, the data may not reflect your actual light exposure. However, it is still important to follow the recommendation of entering a dim environment before bedtime, regardless of your location.\n\nSince the placement and distance from the light source of the light sensor on the controller can affect the recorded light intensity, it is recommended to position the controller with the front facing upward or outward and in an unobstructed area, ideally near the actual light source in the environment (e.g., on the side of the bed closer to a window or lamp). This helps capture light intensity data that more closely reflects the real conditions. If an ideal placement is not possible and the recorded light intensity is lower than the actual environment, you can use the monitoring data as a minimum reference. In such cases, aim to create as dim an environment as possible before bedtime.`
        }, 
        "env_illu_aftersleep": { 
            title: "Bright Environment after Waking up",
            text: `This measures the ambient light intensity within 30 minutes after waking. Morning light exposure is a key signal for resetting the biological clock. If you do not intend to go back to sleep after waking, it is recommended to open the curtains promptly to let natural light in or turn on bright indoor lights. This helps you wake up more quickly from sleep inertia and supports a healthy circadian rhythm. Staying in a dim environment with light levels below 100 lx (e.g., lying in bed with the curtains closed and lights off while using your phone) for an extended period after waking may delay your circadian rhythm, reduce daytime alertness, and, over time, contribute to circadian rhythm disorders.\n\nPlease note that the sensor on the controller only detects light levels in the bedroom. If you leave the bedroom after waking, the data may not reflect your actual light exposure. Nevertheless, it is still important to follow the recommendation of entering a bright environment as soon as possible after waking, regardless of your location.\n\nSince the placement and distance from the light source of the light sensor on the controller can affect the recorded light intensity, it is recommended to position the controller with the front facing upward or outward and in an unobstructed area, ideally near the actual light source in the environment (e.g., on the side of the bed closer to a window or lamp). This helps capture light intensity data that more closely reflects the real conditions. If an ideal placement is not possible and the recorded light intensity is lower than the actual environment, you can use the monitoring data as a minimum reference. In such cases, aim to enter a bright environment as soon as possible after waking up.`
        }, 
        "intention_total": { 
            title: "Non-Sleep Time in Bed",
            text: `This measures the amount of time spent in bed engaging in activities unrelated to sleep and sex. Once in bed, lie down and prepare to sleep as soon as possible, allowing yourself to fall asleep naturally. Reducing other activities in bed—such as using your phone or working—can help strengthen the mental association between bed and sleep, reinforcing the conditioned response of “bed = sleep.” This promotes faster sleep onset and contributes to overall improvements in sleep quality.`
        }, 
        "longwake_total": { 
            title: "Duration of Sustained Wakefulness",
            text: `This measures the situation of remaining awake in bed for more than 20 minutes while trying to fall asleep. When experiencing insomnia at night, avoid forcing yourself to sleep out of a desire to make up for lost sleep. Continuing to lie in bed without falling asleep can strengthen the anxiety and incorrect association between bed and wakefulness, which can worsen insomnia.\n\nIf you haven't fallen asleep after 20 minutes, it’s recommended to get out of bed and engage in low-stimulation relaxation activities (such as sitting quietly or listening to white noise). Avoid screen exposure, work, or intense exercise, and return to bed only when you feel noticeably sleepy (heavy eyelids, slowed thinking). Consistently following this for more than 4 weeks can gradually shorten sleep onset time and help rebuild the “bed = sleep” conditioned response.\n\nIt’s important to note that the 20-minute guideline should not be strictly measured by checking your watch or phone constantly. Instead, estimate based on how you feel. If you haven't fallen asleep after approximately 15–20 minutes, then get out of bed.`
        }, 
        "hygiene": {
            title: "Sleep hygiene",
            paragraphs: [
                `The sleep hygiene score evaluates two key dimensions: sleep routine and sleep environment. It is designed to help users understand the behavioral habits and environmental factors that contribute to better sleep quality. Practicing these sleep hygiene standard  consistently over time can gradually improve both sleep quality and daytime energy levels.`,
                `The evaluation criteria are based on the recommendations and principles of Cognitive Behavioral Therapy for Insomnia (CBTi), which is the first-line non-pharmacological intervention recommended by authoritative institutions and clinical guidelines in the field of sleep medicine worldwide. A large number of randomized controlled trials and systematic reviews have shown that 4–8 weeks of CBTi can significantly reduce sleep onset latency, improve sleep efficiency and subjective sleep quality. Approximately 70%–80% of individuals with insomnia experience significant symptom improvement, and its long-term efficacy surpasses that of medication.\n
            CBTi consists of the following five components:`,
                `- Sleep Restriction: Limits time in bed based on an individual’s average sleep duration and dynamically adjusts it according to sleep efficiency to enhance sleep drive and gradually consolidate continuous sleep.`,
                `- Stimulus Control: Reinforces the association between bed and sleep by encouraging individuals to only go to bed when sleepy, avoid non-sleep activities in bed, get out of bed if unable to sleep within 20 minutes, and maintain a consistent sleep-wake schedule.`,
                `- Cognitive Restructuring: Addresses and corrects misconceptions about sleep (e.g., “I must get 8 hours of sleep” or “Insomnia will cause major harm”), reduces anxiety and excessive effort around sleep, and builds more realistic expectations.`,
                `- Relaxation Techniques: Uses progressive muscle relaxation, breathing exercises, or mindfulness practices to relieve physical and mental tension and support falling and staying asleep.\n\nThe sleep hygiene score incorporates all the recommended principles of CBTi except for relaxation techniques and cognitive restructuring.`,
                `It is important to note that during the initial phase of adjusting sleep hygiene, individuals may experience sleep deprivation or daytime sleepiness. These are normal adaptation responses that typically subside as the 4–8 week process progresses. If you find the adjustment challenging, consider tailoring the pace and extent of behavior changes to your personal lifestyle and work schedule.`
            ]
        },
        "satisfaction": { 
            title: "Sleep Perception", 
            text: `Keeping a daily record of subjective sleep perception is a valuable reference for understanding overall sleep patterns. You can enter or modify your sleep perceptions based on how you feel upon waking or during the day, within the same day that the sleep report is generated (before midnight). This practice can help you track and manage your sleep quality over time, allowing you to make adjustments as needed based on your personal observations.`
        }, 
        "deep": { 
            title: "Deep Sleep", 
            text: `The sleep cycle consists of non-rapid eye movement (NREM) sleep and rapid eye movement (REM) sleep.\n\nNREM sleep includes both light and deep sleep stages. Light sleep predominates in the sleep cycle; during this phase, heart rate and breathing slow down, and body temperature decreases. Deep sleep, also known as slow-wave sleep, is a phase where both breathing and heart rate drop to their lowest levels, and brain activity slows down. This stage is crucial for physical and brain repair and metabolic regulation. Deep sleep generally accounts for 10-25% of total sleep time. Statistics indicate that deep sleep may decrease by about 2% per decade with age. Young adults might experience 80-100 minutes of deep sleep per night, while individuals over 60 years of age might have less than 20 minutes of deep sleep.`
        }, 
        "rem": { 
            title: "Rapid Eye Movement (REM) Sleep", 
            text: `The sleep cycle consists of non-rapid eye movement (NREM) sleep and rapid eye movement (REM) sleep.\n\nREM sleep is the stage of sleep with the highest brain activity, and it is during this phase that most dreaming occurs. During REM sleep, most of the body's muscles are paralyzed, except for those that control breathing, heart rate, and eye movements. REM sleep typically accounts for 20-25% of the total sleep time. Statistics suggest that the amount of REM sleep may slightly decrease with age. Young adults might experience 90-120 minutes of REM sleep each night, while individuals over the age of 60 might have less than 40 minutes.`
        }, 
        "spo2": {
            title: "Estimated Drop of Blood Oxygen",
            text: `Blood oxygen saturation represents the amount of oxygen carried in the blood, indicating whether oxygen distribution throughout the body is sufficient, and thus it can reflect overall health status. Blood oxygen drop ratio approximates the decline percentage in your blood oxygen saturation.\n\nDuring sleep, blood oxygen saturation typically remains relatively stable, and minor fluctuations compared to personal baselines are normal (within green areas or minimal yellow areas). However, if apnea-hypopnea events, or lung issues occur during sleep, oxygen saturation might decrease due to reduced oxygen intake, resulting in more significant fluctuations compared to personal baselines (extensive yellow areas). If the chart frequently shows significant fluctuations accompanied by risks of obstructive sleep apnea, it's important to pay attention and possibly seek medical advice.`,
            note: `Note: Oxygen saturation is not directly measured but is estimated based on heartbeat and respiratory activity during sleep. For reference only.`
        },
        "odi": {
            title: "Oxygen Desaturation Index (ODI)",
            text: `The Oxygen Desaturation Index (ODI) measures how often your blood oxygen level drops by a certain percentage during sleep. It's an important indicator of how well your body is getting oxygen while you rest. In simple terms, ODI helps track the number of times per hour your blood oxygen levels decrease, which can be a sign of breathing problems like sleep apnea. Consistently higher ODI (above 5), accompanied by risks of obstructive sleep apnea, may suggest further investigation or treatment.`
        },
        "rem_latency": {
            title: "REM Latency",
            text: `REM Latency refers to the amount of time it takes for you to enter the REM (Rapid Eye Movement) stage of sleep after initially falling asleep. REM sleep is a crucial phase of your sleep cycle, associated with vivid dreaming, memory consolidation, and emotional regulation.\n\nHealthy REM Latency typically ranges between 60-120 minutes. Shorter REM Latency can be a sign of sleep deprivation, certain sleep disorders like narcolepsy, or excessive daytime sleepiness. Longer REM Latency may indicate difficulties in transitioning through the sleep stages, which could be due to stress, sleep fragmentation, or other underlying sleep issues.\n\nA balanced REM Latency suggests a well-functioning sleep cycle, which is important for overall restfulness and cognitive function. If your REM Latency is consistently outside the normal range, it might be helpful to review your sleep habits or consult a healthcare professional.`
        },
        "snore_index": {
            title: "Snore Index",
            text: `The Snore Index (SI) refers to the average number of snoring events per hour during sleep and is used to assess the severity of snoring. \n\nAbout one-third of people who snore chronically have Obstructive Sleep Apnea (OSA) with an Apnea-Hypopnea Index (AHI) above 5. Snorers with an AHI below 5 are usually classified as simple snorers. Frequent snoring can pose health risks. Due to the prolonged vibration of the carotid artery and surrounding tissues caused by snoring, frequent snorers have a tenfold higher risk of carotid atherosclerosis compared to healthy individuals. Lifestyle changes, such as weight loss, avoiding alcohol before bed, or sleeping on one’s side, can help reduce snoring.`
        },
        "timing": {
            title: "Timing",
            text: `Timing refers to the time of starting to prepare for sleep. Research indicates that maintaining consistent sleep timing, with early bedtimes and wake-ups, is associated with better mental health and a lower risk of various health issues, such as cardiovascular disease, diabetes, and depression. In contrast, habitual late sleepers may face higher health risks.\n\nTo adjust your bedtime to a healthier schedule, consider gradually shifting your routine by avoiding caffeine and screen exposure in the evening, creating a conducive sleep environment, getting plenty of natural light during the day, engaging in moderate physical activity, and relaxing your body and mind before bed.\n\nIf a significant sleep routine reset is needed, it is recommended to make incremental changes of about 15 minutes per day.`
        },
        "rrv": {
            title: "Respiratory Rate Variability",
            text: `Normal breathing exhibits a relatively constant rate. Variations within this respiratory rate (RR) are labeled as Respiratory Rate Variability (RRV). Changes in respiratory rate is an important indicator which often precedes various health issues.`
        },
        "nap": {
            title: "Daytime Nap",
            text: `Nap feature detects naps between 15 minutes and 3 hours. Taking a short nap during the day can improve alertness, enhance cognitive function, and improve mood. A nap duration of no more than 30 minutes is recommended to avoid affecting nighttime sleep. Naps can boost the sleep quality score for the day, but only if they occur before 7:00 PM.`,
        },
        "age": { 
            title: "Sleep Age", 
            text: `Sleep age is an innovative metric which does not rely on inputting your actual chronological age; instead, it calculates a 'physiological age' that reflects your overall physiological health based solely on heart and respiration signals during sleep.\n
            Our deep learning algorithm are trained and validated on sleep data from over 60,000 individuals, and in healthy populations, it closely aligns with chronological age. The difference between sleep age and chronological age can indicate your recent overall health status. Based on a 17-year cohort study involving more than 6,000 participants, we found that a higher sleep age relative to chronological age is significantly associated with an increased risk of all-cause mortality. Specifically, a sleep age that exceeds chronological age by 5 and 10 years corresponds to hazard ratios (HR) of 1.18 and 1.40, respectively — indicating an 18% and 40% increase in the risk of all-cause mortality. Using the fitted results from this cohort data, we also provide a health risk ratio (HR of all-cause health risk) comparing you to healthy peers.\n
            Sleep age reflects your recent overall physiological state and tends to change gradually with lifestyle and health conditions. If you begin to adopt healthy lifestyle interventions — such as maintaining regular sleep patterns and increasing physical activity — these changes may take several weeks to reflect in the data, but sustained efforts will accumulate into visible positive improvements.\n
            Sleep age is assessed through a evaluation of data from the past 30 days (requiring at least 14 days of valid data). Please continue monitoring consistently.`,
        }, 
        "insomnia_health": {
            title: "Insomnia",
            text: `Insomnia usually refers to difficulty falling asleep, frequent awakenings during the night, or trouble returning to sleep, often followed by reduced daytime energy, concentration, or mood. The insomnia panel on this page mainly uses objective trends such as sleep onset latency, wake time after sleep onset, and awakenings to help identify recent persistent fluctuations.\n\nThese results are intended for wellness guidance and longitudinal tracking, not as a medical diagnosis. If the pattern occurs frequently each week, lasts for an extended period, and is accompanied by clear daytime impairment, professional medical evaluation is recommended.`,
        },
        "aging_speed": {
            title: "Aging Speed",
            text: `Aging speed is a real-time reflection of how fast your body is aging.\n\nEach day, Five Seasons uses your sleep, heart, and breathing data to calculate one number: whether last night made your body younger or older.\n\nA value of 1 represents the natural pace of aging: each passing year means your body ages by one year. A value below 1 means your body is aging more slowly than that natural pace. A value below 0 means reverse aging. A value above 1 means aging is accelerating, and the higher the number, the faster your body is aging.\n\nEven one less late night may improve this number tomorrow. Five Seasons also breaks down which factors are accelerating aging and which are helping slow it down, so you can see a clearer direction for improvement.`,
        },
        "afib": {
            title: 'Atrial Fibrillation Detection',
            text: `Atrial Fibrillation (AFib) is a type of arrhythmia characterized by the unsynchronized beating of the heart's upper and lower chambers. AFib is a condition that requires attention, as it can increase the risks of stroke, heart failure, and other heart-related complications. The symptoms of AFib may include palpitations and chest discomfort, or they may be more subtle, such as generalized fatigue, exercise intolerance, shortness of breath, or dizziness — even some individuals with AFib may exhibit no symptoms at all.\n
            AFib Burden measures the percentage of total sleep time during which you are in a suspected AFib state. Research indicates that a healthy lifestyle plays a significant role in reducing AFib burden. Factors that may contribute to an increased AFib burden include excessive intake of caffeine or alcohol, lack of exercise, insufficient sleep, being overweight, dehydration, and other stress-inducing factors. Conversely, factors that may help lower AFib burden include maintaining a healthy diet, keeping a healthy weight, getting adequate sleep, and engaging in regular, moderate exercise.\n
            When signs of AFib are detected, the number of AFib episodes lasting more than 5 minutes, as well as the duration of the longest AFib episode in the past 30 days, will be displayed to help you better understand your AFib risk.\n
            Please note that AFib detection is not a substitute for clinical diagnosis. If AFib is detected, it is recommended that you seek further consultation and examination at a professional medical institution.`,
        },
        // Lab Page
        "cpc": {
            title: 'Cardiopulmonary Coupling Index',
            text: `The Cardiopulmonary Coupling Index is estimated by analyzing the correlation between your heart rate and breathing patterns, reflecting the level of coordination between the heart and lungs. \n\nA high value indicates good heart-lung coordination, which is typically a sign of healthy cardiorespiratory function and overall physical well-being. A low value suggests reduced coordination between the heart and lungs, which may be associated with stress, fatigue, or potential cardiorespiratory health issues.`,
        },
        // Health Page: CPC (stable sleep ratio) specific
        "cpc_health": {
            title: 'Cardiopulmonary Coupling (CPC)',
            text: `This metric measures the proportion of sleep stages with high cardiopulmonary coordination relative to total sleep time.\n\nCardiopulmonary Coupling (CPC) evaluates autonomic regulation by analyzing the synchrony between heartbeats and breathing rhythms. High synchrony typically corresponds to more stable deep sleep and deeper relaxation; reduced synchrony may indicate lower coordination and can be associated with chronic stress, physiological fatigue, or broader functional decline.`,
        },
        "stable_sleep": {
            title: 'Stable Sleep',
            text: 'Stable Sleep is a sleep stage characterized by high cardiorespiratory coordination. The proportion of stable sleep refers to the percentage of stable sleep duration in relation to the total sleep duration throughout the night.',
        },
        "sleep_entry": {
            title: 'Sleep Onset Process',
            text: `The curve of Sleep Onset Process reflects the ease or difficulty of your process of falling asleep. If you transition from wakefulness to sleep quickly, it indicates that you fall asleep easily. However, if your transition is slower, involves repeated interruptions, or takes too long, it may suggest potential sleep-onset issues.`,
        },
        "sleep_need": {
            title: 'Remaining Time to Natural Awakening',
            text: `This metric predicts, at any given moment during sleep, how long it will take until natural awakening occurs. The value continuously changes depending on the current sleep stage. A higher value indicates that more rest is still needed; as it gradually decreases toward zero, it signifies approaching the state of natural awakening. By observing this indicator, one can assess whether sleep throughout the night has been continuous and sufficient, and whether nighttime awakenings or restless sleep have occurred. It functions like a “progress bar” for sleep, providing an intuitive sense of whether the body has “slept enough” and how far away it is from waking up naturally.`,
        },
        "sex_index": {
            title: 'Physiological Sex Index',
            text: `The physiological sex index of sleep can be regarded as a “physiological fingerprint of sex” during sleep. By analyzing physiological activities such as heartbeat, respiration, and body movements, it determines whether the user’s sleep characteristics more closely resemble typical male or female patterns. Just as external appearance reveals sex, different biological sexes leave distinct physiological imprints during sleep.`,
        },
        "resp_ri": {
            title: 'Respiratory Interval(RI)',
            text: `The respiratory interval (RI) refers to the time between two consecutive breaths and represents the most fundamental measure of respiratory rhythm. It directly reflects the breathing rate: the longer the RI, the slower the respiration; the shorter the RI, the faster the respiration. In healthy adults at rest, RI typically ranges from 3 to 5 seconds, corresponding to a respiratory rate of about 12–20 breaths per minute. Shorter RI values may occur during exercise, stress, or tachypnea, whereas markedly prolonged RI may indicate respiratory suppression, deep sleep, or certain pathological conditions. Maintaining an appropriate RI is an important indicator of normal respiratory function and autonomic nervous system balance.`,
        },
        "resp_sdri": {
            title: 'Standard Deviation of RI',
            text: `The standard deviation of respiratory interval (SDRI) is an important parameter reflecting the variability of respiratory rhythm, measuring the degree of fluctuation in the time intervals between consecutive breaths. In healthy adults during rest or natural sleep, SDRI typically ranges from 100 to 400 milliseconds, indicating that respiration is both regular and possesses appropriate flexibility.\n\nWhen SDRI values are abnormally low (below 100 ms), it may suggest overly monotonous or constrained breathing rhythms, commonly observed in deep sleep or under mechanical ventilation. Conversely, elevated SDRI values (above 400 ms) may indicate unstable respiration, which can be associated with emotional fluctuations, sleep disorders, or autonomic nervous system dysregulation.`,
        },
        "resp_cv": {
            title: 'Coefficient of Variation of RI(CV%)',
            text: `The coefficient of variation (CV) is an important indicator of respiratory rhythm stability, reflecting the degree of fluctuation in the intervals between breaths. Under normal conditions, CV typically ranges from 2% to 10%, indicating regular and naturally paced breathing. A lower CV (<2%) may suggest overly monotonous breathing, commonly observed during mechanical ventilation or states of profound suppression. Conversely, a higher CV (>10–12%) reflects greater variability in respiratory rhythm, which may be associated with unstable sleep, emotional tension, or abnormal autonomic regulation. Moderate respiratory variability is a sign of health, but persistently elevated or reduced CV values may indicate that the body is under stress or experiencing an underlying pathological condition.`,
        },
        "resp_dc": {
            title: 'Duty Cycle(DC%)',
            text: `The duty cycle (DC) represents the proportion of inspiratory time within a complete respiratory cycle and is an important index for assessing the balance of respiratory rhythm. In healthy adults at rest, inspiration is usually slightly shorter than expiration, with a typical DC value ranging from 30% to 45%. This means that roughly one-third to nearly one-half of each breathing cycle is spent in inspiration. A higher DC (>50%) may indicate excessive inspiration or insufficient expiration, commonly seen in conditions such as anxiety, dyspnea, or certain pulmonary dysfunctions. Conversely, a lower DC (<30%) may suggest disproportionately prolonged expiration, which can be associated with fatigue or increased airway resistance.`,
        },
        "hrv_rri": {
            title: 'Mean RR Interval',
            text: `The mean RR interval refers to the average time between two consecutive heartbeats and reflects the average heart rate. Under normal conditions, the RR interval during sleep is relatively stable, typically ranging from 900 to 1200 ms (corresponding to a heart rate of 50–67 beats per minute). A longer RR interval (e.g., >1400 ms) indicates a slower heart rate, which may reflect deeper stages of sleep or a well-conditioned, athlete-like heart. However, excessively prolonged RR intervals may also be associated with cardiac abnormalities such as sinoatrial node dysfunction. Conversely, a shorter RR interval (e.g., <700 ms) indicates a faster heart rate, which may suggest poor sleep quality, stress, or potential underlying health issues.`,
        },
        "hrv_sdnn": {
            title: 'SDNN',
            text: `SDNN is the standard deviation of the RR intervals and reflects overall heart rate variability and fluctuations. The normal range is generally 50–150 ms. A markedly reduced SDNN (e.g., <30 ms) may indicate excessive stress or impaired autonomic nervous function, as seen in chronic diseases and other conditions. Conversely, a higher SDNN (e.g., >150 ms) is typically observed during deep sleep or in certain special physiological states, and usually indicates strong autonomic regulatory capacity.`,
        },
        "hrv_nn50": {
            title: 'NN50 per hour',
            text: `NN50 refers to the number of adjacent RR intervals that differ by more than 50 milliseconds. The value shown here represents the average NN50 per hour and reflects short-term heart rate variability. Individual values can vary considerably depending on age and health status. In general, values greater than 100 times per hour suggest good cardiac health and autonomic nervous system function, whereas markedly low values (<20 times per hour) may indicate potential cardiac problems or impaired autonomic function.`,
        },
        "hrv_pnn50": {
            title: 'pNN50',
            text: `pNN50 represents the percentage of NN50 (the number of adjacent RR intervals differing by more than 50 ms) relative to the total number of RR intervals. Like NN50, it reflects short-term heart rate variability and autonomic nervous system activity. Compared with NN50, pNN50 is a more standardized indicator and is more frequently emphasized in sleep research. The normal range is generally 10%–30%. A markedly low value (<5%) may suggest poor sleep quality, stress, or autonomic dysfunction. In contrast, higher values are usually benign and reflect good cardiac health and autonomic nervous system function.`,
        },
        "ans_activity": {
            title: 'Autonomic Nervous System Activity',
            text: `Sympathetic Nervous Activity:\nLike the body’s “stress accelerator,” when sympathetic activity rises, the body tends to manifest wakefulness, tension, excitement, or anxiety. In this context, it is assessed through the low-frequency (LF) component of heart rate variability (HRV). Elevated sympathetic activity at night can make it difficult for the brain to relax, leading to problems such as difficulty falling asleep, shallow sleep, or frequent awakenings.\n\nParasympathetic Nervous Activity:\nLike the body’s “smart brake,” parasympathetic activity regulates the shift into a relaxed, restorative state. Here it is assessed through the high-frequency (HF) component of HRV. Higher parasympathetic activity during the night helps the body enter deep relaxation, reduces heart rate, and promotes digestion, absorption, and cellular repair.`,
        },
        "sleep_dur": {
            title: '睡眠进度偏差',
            text: `表示当前的睡眠进展是否符合整晚应有的节奏。数值接近0时，说明睡眠节奏平稳；数值偏高表示当前进度相对较慢，需要更多时间才能完成睡眠，也可能是由于睡眠被提前中断而导致的偏差；数值偏低则可能意味着进展过快，出现了提前醒来或不稳定的趋势。`,
        },
        "strength": {
            title: 'Circadian Strength Index',
            text: `Circadian strength index is an indicator used to evaluate the stability of the body’s “biological clock” during sleep.\n\nIn simple terms: if the score is close to 100, it means the internal clock is functioning well. This is typically manifested by the ability to fall asleep naturally with ease, maintain uninterrupted sleep throughout the night, and experience balanced cycles of deep and light sleep.\n\nIf the score is close to 0, it indicates circadian rhythm disruption, which may present as difficulty falling asleep, frequent awakenings, or early morning awakenings. Over the long term, this can lead to reduced daytime attention and increased emotional fluctuations.\n\nIt is recommended to help restore a stable rhythm through maintaining regular sleep–wake schedules, engaging in appropriate daytime exercise, and increasing sunlight exposure.`,
        },
        "hrv_recovery": {
            title: 'HRV恢复',
            text: `通过HRV角度所反映的睡眠恢复程度，其值为晨间HRV减去夜间HRV，用颜色箭头表示。箭头起点为夜间HRV，终点为晨间HRV，绿色代表正值，黄色代表负值，箭头长度代表差值幅度。\n\n夜间HRV反映当日压力积累，如数值偏低可能预示过度疲惫、深夜进食、剧烈运动或睡前工作；晨间HRV反映经过一夜睡眠后身心压力恢复水平，更能反映早晨醒来时的感受。\n
            HRV恢复为正值时，可能代表整夜睡眠带来较好的恢复，但也应参考晨间HRV数值是否恢复到和平时数值接近或更高的状态，低于平时的数值可能表示因前一天压力较大，通过良好睡眠带来的恢复也是有限的。\n
            HRV恢复接近0时，如果夜间HRV和晨间HRV都和平时的数值接近或更高，则可认为需恢复的空间不大，在前一天压力水平较低的情况下低恢复值是很常见的；如果都低于平时的数值，可能表明前一天经历较大的压力且未能通过睡眠得到有效的恢复。\n
            HRV恢复为负值时，可能表明睡眠不足、质量差，或者出现了需要关注的健康情况。`,
        },
        "meq": {
            title: 'Morningness–Eveningness Chronotype',
            text: `The morningness–eveningness chronotype is inferred from nightly sleep data and classifies sleep–wake tendencies into five categories: definite morning type, moderate morning type, intermediate type, moderate evening type, and definite evening type. It reflects whether an individual tends to go to bed and wake up earlier or later in daily life.\n\nDefinite morning and moderate morning types are generally better suited to falling asleep and waking up earlier, often feeling more alert in the morning. In contrast, moderate evening and definite evening types tend to fall asleep later and may feel drowsy upon early waking. The intermediate type lies in between, with a sleep–wake rhythm that is more aligned with common social schedules.\n\nBy understanding one’s morningness–eveningness chronotype, individuals can better recognize their natural sleep–wake preferences and adjust lifestyle habits accordingly, improving the alignment between sleep patterns and daily activities.`,
        },
        "wakeprob": {
            title: 'Wakefulness Index',
            text: `The wakefulness index reflects the ability to maintain continuous sleep by monitoring variations in sleep depth throughout the night.\n\nA value close to 0 indicates deep, uninterrupted sleep; rising values suggest lighter sleep or proximity to arousal; when the value reaches 1, it is recorded as full wakefulness (e.g., getting up at night or checking the phone).\n\nYou can identify potential arousal episodes by observing the peaks in the curve—the higher and wider the peak, the stronger the arousal; the speed of the peak’s decline reflects how easily one falls back asleep. High-quality sleep is usually represented by the curve remaining low and stable, with only a few narrow fluctuations. In contrast, frequent high-level oscillations or dense peaks indicate poor sleep continuity, which may be related to frequent nocturnal movements, environmental disturbances, or sleep disorders. Such fragmented sleep can lead to daytime sleepiness, decreased attention, and other problems.`,
        },
        "energy_score": {
            title: 'Energy Potential',
            text: `The Energy Potential index is calculated based on recent sleep rhythms and sleep duration, combined with your personalized sleep needs. It reflects the overall recovery of your physical and cognitive state for the day. A higher score indicates a greater likelihood of feeling energetic, clear-minded, and responsive. Low energy levels are often linked to irregular routines or prolonged sleep deprivation. Returning to a higher level typically requires a sustained period of regular and sufficient sleep; while occasional catch-up sleep may provide some benefit, it cannot quickly offset long-term sleep debt.`,
            changelog: [{
                title: "Recommended Sleep Duration", 
                text: `Refers to the personalized recommended sleep duration for you. The system’s initial recommendation is based on general requirements for your age group and can serve as a guideline for adjusting your schedule. Since individual sleep needs may vary, you can fine-tune this recommendation based on your own experience and condition to better support health and daytime performance.` ,
            }, {
                title: 'Estimated Recovery Period',
                text: `The Estimated Recovery Period is estimated from your personal sleep need and accumulated sleep debt. It estimates how many days of consistent, sufficient sleep are required to restore you to a high-energy state. This serves as a practical reference for setting a realistic recovery pace.`,
            }]
        },
        "energy_curve": {
            title: "Energy Schedule", 
            text: `The Energy Schedule provides a more detailed view of energy fluctuations across different periods of the day, highlighting peaks and dips. It shows when you are likely to feel most alert—ideal for scheduling demanding physical or cognitive tasks—as well as when energy dips may occur, allowing you to plan for short breaks or avoid critical activities. It also suggests an optimal bedtime for the evening, helping you align with your circadian rhythm and establish a positive cycle of regular sleep and improved daytime performance.` ,
            changelog: [{
                title: "Sleep Inertia", 
                text: `Sleep inertia refers to the brief period of grogginess and sluggishness upon waking. During this stage, you may feel slower to react and find it harder to concentrate. This is a natural transition as the body shifts from sleep to wakefulness. Ways to reduce sleep inertia include maintaining a regular sleep schedule, avoiding waking from deep sleep, ensuring sufficient rest, and exposing yourself to natural light or engaging in light activity shortly after waking to speed up the process of becoming alert.` ,
            }, {
                title: 'Morning Energy Peak',
                text: `This is typically the clearest and most focused time of the day, when both physical and cognitive performance are at their best. It’s an ideal window for high-intensity tasks or important activities. Regular, sufficient sleep helps maximize energy during this phase.`,
            }, {
                title: 'Stop Caffeine Intake',
                text: `It is recommended to avoid caffeine within 10 hours before bedtime. It takes your body about 5–6 hours to breakdown half of the caffeine in your system, meaning that even after 10 hours, about one-quarter may still remain in your system. Ideally, caffeine should be consumed in the morning, while coffee or tea in the afternoon should be avoided to minimize interference with nighttime sleep.`,
            }, {
                title: 'Afternoon Energy Dip',
                text: `This is a lower-energy phase of the day, when fatigue may set in. A short nap (around 20 minutes) can help, while it’s best to avoid critical work during this period. Relaxation or social activities can also help restore energy and ease both body and mind.`,
            }, {
                title: 'Evening Energy Peak',
                text: `Another period of heightened clarity and focus, suitable for tackling meaningful tasks. The end of this phase signals the time to start winding down, relaxing the body, and calming the mind in preparation for sleep.`,
            }, {
                title: 'Avoid Late or Heavy Meals',
                text: `Avoid eating large or heavy meals within 3 hours before bedtime. Eating close to sleep—especially greasy or calorie-dense foods—places extra burden on digestion, making it harder to fall asleep and reducing sleep quality. Light dinners at an appropriate time are recommended to support better rest.`,
            }, {
                title: 'Avoid Intense Exercise',
                text: `Avoid exercise within 1 hour before bedtime. The impact of workout timing varies among individuals, but exercising earlier in the day is preferable. Even just 10 minutes of daytime exercise can positively affect sleep quality.`,
            }, {
                title: 'Wind-down',
                text: `As your suggested sleep time approaches (the melatonin window), it’s recommended to start winding down with relaxation practices such as meditation or breathing exercises. Keep the environment dim and avoid electronic devices to prepare the body and mind for rest.`,
            }, {
                title: 'Melatonin Window',
                text: `The melatonin window refers to the time when the brain naturally begins secreting melatonin, a hormone produced by the pineal gland in response to darkness, known as "dim light melatonin onset (DLMO)". This serves as the body’s “time to rest” signal. Falling asleep within this window makes it easier to drift off quickly, reduces nighttime awakenings, and improves overall sleep quality.\n\nThe melatonin window is estimated based on your recent sleep patterns and duration, and helps determine your natural DLMO. However, it reflects your current biological rhythm rather than a fixed guarantee. Consistently falling asleep late in the window—or after it—can gradually delay your circadian rhythm, pushing melatonin secretion later and destabilizing long-term sleep patterns. A practical way to shift bedtime earlier is to begin sleep preparation 15 minutes earlier each night, aiming to fall asleep before 11:00 p.m. Over time, as your schedule shifts earlier, your melatonin window will also advance, leading to quicker morning wakefulness and more sustained energy throughout the day.`,
            }],
        }
    }
};
